import React from "react";
import $ from 'jquery';
import parse from 'html-react-parser';
import { ConnectCallTWebSocket } from './SocketAPI';
import cookie from 'react-cookies';
import { getUserTokenMethod } from "./MLayout";
import { getStore, DispatchFromAppJs } from "./app";
import { StoreUserData, StoreMasterData, StoreUser } from "./DataStore";
import { modes } from "react-transition-group/SwitchTransition";
var currentURL = "https://www.pinnacleblooms.org/";
var googlePingUrl = "https://clients1.google.se/generate_204";
export default class RUtlity extends React.Component {

    constructor(props) {
        super(props);

    }

    render() { return <div></div> }


}


let bbp = class BBP {


    static async Log(Title = null, Start = null, End = null) {

        try {
            var type = localStorage.getItem("BBP");
            var newData = type && type != '1' && type != 'null' ? JSON.parse(type) : [];
            newData.push({ T: Title, S: Start, E: End, CDT: new Date() });
            localStorage.setItem("BBP", JSON.stringify(newData));

        } catch (e) {
            console.log("Error in getUsageTypeFromLS : " + e);
        }
    }
}

export const NewCategories = [
    {
        Name: "Atten.",
        Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><circle cx={16} cy={20} r={3} fill="none" stroke="#0a0a0a" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} data-color="color-2" strokeLinejoin="miter" /><circle cx="8.5" cy="4.5" r="3.5" fill="none" stroke="#0a0a0a" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><polyline points="12 31 12 26 20 26 20 31" fill="none" stroke="#0a0a0a" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} data-color="color-2" strokeLinejoin="miter" /><line x1={6} y1={22} x2={12} y2={26} fill="none" stroke="#0a0a0a" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} data-color="color-2" strokeLinejoin="miter" /><line x1={26} y1={22} x2={20} y2={26} fill="none" stroke="#0a0a0a" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} data-color="color-2" strokeLinejoin="miter" /><path d="M1,25V17a6,6,0,0,1,6-6h3a5.977,5.977,0,0,1,4,1.528" fill="none" stroke="#0a0a0a" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><circle cx="23.5" cy="4.5" r="3.5" fill="none" stroke="#0a0a0a" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><path d="M31,25V17a6,6,0,0,0-6-6H22a5.977,5.977,0,0,0-4,1.528" fill="none" stroke="#0a0a0a" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /></g></svg>
        ,
        URL:"/attendancekpi?status=pending&month=&year=",
        Role:"Therapist",
        Priority : 1

    },
    {
        Name: "Goals",
        Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><circle cx={16} cy={16} r={15} fill="none" stroke="#0a0a0a" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /> <polyline data-color="color-2" points="16 7 16 16 25 16" fill="none" stroke="#0a0a0a" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /></g></svg>
        ,
        URL:"/goalskpi?status=pending",
        Role:"Therapist",
        Priority : 2

    },
    {
        Name: "Pollinate",
        Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><path d="M16,25A14,14,0,0,0,30,11a13.94,13.94,0,0,0-5.072.962" fill="none" stroke="#0a0a0a" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} data-color="color-2" strokeLinejoin="miter" /><path d="M16,25A14,14,0,0,1,2,11a13.94,13.94,0,0,1,5.072.962" fill="none" stroke="#0a0a0a" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} data-color="color-2" strokeLinejoin="miter" /><path d="M2.521,22.9A9.539,9.539,0,0,0,1.31,23.971,9.5,9.5,0,0,0,16,25" fill="none" stroke="#0a0a0a" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><ellipse cx={16} cy="13.4" rx={5} ry="11.599" fill="none" stroke="#0a0a0a" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><path d="M29.479,22.9a9.539,9.539,0,0,1,1.211,1.069A9.5,9.5,0,0,1,16,25" fill="none" stroke="#0a0a0a" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /></g></svg>,
        URL: "/kpireport?facility=&month=&year=&range=&fdt=undefined&TDT=undefined&radiofiltertype=thismonth&hname=Pollinate&rtype=pollinatebytherapy&FilterType=undefinedDDDDDD&FDT=&TDT=&range=",
        Role: "Therapist",
        Priority: 3

    },
    {
        Name: "SR",
        Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="24px" height="24px" viewBox="0 0 24 24" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><path fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} d="M21.243,3.757 c-2.343-2.343-6.142-2.343-8.485,0c-0.289,0.289-0.54,0.6-0.757,0.927c-0.217-0.327-0.469-0.639-0.757-0.927 c-2.343-2.343-6.142-2.343-8.485,0c-2.343,2.343-2.343,6.142,0,8.485L12,21.485l9.243-9.243C23.586,9.899,23.586,6.1,21.243,3.757z" strokeLinejoin="miter" /></g></svg>,
        URL: "/servicerequest",
        Role: "Therapist",
        Priority: 4

    },
    // {
    //     Name:"Feedback",
    //     Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><polygon fill="none" stroke="#0a0a0a" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} points="16,2.686 20.326,11.45 30,12.856 23,19.679 24.652,29.314 16,24.767 7.348,29.314 9,19.679 2,12.856 11.674,11.45 " strokeLinejoin="miter" /></g></svg>,
    //     URL:"/attendancekpi?status=pending&month=&year=",
    //     Role:"Boss",
    //     Priority : 1

    // },
    
    // {
    //     Name:"SR",
    //     Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="24px" height="24px" viewBox="0 0 24 24" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><path fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} d="M21.243,3.757 c-2.343-2.343-6.142-2.343-8.485,0c-0.289,0.289-0.54,0.6-0.757,0.927c-0.217-0.327-0.469-0.639-0.757-0.927 c-2.343-2.343-6.142-2.343-8.485,0c-2.343,2.343-2.343,6.142,0,8.485L12,21.485l9.243-9.243C23.586,9.899,23.586,6.1,21.243,3.757z" strokeLinejoin="miter" /></g></svg>,
    //     URL:"/servicerequest",
    //     Role:"Therapist",
    //     Priority : 4

    // },
    {
        Name:"Feedback",
        Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><polygon fill="none" stroke="#0a0a0a" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} points="16,2.686 20.326,11.45 30,12.856 23,19.679 24.652,29.314 16,24.767 7.348,29.314 9,19.679 2,12.856 11.674,11.45 " strokeLinejoin="miter" /></g></svg>,
        URL:"/attendancekpi?status=pending&month=&year=",
        Role:"Boss",
        Priority : 1

    },
    
    {
        Name:"SR",
        Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="24px" height="24px" viewBox="0 0 24 24" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><path fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} d="M21.243,3.757 c-2.343-2.343-6.142-2.343-8.485,0c-0.289,0.289-0.54,0.6-0.757,0.927c-0.217-0.327-0.469-0.639-0.757-0.927 c-2.343-2.343-6.142-2.343-8.485,0c-2.343,2.343-2.343,6.142,0,8.485L12,21.485l9.243-9.243C23.586,9.899,23.586,6.1,21.243,3.757z" strokeLinejoin="miter" /></g></svg>,
        URL:"/servicerequest",
        Role:"Boss",
        Priority : 2

    },
    {
        Name:"Leave",
        Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><polyline data-color="color-2" points="16 13 16 19 22 19" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /> <circle cx={16} cy={19} r={12} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /> <line data-color="color-2" x1={12} y1={1} x2={20} y2={1} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /> <line data-cap="butt" data-color="color-2" x1={16} y1={1} x2={16} y2={4} fill="none" stroke="#444444" strokeMiterlimit={10} strokeWidth={1} strokeLinecap="butt" strokeLinejoin="miter" /> <line data-color="color-2" x1={26} y1={7} x2={28} y2={9} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /></g></svg>
        ,
        URL:"/leaverequest",
        Role:"Boss",
        Priority : 3

    }
    ,
    {
        Name:"Offers",
        Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><line data-color="color-2" fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} x1={11} y1={21} x2={21} y2={11} strokeLinejoin="miter" /> <circle data-color="color-2" fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} cx={12} cy={12} r={2} strokeLinejoin="miter" /> <circle data-color="color-2" fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} cx={20} cy={20} r={2} strokeLinejoin="miter" /> <polygon fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} points="27,21 31,16 27,11 27,5 21,5 16,1 11,5 5,5 5,11 1,16 5,21 5,27 11,27 16,31 21,27 27,27 " strokeLinejoin="miter" /></g></svg>
        ,
        URL:"/roffers",
        Role:"Boss",
        Priority : 4

    },

    {
        Name:"Leads",
        Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><path d="M13.279,17A7.967,7.967,0,0,1,2.721,17,7.991,7.991,0,0,1,16,23" fill="none" stroke="#444444" strokeMiterlimit={10} strokeWidth={1} data-cap="butt" strokeLinecap="butt" strokeLinejoin="miter" /><path d="M18.721,17a7.967,7.967,0,0,0,10.558,0A7.991,7.991,0,0,0,16,23" fill="none" stroke="#444444" strokeMiterlimit={10} strokeWidth={1} data-cap="butt" strokeLinecap="butt" strokeLinejoin="miter" /><circle cx={16} cy={7} r={6} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} data-color="color-2" strokeLinejoin="miter" /><line x1={16} y1={5} x2={16} y2={9} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} data-color="color-2" strokeLinejoin="miter" /><polygon points="10 23 22 23 21 31 11 31 10 23" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /></g></svg>
        ,
        URL:"/createlead",
        Role:"Admin",
        Priority : 1

    },
    {
        Name:"Walkin",
        Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><circle cx="22.5" cy="6.5" r={1} fill="#0a0a0a" data-cap="butt" data-color="color-2" data-stroke="none" strokeLinecap="butt" strokeLinejoin="miter" /><path d="M20,17a7,7,0,0,1-7,7" fill="none" stroke="#0a0a0a" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} data-color="color-2" strokeLinejoin="miter" /><path d="M17,7a9.942,9.942,0,0,0,2.014,6C10,13,6,16,6,16L1,14l.008,2.993C1.008,23.988,7,29,16,29c7,0,13-3,13-9,0-4-3.493-6-3.493-8.5A1.5,1.5,0,0,1,27,10h4V9a1,1,0,0,0-.8-.98h0a4.5,4.5,0,0,1-3.484-2.689A5,5,0,0,0,17,7Z" fill="none" stroke="#0a0a0a" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /></g></svg>
        ,
        URL:"/kpireport?facility=&insight=thismonth&status=active&month=&year=&hname=Walkins&rtype=walkinleads&fatext=Entire%20Network&FDT=&TDT=&range=",
        Role:"Admin",
        Priority : 2

    },
    {
        Name:"Admn",
        Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><circle data-color="color-2" fill="none" stroke="#0a0a0a" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} cx={16} cy={11} r={3} strokeLinejoin="miter" /> <path data-color="color-2" fill="none" stroke="#0a0a0a" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} d="M22,22 v-1.983c0-0.71-0.372-1.363-0.983-1.725C20.044,17.717,18.358,17,16,17c-2.388,0-4.064,0.713-5.026,1.288 C10.368,18.65,10,19.301,10,20.007V22H22z" strokeLinejoin="miter" /> <circle fill="none" stroke="#0a0a0a" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} cx={27} cy={6} r={3} strokeLinejoin="miter" /> <path data-cap="butt" fill="none" stroke="#0a0a0a" strokeWidth={1} strokeMiterlimit={10} d="M30.7,13c0.197,0.969,0.3,1.973,0.3,3 c0,8.284-6.716,15-15,15S1,24.284,1,16S7.716,1,16,1c3.317,0,6.378,1.073,8.862,2.896" strokeLinejoin="miter" strokeLinecap="butt" /></g></svg>
        ,
        URL:"/serviceland?type=create",
        Role:"Admin",
        Priority : 3

    },
    {
        Name:"Fee",
        Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><line fill="none" stroke="#0a0a0a" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} x1={28} y1={12} x2={25} y2={12} strokeLinejoin="miter" /> <line fill="none" stroke="#0a0a0a" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} x1={21} y1={12} x2={19} y2={12} strokeLinejoin="miter" /> <line fill="none" stroke="#0a0a0a" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} x1={15} y1={12} x2={13} y2={12} strokeLinejoin="miter" /> <line fill="none" stroke="#0a0a0a" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} x1={9} y1={12} x2={7} y2={12} strokeLinejoin="miter" /> <line fill="none" stroke="#0a0a0a" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} x1={3} y1={12} x2={1} y2={12} strokeLinejoin="miter" /> <line fill="none" stroke="#0a0a0a" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} x1={28} y1={26} x2={25} y2={26} strokeLinejoin="miter" /> <line fill="none" stroke="#0a0a0a" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} x1={21} y1={26} x2={19} y2={26} strokeLinejoin="miter" /> <line fill="none" stroke="#0a0a0a" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} x1={15} y1={26} x2={13} y2={26} strokeLinejoin="miter" /> <line fill="none" stroke="#0a0a0a" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} x1={9} y1={26} x2={7} y2={26} strokeLinejoin="miter" /> <line fill="none" stroke="#0a0a0a" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} x1={3} y1={26} x2={1} y2={26} strokeLinejoin="miter" /> <path fill="none" stroke="#0a0a0a" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} d="M28,16V8h-6H9H4 C2.343,8,1,6.657,1,5v21c0,2.209,1.791,4,4,4h23v-8" strokeLinejoin="miter" /> <path data-color="color-2" fill="none" stroke="#0a0a0a" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} d="M31,22h-7 c-1.657,0-3-1.343-3-3v0c0-1.657,1.343-3,3-3h7V22z" strokeLinejoin="miter" /> <path fill="none" stroke="#0a0a0a" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} d="M22,4V2H4 C2.343,2,1,3.343,1,5v0c0,1.657,1.343,3,3,3" strokeLinejoin="miter" /></g></svg>

        ,
        URL:"/createinvoice",
        Role:"Admin",
        Priority : 4

    },


    {
        Name:"Leads",
        Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><path d="M13.279,17A7.967,7.967,0,0,1,2.721,17,7.991,7.991,0,0,1,16,23" fill="none" stroke="#444444" strokeMiterlimit={10} strokeWidth={1} data-cap="butt" strokeLinecap="butt" strokeLinejoin="miter" /><path d="M18.721,17a7.967,7.967,0,0,0,10.558,0A7.991,7.991,0,0,0,16,23" fill="none" stroke="#444444" strokeMiterlimit={10} strokeWidth={1} data-cap="butt" strokeLinecap="butt" strokeLinejoin="miter" /><circle cx={16} cy={7} r={6} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} data-color="color-2" strokeLinejoin="miter" /><line x1={16} y1={5} x2={16} y2={9} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} data-color="color-2" strokeLinejoin="miter" /><polygon points="10 23 22 23 21 31 11 31 10 23" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /></g></svg>
     
        ,
        URL:"/createlead",
        Role:"Care",
        Priority : 1

    },
    {
        Name:"Memo",
        Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><line x1={16} y1={7} x2={16} y2={19} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} data-color="color-2" strokeLinejoin="miter" /><circle cx={16} cy="24.5" r="1.5" fill="#444444" data-cap="butt" data-color="color-2" data-stroke="none" strokeLinecap="butt" strokeLinejoin="miter" /><polygon points="22.213 1 9.787 1 1 9.787 1 22.213 9.787 31 22.213 31 31 22.213 31 9.787 22.213 1" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /></g></svg>
        ,
        URL:"/publishscreen",
        Role:"Care",
        Priority : 2

    },
    {
        Name:"Award",
        Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><path data-cap="butt" data-color="color-2" d="M7,10H6A4,4,0,0,1,2,6V1H7" fill="none" stroke="#444444" strokeMiterlimit={10} strokeWidth={1} strokeLinecap="butt" strokeLinejoin="miter" /> <path data-cap="butt" data-color="color-2" d="M25,10h1a4,4,0,0,0,4-4V1H25" fill="none" stroke="#444444" strokeMiterlimit={10} strokeWidth={1} strokeLinecap="butt" strokeLinejoin="miter" /> <line data-cap="butt" data-color="color-2" x1={16} y1={26} x2={16} y2={20} fill="none" stroke="#444444" strokeMiterlimit={10} strokeWidth={1} strokeLinecap="butt" strokeLinejoin="miter" /> <path d="M16,20h0a9,9,0,0,1-9-9V1H25V11A9,9,0,0,1,16,20Z" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /> <path d="M23,31H9a5,5,0,0,1,5-5h4a5,5,0,0,1,5,5Z" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /></g></svg>

        ,
        URL:"/publishscreen",
        Role:"Care",
        Priority : 3

    },
    {
        Name:"Staff",
        Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><path d="M29.5,1H15.5c-.828,0-1.5,.672-1.5,1.5V15l5-4h10.5c.828,0,1.5-.672,1.5-1.5V2.5c0-.828-.672-1.5-1.5-1.5Z" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} data-color="color-2" strokeLinejoin="miter" /><circle cx={7} cy={19} r={3} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><path d="M7,25c-3.314,0-6,2.686-6,6H13c0-3.314-2.686-6-6-6Z" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><circle cx={25} cy={19} r={3} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><path d="M25,25c-3.314,0-6,2.686-6,6h12c0-3.314-2.686-6-6-6Z" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /></g></svg>

        ,
        URL:"/kpireport?facility=&month=&year=&range=&fdt=undefined&TDT=undefined&hname=Co-Workers&rtype=COWORKERS&isFromLocal=true&fatext=Entire%20Network&FDT=&TDT=&range=",
        Role:"Care",
        Priority : 4

    },

    {
        Name:"Leads",
        Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><path d="M13.279,17A7.967,7.967,0,0,1,2.721,17,7.991,7.991,0,0,1,16,23" fill="none" stroke="#444444" strokeMiterlimit={10} strokeWidth={1} data-cap="butt" strokeLinecap="butt" strokeLinejoin="miter" /><path d="M18.721,17a7.967,7.967,0,0,0,10.558,0A7.991,7.991,0,0,0,16,23" fill="none" stroke="#444444" strokeMiterlimit={10} strokeWidth={1} data-cap="butt" strokeLinecap="butt" strokeLinejoin="miter" /><circle cx={16} cy={7} r={6} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} data-color="color-2" strokeLinejoin="miter" /><line x1={16} y1={5} x2={16} y2={9} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} data-color="color-2" strokeLinejoin="miter" /><polygon points="10 23 22 23 21 31 11 31 10 23" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /></g></svg>
        ,
        URL:"/kpireport?facility=&insight=thismonth&status=active&month=&year=&hname=Active%20Leads&rtype=activeleads&fatext=Entire%20Network&FDT=&TDT=&range=",
        Role:"Finance",
        Priority : 1

    },
    {
        Name:"Walkin",
        Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><circle cx="22.5" cy="6.5" r={1} fill="#0a0a0a" data-cap="butt" data-color="color-2" data-stroke="none" strokeLinecap="butt" strokeLinejoin="miter" /><path d="M20,17a7,7,0,0,1-7,7" fill="none" stroke="#0a0a0a" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} data-color="color-2" strokeLinejoin="miter" /><path d="M17,7a9.942,9.942,0,0,0,2.014,6C10,13,6,16,6,16L1,14l.008,2.993C1.008,23.988,7,29,16,29c7,0,13-3,13-9,0-4-3.493-6-3.493-8.5A1.5,1.5,0,0,1,27,10h4V9a1,1,0,0,0-.8-.98h0a4.5,4.5,0,0,1-3.484-2.689A5,5,0,0,0,17,7Z" fill="none" stroke="#0a0a0a" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /></g></svg>
        ,
        URL:"/kpireport?facility=&insight=thismonth&status=active&month=&year=&hname=Walkins&rtype=walkinleads&fatext=Entire%20Network&FDT=&TDT=&range=",
         Role:"Finance",
        Priority : 2

    },
    {
        Name:"Pollin",
        Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><path d="M16,25A14,14,0,0,0,30,11a13.94,13.94,0,0,0-5.072.962" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} data-color="color-2" strokeLinejoin="miter" /><path d="M16,25A14,14,0,0,1,2,11a13.94,13.94,0,0,1,5.072.962" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} data-color="color-2" strokeLinejoin="miter" /><path d="M2.521,22.9A9.539,9.539,0,0,0,1.31,23.971,9.5,9.5,0,0,0,16,25" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><ellipse cx={16} cy="13.4" rx={5} ry="11.599" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><path d="M29.479,22.9a9.539,9.539,0,0,1,1.211,1.069A9.5,9.5,0,0,1,16,25" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /></g></svg>

        ,
        URL:"/kpireport?facility=&month=&year=&range=&fdt=undefined&TDT=undefined&radiofiltertype=thismonth&hname=Pollinate&rtype=pollinatebytherapy&FilterType=0DDDDDD&fatext=Entire%20Network&FDT=&TDT=&range=",
        Role:"Finance",
        Priority : 3

    },
    {
        Name:"SR",
        Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><line data-color="color-2" fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} x1={11} y1={21} x2={21} y2={11} strokeLinejoin="miter" /> <circle data-color="color-2" fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} cx={12} cy={12} r={2} strokeLinejoin="miter" /> <circle data-color="color-2" fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} cx={20} cy={20} r={2} strokeLinejoin="miter" /> <polygon fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} points="27,21 31,16 27,11 27,5 21,5 16,1 11,5 5,5 5,11 1,16 5,21 5,27 11,27 16,31 21,27 27,27 " strokeLinejoin="miter" /></g></svg>
        ,
        URL:"/kpireport?facility=&month=&year=&range=&fdt=undefined&TDT=undefined&radiofiltertype=thismonth&hname=Service%20Request%20Active&rtype=servicerequestactive&FilterType=ACTIVE&fatext=Entire%20Network&FDT=&TDT=&range=",
        Role:"Finance",
        Priority : 4

    },

    {
        Name:"Staff",
        Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><path d="M29.5,1H15.5c-.828,0-1.5,.672-1.5,1.5V15l5-4h10.5c.828,0,1.5-.672,1.5-1.5V2.5c0-.828-.672-1.5-1.5-1.5Z" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} data-color="color-2" strokeLinejoin="miter" /><circle cx={7} cy={19} r={3} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><path d="M7,25c-3.314,0-6,2.686-6,6H13c0-3.314-2.686-6-6-6Z" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><circle cx={25} cy={19} r={3} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><path d="M25,25c-3.314,0-6,2.686-6,6h12c0-3.314-2.686-6-6-6Z" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /></g></svg>

        ,
        URL:"/kpireport?facility=&month=&year=&range=&fdt=undefined&TDT=undefined&hname=Co-Workers&rtype=COWORKERS&isFromLocal=true&fatext=Entire%20Network&FDT=&TDT=&range=",
          Role:"Harvest",
        Priority : 1

    },
    {
        Name:"Pollin",
        Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><path d="M16,25A14,14,0,0,0,30,11a13.94,13.94,0,0,0-5.072.962" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} data-color="color-2" strokeLinejoin="miter" /><path d="M16,25A14,14,0,0,1,2,11a13.94,13.94,0,0,1,5.072.962" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} data-color="color-2" strokeLinejoin="miter" /><path d="M2.521,22.9A9.539,9.539,0,0,0,1.31,23.971,9.5,9.5,0,0,0,16,25" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><ellipse cx={16} cy="13.4" rx={5} ry="11.599" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><path d="M29.479,22.9a9.539,9.539,0,0,1,1.211,1.069A9.5,9.5,0,0,1,16,25" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /></g></svg>

        ,
        URL:"/kpireport?facility=&month=&year=&range=&fdt=undefined&TDT=undefined&radiofiltertype=thismonth&hname=Pollinate&rtype=pollinatebytherapy&FilterType=0DDDDDD&fatext=Entire%20Network&FDT=&TDT=&range=",
    Role:"Harvest",
        Priority : 2

    },
    {
        Name:"Ranks",
        Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><rect x={1} y={16} width={15} height={15} fill="none" stroke="#444444" strokeMiterlimit={10} strokeWidth={1} data-cap="butt" strokeLinecap="butt" strokeLinejoin="miter" /><rect x={16} y={16} width={15} height={15} fill="none" stroke="#444444" strokeMiterlimit={10} strokeWidth={1} data-cap="butt" strokeLinecap="butt" strokeLinejoin="miter" /><rect x={8} y={1} width={16} height={15} fill="none" stroke="#444444" strokeMiterlimit={10} strokeWidth={1} data-cap="butt" strokeLinecap="butt" strokeLinejoin="miter" /><path d="M17.637,12H15.718V8.3q0-.673.029-1.234a4.373,4.373,0,0,1-.441.45l-.794.655-.981-1.206L15.933,5h1.7Z" fill="#444444" data-cap="butt" data-color="color-2" data-stroke="none" strokeLinecap="butt" strokeLinejoin="miter" /><path d="M11,27H5.921V25.756l1.708-1.728q.732-.765.957-1.045A2.292,2.292,0,0,0,8.9,22.5a1.033,1.033,0,0,0,.089-.421.548.548,0,0,0-.177-.431.724.724,0,0,0-.5-.158,1.357,1.357,0,0,0-.667.189,4.771,4.771,0,0,0-.763.558L5.844,21.023a5.669,5.669,0,0,1,.909-.691,3.228,3.228,0,0,1,.8-.318,3.93,3.93,0,0,1,.974-.11,2.931,2.931,0,0,1,1.213.239,1.885,1.885,0,0,1,.827.682,1.748,1.748,0,0,1,.295.993,2.672,2.672,0,0,1-.1.761,2.715,2.715,0,0,1-.318.686,4.826,4.826,0,0,1-.572.711q-.357.374-1.519,1.416v.048H11Z" fill="#444444" data-cap="butt" data-color="color-2" data-stroke="none" strokeLinecap="butt" strokeLinejoin="miter" /><path d="M25.763,21.521a1.664,1.664,0,0,1-.4,1.117,2.253,2.253,0,0,1-1.148.677v.029q1.751.22,1.751,1.656a1.8,1.8,0,0,1-.773,1.536,3.6,3.6,0,0,1-2.146.56,6.294,6.294,0,0,1-1.045-.082,5.468,5.468,0,0,1-1.041-.3v-1.57a4.123,4.123,0,0,0,.935.347,3.84,3.84,0,0,0,.878.112,1.8,1.8,0,0,0,.907-.174.6.6,0,0,0,.285-.548.621.621,0,0,0-.148-.443.971.971,0,0,0-.479-.234,3.8,3.8,0,0,0-.861-.079H22.05V22.708h.44q1.442,0,1.441-.737a.453.453,0,0,0-.213-.412,1.069,1.069,0,0,0-.572-.134,2.618,2.618,0,0,0-1.388.45l-.784-1.263a3.787,3.787,0,0,1,1.136-.546,4.979,4.979,0,0,1,1.332-.162,2.94,2.94,0,0,1,1.7.43A1.37,1.37,0,0,1,25.763,21.521Z" fill="#444444" data-cap="butt" data-color="color-2" data-stroke="none" strokeLinecap="butt" strokeLinejoin="miter" /></g></svg>

        ,
        URL:"/wip",
        Role:"Harvest",
        Priority : 3

    },
    {
        Name:"EMI",
        Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><path d="M5,17H6a7.674,7.674,0,0,1,6,3h4a4.29,4.29,0,0,1,4,4H11" fill="none" stroke="#444444" strokeMiterlimit={10} strokeWidth={1} data-cap="butt" strokeLinecap="butt" strokeLinejoin="miter" /> <path d="M19.361,22H26c3.625,0,4,2,4,2L15.68,29.816a4.3,4.3,0,0,1-3.517-.146L5,26.032" fill="none" stroke="#444444" strokeMiterlimit={10} strokeWidth={1} data-cap="butt" strokeLinecap="butt" strokeLinejoin="miter" /> <rect x={1} y={15} width={4} height={13} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /> <line x1={31} y1={18} x2={20} y2={18} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} data-color="color-2" strokeLinejoin="miter" /> <path d="M6.252,11A12,12,0,0,1,28,18" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} data-color="color-2" strokeLinejoin="miter" /> <path d="M13,6.378V4a3,3,0,0,1,3-3h0a3,3,0,0,1,3,3V6.378" fill="none" stroke="#444444" strokeMiterlimit={10} strokeWidth={1} data-cap="butt" data-color="color-2" strokeLinecap="butt" strokeLinejoin="miter" /></g></svg>

        ,
        URL:"/wip",
        Role:"Harvest",
        Priority : 4

    },


    {
        Name:"Ranks",
        Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><rect x={1} y={16} width={15} height={15} fill="none" stroke="#444444" strokeMiterlimit={10} strokeWidth={1} data-cap="butt" strokeLinecap="butt" strokeLinejoin="miter" /><rect x={16} y={16} width={15} height={15} fill="none" stroke="#444444" strokeMiterlimit={10} strokeWidth={1} data-cap="butt" strokeLinecap="butt" strokeLinejoin="miter" /><rect x={8} y={1} width={16} height={15} fill="none" stroke="#444444" strokeMiterlimit={10} strokeWidth={1} data-cap="butt" strokeLinecap="butt" strokeLinejoin="miter" /><path d="M17.637,12H15.718V8.3q0-.673.029-1.234a4.373,4.373,0,0,1-.441.45l-.794.655-.981-1.206L15.933,5h1.7Z" fill="#444444" data-cap="butt" data-color="color-2" data-stroke="none" strokeLinecap="butt" strokeLinejoin="miter" /><path d="M11,27H5.921V25.756l1.708-1.728q.732-.765.957-1.045A2.292,2.292,0,0,0,8.9,22.5a1.033,1.033,0,0,0,.089-.421.548.548,0,0,0-.177-.431.724.724,0,0,0-.5-.158,1.357,1.357,0,0,0-.667.189,4.771,4.771,0,0,0-.763.558L5.844,21.023a5.669,5.669,0,0,1,.909-.691,3.228,3.228,0,0,1,.8-.318,3.93,3.93,0,0,1,.974-.11,2.931,2.931,0,0,1,1.213.239,1.885,1.885,0,0,1,.827.682,1.748,1.748,0,0,1,.295.993,2.672,2.672,0,0,1-.1.761,2.715,2.715,0,0,1-.318.686,4.826,4.826,0,0,1-.572.711q-.357.374-1.519,1.416v.048H11Z" fill="#444444" data-cap="butt" data-color="color-2" data-stroke="none" strokeLinecap="butt" strokeLinejoin="miter" /><path d="M25.763,21.521a1.664,1.664,0,0,1-.4,1.117,2.253,2.253,0,0,1-1.148.677v.029q1.751.22,1.751,1.656a1.8,1.8,0,0,1-.773,1.536,3.6,3.6,0,0,1-2.146.56,6.294,6.294,0,0,1-1.045-.082,5.468,5.468,0,0,1-1.041-.3v-1.57a4.123,4.123,0,0,0,.935.347,3.84,3.84,0,0,0,.878.112,1.8,1.8,0,0,0,.907-.174.6.6,0,0,0,.285-.548.621.621,0,0,0-.148-.443.971.971,0,0,0-.479-.234,3.8,3.8,0,0,0-.861-.079H22.05V22.708h.44q1.442,0,1.441-.737a.453.453,0,0,0-.213-.412,1.069,1.069,0,0,0-.572-.134,2.618,2.618,0,0,0-1.388.45l-.784-1.263a3.787,3.787,0,0,1,1.136-.546,4.979,4.979,0,0,1,1.332-.162,2.94,2.94,0,0,1,1.7.43A1.37,1.37,0,0,1,25.763,21.521Z" fill="#444444" data-cap="butt" data-color="color-2" data-stroke="none" strokeLinecap="butt" strokeLinejoin="miter" /></g></svg>
        ,
        URL:"/wip",
        Role:"Owner",
        Priority : 1

    },
    {
        Name:"Fee",
        Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><polyline data-cap="butt" points="12 9 8 1 24 1 20 9" fill="none" stroke="#444444" strokeMiterlimit={10} strokeWidth={1} strokeLinecap="butt" strokeLinejoin="miter" /><line x1={16} y1={9} x2={16} y2={5} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><path d="M20,9H12S4,17,4,23c0,4,3,8,12,8s12-4,12-8C28,17,20,9,20,9Z" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /></g></svg>

        ,
        URL:"/kpireport?facility=&month=&year=&range=&fdt=undefined&TDT=undefined&radiofiltertype=thismonth&hname=Business&rtype=business&fatext=Entire%20Network&FDT=&TDT=&range=",
        Role:"Owner",
        Priority : 2

    },
    {
        Name:"Leads",
        Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><path d="M13.279,17A7.967,7.967,0,0,1,2.721,17,7.991,7.991,0,0,1,16,23" fill="none" stroke="#444444" strokeMiterlimit={10} strokeWidth={1} data-cap="butt" strokeLinecap="butt" strokeLinejoin="miter" /><path d="M18.721,17a7.967,7.967,0,0,0,10.558,0A7.991,7.991,0,0,0,16,23" fill="none" stroke="#444444" strokeMiterlimit={10} strokeWidth={1} data-cap="butt" strokeLinecap="butt" strokeLinejoin="miter" /><circle cx={16} cy={7} r={6} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} data-color="color-2" strokeLinejoin="miter" /><line x1={16} y1={5} x2={16} y2={9} fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} data-color="color-2" strokeLinejoin="miter" /><polygon points="10 23 22 23 21 31 11 31 10 23" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /></g></svg>
        ,
        URL:"/kpireport?facility=&insight=thismonth&status=active&month=&year=&hname=Active%20Leads&rtype=activeleads&fatext=Entire%20Network&FDT=&TDT=&range=",
    
        Role:"Owner",
        Priority : 3

    },
    {
        Name:"Pollin",
        Icon: <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><path d="M16,25A14,14,0,0,0,30,11a13.94,13.94,0,0,0-5.072.962" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} data-color="color-2" strokeLinejoin="miter" /><path d="M16,25A14,14,0,0,1,2,11a13.94,13.94,0,0,1,5.072.962" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} data-color="color-2" strokeLinejoin="miter" /><path d="M2.521,22.9A9.539,9.539,0,0,0,1.31,23.971,9.5,9.5,0,0,0,16,25" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><ellipse cx={16} cy="13.4" rx={5} ry="11.599" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /><path d="M29.479,22.9a9.539,9.539,0,0,1,1.211,1.069A9.5,9.5,0,0,1,16,25" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={1} strokeLinejoin="miter" /></g></svg>

        ,
        URL:"/kpireport?facility=&month=&year=&range=&fdt=undefined&TDT=undefined&radiofiltertype=thismonth&hname=Pollinate&rtype=pollinatebytherapy&FilterType=0DDDDDD&fatext=Entire%20Network&FDT=&TDT=&range=",
    
        Role:"Owner",
        Priority : 4

    },
]





/**Local Data Table Enum */
export const TableLastSyncDateTime = {
    Aggregates: window.tableVersion + "-Aggregates",
    Assessments: window.tableVersion + "-Assessments",
    Attendance: window.tableVersion + "-Attendance",
    CenterNotes: window.tableVersion + "-CenterNotes",
    Centers: window.tableVersion + "-Centers",
    Fee: window.tableVersion + "-Fee",
    Goals: window.tableVersion + "-Goals",
    Guru: window.tableVersion + "-Guru",
    Leads: window.tableVersion + "-Leads",
    //MirracleTypes: window.tableVersion + "-MirracleTypes",
    PeopleNotes: window.tableVersion + "-PeopleNotes",
    ServiceRequests: window.tableVersion + "-ServiceRequests",
    ServiceRequestsAnalytics: window.tableVersion + "-ServiceRequestsAnalytics",
    Therapies: window.tableVersion + "-Therapies",
    // Types: window.tableVersion + "-Types",
    // UserSettings: window.tableVersion + "-UserSettings",
    People: window.tableVersion + "-People",
    Feedback: window.tableVersion + "-Feedback",
    FeeReceipt: window.tableVersion + "-FeeReceipt",
    Responses: window.tableVersion + "-Responses",
    FacilityPeople: window.tableVersion + "-FacilityPeople",
    FacilityTherapies: window.tableVersion + "-FacilityTherapies",
    Biometric: window.tableVersion + "-Biometric",
    Offers: window.tableVersion + "-Offers",
    Mirracles: window.tableVersion + "-Mirracles",
    PinnacleClarity: window.tableVersion + "-PinnacleClarity"
}


export const PinnacleCategories = [
    {
     "Title": "Pendings",
     "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><g class='nc-loop-clock-anim-icon-o' stroke-width='2'><circle cx='24' cy='24' fill='none' r='22' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></circle><line fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' x1='24' x2='24' y1='8' y2='12' stroke-linejoin='miter'></line><line fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' x1='40' x2='36' y1='24' y2='24' stroke-linejoin='miter'></line><line fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' x1='24' x2='24' y1='40' y2='36' stroke-linejoin='miter'></line><line fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' x1='8' x2='12' y1='24' y2='24' stroke-linejoin='miter'></line><line fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' x1='24' x2='24' y1='24' y2='8' data-color='color-2' stroke-linejoin='miter'></line><line fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' x1='24' x2='24' y1='24' y2='11' data-color='color-2' stroke-linejoin='miter'></line></g><style data-cap='butt' stroke-width='2' stroke-linecap='butt' stroke-linejoin='miter'>.nc-loop-clock-anim-icon-o>*{--animation-duration:1s;transform-origin:50% 50%}.nc-loop-clock-anim-icon-o>:nth-last-child(2){animation:nc-loop-clock-anim-m calc(var(--animation-duration)/2) infinite linear}.nc-loop-clock-anim-icon-o>:nth-last-child(1){animation:nc-loop-clock-anim-h var(--animation-duration) infinite linear}@keyframes nc-loop-clock-anim-h{0%{transform:rotate(90deg)}100%{transform:rotate(450deg)}}@keyframes nc-loop-clock-anim-m{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}</style></g></svg>",
     "URL": "gptcategory?t=pendings",
     "Roles": "boss,therapist,senior,receptionist,manager,owner,ncc,ccc,harvestadmin,facilityowner",
     "ImageURL" : "https://www.pinnacleblooms.org/images/discord/pendings.png",
     "Priority": 1
    },
    {
     "Title": "Renew",
     "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><path d='M23.983,38H24A20,20,0,0,1,4,18a19.926,19.926,0,0,1,8.05,1.7' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></path><path d='M5.7,34.993a14.651,14.651,0,0,0-2.654,1.986A14.459,14.459,0,0,0,23.983,38H24' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path><path d='M24,38h-.017a20,20,0,0,0,20-20,19.926,19.926,0,0,0-8.05,1.7' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></path><path d='M24,38A23.9,23.9,0,0,0,24,4.2,23.9,23.9,0,0,0,24,38' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></path><path d='M42.287,34.993a14.651,14.651,0,0,1,2.654,1.986A14.459,14.459,0,0,1,24,38h-.017' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path></g></svg>",
     "URL": "gptcategory?t=Renew",
     "Roles": "therapist,senior,receptionist,manager,owner,ncc,ccc,harvestadmin,facilityowner",
     "ImageURL" : "https://www.pinnacleblooms.org/images/discord/renewal.png",
     "Priority": 2
    },
    {
     "Title": "Pollin",
     "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><circle cx='8' cy='15' r='4' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></circle><circle cx='40.001' cy='15' r='4' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></circle><circle cx='24.001' cy='42' r='4' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></circle><line x1='24.001' y1='28' x2='24.001' y2='38' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></line><line x1='32.163' y1='37.409' x2='27.486' y2='40.04' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></line><line x1='8' y1='19' x2='8' y2='24' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></line><line x1='20.517' y1='22.041' x2='11.483' y2='16.959' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></line><line x1='27.487' y1='22.039' x2='36.515' y2='16.961' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></line><line x1='36.517' y1='13.04' x2='31.839' y2='10.409' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></line><circle cx='8' cy='33' r='4' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' data-color='color-2' stroke-linecap='butt' stroke-linejoin='miter'></circle><circle cx='40.001' cy='33' r='4' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' data-color='color-2' stroke-linecap='butt' stroke-linejoin='miter'></circle><circle cx='24.001' cy='24' r='4' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' data-color='color-2' stroke-linecap='butt' stroke-linejoin='miter'></circle><line x1='24.001' y1='10' x2='24.001' y2='20' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' data-color='color-2' stroke-linecap='butt' stroke-linejoin='miter'></line><circle cx='24.001' cy='6' r='4' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' data-color='color-2' stroke-linecap='butt' stroke-linejoin='miter'></circle><line x1='15.838' y1='10.591' x2='20.515' y2='7.96' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></line><line x1='16.163' y1='37.591' x2='11.484' y2='34.96' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></line><line x1='40.001' y1='24' x2='40.001' y2='29' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></line><line x1='20.517' y1='25.959' x2='11.483' y2='31.041' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' data-color='color-2' stroke-linecap='butt' stroke-linejoin='miter'></line><line x1='27.487' y1='25.961' x2='36.515' y2='31.039' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' data-color='color-2' stroke-linecap='butt' stroke-linejoin='miter'></line></g></svg>",
     "URL": "gptcategory?t=Pollin",
     "Roles": "therapist,senior,receptionist,manager,owner,ncc,ccc,harvestadmin,facilityowner",
     "ImageURL" : "https://www.pinnacleblooms.org/images/discord/pollination.png",
     "Priority": 3
    },
    {
     "Title": "Wins",
     "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><polyline data-cap='butt' data-color='color-2' points='14.068 22.136 4 2 16 2 24 18' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' stroke-linecap='butt' stroke-linejoin='miter'></polyline> <polyline data-cap='butt' data-color='color-2' points='33.933 22.134 44 2 32 2 24 18' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' stroke-linecap='butt' stroke-linejoin='miter'></polyline> <circle cx='24' cy='32' r='14' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></circle> <polygon data-color='color-2' points='24 24.764 26.352 29.528 31.608 30.292 27.804 34 28.702 39.236 24 36.764 19.298 39.236 20.196 34 16.392 30.292 21.648 29.528 24 24.764' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></polygon></g></svg>",
     "URL": "gptcategory?t=Wins",
     "Roles": "boss,therapist,senior,receptionist,manager,owner,ncc,ccc,harvestadmin,facilityowner",
     "ImageURL" : "https://www.pinnacleblooms.org/images/discord/wins.png",
     "Priority": 4
    },
    {
     "Title": "Inno",
     "Icon": "<svg xmlns=\"http:\/\/www.w3.org\/2000\/svg\" xmlnsXlink=\"http:\/\/www.w3.org\/1999\/xlink\" x=\"0px\" y=\"0px\" width=\"48px\" height=\"48px\" viewBox=\"0 0 48 48\" strokeWidth={2}><g strokeWidth={2} transform=\"translate(0, 0)\"><line data-cap=\"butt\" x1=\"29.769\" y1=\"6.086\" x2=\"41.866\" y2=\"18.182\" fill=\"none\" stroke=\"#59696d\" strokeMiterlimit={10} strokeWidth={2} strokeLinecap=\"butt\" strokeLinejoin=\"miter\" \/> <path data-cap=\"butt\" d=\"M24.831,8.965C18.989,6.449,11.5,8,6,15l6.734,6.736\" fill=\"none\" stroke=\"#59696d\" strokeMiterlimit={10} strokeWidth={2} strokeLinecap=\"butt\" strokeLinejoin=\"miter\" \/> <path data-cap=\"butt\" d=\"M39.035,23.169C41.551,29.011,40,36.5,33,42l-6.736-6.734\" fill=\"none\" stroke=\"#59696d\" strokeMiterlimit={10} strokeWidth={2} strokeLinecap=\"butt\" strokeLinejoin=\"miter\" \/> <path d=\"M21,38,10,27S18.894,3.414,46,2C44.468,28.988,21,38,21,38Z\" fill=\"none\" stroke=\"#59696d\" strokeLinecap=\"square\" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin=\"miter\" \/> <circle data-color=\"color-2\" cx={27} cy={21} r={4} fill=\"none\" stroke=\"#59696d\" strokeLinecap=\"square\" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin=\"miter\" \/> <path data-color=\"color-2\" d=\"M4.464,36.464a5,5,0,0,1,7.072,7.072C9.583,45.488,2,46,2,46S2.512,38.417,4.464,36.464Z\" fill=\"none\" stroke=\"#59696d\" strokeLinecap=\"square\" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin=\"miter\" \/><\/g><\/svg>",
     "URL": "innovationsgpt",
     "Roles": "boss,therapist,senior,receptionist,manager,owner,ncc,ccc,harvestadmin,facilityowner",
     "ImageURL" : "https://www.pinnacleblooms.org/images/discord/innovation.png",
     "Priority": 5
    },
    {
     "Title": "System",
     "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><rect x='16' y='23' width='16' height='10' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></rect><path d='M20,23V17a4.012,4.012,0,0,1,4-4h0a4.012,4.012,0,0,1,4,4v6' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></path><path d='M42,27A18,18,0,0,1,6,27V7L24,3,42,7Z' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path></g></svg>",
     "URL": "systemsgpt",
     "Roles": "boss,therapist,senior,receptionist,manager,owner,ncc,ccc,harvestadmin,facilityowner",
     "ImageURL" : "https://www.pinnacleblooms.org/images/discord/system.png",
     "Priority": 6
    },
    {
     "Title": "Empower",
     "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><polygon data-color='color-2' fill='none' stroke='#444444' stroke-width='2' stroke-linecap='square' stroke-miterlimit='10' points=' 46,2 22,2 22,23 31,16 46,16 ' stroke-linejoin='miter'></polygon> <path fill='none' stroke='#444444' stroke-width='2' stroke-linecap='square' stroke-miterlimit='10' d='M20,43.672 c0-1.208-0.529-2.357-1.476-3.108C17.078,39.416,14.57,38,11,38s-6.078,1.416-7.524,2.564C2.529,41.315,2,42.464,2,43.672V46h18 V43.672z' stroke-linejoin='miter'></path> <circle fill='none' stroke='#444444' stroke-width='2' stroke-linecap='square' stroke-miterlimit='10' cx='11' cy='28' r='5' stroke-linejoin='miter'></circle> <path fill='none' stroke='#444444' stroke-width='2' stroke-linecap='square' stroke-miterlimit='10' d='M46,43.672 c0-1.208-0.529-2.357-1.476-3.108C43.078,39.416,40.57,38,37,38s-6.078,1.416-7.524,2.564C28.529,41.315,28,42.464,28,43.672V46h18 V43.672z' stroke-linejoin='miter'></path> <circle fill='none' stroke='#444444' stroke-width='2' stroke-linecap='square' stroke-miterlimit='10' cx='37' cy='28' r='5' stroke-linejoin='miter'></circle></g></svg>",
     "Roles": "therapist,senior,receptionist,manager,owner,ncc,ccc,harvestadmin,facilityowner",
     "URL": "kpireport?hname=Empowring&rtype=EMPOWERINGKIDS",
     "ImageURL" : "https://www.pinnacleblooms.org/images/discord/empower.png",
     "Priority": 7
    },
    {
     "Title": "Team",
     "Icon": " <svg xmlns=\"http:\/\/www.w3.org\/2000\/svg\" xmlnsXlink=\"http:\/\/www.w3.org\/1999\/xlink\" x=\"0px\" y=\"0px\" width=\"48px\" height=\"48px\" viewBox=\"0 0 48 48\" strokeWidth={2}><g strokeWidth={2} transform=\"translate(0, 0)\"><path data-color=\"color-2\" fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeLinecap=\"square\" strokeMiterlimit={10} d=\"M9,13L9,13 c-2.209,0-4-1.791-4-4v0c0-2.209,1.791-4,4-4h0c2.209,0,4,1.791,4,4v0C13,11.209,11.209,13,9,13z\" strokeLinejoin=\"miter\" \/> <path data-cap=\"butt\" data-color=\"color-2\" fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeMiterlimit={10} d=\"M12,43H6L5,32l-3-1v-9 c0-2.209,1.791-4,4-4h6c1.454,0,2.727,0.777,3.427,1.937\" strokeLinejoin=\"miter\" strokeLinecap=\"butt\" \/> <path data-color=\"color-2\" fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeLinecap=\"square\" strokeMiterlimit={10} d=\"M39,13 L39,13c2.209,0,4-1.791,4-4v0c0-2.209-1.791-4-4-4h0c-2.209,0-4,1.791-4,4v0C35,11.209,36.791,13,39,13z\" strokeLinejoin=\"miter\" \/> <path data-cap=\"butt\" data-color=\"color-2\" fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeMiterlimit={10} d=\"M36,43h6l1-11l3-1v-9 c0-2.209-1.791-4-4-4h-6c-1.454,0-2.727,0.777-3.427,1.937\" strokeLinejoin=\"miter\" strokeLinecap=\"butt\" \/> <path fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeLinecap=\"square\" strokeMiterlimit={10} d=\"M24,14L24,14 c-3.314,0-6-2.686-6-6v0c0-3.314,2.686-6,6-6h0c3.314,0,6,2.686,6,6v0C30,11.314,27.314,14,24,14z\" strokeLinejoin=\"miter\" \/> <path fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeLinecap=\"square\" strokeMiterlimit={10} d=\"M29,46H19l-1-12l-4-1V23 c0-2.209,1.791-4,4-4h12c2.209,0,4,1.791,4,4v10l-4,1L29,46z\" strokeLinejoin=\"miter\" \/><\/g><\/svg>",
     "Roles": "therapist,senior,receptionist,manager,owner,ncc,ccc,harvestadmin,facilityowner",
     "URL": "kpireport?hname=Co-Workers&rtype=COWORKERS&isFromLocal=true&fatext=Entire%20Network",
     "ImageURL" : "https://www.pinnacleblooms.org/images/discord/team.png",
     "Priority": 8
    },
    {
     "Title": "Leave",
     "Icon": "<svg xmlns=\"http:\/\/www.w3.org\/2000\/svg\" xmlnsXlink=\"http:\/\/www.w3.org\/1999\/xlink\" x=\"0px\" y=\"0px\" width=\"48px\" height=\"48px\" viewBox=\"0 0 48 48\" strokeWidth={2}><g strokeWidth={2} transform=\"translate(0, 0)\"><circle cx={24} cy={22} r={4} fill=\"none\" stroke=\"#444444\" strokeLinecap=\"square\" strokeMiterlimit={10} strokeWidth={2} data-color=\"color-2\" strokeLinejoin=\"miter\" \/><path d=\"M35.315,32.221a14,14,0,1,0-22.63,0\" fill=\"none\" stroke=\"#444444\" strokeLinecap=\"square\" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin=\"miter\" \/><path d=\"M35.218,42.924a22,22,0,1,0-22.436,0\" fill=\"none\" stroke=\"#444444\" strokeLinecap=\"square\" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin=\"miter\" \/><path d=\"M22.276,31h3.448a4,4,0,0,1,3.992,4.266L29,46H19l-.716-10.734A4,4,0,0,1,22.276,31Z\" fill=\"none\" stroke=\"#444444\" strokeLinecap=\"square\" strokeMiterlimit={10} strokeWidth={2} data-color=\"color-2\" strokeLinejoin=\"miter\" \/><\/g><\/svg>",
     "Roles": "therapist,senior,receptionist,manager,owner,ncc,ccc,harvestadmin,facilityowner",
     "URL": "gptcategory?t=leaves",
     "ImageURL" : "https://www.pinnacleblooms.org/images/discord/leaves.png",
     "Priority": 9
    },
    {
     "Title": "SR",
     "Icon": " <svg xmlns=\"http:\/\/www.w3.org\/2000\/svg\" xmlnsXlink=\"http:\/\/www.w3.org\/1999\/xlink\" x=\"0px\" y=\"0px\" width=\"48px\" height=\"48px\" viewBox=\"0 0 48 48\" strokeWidth={2}><g strokeWidth={2} transform=\"translate(0, 0)\"><path d=\"M33.545,4A11.235,11.235,0,0,0,24,9.143,11.235,11.235,0,0,0,14.455,4,11.476,11.476,0,0,0,3,15.429C3,26.857,24,44,24,44S45,26.857,45,15.429A11.476,11.476,0,0,0,33.545,4Z\" fill=\"none\" stroke=\"#444444\" strokeLinecap=\"square\" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin=\"miter\" \/><\/g><\/svg>",
     "Roles": "boss,therapist,senior,receptionist,manager,owner,ncc,ccc,harvestadmin,facilityowner",
     "URL": "gptcategory?t=sr",
     "ImageURL" : "https://www.pinnacleblooms.org/images/discord/sr.png",
     "Priority": 10
    },
    {
     "Title": "Absents",
     "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><circle cx='24' cy='30' r='5' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></circle><polyline points='18 46 18 39 30 39 30 46' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></polyline><line x1='18' y1='39' x2='9' y2='32' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></line><line x1='30' y1='39' x2='39' y2='32' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></line><path d='M3,37,4.28,24.2A8,8,0,0,1,12.24,17h6.52A8,8,0,0,1,26,21.594' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path><circle cx='15.5' cy='7.5' r='5.5' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></circle><circle cx='32.5' cy='7.5' r='5.5' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></circle><path d='M45,37,43.72,24.2A8,8,0,0,0,35.76,17H29.24A7.984,7.984,0,0,0,24,18.956' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></path></g></svg>",
     "Roles": "boss,therapist",
     "URL": "gptcategory?t=absents",
     "ImageURL" : "https://www.pinnacleblooms.org/images/discord/absent.png",
     "Priority": 11
    },
    {
     "Title": "Assessments",
     "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><polyline fill='none' stroke='#444444' stroke-width='2' stroke-linecap='square' stroke-miterlimit='10' points='37,9 42,9 42,46 6,46 6,9 11,9 ' stroke-linejoin='miter'></polyline> <polyline data-color='color-2' fill='none' stroke='#444444' stroke-width='2' stroke-linecap='square' stroke-miterlimit='10' points=' 17,28 22,33 31,24 ' stroke-linejoin='miter'></polyline> <path fill='none' stroke='#444444' stroke-width='2' stroke-linecap='square' stroke-miterlimit='10' d='M29,7c0-2.761-2.239-5-5-5 s-5,2.239-5,5h-4v6h18V7H29z' stroke-linejoin='miter'></path></g></svg>",
     "Roles": "boss,therapist",
     "URL": "gptcategory?t=assessments",
     "ImageURL" : "https://www.pinnacleblooms.org/images/discord/assessments.png",
     "Priority": 12
    },
    {
     "Title": "Dues",
     "Icon": "<svg xmlns=\"http:\/\/www.w3.org\/2000\/svg\" xmlnsXlink=\"http:\/\/www.w3.org\/1999\/xlink\" x=\"0px\" y=\"0px\" width=\"48px\" height=\"48px\" viewBox=\"0 0 48 48\" strokeWidth={2}><g strokeWidth={2} transform=\"translate(0, 0)\"><path data-cap=\"butt\" fill=\"none\" stroke=\"#59696d\" strokeWidth={2} strokeMiterlimit={10} d=\"M10,11V7c0-1.657,1.343-3,3-3h0 c1.657,0,3,1.343,3,3v4\" strokeLinejoin=\"miter\" strokeLinecap=\"butt\" \/> <path data-cap=\"butt\" fill=\"none\" stroke=\"#59696d\" strokeWidth={2} strokeMiterlimit={10} d=\"M16,11V6c0-1.657,1.343-3,3-3h0 c1.657,0,3,1.343,3,3v5\" strokeLinejoin=\"miter\" strokeLinecap=\"butt\" \/> <path data-cap=\"butt\" fill=\"none\" stroke=\"#59696d\" strokeWidth={2} strokeMiterlimit={10} d=\"M28,11V6c0-1.657,1.343-3,3-3h0 c1.657,0,3,1.343,3,3v5\" strokeLinejoin=\"miter\" strokeLinecap=\"butt\" \/> <path data-cap=\"butt\" fill=\"none\" stroke=\"#59696d\" strokeWidth={2} strokeMiterlimit={10} d=\"M22,11V5c0-1.657,1.343-3,3-3h0 c1.657,0,3,1.343,3,3v6\" strokeLinejoin=\"miter\" strokeLinecap=\"butt\" \/> <polyline data-cap=\"butt\" fill=\"none\" stroke=\"#59696d\" strokeWidth={2} strokeMiterlimit={10} points=\"27.081,31 3,31 3,11 45,11 45,31 40,31 \" strokeLinejoin=\"miter\" strokeLinecap=\"butt\" \/> <circle data-color=\"color-2\" fill=\"none\" stroke=\"#59696d\" strokeWidth={2} strokeLinecap=\"square\" strokeMiterlimit={10} cx={23} cy={21} r={4} strokeLinejoin=\"miter\" \/> <line data-color=\"color-2\" fill=\"none\" stroke=\"#59696d\" strokeWidth={2} strokeLinecap=\"square\" strokeMiterlimit={10} x1={13} y1={17} x2={9} y2={17} strokeLinejoin=\"miter\" \/> <path data-cap=\"butt\" fill=\"none\" stroke=\"#59696d\" strokeWidth={2} strokeMiterlimit={10} d=\"M10,31c0,8.284,6.716,15,15,15 s15-6.716,15-15V18c-3.464,0-6,2.536-6,6v4c-4.728,0-9,3.656-9,8\" strokeLinejoin=\"miter\" strokeLinecap=\"butt\" \/><\/g><\/svg>",
     "URL": "gptcategory?t=dues",
     "Roles": "receptionist,manager,owner,ncc,ccc,harvestadmin,facilityowner",
     "ImageURL" : "https://www.pinnacleblooms.org/images/discord/dues.png",
     "Priority": 13
    },
    {
     "Title": "Proven Impro",
     "Icon": "<svg xmlns=\"http:\/\/www.w3.org\/2000\/svg\" xmlnsXlink=\"http:\/\/www.w3.org\/1999\/xlink\" x=\"0px\" y=\"0px\" width=\"48px\" height=\"48px\" viewBox=\"0 0 48 48\" strokeWidth={2}><g strokeWidth={2} transform=\"translate(0, 0)\"><path fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeLinecap=\"square\" strokeMiterlimit={10} d=\"M20,19c0-8.3,4-15,4-15 s4,6.7,4,15s-4,15-4,15S20,27.3,20,19z\" strokeLinejoin=\"miter\" \/> <path data-color=\"color-2\" fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeLinecap=\"square\" strokeMiterlimit={10} d=\"M34.8,26.9 c3.8-3.8,9.1-4.8,9.1-4.8s-1,5.2-4.8,9.1S30,36,30,36S31,30.8,34.8,26.9z\" strokeLinejoin=\"miter\" \/> <path fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeLinecap=\"square\" strokeMiterlimit={10} d=\"M37,40c4.2,0,7.6,3,7.6,3 s-3.4,3-7.6,3s-7.6-3-7.6-3S32.8,40,37,40z\" strokeLinejoin=\"miter\" \/> <path data-color=\"color-2\" fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeLinecap=\"square\" strokeMiterlimit={10} d=\"M13.2,26.9 c-3.8-3.8-9.1-4.8-9.1-4.8s1,5.2,4.8,9.1S18,36,18,36S17,30.8,13.2,26.9z\" strokeLinejoin=\"miter\" \/> <path fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeLinecap=\"square\" strokeMiterlimit={10} d=\"M11,40c-4.2,0-7.6,3-7.6,3 s3.4,3,7.6,3s7.6-3,7.6-3S15.2,40,11,40z\" strokeLinejoin=\"miter\" \/><\/g><\/svg>",
     "Roles": "boss,therapist,senior,receptionist,manager,owner,ncc,ccc,harvestadmin,facilityowner",
     "ImageURL" : "https://www.pinnacleblooms.org/images/discord/proven.png",
     "URL": "pendingsgpt",
     "Priority": 14
    },
    {
     "Title": "Goals",
     "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><polyline data-cap='butt' data-color='color-2' points='14.068 22.136 4 2 16 2 24 18' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' stroke-linecap='butt' stroke-linejoin='miter'></polyline> <polyline data-cap='butt' data-color='color-2' points='33.933 22.134 44 2 32 2 24 18' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' stroke-linecap='butt' stroke-linejoin='miter'></polyline> <circle cx='24' cy='32' r='14' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></circle> <polygon data-color='color-2' points='24 24.764 26.352 29.528 31.608 30.292 27.804 34 28.702 39.236 24 36.764 19.298 39.236 20.196 34 16.392 30.292 21.648 29.528 24 24.764' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></polygon></g></svg>",
     "Roles": "senior,receptionist,manager,owner,ncc,ccc,harvestadmin,facilityowner",
     "ImageURL" : "https://www.pinnacleblooms.org/images/discord/goals.png",
     "URL": "gptcategory?t=goals",
     "Priority": 14
    },
    {
     "Title": "Attendance",
     "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><circle cx='24' cy='30' r='5' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></circle><polyline points='18 46 18 39 30 39 30 46' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></polyline><line x1='18' y1='39' x2='9' y2='32' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></line><line x1='30' y1='39' x2='39' y2='32' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></line><path d='M3,37,4.28,24.2A8,8,0,0,1,12.24,17h6.52A8,8,0,0,1,26,21.594' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path><circle cx='15.5' cy='7.5' r='5.5' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></circle><circle cx='32.5' cy='7.5' r='5.5' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></circle><path d='M45,37,43.72,24.2A8,8,0,0,0,35.76,17H29.24A7.984,7.984,0,0,0,24,18.956' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></path></g></svg>",
     "Roles": "senior,receptionist,manager,owner,ncc,ccc,harvestadmin,facilityowner",
     "URL": "gptcategory?t=attendance",
     "ImageURL" : "https://www.pinnacleblooms.org/images/discord/attendance.png",
     "Priority": 15
    },
    {
     "Title": "Homework",
     "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><rect x='20' y='17' width='8' height='8' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></rect><polyline data-cap='butt' data-color='color-2' points='2 21 24 3 46 21' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' stroke-linecap='butt' stroke-linejoin='miter'></polyline><polyline data-cap='butt' points='19 45 19 33 29 33 29 45' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' stroke-linecap='butt' stroke-linejoin='miter'></polyline><path d='M7,24v17c0,2.209,1.791,4,4,4h26c2.209,0,4-1.791,4-4V24' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path><line data-cap='butt' data-color='color-2' x1='9' y1='15.273' x2='9' y2='7' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' stroke-linecap='butt' stroke-linejoin='miter'></line></g></svg>",
     "Roles": "boss",
     "URL": "gptcategory?t=homework",
     "ImageURL" : "https://www.pinnacleblooms.org/images/discord/homework.png",
     "Priority": 16
    },
    {
     "Title": "Feedback",
     "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><circle cx='24' cy='31' r='1' fill='#444444' data-cap='butt' data-color='color-2' data-stroke='none' stroke-linecap='butt' stroke-linejoin='miter'></circle> <path d='M40.8,33.6A16.034,16.034,0,0,0,46,22c0-9.9-9.8-18-22-18S2,12.1,2,22s9.8,18,22,18a31.827,31.827,0,0,0,6.2-.7L42,44Z' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path> <line x1='24' y1='12' x2='24' y2='24' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></line> <circle cx='24' cy='31' r='1' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></circle></g></svg>",
     "Roles": "boss",
     "ImageURL" : "https://www.pinnacleblooms.org/images/discord/feedback.png",
     "URL": "gptcategory?t=feedback",
     "Priority": 17
    },
    {
     "Title": "Fees",
     "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><polyline data-cap='butt' points='19.2 4.4 14 7 19 14' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' stroke-linecap='butt' stroke-linejoin='miter'></polyline><polyline data-cap='butt' points='28.8 4.4 34 7 29 14' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' stroke-linecap='butt' stroke-linejoin='miter'></polyline><polyline points='21 8 18 2 30 2 27 8' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></polyline><path d='M29,14H19S7,27,7,35c0,6,4.25,11,17,11s17-5,17-11C41,27,29,14,29,14Z' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path><line data-color='color-2' x1='24' y1='21' x2='24' y2='39' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></line><path data-color='color-2' d='M28.96,23.974c-2.273-1.181-9.574-2.072-9.574,1.992,0,4.865,9.091,3.148,9.091,7.441s-5.909,3.971-10,2.576' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></path></g></svg>",
     "Roles": "receptionist,manager,owner,ncc,ccc,harvestadmin,facilityowner",
     "ImageURL" : "https://www.pinnacleblooms.org/images/discord/fees.png",
     "URL": "gptcategory?t=fees",
     "Priority": 18
    },
    {
     "Title": "Credits",
     "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><path data-cap='butt' fill='none' stroke='#444444' stroke-width='2' stroke-miterlimit='10' d='M10,11V7c0-1.657,1.343-3,3-3h0 c1.657,0,3,1.343,3,3v4' stroke-linejoin='miter' stroke-linecap='butt'></path> <path data-cap='butt' fill='none' stroke='#444444' stroke-width='2' stroke-miterlimit='10' d='M16,11V6c0-1.657,1.343-3,3-3h0 c1.657,0,3,1.343,3,3v5' stroke-linejoin='miter' stroke-linecap='butt'></path> <path data-cap='butt' fill='none' stroke='#444444' stroke-width='2' stroke-miterlimit='10' d='M28,11V6c0-1.657,1.343-3,3-3h0 c1.657,0,3,1.343,3,3v5' stroke-linejoin='miter' stroke-linecap='butt'></path> <path data-cap='butt' fill='none' stroke='#444444' stroke-width='2' stroke-miterlimit='10' d='M22,11V5c0-1.657,1.343-3,3-3h0 c1.657,0,3,1.343,3,3v6' stroke-linejoin='miter' stroke-linecap='butt'></path> <polyline data-cap='butt' fill='none' stroke='#444444' stroke-width='2' stroke-miterlimit='10' points='27.081,31 3,31 3,11 45,11 45,31 40,31 ' stroke-linejoin='miter' stroke-linecap='butt'></polyline> <circle data-color='color-2' fill='none' stroke='#444444' stroke-width='2' stroke-linecap='square' stroke-miterlimit='10' cx='23' cy='21' r='4' stroke-linejoin='miter'></circle> <line data-color='color-2' fill='none' stroke='#444444' stroke-width='2' stroke-linecap='square' stroke-miterlimit='10' x1='13' y1='17' x2='9' y2='17' stroke-linejoin='miter'></line> <path data-cap='butt' fill='none' stroke='#444444' stroke-width='2' stroke-miterlimit='10' d='M10,31c0,8.284,6.716,15,15,15 s15-6.716,15-15V18c-3.464,0-6,2.536-6,6v4c-4.728,0-9,3.656-9,8' stroke-linejoin='miter' stroke-linecap='butt'></path></g></svg>",
     "Roles": "boss",
     "ImageURL" : "https://www.pinnacleblooms.org/images/discord/credits.png",
     "URL": "pendingsgpt",
     "Priority": 19
    },

    {
     "Title": "Leads",
     "Icon": "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='48px' height='48px' viewBox='0 0 48 48' stroke-width='2'><g stroke-width='2' transform='translate(0, 0)'><circle cx='24' cy='11' r='9' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' data-color='color-2' stroke-linejoin='miter'></circle><polygon points='14 34 34 34 32 46 16 46 14 34' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' stroke-width='2' stroke-linejoin='miter'></polygon><path d='M19.919,25A11.952,11.952,0,0,1,4.081,25,11.987,11.987,0,0,1,24,34' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></path><path d='M28.081,25a11.952,11.952,0,0,0,15.838,0A11.987,11.987,0,0,0,24,34' fill='none' stroke='#444444' stroke-miterlimit='10' stroke-width='2' data-cap='butt' stroke-linecap='butt' stroke-linejoin='miter'></path><rect x='21.172' y='8.172' width='5.657' height='5.657' stroke-width='2' fill='none' stroke='#444444' stroke-linecap='square' stroke-miterlimit='10' transform='translate(-0.749 20.192) rotate(-45)' data-color='color-2' stroke-linejoin='miter'></rect></g></svg>",
     "Roles": "receptionist,manager,owner,ncc,ccc,harvestadmin,facilityowner",
     "ImageURL" : "https://www.pinnacleblooms.org/images/discord/leads.png",
     "URL": "gptcategory?t=leads",
     "Priority": 21
    },
    {
     "Title": "Services",
     "Icon": "<svg xmlns=\"http:\/\/www.w3.org\/2000\/svg\" xmlnsXlink=\"http:\/\/www.w3.org\/1999\/xlink\" x=\"0px\" y=\"0px\" width=\"48px\" height=\"48px\" viewBox=\"0 0 48 48\" strokeWidth={2}><g strokeWidth={2} transform=\"translate(0, 0)\"><path data-cap=\"butt\" data-color=\"color-2\" fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeMiterlimit={10} d=\"M26,9h8c4.418,0,8,3.582,8,8v1\" strokeLinejoin=\"miter\" strokeLinecap=\"butt\" \/> <polyline data-color=\"color-2\" fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeLinecap=\"square\" strokeMiterlimit={10} points=\" 32,3 26,9 32,15 \" strokeLinejoin=\"miter\" \/> <path data-cap=\"butt\" data-color=\"color-2\" fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeMiterlimit={10} d=\"M22,39h-8c-4.418,0-8-3.582-8-8 v-1\" strokeLinejoin=\"miter\" strokeLinecap=\"butt\" \/> <polyline data-color=\"color-2\" fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeLinecap=\"square\" strokeMiterlimit={10} points=\" 16,45 22,39 16,33 \" strokeLinejoin=\"miter\" \/> <path fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeLinecap=\"square\" strokeMiterlimit={10} d=\"M20,23H2v-2.242 c0-1.775,1.164-3.334,2.866-3.838C6.46,16.448,8.604,16,11,16c2.356,0,4.514,0.456,6.125,0.932C18.83,17.436,20,18.994,20,20.773V23 z\" strokeLinejoin=\"miter\" \/> <path fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeLinecap=\"square\" strokeMiterlimit={10} d=\"M6,7c0-2.761,2.239-5,5-5 s5,2.239,5,5s-2.239,6-5,6S6,9.761,6,7z\" strokeLinejoin=\"miter\" \/> <path fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeLinecap=\"square\" strokeMiterlimit={10} d=\"M46,46H28v-2.242 c0-1.775,1.164-3.334,2.866-3.838C32.46,39.448,34.604,39,37,39c2.356,0,4.514,0.456,6.125,0.932C44.83,40.436,46,41.994,46,43.773 V46z\" strokeLinejoin=\"miter\" \/> <path fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeLinecap=\"square\" strokeMiterlimit={10} d=\"M32,30c0-2.761,2.239-5,5-5 s5,2.239,5,5s-2.239,6-5,6S32,32.761,32,30z\" strokeLinejoin=\"miter\" \/><\/g><\/svg>",
     "Roles": "receptionist,manager,owner,ncc,ccc,harvestadmin,facilityowner,",
     "ImageURL" : "https://www.pinnacleblooms.org/images/discord/services.png",
     "URL": "gptcategory?t=services",
     "Priority": 22
    },
    {
        "Title": "Memos",
        "Icon": "<svg xmlns=\"http:\/\/www.w3.org\/2000\/svg\" xmlnsXlink=\"http:\/\/www.w3.org\/1999\/xlink\" x=\"0px\" y=\"0px\" width=\"48px\" height=\"48px\" viewBox=\"0 0 48 48\" strokeWidth={2}><g strokeWidth={2} transform=\"translate(0, 0)\"><path data-cap=\"butt\" data-color=\"color-2\" fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeMiterlimit={10} d=\"M26,9h8c4.418,0,8,3.582,8,8v1\" strokeLinejoin=\"miter\" strokeLinecap=\"butt\" \/> <polyline data-color=\"color-2\" fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeLinecap=\"square\" strokeMiterlimit={10} points=\" 32,3 26,9 32,15 \" strokeLinejoin=\"miter\" \/> <path data-cap=\"butt\" data-color=\"color-2\" fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeMiterlimit={10} d=\"M22,39h-8c-4.418,0-8-3.582-8-8 v-1\" strokeLinejoin=\"miter\" strokeLinecap=\"butt\" \/> <polyline data-color=\"color-2\" fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeLinecap=\"square\" strokeMiterlimit={10} points=\" 16,45 22,39 16,33 \" strokeLinejoin=\"miter\" \/> <path fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeLinecap=\"square\" strokeMiterlimit={10} d=\"M20,23H2v-2.242 c0-1.775,1.164-3.334,2.866-3.838C6.46,16.448,8.604,16,11,16c2.356,0,4.514,0.456,6.125,0.932C18.83,17.436,20,18.994,20,20.773V23 z\" strokeLinejoin=\"miter\" \/> <path fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeLinecap=\"square\" strokeMiterlimit={10} d=\"M6,7c0-2.761,2.239-5,5-5 s5,2.239,5,5s-2.239,6-5,6S6,9.761,6,7z\" strokeLinejoin=\"miter\" \/> <path fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeLinecap=\"square\" strokeMiterlimit={10} d=\"M46,46H28v-2.242 c0-1.775,1.164-3.334,2.866-3.838C32.46,39.448,34.604,39,37,39c2.356,0,4.514,0.456,6.125,0.932C44.83,40.436,46,41.994,46,43.773 V46z\" strokeLinejoin=\"miter\" \/> <path fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeLinecap=\"square\" strokeMiterlimit={10} d=\"M32,30c0-2.761,2.239-5,5-5 s5,2.239,5,5s-2.239,6-5,6S32,32.761,32,30z\" strokeLinejoin=\"miter\" \/><\/g><\/svg>",
        "Roles": "receptionist,manager,owner,ncc,ccc,harvestadmin,facilityowner,",
        "ImageURL": "https://www.pinnacleblooms.org/images/discord/services.png",
        "URL": "gptcategory?t=memos",
        "Priority": 23
    },
    {
        "Title": "Awards",
        "Icon": "<svg xmlns=\"http:\/\/www.w3.org\/2000\/svg\" xmlnsXlink=\"http:\/\/www.w3.org\/1999\/xlink\" x=\"0px\" y=\"0px\" width=\"48px\" height=\"48px\" viewBox=\"0 0 48 48\" strokeWidth={2}><g strokeWidth={2} transform=\"translate(0, 0)\"><path data-cap=\"butt\" data-color=\"color-2\" fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeMiterlimit={10} d=\"M26,9h8c4.418,0,8,3.582,8,8v1\" strokeLinejoin=\"miter\" strokeLinecap=\"butt\" \/> <polyline data-color=\"color-2\" fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeLinecap=\"square\" strokeMiterlimit={10} points=\" 32,3 26,9 32,15 \" strokeLinejoin=\"miter\" \/> <path data-cap=\"butt\" data-color=\"color-2\" fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeMiterlimit={10} d=\"M22,39h-8c-4.418,0-8-3.582-8-8 v-1\" strokeLinejoin=\"miter\" strokeLinecap=\"butt\" \/> <polyline data-color=\"color-2\" fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeLinecap=\"square\" strokeMiterlimit={10} points=\" 16,45 22,39 16,33 \" strokeLinejoin=\"miter\" \/> <path fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeLinecap=\"square\" strokeMiterlimit={10} d=\"M20,23H2v-2.242 c0-1.775,1.164-3.334,2.866-3.838C6.46,16.448,8.604,16,11,16c2.356,0,4.514,0.456,6.125,0.932C18.83,17.436,20,18.994,20,20.773V23 z\" strokeLinejoin=\"miter\" \/> <path fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeLinecap=\"square\" strokeMiterlimit={10} d=\"M6,7c0-2.761,2.239-5,5-5 s5,2.239,5,5s-2.239,6-5,6S6,9.761,6,7z\" strokeLinejoin=\"miter\" \/> <path fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeLinecap=\"square\" strokeMiterlimit={10} d=\"M46,46H28v-2.242 c0-1.775,1.164-3.334,2.866-3.838C32.46,39.448,34.604,39,37,39c2.356,0,4.514,0.456,6.125,0.932C44.83,40.436,46,41.994,46,43.773 V46z\" strokeLinejoin=\"miter\" \/> <path fill=\"none\" stroke=\"#444444\" strokeWidth={2} strokeLinecap=\"square\" strokeMiterlimit={10} d=\"M32,30c0-2.761,2.239-5,5-5 s5,2.239,5,5s-2.239,6-5,6S32,32.761,32,30z\" strokeLinejoin=\"miter\" \/><\/g><\/svg>",
        "Roles": "receptionist,manager,owner,ncc,ccc,harvestadmin,facilityowner,",
        "ImageURL": "https://www.pinnacleblooms.org/images/discord/services.png",
        "URL": "gptcategory?t=awards",
        "Priority": 24
    }
   ]

export const PinnacleSubCategories = [
    {
     "Category": "Pendings",
     "Title": "Attendance",
     "URL": "/attendancekpi",
     "Key": "AP",
     "Zone": "Red",
     "Priority": 5,
     "Role": "Therapist"
    },
    {
     "Category": "Pendings",
     "Title": "Attendance",
     "URL": "/kpireport",
     "Key": "AP",
     "Zone": "Red",
     "Priority": 5,
     "Role": "Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "pendingattendance"
    },
    {
     "Category": "Pendings",
     "Title": "Compos",
     "URL": "/kpireport",
     "Key": "CPC",
     "Zone": "Red",
     "Priority": 1,
     "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "compospending"
    },
    {
     "Category": "Pendings",
     "Title": "Pollination",
     "URL": "/kpireport",
     "Key": "POL",
     "Zone": "Red",
     "Priority": 2,
     "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "pollinatebytherapy"
    },
    {
     "Category": "Pendings",
     "Title": "Not Set",
     "URL": "/goalskpi",
     "Key": "TGNS",
     "Zone": "Red",
     "Priority": 3,
     "Role": "Therapist"
    },
    {
     "Category": "Pendings",
     "Title": "Reviews",
     "URL": "/goalskpi",
     "Key": "GP",
     "Zone": "Red",
     "Priority": 4,
     "Role": "Therapist"
    },
    {
     "Category": "Pendings",
     "Title": "Not Set",
     "URL": "/kpireport",
     "Key": "TGNS",
     "Zone": "Red",
     "Priority": 3,
     "Role": "Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "goalsnotset"
    },
    {
     "Category": "Pendings",
     "Title": "Reviews",
     "URL": "/kpireport",
     "Key": "GP",
     "Zone": "Red",
     "Priority": 4,
     "Role": "Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner"
    },
    {
     "Category": "Pendings",
     "Title": "Available",
     "URL": "/availableslots",
     "Key": "AVL",
     "Zone": "Green",
     "Priority": 2,
     "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner"
    },
    {
     "Category": "Pendings",
     "Title": "Mirracles",
     "URL": "/kpireport",
     "Key": "MAC",
     "Zone": "Red",
     "Priority": 5,
     "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "mirraclepending"
    },
    {
     "Category": "Pendings",
     "Title": "Courses",
     "URL": "/miraverse",
     "Key": "TCOP",
     "Priority": 5,
     "Zone": "Red",
     "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner"
    },
    {
     "Category": "Pendings",
     "Title": "Tantrums",
     "URL": "/miraverse",
     "Key": "TTP",
     "Zone": "Red",
     "Priority": 5,
     "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner"
    },
    {
     "Category": "Pendings",
     "Title": "Conditions",
     "URL": "/miraverse",
     "Key": "TCNP",
     "Priority": 5,
     "Zone": "Red",
     "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner"
    },
    {
     "Category": "Pendings",
     "Title": "Assessments",
     "URL": "/kpireport",
     "Key": "ASP",
     "Zone": "Red",
      "Priority": 5,
     "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "assessmentpending"
    },
    {
     "Category": "Pendings",
     "Title": "Payment",
     "URL": "/kpireport",
     "Key": "PP",
     "Zone": "Red",
     "Priority": 5,
     "Role": "receptionist, FranciseOwner, Owner",
     "Rkey": "paymentpending"
    },
    {
     "Category": "Pendings",
     "Title": "Adv. Pending",
     "URL": "/payments",
     "Key": "APEN",
     "Priority": 5,
     "Zone": "Red",
     "Role": "receptionist, FranciseOwner, Owner"
    },
    {
     "Category": "Pendings",
     "Title": "Leads",
     "URL": "/kpireport",
     "Key": "LEP",
     "Zone": "Red",
     "Priority": 5,
     "Role": "receptionist, FranciseOwner, NCC, Owner",
     "Rkey": "pendingleads"
    },
    {
     "Category": "Pendings",
     "Title": "Goals",
     "URL": "/kpireport",
     "Key": "GP",
     "Zone": "Red",
     "Priority": 5,
     "Role": "receptionist, FranciseOwner, NCC, Owner",
     "Rkey": "goalspending"
    },
    {
     "Category": "Pendings",
     "Title": "Leaves",
     "URL": "/leaveapprovals",
     "Key": "SLPA",
     "Zone": "Red",
     "Priority": 5,
     "Role": "receptionist, FranciseOwner, NCC, Owner"
    },
    {
     "Category": "Pendings",
     "Title": "SR",
     "URL": "/kpireport",
     "Key": "SRIP",
     "Zone": "Red",
     "Priority": 5,
     "Role": "receptionist, FranciseOwner, NCC, Owner",
     "Rkey": "servicerequestpending"
    },
    {
     "Category": "Pendings",
     "Title": "WHI",
     "URL": "/kpireport",
     "Key": "PROP",
     "Zone": "Red",
     "Priority": 5,
     "Role": "receptionist, FranciseOwner, NCC, Owner",
     "Rkey": "proquery"
    },
    {
     "Category": "Pendings",
     "Title": "CHI",
     "URL": "/kpireport",
     "Key": "CPA",
     "Zone": "Red",
     "Priority": 5,
     "Role": "receptionist, FranciseOwner, NCC, Owner",
     "Rkey": "ADMINPTI"
    },
    {
     "Category": "Pendings",
     "Title": "PISI",
     "URL": "/kpireport",
     "Key": "TPA",
     "Priority": 5,
     "Zone": "Red",
     "Role": "receptionist, FranciseOwner, NCC, Owner",
     "Rkey": "THERAPISTPTI"
    },
    {
     "Category": "Pendings",
     "Title": "Fees",
     "URL": "/bossreceipts",
     "Priority": 5,
     "Zone": "Red",
     "Role": "Boss"
    },
    {
     "Category": "Pendings",
     "Title": "Homework",
     "URL": "/attendancekpi",
     "Priority": 5,
     "Key": "HWP",
     "Zone": "Red",
     "Role": "Boss"
    },
    {
     "Category": "Renew",
     "Title": "All",
     "URL": "/kpireport",
     "Key": "RCA",
     "Zone": "Red",
     "Priority": 1,
     "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "renewalclarityall"
    },
    {
     "Category": "Renew",
     "Title": "Overdue",
     "URL": "/kpireport",
     "Key": "RCOD",
     "Zone": "Red",
     "Priority": 2,
     "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "renewalclarityoverdue"
    },
    {
     "Category": "Renew",
     "Title": "Today",
     "URL": "/kpireport",
     "Key": "RCTD",
     "Zone": "Red",
     "Priority": 3,
     "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "renewalclaritytoday"
    },
    {
     "Category": "Renew",
     "Title": "Tommorow",
     "URL": "/kpireport",
     "Key": "RCTR",
     "Zone": "Red",
     "Priority": 4,
     "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "renewalclaritytomorrow"
    },
    {
     "Category": "Renew",
     "Title": "This Week",
     "URL": "/kpireport",
     "Key": "RCTW",
     "Zone": "Red",
     "Priority": 5,
     "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "renewalclaritythisweek"
    },
    {
     "Category": "Renew",
     "Title": "Next Week",
     "URL": "/kpireport",
     "Key": "RCNW",
     "Zone": "Red",
     "Priority": 6,
     "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "renewalclaritynextweek"
    },
    {
     "Category": "Renew",
     "Title": "This Month",
     "URL": "/kpireport",
     "Key": "RCTM",
     "Zone": "Red",
     "Priority": 7,
     "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "renewalclaritythismonth"
    },
    {
     "Category": "Renew",
     "Title": "Next Month",
     "URL": "/kpireport",
     "Key": "RCNM",
     "Zone": "Red",
     "Priority": 8,
     "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "renewalclaritynextmonth"
    },
    {
     "Category": "Renew",
     "Title": "Not Renewing",
     "URL": "/kpireport",
     "Key": "RCOT",
     "Zone": "Red",
     "Priority": 9,
     "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "renewalclarityothers"
    },
    {
     "Category": "Renew",
     "Title": "Tobe Renewed",
     "URL": "/kpireport",
     "Key": "RCTBR",
     "Zone": "Red",
     "Priority": 10,
     "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "renewalclaritytoberenewed"
    },
    {
     "Category": "Renew",
     "Title": "Pending",
     "URL": "/kpireport",
     "Key": "RCP",
     "Zone": "Red",
     "Priority": 11,
     "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "renewalclaritypending"
    },
    {
     "Category": "Renew",
     "Title": "Renewed",
     "URL": "/kpireport",
     "Key": "RCR",
     "Zone": "Red",
     "Priority": 12,
     "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "renewalclarityrenewed"
    },
    {
     "Category": "Pollin",
     "Title": "Promised",
     "URL": "/kpireport",
     "Key": "PCP",
     "Zone": "Red",
     "Priority": 1,
     "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "pollinationclaritypromised"
    },
    {
     "Category": "Pollin",
     "Title": "Completed",
     "URL": "/kpireport",
     "Key": "PCC",
     "Zone": "Red",
     "Priority": 2,
     "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "pollinationclaritycompleted"
    },
    {
     "Category": "Pollin",
     "Title": "YetTo",
     "URL": "/kpireport",
     "Key": "PCYT",
     "Zone": "Red",
     "Priority": 3,
     "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "pollinationclarityyetto"
    },
    {
     "Category": "Pollin",
     "Title": "Zero",
     "URL": "/kpireport",
     "Key": "PCZ",
     "Zone": "Red",
     "Priority": 4,
     "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "pollinationclarityzero"
    },
    {
     "Category": "Pollin",
     "Title": "<3",
     "URL": "/kpireport",
     "Key": "PCLT",
     "Zone": "Red",
     "Priority": 5,
     "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "pollinationclaritylessthanthree"
    },
    {
     "Category": "Pollin",
     "Title": ">=3",
     "URL": "/kpireport",
     "Key": "PCGT",
     "Zone": "Red",
     "Priority": 6,
     "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "pollinationclaritygreaterthanthree"
    },
    {
     "Category": "Pollin",
     "Title": "Opty",
     "Key": "POL",
     "Zone": "Red",
     "Priority": 7,
     "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner"
    },
    {
     "Category": "Pollin",
     "Title": "ST",
     "URL": "/kpireport",
     "Key": "PAST",
     "Zone": "Red",
     "Priority": 8,
     "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "pollinationoptyst"
    },
    {
     "Category": "Pollin",
     "Title": "OT",
     "URL": "/kpireport",
     "Key": "PAOT",
     "Zone": "Red",
     "Priority": 9,
     "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "pollinationoptyot"
    },
    {
     "Category": "Pollin",
     "Title": "ABA",
     "URL": "/kpireport",
     "Key": "PAABA",
     "Zone": "Red",
     "Priority": 10,
     "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "pollinationoptyaba"
    },
    {
     "Category": "Pollin",
     "Title": "SE",
     "URL": "/kpireport",
     "Key": "PASE",
     "Zone": "Red",
     "Priority": 11,
     "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "pollinationoptyse"
    },
    {
     "Category": "Achivements",
     "Title": "Walkins",
     "URL": "/kpireport",
     "Key": "OW",
     "Zone": "Red",
     "Priority": 5,
     "Role": "Senior,receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "walkinleads"
    },
    {
     "Category": "Achivements",
     "Title": "Additions",
     "URL": "/kpireport",
     "Key": "ADD",
     "Zone": "Red",
     "Role": "Senior,receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "additionleads"
    },
    {
     "Category": "Achivements",
     "Title": "Therapies",
     "URL": "/kpireport",
     "Key": "AGP",
     "Zone": "Red",
     "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "activeservices"
    },
    {
     "Category": "Achivements",
     "Title": "Rating",
     "URL": "/kpireport",
     "Key": "RAT",
     "Zone": "Red",
     "Priority": 5,
     "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "feedbacksgiven"
    },
    {
     "Category": "Achivements",
     "Title": "Goals",
     "URL": "/kpireport",
     "Key": "GR",
     "Zone": "Red",
     "Priority": 5,
     "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "goalreviewed"
    },
    {
     "Category": "Achivements",
     "Title": "Mirracles",
     "URL": "/mirracles",
     "Key": "MIRT",
     "Zone": "Red",
     "Priority": 5,
     "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner"
    },
    {
     "Category": "Achivements",
     "Title": "Tantrums",
     "URL": "/kpireport",
     "Key": "MIRV",
     "Zone": "Red",
     "Priority": 5,
     "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner"
    },
    {
     "Category": "Achivements",
     "Title": "Admissions",
     "URL": "/kpireport",
     "Key": "ADM",
     "Zone": "Red",
     "Priority": 5,
     "Role": "Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "admissionleads"
    },
    {
     "Category": "Achivements",
     "Title": "InActive",
     "URL": "/kpireport",
     "Key": "TCS",
     "Priority": 5,
     "Zone": "Red",
     "Role": "Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "inactiveservices"
    },
    {
     "Category": "Achivements",
     "Title": "Credits",
     "URL": "/AdvancedInvoices",
     "Key": "AC",
     "Priority": 5,
     "Zone": "Red",
     "Role": "Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner"
    },
    {
     "Category": "Achivements",
     "Title": "Therapies",
     "URL": "/attendancekpi",
     "Key": "TBOT",
     "Priority": 5,
     "Zone": "Red",
     "Role": "Boss"
    },
    {
     "Category": "Achivements",
     "Title": "Goals",
     "URL": "/attendancekpi",
     "Key": "TBOG",
     "Priority": 5,
     "Zone": "Red",
     "Role": "Boss"
    },
    {
     "Category": "Achivements",
     "Title": "Feedback",
     "URL": "/attendancekpi",
     "Key": "TBOF",
     "Priority": 5,
     "Zone": "Red",
     "Role": "Boss"
    },
    {
     "Category": "Achivements",
     "Title": "Credits",
     "URL": "/bossreceipts",
     "Key": "AC",
     "Zone": "Red",
     "Role": "Boss",
     "Priority": 5,
    },
    {
     "Category": "Achivements",
     "Title": "Recommend.",
     "URL": "/kpireport",
     "Key": "RG",
     "Zone": "Red",
     "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "feedbacksgiven",
     "Priority": 5,
    },
    {
     "Category": "Achivements",
     "Title": "Awards",
     "URL": "/kpireport",
     "Key": "AWARDS",
     "Zone": "Red",
     "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "awards",
     "Priority": 5
    },
    {
     "Category": "Achivements",
     "Title": "Courses",
     "URL": "/kpireport",
     "Key": "MIRC",
     "Zone": "Red",
     "Priority": 5,
     "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner"
    },
    {
     "Category": "Achivements",
     "Title": "Conditions",
     "URL": "/kpireport",
     "Key": "MIRLC",
     "Priority": 5,
     "Zone": "Red",
     "Role": "Therapist, Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner"
    },
    {
     "Category": "Dues",
     "Title": "Overdue",
     "URL": "/kpireport",
     "Key": "DO",
     "Zone": "Red",
     "Priority": 1,
     "Role": "Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "dueoverdue"
    },
    {
     "Category": "Dues",
     "Title": "All",
     "URL": "/kpireport",
     "Key": "DA",
     "Zone": "Red",
     "Priority": 2,
     "Role": "Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "dueall"
    },
    {
     "Category": "Dues",
     "Title": "Today",
     "URL": "/kpireport",
     "Key": "DT",
     "Zone": "Red",
     "Priority": 3,
     "Role": "Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "duetoday"
    },
    {
     "Category": "Dues",
     "Title": "Tomorrow",
     "URL": "/kpireport",
     "Key": "DTM",
     "Zone": "Red",
     "Priority": 4,
     "Role": "Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "duetomorrow"
    },
    {
     "Category": "Dues",
     "Title": "ETA Pending",
     "URL": "/kpireport",
     "Key": "DEP",
     "Zone": "Red",
     "Priority": 5,
     "Role": "Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "etapending"
    },
    {
     "Category": "Dues",
     "Title": "This Week",
     "URL": "/kpireport",
     "Key": "DTW",
     "Zone": "Red",
     "Priority": 6,
     "Role": "Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "duethisweek"
    },
    {
     "Category": "Dues",
     "Title": "Next Week",
     "URL": "/kpireport",
     "Key": "DNW",
     "Zone": "Red",
     "Priority": 7,
     "Role": "Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "duenextweek"
    },
    {
     "Category": "Dues",
     "Title": "This Month",
     "URL": "/kpireport",
     "Key": "DTMN",
     "Zone": "Red",
     "Priority": 8,
     "Role": "Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "duethismonth"
    },
    {
     "Category": "Dues",
     "Title": "Next Month",
     "URL": "/kpireport",
     "Key": "DNM",
     "Zone": "Red",
     "Priority": 9,
     "Role": "Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "duenextmonth"
    },
    {
     "Category": "Dues",
     "Title": "Future",
     "URL": "/kpireport",
     "Key": "DF",
     "Zone": "Red",
     "Priority": 10,
     "Role": "Senior, Admin,receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "duefuture"
    },
    {
     "Category": "Kubera",
     "Title": "18k",
     "URL": "/kpireport",
     "Key": "KU18",
     "Zone": "Red",
     "Priority": 5,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "kuberamonthlyfee"
    },
    {
     "Category": "Kubera",
     "Title": "Missing",
     "URL": "/kpireport",
     "Key": "KUM",
     "Zone": "Red",
     "Priority": 5,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "kuberamissing"
    },
    {
     "Category": "Kubera",
     "Title": "Abnormal",
     "URL": "/kpireport",
     "Key": "KUAB",
     "Zone": "Red",
     "Priority": 5,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "kuberaabnormal"
    },
    {
     "Category": "Kubera",
     "Title": "Rest",
     "URL": "/kpireport",
     "Key": "KUR",
     "Zone": "Red",
     "Priority": 5,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "allinvoicesthismonth"
    },
    {
     "Category": "Empower2",
     "Title": "Monthly",
     "URL": "/kpireport",
     "Key": "EMPM",
     "Priority": 5,
     "Zone": "Red",
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "monthlypack"
    },
    {
     "Category": "Empower2",
     "Title": "Single",
     "URL": "/kpireport",
     "Key": "EMPS",
     "Zone": "Red",
     "Priority": 5,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "empwoer2single"
    },
    {
     "Category": "Empower2",
     "Title": "Renew",
     "URL": "/kpireport",
     "Key": "RWT",
     "Zone": "Red",
     "Priority": 5,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "allrenewals"
    },
    {
     "Category": "Empower2",
     "Title": "Lost Parents",
     "URL": "/kpireport",
     "Key": "TLKIDS",
     "Zone": "Red",
     "Priority": 5,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "leftparents"
    },
    {
     "Category": "Seeta",
     "Title": "Pending",
     "URL": "/kpireport",
     "Key": "SETP",
     "Zone": "Red",
     "Priority": 5,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "seetapending"
    },
    {
     "Category": "Seeta",
     "Title": "Partial",
     "URL": "/kpireport",
     "Key": "SETPP",
     "Zone": "Red",
     "Priority": 5,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "seetapartiallypaid"
    },
    {
     "Category": "Seeta",
     "Title": "Paid",
     "URL": "/kpireport",
     "Key": "SETPA",
     "Zone": "Red",
     "Priority": 5,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "seetapaid"
    },
    {
     "Category": "Seeta",
     "Title": "Kids",
     "URL": "/kpireport",
     "Key": "SETKI",
     "Zone": "Red",
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "seetakids"
    },
    {
     "Category": "Attendance",
     "Title": "Total",
     "URL": "/kpireport",
     "Key": "TOA",
     "Zone": "Red",
     "Priority": 1,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "pendingattendance"
    },
    {
     "Category": "Attendance",
     "Title": "Present",
     "URL": "/kpireport",
     "Key": "AGP",
     "Zone": "Red",
     "Priority": 2,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "attendancepresent"
    },
    {
     "Category": "Attendance",
     "Title": "Pending",
     "URL": "/kpireport",
     "Key": "AP",
     "Zone": "Red",
     "Priority": 3,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "pendingattendance"
    },
    {
     "Category": "Attendance",
     "Title": "Absent",
     "URL": "/kpireport",
     "Key": "ABS",
     "Zone": "Red",
     "Priority": 4,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "attendanceabsent"
    },
    {
     "Category": "Attendance",
     "Title": "Pending Compos",
     "URL": "/kpireport",
     "Key": "CPC",
     "Zone": "Red",
     "Priority": 5,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "compospending"
    },
    {
     "Category": "Attendance",
     "Title": "Parent Pending",
     "URL": "/kpireport",
     "Key": "RP",
     "Zone": "Red",
     "Priority": 6,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "homeworkpending"
    },
    {
     "Category": "Attendance",
     "Title": "Parent Given",
     "URL": "/kpireport",
     "Key": "RG",
     "Zone": "Red",
     "Priority": 7,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "feedbacksgiven"
    },
    {
     "Category": "Attendance",
     "Title": "Total Compos",
     "URL": "/kpireport",
     "Key": "CST",
     "Zone": "Red",
     "Priority": 8,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "compenstations"
    },
    {
     "Category": "Attendance",
     "Title": "Compos Given",
     "URL": "/kpireport",
     "Key": "CSC",
     "Zone": "Red",
     "Priority": 9,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "compenstations"
    },
    {
     "Category": "Attendance",
     "Title": "Compos Future",
     "URL": "/kpireport",
     "Key": "CSF",
     "Zone": "Red",
     "Priority": 10,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "compenstations"
    },
    {
     "Category": "Attendance",
     "Title": "Compos Not Accomplished",
     "URL": "/kpireport",
     "Key": "CSO",
     "Zone": "Red",
     "Priority": 11,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "compenstations"
    },
    {
     "Category": "Attendance",
     "Title": "Compos Cancelled",
     "URL": "/kpireport",
     "Key": "CCL",
     "Zone": "Red",
     "Priority": 12,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "Compensations"
    },
    {
     "Category": "Goals",
     "Title": "Total",
     "URL": "/kpireport",
     "Key": "TGO",
     "Zone": "Red",
     "Priority": 1,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "totalgoals"
    },
    {
     "Category": "Goals",
     "Title": "Active",
     "URL": "/kpireport",
     "Key": "TAG",
     "Zone": "Red",
     "Priority": 2,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "activegoals"
    },
    {
     "Category": "Goals",
     "Title": "Pending",
     "URL": "/kpireport",
     "Key": "GP",
     "Zone": "Red",
     "Priority": 3,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "goalspending"
    },
    {
     "Category": "Goals",
     "Title": "Today Pending",
     "URL": "/kpireport",
     "Key": "TGP",
     "Zone": "Red",
     "Priority": 4,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "todaygoalspending"
    },
    {
     "Category": "Goals",
     "Title": "Not Set",
     "URL": "/kpireport",
     "Key": "TGNS",
     "Zone": "Red",
     "Priority": 5,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "goalsnotset"
    },
    {
     "Category": "Goals",
     "Title": "Reviewed",
     "URL": "/kpireport",
     "Key": "GR",
     "Zone": "Red",
     "Priority": 6,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "goalreviewed"
    },
    {
     "Category": "Goals",
     "Title": "Met",
     "URL": "\/GoalsInsights",
     "Key": "TGM",
     "Zone": "Red",
     "Priority": 7,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner"
    },
    {
     "Category": "Goals",
     "Title": "Not Met",
     "URL": "\/GoalsInsights",
     "Key": "GNM",
     "Zone": "Red",
     "Priority": 8,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner"
    },
    {
     "Category": "Leads",
     "Title": "Total",
     "URL": "/kpireport",
     "Key": "LTO",
     "Zone": "Red",
     "Priority": 1,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "totalleads"
    },
    {
     "Category": "Leads",
     "Title": "Active",
     "URL": "/kpireport",
     "Key": "LA",
     "Zone": "Red",
     "Priority": 2,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "activeleads"
    },
    {
     "Category": "Leads",
     "Title": "Pending",
     "URL": "/kpireport",
     "Key": "LEP",
     "Zone": "Red",
     "Priority": 3,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "pendingleads"
    },
    {
     "Category": "Leads",
     "Title": "New",
     "URL": "/kpireport",
     "Key": "LN",
     "Zone": "Red",
     "Priority": 4,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "newleads"
    },
    {
     "Category": "Leads",
     "Title": "Closed",
     "URL": "/kpireport",
     "Key": "LC",
     "Zone": "Red",
     "Priority": 5,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "closedleads"
    },
    {
     "Category": "Leads",
     "Title": "Walkins",
     "URL": "/kpireport",
     "Key": "OW",
     "Zone": "Red",
     "Priority": 6,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "walkinleads"
    },
    {
     "Category": "Leads",
     "Title": "Assessments",
     "URL": "/kpireport",
     "Key": "LASM",
     "Zone": "Red",
     "Priority": 7,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "assessmentsleads"
    },
    {
     "Category": "Leads",
     "Title": "Admissions",
     "URL": "/kpireport",
     "Key": "LTA",
     "Zone": "Red",
     "Priority": 8,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "admissionleads"
    },
    {
     "Category": "Leads",
     "Title": "ElseWhere",
     "URL": "/kpireport",
     "Key": "JSW",
     "Zone": "Red",
     "Priority": 9,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "joinedelsewhere"
    },
    {
     "Category": "Team",
     "Title": "Total Staff Leaves",
     "URL": "/kpireport",
     "Key": "TOSL",
     "Zone": "Red",
     "Priority": 1,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "leaverequestnonparent"
    },
    {
     "Category": "Team",
     "Title": "<4 Compos",
     "URL": "/kpireport",
     "Key": "SLCLT4",
     "Zone": "Red",
     "Priority": 2,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "leaverequestcomposlt4"
    },
    {
     "Category": "Team",
     "Title": "Approval Pending",
     "URL": "\/leaveapprovals",
     "Key": "SLAP",
     "Zone": "Red",
     "Priority": 3,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner"
    },
    {
     "Category": "Team",
     "Title": "Approved",
     "URL": "/kpireport",
     "Key": "SLA",
     "Zone": "Red",
     "Priority": 4,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "leaverequestanalytic"
    },
    {
     "Category": "Team",
     "Title": "Unaproved",
     "URL": "/kpireport",
     "Key": "SLUA",
     "Zone": "Red",
     "Priority": 5,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "leaverequestanalyticunapproved"
    },
    {
     "Category": "Team",
     "Title": "Future",
     "URL": "/kpireport",
     "Key": "SLF",
     "Zone": "Red",
     "Priority": 6,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "leaverequestnonparentfuture"
    },
    {
     "Category": "Team",
     "Title": "Completed",
     "URL": "/kpireport",
     "Key": "SLC",
     "Zone": "Red",
     "Priority": 7,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "leaverequestnonparentcompleted"
    },
    {
     "Category": "Team",
     "Title": "Canceled",
     "URL": "/kpireport",
     "Key": "SLCA",
     "Zone": "Red",
     "Priority": 8,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "leaverequestnonparentcanceled"
    },
    {
     "Category": "Team",
     "Title": "Total Parent Leaves",
     "URL": "/kpireport",
     "Key": "TOPL",
     "Zone": "Red",
     "Priority": 9,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "leaverequestparent"
    },
    {
     "Category": "Team",
     "Title": "Completed",
     "URL": "/kpireport",
     "Key": "PLC",
     "Zone": "Red",
     "Priority": 10,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "leaverequestparentcompleted"
    },
    {
     "Category": "Team",
     "Title": "Future",
     "URL": "/kpireport",
     "Key": "PLF",
     "Zone": "Red",
     "Priority": 11,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "leaverequestparentfuture"
    },
    {
     "Category": "Team",
     "Title": "Canceled",
     "URL": "/kpireport",
     "Key": "PLCA",
     "Zone": "Red",
     "Priority": 12,
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "leaverequestparentcanceled"
    },
    {
     "Category": "Team",
     "Title": "Staff",
     "URL": "/kpireport",
     "Key": "TStaff",
     "Zone": "Red",
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "activestaff"
    },
    {
     "Category": "Team",
     "Title": "+",
     "URL": "/kpireport",
     "Key": "ASTAFF",
     "Zone": "Red",
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "addedstaff"
    },
    {
     "Category": "Team",
     "Title": "-",
     "URL": "/kpireport",
     "Key": "TLStaff",
     "Zone": "Red",
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "leftstaff"
    },
    {
     "Category": "Team",
     "Title": "Parents",
     "URL": "/kpireport",
     "Key": "KIDS",
     "Zone": "Red",
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "activeparents"
    },
    {
     "Category": "Team",
     "Title": "New Parents",
     "URL": "/kpireport",
     "Key": "AKIDs",
     "Zone": "Red",
     "Role": "receptionist, FranciseOwner, NCC, Harvest, Owner",
     "Rkey": "addedparents"
    },
    {
        "Category": "SR",
        "Title": "All",
        "URL": "/kpireport",
        "Key": "SRT",
        "Zone": "Red",
        "Priority": 1,
        "Role": "Therapist,Senior,receptionist, FranciseOwner, NCC, Harvest, Owner",
        "Rkey": "servicerequestall"
       },
       {
        "Category": "SR",
        "Title": "In Progress",
        "URL": "/kpireport",

        "Key": "SRIP",
        "Zone": "Red",
        "Priority": 2,
        "Role": "Therapist,Senior,receptionist, FranciseOwner, NCC, Harvest, Owner",
        "Rkey": "servicerequestpending"
       },
       {
        "Category": "SR",
        "Title": "Resolved",
        "URL": "/kpireport",
        "Key": "SRR",
        "Zone": "Red",
        "Priority": 3,
        "Role": "Therapist,Senior,receptionist, FranciseOwner, NCC, Harvest, Owner",
        "Rkey": "servicerequestresolved"
       },
       {
        "Category": "SR",
        "Title": "Closed",
        "URL": "/kpireport",
        "Key": "SRW",
        "Zone": "Red",
        "Priority": 4,
        "Role": "Therapist,Senior,receptionist, FranciseOwner, NCC, Harvest, Owner",
        "Rkey": "servicerequestwaiting"
       }
   ]
   export function GetPinnacleCategories(role){

     try{
        console.log("GET CATEGORIES INFORMATION");

        var values = PinnacleCategories.filter(t=> t.Roles == 'All' || t.Roles.toLowerCase().indexOf(role.toLowerCase()) > -1);

        return values;

     }
     catch(e){
        console.log("GetCategories",e)
     }
   }

   export function GetPinnacleSubCategories(role,category){

    try{
       console.log("GetPinnacleSubCategories");

       var values = PinnacleSubCategories.filter(t=> (t.Role == 'All' || (t.Role && t.Role.toLowerCase().indexOf(role.toLowerCase()) > -1)) && t.Category.toLowerCase() == category.toLowerCase());

       return values;

    }
    catch(e){
       console.log("GetPinnacleSubCategories",e)
    }
  }

  export function GetPinnacleSubCategoriesByRole(role){

    try{
       console.log("GetPinnacleSubCategoriesByRole");

       var values = PinnacleSubCategories.filter(t=> (t.Role == 'All' || (t.Role && t.Role.toLowerCase().indexOf(role.toLowerCase()) > -1)));

       return values;

    }
    catch(e){
       console.log("GetPinnacleSubCategoriesByRole",e)
    }
  }

   //PinnacleSubCategories
   export function GetPinnacleCategoryByName(name){

    try{
       console.log("GetPinnacleCategoryByName");

       var values = PinnacleCategories.filter(t=> t.Title.toLowerCase() == name.toLowerCase());

       return values && values.length > 0 ? values [0] : null;

    }
    catch(e){
       console.log("GetCategories",e)
    }
  }

export const PinnacleKPIUseCases = [
    {
        "Id": "dueoverdue",
        "Title": "OverDue ",
        "Math": "All Pending Payments which are not met ETA",
        "UseCases": "→ Admins, Leadership to know all fee which are missed day of clearance.<br\/>\n→ Pinnacle AI to remind Admins , Leadership about Overdue"
    },
    {
        "Id": "duea;;",
        "Title": "All",
        "Math": "All Pending Payments which are having ETA ",
        "UseCases": "→ Admins, Leadership to know all fee which needs to be cleared by when.<br\/>\n→ Pinnacle AI to remind Parents, Admins , Leadership about fee clearance"
    },
    {
        "Id": "duetoday",
        "Title": "Today",
        "Math": "All Pending Payments with today's ETA ",
        "UseCases": "→ Admins, Leadership to know all fee which are clearing today.<br\/>\n→ Pinnacle AI to remind Parents, Admins , Leadership about Fee Clearance of today."
    },
    {
        "Id": "duetomorrow",
        "Title": "Tomorrow",
        "Math": "All Pending Payments with tomorrow's ETA ",
        "UseCases": "→ Admins, Leadership to know all fee which are clearing tomorrow.<br\/>\n→ Pinnacle AI to remind Parents, Admins , Leadership about Fee Clearance of tomrrow."
    },
    {
        "Id": "etapending",
        "Title": "Pending",
        "Math": "All Pending Payments with out ETA",
        "UseCases": "→ Admins, Leadership to know all fee clearing date<br\/>\n→ Pinnacle AI to remind Parents, Admins , Leadership to clear fee."
    },
    {
        "Id": "duethisweek",
        "Title": "This Week",
        "Math": "All Pending Payments where ETA is This Week and Not today and tomorrow",
        "UseCases": "→ Admins, Leadership to know all fee which are clearing this week.<br\/>\n→ Pinnacle AI to remind Parents, Admins , Leadership about Fee Clearance of this week."
    },
    {
        "Id": "duenextweek",
        "Title": "Next Week ",
        "Math": "All Pending Payments where ETA is Next Week",
        "UseCases": "→ Admins, Leadership to know all fee which are clearing next week.<br\/>\n→ Pinnacle AI to remind Parents, Admins , Leadership about Fee Clearance of next week."
    },
    {
        "Id": "duethismonth",
        "Title": "This Month",
        "Math": "All Pending Payments which are having this month ETA and greater than next week",
        "UseCases": "→ Admins, Leadership to know all fee which are clearing this month.<br\/>\n→ Pinnacle AI to remind Parents, Admins , Leadership about Fee Clearance of this month."
    },
    {
        "Id": "duenextmonth",
        "Title": "Next Month",
        "Math": "All Pending Payments with next month ETA",
        "UseCases": "→ Admins, Leadership to know all fee which are clearing next month.<br\/>\n→ Pinnacle AI to remind Parents, Admins , Leadership about Fee Clearance of next month."
    },
    {
        "Id": "duefuture",
        "Title": "Future",
        "Math": "All Pending Payments with ETA greaterthan next month",
        "UseCases": "→ Admins, Leadership to know all fee which are clearing after next month.<br\/>\n→ Pinnacle AI to remind Parents, Admins , Leadership about Fee Clearance of after next month."
    },
    {
        "Id": "Achievements",
        "Title": "Achievements"
    },
    {
        "Id": "WalkIns",
        "Title": "Walkins",
        "Math": "All Walkins Marked in Pinnacle",
        "UseCases": "→ Admins, Leadership to know all walkins happened in current month.<br/>\r\n→ Pinnacle AI to remind Admin manger for Walkings."
    },
    {
        "Id": "Additions",
        "Title": "Additions",
        "Math": "All new services added in Current month",
        "UseCases": "→ Admins, Leadership to know all sevices added in current month.<br/>\r\n"
    },
    {
        "Id": "InActive",
        "Title": "Inactive",
        "Math": "All services Closed in current month",
        "UseCases": "→ Admins, Leadership to know all sevices added in current month.<br/>\r\n→ Pinnacle AI to conduct inactivation root cause\r\n→ Harvest to monitor uneven and high number of inactivations"
    },
    {
        "Id": "Therapies",
        "Title": "Therapies",
        "Math": "total number of therapies session provided in current month",
        "UseCases": "→ Admins, Leadership to know all sevices provided in current month.<br/>\r\n→ Therapist to know all sevices provided by them in current month.<br/>"
    },
    {
        "Id": "Credits",
        "Title": "Credits",
        "Math": "count of all future invoices",
        "UseCases": "→ Admins, Leadership to know all the future credits to be fullfilled<br/>\r\n→ Parents to know their Credits remaining"
    },
    {
        "Id": "Rating",
        "Title": "Rating",
        "Math": "Average Rating recieved from Parents",
        "UseCases": "→ Admins, Leadership to know all the ratings recieved<br/>\r\n→ Therapist to know their performance based on rating"
    },
    {
        "Id": "Recommend",
        "Title": "Recomendations",
        "Math": "Total number of feedbacks recieved from parents",
        "UseCases": "→ Admins, Leadership to know all recommendations recieved<br/>\r\n→ Therapist to know their performance based on reccomendations"
    },
    {
        "Id": "Goals",
        "Title": "Goals",
        "Math": "Total number of Goals Set in current month",
        "UseCases": "→ Admins, Leadership to know all Goals set in current month.<br/>\r\n→ Therapist to know all Goals set by them in current month.<br/>"
    },
    {
        "Id": "Awards",
        "Title": "Awards",
        "Math": "Total number of awards achieved in current month",
        "UseCases": "→ Admins, Leadership to know all Awards Issued current month.<br/>\r\n→ Therapist to know all Awards received by them in current month.<br/>"
    },
    {
        "Id": "Mirracles",
        "Title": "Mirracles",
        "Math": "Total number of mirracles recorded in current month",
        "UseCases": "→ Admins, Leadership to know all mirracles recorded current month.<br/>\r\n→ Therapist to know all mirracles contributed by them in current month.<br/>"
    },
    {
        "Id": "Courses",
        "Title": "Courses",
        "Math": "Total number of courses recorded in current month",
        "UseCases": "→ Admins, Leadership to know all courses completed in current month.<br/>\r\n→ Therapist to know courses completed by them in current month.<br/>"
    },
    {
        "Id": "Tantrums",
        "Title": "Tantrumns",
        "Math": "Total number of Tantrums recorded in current month",
        "UseCases": "→ Admins, Leadership to know all tantrums completed in current month.<br/>\r\n→ Therapist to know tantrums completed by them in current month.<br/>"
    },
    {
        "Id": "Conditions",
        "Title": "Conditios",
        "Math": "Total number of Conditions recorded in current month",
        "UseCases": "→ Admins, Leadership to know all conditions completed in current month.<br/>\r\n→ Therapist to know conditions completed by them in current month.<br/>"
    },
    {
        "Id": "pollinatebytherapy",
        "Title": "Pollination",
        "Math": "All services which are not being availed by Kid",
        "UseCases": "→ Therapist, Admins, Leadership to know all the pollination opportunity in kids empoerment. <br/>\r\n→ Harvest to know the opprtunities where therapists can be part of Kids empowerment."
    },
    {
        "Id": "paymentpending",
        "Title": "Payment",
        "Math": "All Fee Pending which are availed and raised in this month.",
        "UseCases": "→ Admins, Leadership to know all fee pending in the current month<br/>\r\n→ Pinnacle AI to remind Parents, Admins , Leadership about fee pending in this month"
    },
    {
        "Id": "pendingleads",
        "Title": "Leads",
        "Math": "Total active leads which are need to be followed up on or before today",
        "UseCases": "→ Admins, Leadership to know ongoing leads <br/>\r\n→ Pinnacle AI to remind Admins and Leadership about Leads to be followed up"
    },
    {
        "Id": "goalsnotsetnew",
        "Title": "Not Set",
        "Math": "There is no active goal for ongoing service",
        "UseCases": "→ Therapists, Admins, Leadership to know who are not being part of kids empowerment <br/>\r\n→ Pinnacle AI to remind Therapists,Admins and Leadership about goals not set."
    },
    {
        "Id": "pendingattendance",
        "Title": "Attendance",
        "Math": "Total attendances to be given",
        "UseCases": "→ Therapists, Admins, Leadership to know all pending attendances in current month <br/>\r\n→ Pinnacle AI to remind Therapists,Admins and Leadership about pending attendances."
    },
    {
        "Id": "Conditions",
        "Title": "Available",
        "Math": "Total Sessions availble based on therapist slots",
        "UseCases": "→ Therapists, Admins, Leadership to know available slots<br/>\r\n→ Therapist to know available slots in current month."
    },
    {
        "Id": "newpayments",
        "Title": "Adv. Pending",
        "Math": "Total advance fees to be collected",
        "UseCases": "→ Admins, Leadership to know all advance pending fee .<br/>\r\n→ Pinnacle AI to remind Parents, Admins , Leadership about all Adv Fee Clearance."
    },
    {
        "Id": "assessmentpending",
        "Title": "Assessements",
        "Math": "Total Assessments to be completed",
        "UseCases": "→ Therapist, Admins, Leadership to know all therapy Assessments in kids empowerment. <br/>\r\n→"
    },
    {
        "Id": "goalspending",
        "Title": "Goals",
        "Math": "Total Goals to be reviewed",
        "UseCases": "→ Therapist, Admins, Leadership to know all goal reviews. <br/>\r\n→ Pinnacle AI to remind Therapists, Admins , Leadership about all goal reviews."
    },
    {
        "Id": "compospending",
        "Title": "Compos",
        "Math": "Total Componsations to be provided",
        "UseCases": "→ Therapist, Admins, Leadership to know compensation provided in this month. <br/>\r\n→ Pinnacle AI to remind Parents,Therapists, Admins , Leadership about all compensations."
    },
    {
        "Id": "leavespending",
        "Title": "Leaves",
        "Math": "Total Leaves pending for approval",
        "UseCases": "→ Therapist, Admins, Leadership to know all leaves approval pending <br/>\r\n→ Pinnacle AI to remind Therapists, Admins about all leaves approval pendings."
    },
    {
        "Id": "servicerequestpending",
        "Title": "SR",
        "Math": "Total Service Request to be resolved",
        "UseCases": "→ Therapist, Admins, Leadership to know all service requests pending <br/>\r\n"
    },
    {
        "Id": "WHI",
        "Title": "WHI",
        "Math": "Total number of WHI responses yet to be given",
        "UseCases": "→ Admins, Leadership to know all WHI pending responses in current month.<br/>\r\n→ Therapist, Admins to know WHI pending responses by them in current month.<br/>"
    },
    {
        "Id": "CHI",
        "Title": "CHI",
        "Math": "Total number of CHI responses yet to be given",
        "UseCases": "→ Admins, Leadership to know all CHI pending responses in current month.<br/>\r\n→ Therapist, Admins to know CHI pending responses by them in current month.<br/>"
    },
    {
        "Id": "PISI",
        "Title": "PISI",
        "Math": "Total number of PISI responses yet to be given",
        "UseCases": "→ Admins, Leadership to know all PISI pending responses in current month.<br/>\r\n→ Therapist, Admins to know PISI pending responses by them in current month.<br/>"
    },
    {
        "Id": "Courses",
        "Title": "Courses",
        "Math": "Total number of Courses to be completed",
        "UseCases": "→ Admins, Leadership to know all tantrums completed.<br/>\r\n→ Therapist to know tantrums completed by them.<br/>"
    },
    {
        "Id": "mirraclepending",
        "Title": "Mirracles",
        "Math": "Total number of Mirracles Assigned to be recorded",
        "UseCases": "→ Admins, Leadership to know allmirracles pending to be recorded.<br/>\r\n→ Therapist to know all mirracles pending for recording<br/>"
    },
    {
        "Id": "renewalclarityoverdue",
        "Title": "OverDue",
        "Math": "All Pending Renewals which are not met ETA",
        "UseCases": "→ Admins, Leadership to know all Renewals which are missed day of clearance.<br/>\r\n→ Pinnacle AI to remind Admins , Leadership about Overdue Renewals"
    },
    {
        "Id": "renewalclarityall",
        "Title": "All",
        "Math": "All Pending Renewals which are having ETA",
        "UseCases": "→ Admins, Leadership to know all Renewals which needs to be cleared by when.<br/>\r\n→ Pinnacle AI to remind Parents, Admins , Leadership about Renewals clearance"
    },
    {
        "Id": "renewalclaritytoday",
        "Title": "Today",
        "Math": "All Pending Renewals with today's ETA",
        "UseCases": "→ Admins, Leadership to know all Renewals which are clearing today.<br/>\r\n→ Pinnacle AI to remind Parents, Admins , Leadership about Renewals Clearance of today."
    },
    {
        "Id": "renewalclaritytomorrow",
        "Title": "Tomorrow",
        "Math": "All Pending Renewals with tomorrow's ETA",
        "UseCases": "→ Admins, Leadership to know all Renewals which are clearing tomorrow.<br/>\r\n→ Pinnacle AI to remind Parents, Admins , Leadership about Fee Clearance of tomrrow."
    },
    {
        "Id": "renewalclaritypending",
        "Title": "Pending",
        "Math": "All Pending Renewals with out ETA",
        "UseCases": "→ Admins, Leadership to know all Renewals clearing date<br/>\r\n→ Pinnacle AI to remind Parents, Admins , Leadership to clear Renewals."
    },
    {
        "Id": "renewalclaritythisweek",
        "Title": "This Week",
        "Math": "All Pending Renewals where ETA is This Week and Not today and tomorrow",
        "UseCases": "→ Admins, Leadership to know all Renewals which are clearing this week.<br/>\r\n→ Pinnacle AI to remind Parents, Admins , Leadership about Renewals Clearance of this week."
    },
    {
        "Id": "renewalclaritynextweek",
        "Title": "Next Week",
        "Math": "All Pending Renewals where ETA is Next Week",
        "UseCases": "→ Admins, Leadership to know all Renewals which are clearing next week.<br/>\r\n→ Pinnacle AI to remind Parents, Admins , Leadership about Renewals Clearance of next week."
    },
    {
        "Id": "renewalclaritythismonth",
        "Title": "This Month",
        "Math": "All Pending Renewals which are having this month ETA and greater than next week",
        "UseCases": "→ Admins, Leadership to know all Renewals which are clearing this month.<br/>\r\n→ Pinnacle AI to remind Parents, Admins , Leadership about Renewals Clearance of this month."
    },
    {
        "Id": "renewalclaritynextmonth",
        "Title": "Next Month",
        "Math": "All Pending Renewals with next month ETA",
        "UseCases": "→ Admins, Leadership to know all Renewals which are clearing next month.<br/>\r\n→ Pinnacle AI to remind Parents, Admins , Leadership about Renewals Clearance of next month."
    },
    {
        "Id": "renewalclarityothers",
        "Title": "Future",
        "Math": "All Pending Renewals with ETA greaterthan next month",
        "UseCases": "→ Admins, Leadership to know all Renewals which are clearing after next month.<br/>\r\n→ Pinnacle AI to remind Parents, Admins , Leadership about Renewals Clearance of after next month."
    },
    {
        "Id": "renewalclarityrenewed",
        "Title": "Renewed",
        "Math": "All Renewed kids for next month",
        "UseCases": "→ Admins, Leadership to know all Renewed kids for next month.<br/>\r\n→ Therapist,Admins,Leadership to know Renewals completed for next month.<br/>"
    },
    {
        "Id": "activestaff",
        "Title": "Active Staff",
        "Math": "All Active Staff",
        "UseCases": "→ Admins, Leadership to know all active staff.<br/>\r\n→ Pinnacle AI to remind how many staff are available.<br/>"
    },
    {
        "Id": "addedstaff",
        "Title": "Added Staff",
        "Math": "Newly Added Staff",
        "UseCases": "→ Admins, Leadership to know all newly added staff.<br/>\r\n→ Pinnacle AI to remind how many co-wrokers joined this month.<br/>"
    },
    {
        "Id": "leftstaff",
        "Title": "Left Staff",
        "Math": "All Left Staff",
        "UseCases": "→ Admins, Leadership to know all about left staff.<br/>\r\n→ Pinnacle AI to remind how many co-wrokers left.<br/>"
    },
    {
        "Id": "activeparents",
        "Title": "Active Parents",
        "Math": "All Active Parents Taking Services",
        "UseCases": "→ Admins, Leadership to know active parents Having active services.<br/>\r\n→ Pinnacle AI to remind how many kids Taking services Currently.<br/>"
    },
    {
        "Id": "addedparents",
        "Title": "Added Parents",
        "Math": "All Parents whose are Joined this month",
        "UseCases": "→ Admins, Leadership to know all about parents added this month.<br/>\r\n→ Pinnacle AI to remind parents added this month.<br/>"
    },
    {
        "Id": "activememos",
        "Title": "Active Memos",
        "Math": "All Active Memos this month",
        "UseCases": "→ Admins, Leadership to know all about active memos.<br/>\r\n→ Pinnacle AI to remind Remaning active memos this month.<br/>"
    },
    {
        "Id": "closedmemos",
        "Title": "Closes Memos",
        "Math": "All closed memos this month",
        "UseCases": "→ Admins, Leadership to know all about closed memos.<br/>\r\n→ Pinnacle AI to remind closed memos this month.<br/>"
    },
    {
        "Id": "awards",
        "Title": "Awards",
        "Math": "All Awards Raised this month",
        "UseCases": "→ Admins, Leadership to know all awards for this month.<br/>\r\n→ Pinnacle AI to remind awards issued this month.<br/>"
    },
    {
        "Id": "viewpayslips",
        "Title": "View Paylsip",
        "Math": "All paylip viewed this month",
        "UseCases": "→ Admins, Leadership to know all viewed payslips this month.<br/>\r\n→ Pinnacle AI to remind Co-worker who viewed his paylsip for this month.<br/>"
    },
    {
        "Id": "downloadpayslips",
        "Title": "Download Payslip",
        "Math": "All Payslips downloaded this month",
        "UseCases": "→ Admins, Leadership to know all paylsips downloaded this month.<br/>\r\n→ Pinnacle AI to remind Co-worker who downloaded his paylsip for this month<br/>"
    },
    {
        "Id": "pinnacleclaritypending",
        "Title": "Clarity Pending",
        "Math": "All Clarity pendings Remains",
        "UseCases": "→ Leadership to know all Pending Responses given by Co-Worker.<br/>\r\n→ Pinnacle AI to remind Co-worker who not Clarify the Leader doubts.<br/>"
    },
    {
        "Id": "renewalclaritytoberenewed",
        "Title": "To Be Renewed",
        "Math": "All Kids To be Renewed",
        "UseCases": "→ Admin,receptionist, Leadership to know all Pending Renewels to be Renewed.<br/>\r\n→ Pinnacle AI to remind kids to be Renewed.<br/>"
    },
    {
        "Id": "leaverequestnonparent",
        "Title": "Total Staff Leaves",
        "Math": "All Staff Leaves Applied this month",
        "UseCases": "→ Admin,receptionist, Leadership to know all Staff Leaves Applied this month.<br/>\r\n→ Pinnacle AI to remind Staff who are applied leave this month.<br/>"
    },
    {
        "Id": "leaverequestcomposlt4",
        "Title": "< 4 compos",
        "Math": "All Compensations booked along with leave request",
        "UseCases": "→ Admin,receptionist, Leadership to know all Compensations booked along with leave request this month.<br/>\r\n→ Pinnacle AI to remind what compensations are booked this month.<br/>"
    },
    {
        "Id": "leaveapprovalpending",
        "Title": "Approval Pending",
        "Math": "All Leave Approval pendings",
        "UseCases": "→ Admin,receptionist, Leadership to know all Pending Leave Approvals for this month.<br/>\r\n→ Pinnacle AI to remind what are the pending leaves to be approved.<br/>"
    },
    {
        "Id": "leaverequestanalytic",
        "Title": "Approved",
        "Math": "All Approved leaves this month",
        "UseCases": "→ Admin,receptionist, Leadership to know all Approved leaves for this month.<br/>\r\n→ Pinnacle AI to remind who have approved leaves for this month.<br/>"
    },
    {
        "Id": "leaverequestanalyticunapproved",
        "Title": "Unapproved",
        "Math": "All Unapproved leaves this month",
        "UseCases": "→ Admin,receptionist, Leadership to know all Unapproved leaves for this month.<br/>\r\n→ Pinnacle AI to remind who have Unapproved leaves for this month.<br/>"
    },
    {
        "Id": "leaverequestnonparentfuture",
        "Title": "Future",
        "Math": "All Future leaves for this month",
        "UseCases": "→ Admin,receptionist, Leadership to know all Future Leaves for this month.<br/>\r\n→ Pinnacle AI to remind who have future leaves.<br/>"
    },
    {
        "Id": "leaverequestnonparentcompleted",
        "Title": "Completed",
        "Math": "All Leaves Completed this month",
        "UseCases": "→ Admin,receptionist, Leadership to know all Completed Leaves this month.<br/>\r\n→ Pinnacle AI to remind who completed their leaves this month.<br/>"
    },
    {
        "Id": "leaverequestnonparentcanceled",
        "Title": "Canceled",
        "Math": "All Canceled Leaves for this month",
        "UseCases": "→ Admin,receptionist, Leadership to know all Canceled leaves for this month.<br/>\r\n→ Pinnacle AI to remind Who canceled their leaves for this month.<br/>"
    },
    {
        "Id": "leaverequestparent",
        "Title": "Total Parent Leaves",
        "Math": "All Parent Leave for this month",
        "UseCases": "→ Admin,receptionist, Leadership to know all parent leaves applied for this month.<br/>\r\n→ Pinnacle AI to remind kids who not present on particular day.<br/>"
    },
    {
        "Id": "leaverequestparentcompleted",
        "Title": "Completed",
        "Math": "All Parent Leave Completed for this month",
        "UseCases": "→ Admin,receptionist, Leadership to know all parent completed leaves for this month.<br/>\r\n→ Pinnacle AI to remind parents who already completed their leaves.<br/>"
    },
    {
        "Id": "leaverequestparentfuture",
        "Title": "Future",
        "Math": "All Parent Leave for future",
        "UseCases": "→ Admin,receptionist, Leadership to know all parent leaves applied for future.<br/>\r\n→ Pinnacle AI to remind kids who not present on future.<br/>"
    },
    {
        "Id": "leaverequestparentcanceled",
        "Title": "Cancelled",
        "Math": "All Parent Leave Cancelled this month",
        "UseCases": "→ Admin,receptionist, Leadership to know all parent cancelled leaves for this month.<br/>\r\n→ Pinnacle AI to remind parents who cancelled their leaves for this month.<br/>"
    },
    {
        "Id": "assessmentall",
        "Title": "Total",
        "Math": "All Assessments for this month",
        "UseCases": "→ Admin,receptionist, Leadership to know all assessments for this month.<br/>\r\n→ Pinnacle AI to remind kids who having assessments for this month.<br/>"
    },
    {
        "Id": "assessmentcompleted",
        "Title": "Completed",
        "Math": "All Completed this month",
        "UseCases": "→ Admin,receptionist, Leadership to know all completed this month.<br/>\r\n→ Pinnacle AI to remind assessments completed this month.<br/>"
    },
    {
        "Id": "assessmentpending",
        "Title": "Pending",
        "Math": "All Assessments Pending for this month",
        "UseCases": "→ Admin,receptionist, Leadership to know all assessments pending for this month.<br/>\r\n→ Pinnacle AI to remind pending assessment for this month.<br/>"
    },
    {
        "Id": "assessmentsfee",
        "Title": "Fee",
        "Math": "OverAll Assessment Fee for this month",
        "UseCases": "→ Admin,receptionist, Leadership to know Total assessment fee for this month.<br/>\r\n→ Pinnacle AI to remind overall assessment fee.<br/>"
    },
    {
        "Id": "totalservices",
        "Title": "Total",
        "Math": "All Services Taking",
        "UseCases": "→ Admin,receptionist, Leadership to know overall services.<br/>\r\n→ Pinnacle AI to remind taotal services.<br/>"
    },
    {
        "Id": "activeservices",
        "Title": "Active",
        "Math": "Total Active Services For this month",
        "UseCases": "→ Admin,receptionist, Leadership to know all active services for this month.<br/>\r\n→ Pinnacle AI to remind who taking services this month.<br/>"
    },
    {
        "Id": "futureservices",
        "Title": "Future",
        "Math": "All Future Services",
        "UseCases": "→ Admin,receptionist, Leadership to know all about future services.<br/>\r\n→ Pinnacle AI to remind upcoming services.<br/>"
    },
    {
        "Id": "inactiveservices",
        "Title": "Closed",
        "Math": "All Closed Services this month",
        "UseCases": "→ Admin,receptionist, Leadership to know closed services this month.<br/>\r\n→ Pinnacle AI to remind How many closed services this month.<br/>"
    },
    {
        "Id": "newservices",
        "Title": "New",
        "Math": "All New Services added with in the month",
        "UseCases": "→ Admin,receptionist, Leadership to know Newly Added services this month.<br/>\r\n→ Pinnacle AI to remind how many services added newly in this month.<br/>"
    },
    {
        "Id": "newservicesst",
        "Title": "ST",
        "Math": "All New ST Services added with in the month",
        "UseCases": "→ Admin,receptionist, Leadership to know Newly Added ST services this month.<br/>\r\n→ Pinnacle AI to remind how many ST services added newly in this month.<br/>"
    },
    {
        "Id": "newservicesot",
        "Title": "OT",
        "Math": "All New OT Services added with in the month",
        "UseCases": "→ Admin,receptionist, Leadership to know Newly Added OT services this month.<br/>\r\n→ Pinnacle AI to remind how many OT services added newly in this month.<br/>"
    },
    {
        "Id": "newservicesbt",
        "Title": "BT",
        "Math": "All New BT Services added with in the month",
        "UseCases": "→ Admin,receptionist, Leadership to know Newly Added BT services this month.<br/>\r\n→ Pinnacle AI to remind how many BT services added newly in this month.<br/>"
    },
    {
        "Id": "newservicesse",
        "Title": "SE",
        "Math": "All New SE Services added with in the month",
        "UseCases": "→ Admin,receptionist, Leadership to know Newly Added SE services this month.<br/>\r\n→ Pinnacle AI to remind how many SE services added newly in this month.<br/>"
    },
    {
        "Id": "inactivecausepending",
        "Title": "Inactivation  Cause",
        "Math": "All Inactivation Root Causes",
        "UseCases": "→ Admin,receptionist, Leadership to know about cause of inactivated service.<br/>\r\n→ Pinnacle AI to remind what is the root cause behind the Inactivation.<br/>"
    },
    {
        "Id": "coursescompleted",
        "Math": "All Courses Completed",
        "UseCases": "→ Admins, Leadership to know all courses completed.<br/>\r\n→ Pinnacle AI to remind Therapists,Admins , Leadership about all courses.",
        "Title": "Courses Completed"
    },
    {
        "Id": "coursespending",
        "Math": "All Courses Pending",
        "UseCases": "→ Admins, Leadership to know all courses pending.<br/>\r\n→ Pinnacle AI to remind Therapists,Admins , Leadership about all courses pending.",
        "Title": "Courses Pending"
    },
    {
        "Id": "mirraclesnotcovered",
        "Math": "All Mirracles not covered",
        "UseCases": "→ Admins, Leadership to know all mirracles not covered.<br/>\r\n→ Pinnacle AI to remind Therapists,Admins , Leadership about all mirracles not covered.",
        "Title": "Languages Not covered"
    },
    {
        "Id": "mirracleslc",
        "Math": "All Mirracles Languages covered",
        "UseCases": "→ Admins, Leadership to know all mirracles languages covered.<br/>\r\n→ Pinnacle AI to remind Therapists,Admins , Leadership about all mirracles languages covered.",
        "Title": "Languages Covered"
    },
    {
        "Id": "mirraclesbottom100",
        "Math": "All Bottom 100 Mirracles",
        "UseCases": "→ Admins, Leadership to know all bottom 100 mirracles.<br/>\r\n→ Pinnacle AI to remind Therapists,Admins , Leadership about all bottom 100 mirracles.",
        "Title": "Bottom 100"
    },
    {
        "Id": "mirraclestop100",
        "Math": "All Top 100 Mirracles",
        "UseCases": "→ Admins, Leadership to know all top 100 mirracles.<br/>\r\n→ Pinnacle AI to remind Therapists,Admins , Leadership about all top 100 mirracles..",
        "Title": "Top 100"
    },
    {
        "Id": "allmirraclesviews",
        "Math": "All views of Mirracles",
        "UseCases": "→ Admins, Leadership to know all mirracles views.<br/>\r\n→ Pinnacle AI to remind Therapists,Admins , Leadership about all views of mirracles.",
        "Title": "Views"
    },
    {
        "Id": "mirraclencontributed",
        "Math": "All Mirracles Not Contributed",
        "UseCases": "→ Admins, Leadership to know all mirracles which are not contributed.<br/>\r\n→ Pinnacle AI to remind Therapists,Admins , Leadership about all mirracles which are not contributed.",
        "Title": "Mirracles Not Contributed"
    },
    {
        "Id": "mirraclescontributed",
        "Math": "All Mirracles Contributed",
        "UseCases": "→ Admins, Leadership to know all mirracles contributed.<br/>\r\n→ Pinnacle AI to remind Therapists,Admins , Leadership about all mirracles contributed.",
        "Title": "Mirracles Contributed"
    },
    {
        "Id": "mirraclestotal",
        "Math": "All Total Mirracles",
        "UseCases": "→ Admins, Leadership to know all total mirracles.<br/>\r\n→ Pinnacle AI to remind Therapists,Admins , Leadership about all total mirracles.",
        "Title": "Total Mirracles"
    },
    {
        "Id": "dangpendingtoday",
        "Math": "All Dang Pending Today",
        "UseCases": "→ Leadership to know all today pending Dang.<br/>\r\n→ Pinnacle AI to remind Admins , Leadership about all today pending Dang.",
        "Title": "Pending for Today"
    },
    {
        "Id": "dangoverallpending",
        "Math": "All Dang Overall Pending",
        "UseCases": "→ Leadership to know all overall pending Dang.<br/>\r\n→ Pinnacle AI to remind Admins , Leadership about all overall pending Dang.",
        "Title": "Overall Pending"
    },
    {
        "Id": "dangdelayed",
        "Math": "All Dang Delayed",
        "UseCases": "→ Leadership to know all Dang delayed.<br/>\r\n→ Pinnacle AI to remind Admins , Leadership about all Dang delayed.",
        "Title": "Delayed"
    },
    {
        "Id": "dangontime",
        "Math": "All Dang Ontime",
        "UseCases": "→ Leadership to know all Dang ontime.<br/>\r\n→ Pinnacle AI to remind Admins , Leadership about all Dang ontime..",
        "Title": "Ontime"
    },
    {
        "Id": "dangunachieved",
        "Math": "All Dang Unachieved",
        "UseCases": "→ Leadership to know all Dang unachieved.<br/>\r\n→ Pinnacle AI to remind Admins , Leadership about all Dang unachieved.",
        "Title": "Unachieved"
    },
    {
        "Id": "dangachieved",
        "Math": "All Dang Achieved",
        "UseCases": "→ Leadership to know all Dang achieved.<br/>\r\n→ Pinnacle AI to remind Admins , Leadership about all Dang achieved.",
        "Title": "Achieved"
    },
    {
        "Id": "dangtotal",
        "Math": "All Dang Total",
        "UseCases": "→ Leadership to know all total Dang.<br/>\r\n→ Pinnacle AI to remind Admins , Leadership about all total Dang.",
        "Title": "Total"
    },
    {
        "Id": "totalgoals",
        "Math": "All Total goals",
        "UseCases": "→ Therapists, Admins, Leadership to know all total goals<br/>\r\n→ Pinnacle AI to remind Therapists,Admins and Leadership about all goals.",
        "Title": "Total"
    },
    {
        "Id": "activegoals",
        "Math": "All Active goals",
        "UseCases": "→ Therapists, Admins, Leadership to know all active goals<br/>\r\n→ Pinnacle AI to remind Therapists,Admins and Leadership about all actove goals.",
        "Title": "Active"
    },
    {
        "Id": "goalspending",
        "Math": "All Pending goals",
        "UseCases": "→ Therapist, Admins, Leadership to know all pending goals. <br/>\r\n→ Pinnacle AI to remind Therapists, Admins , Leadership about all pending goals.",
        "Title": "Pending"
    },
    {
        "Id": "todaypendinggoals",
        "Math": "All Today Pending goals",
        "UseCases": "→ Therapist, Admins, Leadership to know all today goals pending. <br/>\r\n→ Pinnacle AI to remind Therapists, Admins , Leadership about all today goals pending.",
        "Title": "Today Pending"
    },
    {
        "Id": "goalsnotsetnew",
        "Math": "There is no active goal for ongoing service",
        "UseCases": "→ Therapists, Admins, Leadership to know who are not being part of kids empowerment <br/>\r\n→ Pinnacle AI to remind Therapists,Admins and Leadership about goals not set.",
        "Title": "Not Set"
    },
    {
        "Id": "goalreviewed",
        "Math": "Total Goals to be reviewed",
        "UseCases": "→ Therapist, Admins, Leadership to know all goal reviews. <br/>\r\n→ Pinnacle AI to remind Therapists, Admins , Leadership about all goal reviews.",
        "Title": "Reviewed"
    },
    {
        "Id": "goalmet",
        "Math": "All Goals met",
        "UseCases": "→ Therapist, Admins, Leadership to know all goals met. <br/>\r\n→ Pinnacle AI to remind Therapists, Admins , Leadership about all goals met.",
        "Title": "Met"
    },
    {
        "Id": "goalnotmet",
        "Math": "All Goals not met",
        "UseCases": "→ Therapist, Admins, Leadership to know all goals not met. <br/>\r\n→ Pinnacle AI to remind Therapists, Admins , Leadership about all goals not met.",
        "Title": "Not Met"
    },
    {
        "Id": "composcancelled",
        "Math": "All Compos Cancelled",
        "UseCases": "→ Therapist, Admins, Leadership to know compensation cancelled in this month. <br/>\r\n→ Pinnacle AI to  remind Parents,Therapists, Admins , Leadership about all cancelled compensations.",
        "Title:": "Compos Cancelled"
    },
    {
        "Id": "composnotaccomplished",
        "Math": "All Compos not Accomplished",
        "UseCases": "→ Therapist, Admins, Leadership to know compensation not accomplished in this month. <br/>\r\n→ Pinnacle AI to  remind Parents,Therapists, Admins , Leadership about all compensations not accomplished.",
        "Title:": "Compos Not Accomplished"
    },
    {
        "Id": "composfuture",
        "Math": "All Future Compos",
        "UseCases": "→ Therapist, Admins, Leadership to know Future compensation in this month. <br/>\r\n→ Pinnacle AI to  remind Parents,Therapists, Admins , Leadership about all Future compensations.",
        "Title": "Compos Future"
    },
    {
        "Id": "composgiven",
        "Math": "All Compos Given",
        "UseCases": "→ Therapist, Admins, Leadership to know compensation provided in this month. <br/>\r\n→ Pinnacle AI to  remind Parents,Therapists, Admins , Leadership about all compensations.",
        "Title": "Compos Given"
    },
    {
        "Id": "totalcompos",
        "Math": "All Total Compos",
        "UseCases": "→ Therapist, Admins, Leadership to know total compensation in this month. <br/>\r\n→ Pinnacle AI to  remind Parents,Therapists, Admins , Leadership about all compensations.",
        "Title": "Total Compos"
    },
    {
        "Id": "feedbacksgiven",
        "Math": "All Feedbacks Given",
        "UseCases": "→ Therapist, Admins, Leadership to know feedbacks given in this month. <br/>\r\n→ Pinnacle AI to  remind Parents,Therapists, Admins , Leadership about all feedbacks given.",
        "Title": "Parent Given"
    },
    {
        "Id": "homeworkpending",
        "Math": "All HomeWork Pending",
        "UseCases": "→ Therapist, Admins, Leadership to know homework pending in this month. <br/>\r\n→ Pinnacle AI to  remind Parents,Therapists, Admins , Leadership about all homework pending.",
        "Title": "Parent Pending"
    },
    {
        "Id": "compospending",
        "Math": "Total Componsations to be provided",
        "UseCases": "→ Therapist, Admins, Leadership to know compensation provided in this month. <br/>\r\n→ Pinnacle AI to  remind Parents,Therapists, Admins , Leadership about all compensations.",
        "Title": "Pending Compos"
    },
    {
        "Id": "attendanceabsent",
        "Math": "Total Attendance Absent",
        "UseCases": "→ Therapist, Admins, Leadership to know attendances absent in this month. <br/>\r\n→ Pinnacle AI to  remind Parents,Therapists, Admins , Leadership about all attendances absent .",
        "Title": "Absent"
    },
    {
        "Id": "pendingattendance",
        "Math": "Total attendances to be given",
        "UseCases": "→ Therapists, Admins, Leadership to know all pending attendances in current month <br/>\r\n→ Pinnacle AI to remind Therapists,Admins and Leadership about pending attendances.",
        "Title": "Pending Attendance"
    },
    {
        "Id": "attendancepresent",
        "Math": "Total Attendence Present",
        "UseCases": "→ Therapist, Admins, Leadership to know attendances present in this month. <br/>\r\n→ Pinnacle AI to  remind Parents,Therapists, Admins , Leadership about all attendances present.",
        "Title": "Present"
    },
    {
        "Id": "totalattendance",
        "Math": "Total Attendance",
        "UseCases": "→ Therapist, Admins, Leadership to know all attendances in this month. <br/>\r\n→ Pinnacle AI to  remind Parents,Therapists, Admins , Leadership about all attendances.",
        "Title": "Total Attendance"
    },
    {
        "Id": "pollinationclaritypromised",
        "Title": "Promised",
        "Math": "All Promised Pollination",
        "UseCases": "→ Admins, Leadership to know all pollinations which are promised.<br/>\r\n→ Pinnacle AI to remind Admins ,Therapists about promised pollinations."
    },
    {
        "Id": "pollinationclaritycompleted",
        "Title": "Completed",
        "Math": "Total Pollination Completed",
        "UseCases": "→ Admins, Leadership to know pollinations which are completed.<br/>\r\n→ Pinnacle AI to remind Admins ,Therapists about total pollinations completed."
    },
    {
        "Id": "pollinationclarityyetto",
        "Title": "Yet To",
        "Math": "All Pollination Yet To",
        "UseCases": "→ Admins, Leadership to know pollinations yet to.<br/>\r\n→ Pinnacle AI to remind Admins ,Therapists about all pollination to be yet."
    },
    {
        "Id": "pollinationclarityzero",
        "Title": "Zero",
        "Math": "Zero Pollinations",
        "UseCases": "→ Admins, Leadership to know pollinations which are zero.<br/>\r\n→ Pinnacle AI to remind Admins ,Therapists about zero pollinations."
    },
    {
        "Id": "pollinationclaritylessthanthree",
        "Title": "<3",
        "Math": "Pollinations Which are <3",
        "UseCases": "→ Admins, Leadership to know pollinations which are <3.<br/>\r\n→ Pinnacle AI to remind Admins ,Therapists about all pollinations which are <3."
    },
    {
        "Id": "pollinationclaritygreaterthanthree",
        "Title": ">=3",
        "Math": "Pollinations Which are >=3",
        "UseCases": "→ Admins, Leadership to know pollinations which are >=3.<br/>\r\n→ Pinnacle AI to remind Admins ,Therapists about all pollinations which are >=3."
    },
    {
        "Id": "pollinationopty",
        "Title": "Opty",
        "Math": "All Pollination Opty",
        "UseCases": "→ Admins, Leadership to know pollinations which are opty.<br/>\r\n→ Pinnacle AI to remind Admins ,Therapists about all pollinations which are opty."
    },
    {
        "Id": "pollinationoptyst",
        "Title": "ST",
        "Math": "Total ST Pollinations",
        "UseCases": "→ Admins, Leadership to know all speech therapy pollinations.<br/>\r\n→ Pinnacle AI to remind Admins ,Therapists about all speech therapy pollinations."
    },
    {
        "Id": "pollinationoptyot",
        "Title": "OT",
        "Math": "Total OT Pollinations",
        "UseCases": "→ Admins, Leadership to know all occupational therapy pollinations.<br/>\r\n→ Pinnacle AI to remind Admins ,Therapists about all occupational therapy pollinations."
    },
    {
        "Id": "pollinationoptyaba",
        "Title": "ABA",
        "Math": "Total ABA Pollinations",
        "UseCases": "→ Admins, Leadership to know all ABA therapy pollinations.<br/>\r\n→ Pinnacle AI to remind Admins ,Therapists about all ABA therapy pollinations."
    },
    {
        "Id": "pollinationoptyse",
        "Title": "SE",
        "Math": "Total SE Pollinations",
        "UseCases": "→ Admins, Leadership to know all special education pollinations.<br/>\r\n→ Pinnacle AI to remind Admins ,Therapists about all special education pollinations."
    }, {
        "Id": "totalleads",
        "Title": "Total",
        "Math": "Total Leads",
        "UseCases": "→ Admins, Leadership to know all total leads.<br/>\r\n→ Pinnacle AI to remind Leadership,Admins about the total leads."
    },
    {
        "Id": "activeleadsnew",
        "Title": "Active",
        "Math": "All Active Leads",
        "UseCases": "→ Admins, Leadership to know all active leads.<br/>\r\n→ Pinnacle AI to remind Leadership,Admins about the all active leads."
    },
    {
        "Id": "pendingleads",
        "Title": "Pending",
        "Math": "All Pending Leads",
        "UseCases": "→ Admins, Leadership to know all about the all pending leads.<br/>\r\n→ Pinnacle AI to remind Leadership,Admins about the all pending leads."
    },
    {
        "Id": "newleadsnew",
        "Title": "New",
        "Math": "All New Leads",
        "UseCases": "→ Admins, Leadership to know all about thea all new leads.<br/>\r\n→ Pinnacle AI to remind Leadership,Admins about the all new leads."
    },
    {
        "Id": "closedleadsnew",
        "Title": "Closed",
        "Math": "All Closed Leads",
        "UseCases": "→ Admins, Leadership to know about the all closed leads.<br/>\r\n→ Pinnacle AI to remind Leadership,Admins about the all closed leads.."
    },
    {
        "Id": "walkinleads",
        "Title": "WalkIns",
        "Math": "Total WalkIn Leads",
        "UseCases": "→ Admins, Leadership to know about the total walkin leads.<br/>\r\n→ Pinnacle AI to remind Leadership,Admins about the total walkin leads."
    },
    {
        "Id": "assessmentsleads",
        "Title": "Assessments",
        "Math": "All Assessments",
        "UseCases": "→ Admins, Leadership to know about the all assessments done .<br/>\r\n→ Pinnacle AI to remind Leadership,Admins the all assessments done."
    },
    {
        "Id": "admissionleads",
        "Title": "Addmissions",
        "Math": "All Admissions",
        "UseCases": "→ Admins, Leadership to know all about the admissions.<br/>\r\n→ Pinnacle AI to remind Leadership,Admins about the admissions done."
    },
    {
        "Id": "joinedelsewhere",
        "Title": "ElseWhere",
        "Math": "All Admisions Joined Elsewhere",
        "UseCases": "→ Admins, Leadership to know all about the kids joined elsewhere.<br/>\r\n→ Pinnacle AI to remind Leadership,Admins about the kids joined elsewhere."
    },
    {
        "Id": "servicerequest",
        "Title": "Total",
        "Math": "Total Service Requests",
        "UseCases": "→ Leadership to know all raised service requests.<br/>\r\n→ Pinnacle AI to remind Admins , Leadership about all service requests."
    },
    {
        "Id": "servicerequestactive",
        "Title": "Active",
        "Math": "All Active Service Requests",
        "UseCases": "→ Leadership to know all active service requests and resolved by in time.<br/>\r\n→ Pinnacle AI to remind Admins , Leadership about all active requests."
    },
    {
        "Id": "servicerequestpending",
        "Title": "In Process",
        "Math": "All In Process Requests",
        "UseCases": "→ Leadership to know all service requests in process and resolved by in time.<br/>\r\n→ Pinnacle AI to remind Admins , Leadership about all requests in process."
    },
    {
        "Id": "servicerequestwaiting",
        "Title": "Waiting",
        "Math": "All Waiting Requests",
        "UseCases": "→ Leadership to know all service requests in waiting and resolved by in time.<br/>\r\n→ Pinnacle AI to remind Admins , Leadership about all requests in waiting process."
    },
    {
        "Id": "servicerequestresolved",
        "Title": "Resolved",
        "Math": "All Resolved Requests",
        "UseCases": "→ Leadership to know all service requests resolved.<br/>\r\n→ Pinnacle AI to remind Admins , Leadership about all service requests resolved."
    },
    {
        "Id": "servicerequestreopened",
        "Title": "Reopen",
        "Math": "All Reopen Service Requests",
        "UseCases": "→ Leadership to know all service requests reopened.<br/>\r\n→ Pinnacle AI to remind Admins , Leadership about all service requests reopened."
    },
    {
        "Id": "servicerequestrating5",
        "Title": 5,
        "Math": "All 5 * Service Requests",
        "UseCases": "→ Leadership to know all 5 * service requests.<br/>\r\n→ Pinnacle AI to remind Admins , Leadership about all 5 * service requests."
    },
    {
        "Id": "servicerequestrating4",
        "Title": 4,
        "Math": "All 4 * Service Requests",
        "UseCases": "→ Leadership to know all 4 * service requests.<br/>\r\n→ Pinnacle AI to remind Admins , Leadership about all 4 * service requests."
    },
    {
        "Id": "servicerequestrating3",
        "Title": 3,
        "Math": "All 3 * Service Requests",
        "UseCases": "→ Leadership to know all 3 * service requests.<br/>\r\n→ Pinnacle AI to remind Admins , Leadership about all 3 * service requests."
    },
    {
        "Id": "servicerequestrating2",
        "Title": 2,
        "Math": "All 2 * Service Requests",
        "UseCases": "→ Leadership to know all 2 * service requests.<br/>\r\n→ Pinnacle AI to remind Admins , Leadership about all 2 * service requests."
    },
    {
        "Id": "servicerequestrating1",
        "Title": 1,
        "Math": "All 1 * Service Requests",
        "UseCases": "→ Leadership to know all 1 * service requests.<br/>\r\n→ Pinnacle AI to remind Admins , Leadership about all 1 * service requests."
    },
    {
        "Id": "profit",
        "Title": "Profit",
        "Math": "All Profits",
        "UseCases": "→ Leadership to know all Profits.<br/>\r\n"
    },
    {
        "Id": "business",
        "Title": "Business",
        "Math": "All Business",
        "UseCases": "→ Leadership to know all Business for current month.<br/>\r\n"
    },
    {
        "Id": "overallpending",
        "Title": "Pen. All",
        "Math": "All Pending",
        "UseCases": "→ Admins, Leadership to know all pending fee .<br/>\r\n→ Pinnacle AI to remind Parents, Admins , Leadership about all pending Fee Clearance."
    },
    {
        "Id": "pastpending",
        "Title": "Pen. Past",
        "Math": "All Past Pending",
        "UseCases": "→ Admins, Leadership to know all past pending fee .<br/>\r\n→ Pinnacle AI to remind Parents, Admins , Leadership about all past pending Fee Clearance."
    },
    {
        "Id": "paymentpending",
        "Title": "Pen. Month",
        "Math": "All Pending This Month",
        "UseCases": "→ Admins, Leadership to know all advance pending fee for current month .<br/>\r\n→ Pinnacle AI to remind Parents, Admins , Leadership about all pending Fee Clearance for current month."
    },
    {
        "Id": "advancepending",
        "Title": "Pen. Adv",
        "Math": "All Advance Pending",
        "UseCases": "→ Admins, Leadership to know all advance pending fee .<br/>\r\n→ Pinnacle AI to remind Parents, Admins , Leadership about all Adv Fee Clearance."
    },
    {
        "Id": "inflow",
        "Title": "In. All",
        "Math": "All Inflow",
        "UseCases": "→ Leadership to know all inflow for this month.<br/>\r\n"
    },
    {
        "Id": "pastpaid",
        "Title": "In. Past",
        "Math": "All Past Paid",
        "UseCases": "→ Leadership to know all past paid.<br/>\r\n"
    },
    {
        "Id": "paid",
        "Title": "In. Month",
        "Math": "All Paid",
        "UseCases": "→ Leadership to know all paid for thid current month.<br/>\r\n"
    },
    {
        "Id": "advancepaid",
        "Title": "In. Adv.",
        "Math": "All Advance Paid",
        "UseCases": "→ Leadership to know all Advance paid.<br/>\r\n"
    },
    {
        "Id": "outflowreport",
        "Title": "Out. All",
        "Math": "All Outflow Report",
        "UseCases": "→ Leadership to know all Outflow for current month.<br/>\r\n"
    },
    {
        "Id": "salary",
        "Title": "Out. Sal.",
        "Math": "All Salary",
        "UseCases": "→ Leadership to know all salaries for current month.<br/>\r\n"
    },
    {
        "Id": "fixedexpenses",
        "Title": "Out. Fix.",
        "Math": "All Fixed Expenses",
        "UseCases": "→ Leadership to know all fixed expenses.<br/>\r\n"
    },
    {
        "Id": "variableexpenses",
        "Title": "Out. Var",
        "Math": "All Variable Expenses",
        "UseCases": "→ Leadership to know all variable expenses.<br/>\r\n"
    },
    {
        "Id": "discountbusiness",
        "Title": "Discount",
        "Math": "All Discount Business",
        "UseCases": "→ Leadership to know all discount business.<br/>\r\n"
    },
    {
        "Id": "alreadypaid",
        "Title": "Adv. Cleared",
        "Math": "Already paid",
        "UseCases": "→ Leadership to know about already paid fee .<br/>\r\n"
    },
    {
        "Id": "tobefulfilled",
        "Title": "To-be fulfilled",
        "Math": "All To Be Fulfilled",
        "UseCases": "→ Leadership to know all to be fulfilled.<br/>\r\n"
    },
    {
        "Id": "expensesreport",
        "Title": "Expenses",
        "Math": "All Expenses Report",
        "UseCases": "→ Leadership to know all expenses spent for currenrt month.<br/>\r\n"
    },
    {
        "Id": "incentives",
        "Title": "Incentives",
        "Math": "All Incentives",
        "UseCases": "→ Leadership to know all incentives provided.<br/>\r\n"
    },
    {
        "Id": "benifits",
        "Title": "Benefits",
        "Math": "All Benifits",
        "UseCases": "→ Leadership to know all Benifits provoided.<br/>\r\n"
    }

]

function GetLocalStorageByKey(key) {
    try {


        var value = localStorage.getItem(key);

        return value ? JSON.parse(value) : null;

    }
    catch (e) {
        console.log(e);
    }
}

export function GetTablesSyncDateTime() {

    try {

        var obj = {}
        Object.keys(TableLastSyncDateTime).forEach((key, index) => {

            var value = GetLocalStorageByKey(TableLastSyncDateTime[key]);
            if (value) {
                obj[key] = value;
            }

        });

        return obj;

    }
    catch (e) {
        console.log(e);
    }

}


/**Process Data of User Cache DB */
export function ProcessUserData(data, dataStore, aggregate, individualAggregates) {
    try {
        window.globalCacheData = data;
        individualAggregates = individualAggregates || [];

        // Store Aggregates to LOCAL STORAGE
        if (!aggregate) {
            aggregate = JSON.parse(localStorage.getItem("USERMASTERAGGREGATES"));
        }
        else {
            localStorage.setItem("USERMASTERAGGREGATES", JSON.stringify(aggregate));
        }

        //store indivudal aggregates
        if (!individualAggregates || individualAggregates.length == 0) {
            individualAggregates = JSON.parse(localStorage.getItem("USERINDIVIDUALAGGREGATES"));
        }
        else {
            localStorage.setItem("USERINDIVIDUALAGGREGATES", JSON.stringify(individualAggregates));
        }


        data.CurrentAggregateMaster = aggregate;
        data.IndividualAggregates = individualAggregates;

        try {


            if (dataStore) {
                //DispatchFromAppJs
                // Store data in React Store // THIS DOESN'T UPDATES UI
                console.log("DISPATCH 1");
                dataStore.dispatch(StoreUserData(data));
                console.log("DISPATCH 2");

                //DISPATCHING JUST TO UPDATE UI AS ACTUAL DATA PARSING IS TAKING TIME [~2 second], THIS PARSING TAKING 20MS
                var loggedinUser = data.CFUser ? data.CFUser : null
                if (loggedinUser) {
                    dataStore.dispatch(StoreUser(JSON.parse(JSON.stringify(loggedinUser))));
                }
            }
            else {
                DispatchFromAppJs(data, data.CFUser)
            }

        } catch (e) {
            SaveCleintWaufli(e, "Dispatach Failed In ProcessUserData", " ProcessUserData ");
            //ProcessUserData
        }


    }
    catch (e) {
        SaveCleintWaufli(e, "ProcessUserData Failed", " ProcessUserData ");
    }

    // Assign to cache


}


var allMonthShortNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];

export var commonMessageForShare = "";

function GetSalCat(amount) {
    if (amount <= 15000) {
        return "<=15k";
    }

    var start = amount - (amount % 1000);
    var end = start + 1000;
    return (start / 1000) + "K";// + (end / 1000) + "K";
}


function GetRankRYBG(rank, start, second, third, last) {
    return rank <= start && rank != 0 ? "Green" : rank > start && rank <= second ? "Blue" : rank > second && rank <= third ? "Yellow" : "red";
}

var services = ["ST", "BM", "SE", "OT"];
export function FetchLocalData(type, userdata, masterData, currentPersonDetails, completedAnalytics, status, fids, isAdmin, isOwner, isFacilityOwner, discipline, contributions, packagesFilters, responsibilitites, filtertherapists) {
    console.log("FetchLocalData");
    switch (type.toUpperCase()) {
        case "THERAPISTPTIASSESSMENT":
        case "THERAPISTPTIREPORT":
            if (userdata && userdata.Data) {

                var completed = status == "all" ? null : completedAnalytics ? completedAnalytics : $.grep(userdata.Data, function (e) { return e.AT == "ASSESSMENTCOMPLETED" && e.RS != "DELETEACTIVITY" });

                var completedAssessments = completed ? $.map(completed, function (e) { return (e.RDUId[0] + "") }) : [];
                var yesNeedToExecute = completedAssessments.length > 0 ? true : false;


                var data = $.grep(userdata.Data, function (e) { return e.AT == "BOOKASSESSMENT" && e.F23 == "THERAPISTPTI" && (yesNeedToExecute ? (status == "pending" ? completedAssessments.indexOf(e.UId + "") == -1 : completedAssessments.indexOf(e.UId + "") > -1) : true) });

                var mappedData = [];
                if (data) {
                    data.forEach(function (e) {
                        var bossDetails = e.F6 ? e.F6.split("{#}") : [];
                        mappedData.push({
                            'Category': 'Boss',
                            'Name': (bossDetails.length > 2 ? bossDetails[2] : ''),
                            'Call': (bossDetails.length > 3 ? bossDetails[3] : ''),
                            'TOId': e.TOId,
                        });

                    });
                }

                var dataFinal = { "Data": mappedData };
                return dataFinal;
            }
            break;
        case "COWORKERS":

            var facilityData = userdata && userdata.Centers;
            var facilities = facilityData && facilityData.length > 0 ? $.grep(facilityData, function (e) { return fids && fids != 0 && fids.length > 0 ? fids.indexOf(e.Id) > -1 : true }) : [];
            var therapistsDataBlock = [];

            var kidsForTherapists = userdata && userdata.Therapies && userdata.Therapies.length > 0 ? $.grep(userdata.Therapies, function (r) { return r.Status != "INACTIVE" && r.Status != "InActive" && r.RS != "DELETEACTIVITY" && (fids && fids != 0 ? fids.indexOf(r.CenterId) > -1 : true) }) : [];

            /*var therapistRoleId = GetTypeIdByName(data.Types, "Therapist");*/

            /*var therapists = Object.entries(groupBy(userdata.People.filter(f => therapistRoleId == f.RoleId && fids.indexOf(f.CenterId) > -1), "Id")).map(m => m[1][0]);*/

            //var endingRank = Convert.ToInt64(therapists.Where(m => !string.IsNullOrEmpty(m.F30)).OrderByDescending(m => Convert.ToInt64(m.F30)).FirstOrDefault().F30);
            //var startingRank = Convert.ToInt64(therapists.Where(m => !string.IsNullOrEmpty(m.F30)).OrderBy(m => Convert.ToInt64(m.F30)).FirstOrDefault().F30);

            //var total = endingRank - startingRank;
            //var rankFirst = Math.Ceiling(startingRank + total + (total * 0.10));
            //var rankSecond = Math.Ceiling(startingRank + total + (total * 0.50));
            //var rankThird = Math.Ceiling(startingRank + total + (total * 0.90));
            //var facilities = GetAllFacilities();

            var therapists = GetAllTherapistsData(userdata, false, fids);
            var availableServices = getSlotsByData(kidsForTherapists, therapists);

            var datar = GetReportsData('pollinatedata', userdata, true, null, null, null);


            var chartData = {};
            var availableBydiscipline = {};
            var coworkersDes = [];
            if (discipline && discipline.length > 0) {
                coworkersDes = discipline.map(m => GetShortDesignation(m));
            }
            var availableTotal = 0;
            var pollinateTotal = 0;
            var totalEmployees = 0;
            var therapistIds = [];

            var highestsal = therapists.map(m => m.F7).reduce((partialSum, a) => partialSum + a, 0);
            var totalSal = highestsal / 4;
            //console.log(facilities);
            //console.log(highestsal);
            var allFinalFacilitites = [];
            for (var f = 0; f < facilities.length; f++) {
                var facility = JSON.parse(JSON.stringify(facilities[f]));

                facility.TS = therapists.filter(f => f.CenterId == facility.Id);


                var totalServicesOfCenter = 0;
                var totalSalariesByCenter = 0;
                var totalAvailableCountOfTheCenter = 0;
                if (facility && facility.TS) {
                    facility.TS.sort((a, b) => (b.C < a.C ? -1 : 1));

                    totalEmployees += facility.TS.length;
                    for (var i = 0; i < facility.TS.length; i++) {
                        var t = facility.TS[i];
                        t.ASC = availableServices.filter(a => a.S == "available" && a.TherapistId == t.Id).length;
                        discipline = discipline ? discipline.map(m => m.toLowerCase()) : null;

                        if (discipline && discipline.length > 0 && t.Designation && discipline.indexOf(t.Designation.toLowerCase()) == -1) {
                            continue;
                        }

                        var c = t.C > 11 ? ">11" : t.C;
                        if (contributions && contributions.length > 0 && contributions.indexOf(c + "") == -1) {
                            continue;
                        }



                        var therapist = {};
                        therapist.Facility = facility.Name;
                        therapist.Name = t.Name;

                        therapist.Discipline = t.Designation;
                        therapist.TOId = t.Id;
                        therapistIds.push(t.Id);
                        therapist.FId = facility.Id;
                        therapist.Kids = t.C ? t.C : "0";
                        var desc = GetShortDesignation(t.Designation);



                        totalServicesOfCenter += parseInt(t.C);

                        if (availableBydiscipline[desc]) {
                            availableBydiscipline[desc] += parseInt(t.ASC);

                        }
                        else {
                            availableBydiscipline[desc] = parseInt(t.ASC);
                        }

                        totalAvailableCountOfTheCenter += parseInt(t.ASC);

                        totalSalariesByCenter += t.F7;
                        //therapist.Available = t.ASC;
                        if (isOwner || isFacilityOwner) {
                            therapist.Sal = t.F7;

                            therapist.SalCategoryId = GetSalCat(t.SAL);

                            therapist.SalRYBG = t.F7 <= totalSal ? "Green" : t.F7 > totalSal && t.F7 <= totalSal * 2 ? "Blue" : t.F7 > totalSal * 2 && t.F7 <= totalSal * 3 ? "Yellow" : "Red";

                            //   therapist.RankRYBG = t.RU;
                        }
                        therapist.DOJ = t.DOJ && t.DOJ.includes("T") ? t.D.split("T")[0] : t.DOJ;
                        therapist.LID = t.LastHikeDate && t.LastHikeDate.includes("T") ? t.LastHikeDate.split("T")[0] : t.LastHikeDate;

                        var kids = parseInt(t.C);
                        // therapist.Kids = kids;
                        therapist.Contribute = kids >= 11 ? "Green" : (kids >= 9 && kids < 11) ? "Blue" : (kids >= 7 && kids < 9) ? "Yellow" : "Red";



                        // kids >= 11 ? "Above 11" : (kids >= 9 && kids < 11) ? "9 - 10" : (kids >= 7 && kids < 9) ? "7 - 8" : (kids >= 5 && kids < 7) ? "5 - 6" : (kids >= 3 && kids < 5) ? "3 - 4" : (kids >= 1 && kids < 3) ? "1 - 2" : "0";
                        //therapist.Pollinate = therapist.
                        // therapist.F1 = GetShortDesignation(t.F5) + ", " + t.C + " kids";
                        //therapist.Pollinate = therapist.F6.split(',');
                        var serv = t.Pollinate && t.Pollinate.includes(",") ? t.Pollinate.split(',') : t.Pollinate;
                        if (serv) {
                            for (var s = 0; s < services.length; s++) {
                                var val = serv && serv.length > 0 ? $.grep(serv, function (e) { return e.indexOf(services[s]) > -1 })[0] : '';
                                therapist[services[s]] = val && val != '' ? parseInt(val.split(":")[1]) : 0;
                            }
                            therapist.Call = t.Id;
                        }
                        //therapist.F4 = therapist.ASC + " Available";
                        therapistsDataBlock.push(therapist);


                    }
                    var tS = facility.TS ? facility.TS.length : 0;

                    var averageService = totalServicesOfCenter / tS;
                    facility.RYBG = averageService >= 11 ? "Green" : (averageService >= 9 && averageService < 11) ? "Blue" : (averageService >= 7 && averageService < 9) ? "Yellow" : "Red";

                    var fPollinations = datar.filter(a => a.FId == facility.Id);
                    var totalPollination = fPollinations.length;

                    var pollinationsKeys = groupBy(fPollinations, "ShortName");

                    for (var i = 0; i < Object.keys(pollinationsKeys).length; i++) {
                        var key = Object.keys(pollinationsKeys)[i];
                        chartData[key] = pollinationsKeys[key].length;
                    }


                    facility.P = "";
                    var facilitiesPollination = facility.P.split(",");






                    for (var jk = 0; jk < facilitiesPollination.length; jk++) {
                        var se = facilitiesPollination[jk].split(":");
                        if (coworkersDes && coworkersDes.length > 0 && coworkersDes.indexOf(se[0]) == -1) {
                            continue;
                        }
                        // totalPollination += parseInt(se[1]);
                        //if (chartData[se[0]]) {
                        //    chartData[se[0]] += parseInt(se[1]);
                        //}
                        //else {
                        //    chartData[se[0]] = parseInt(se[1]);
                        //}
                    }
                }
                totalAvailableCountOfTheCenter = isNaN(totalAvailableCountOfTheCenter) ? 0 : totalAvailableCountOfTheCenter;
                totalPollination = isNaN(totalPollination) ? 0 : totalPollination;
                facility.ASC = totalAvailableCountOfTheCenter;
                facility.PC = totalPollination;

                availableTotal += parseInt(facility.ASC);
                pollinateTotal += parseInt(facility.PC);
                facility.SalariesRYBG = facility.SAL <= totalSal ? "Green" : facility.SAL <= (2 * totalSal) && facility.SAL > (1 * totalSal) ? "Blue" : facility.SAL <= (3 * totalSal) && facility.SAL > (2 * totalSal) ? "Yellow" : "Red";

                allFinalFacilitites.push(facility);

            }

            //facility.sort((a, b) => (a.TSL < b.TSL ? -1 : 1))
            therapistsDataBlock.sort((a, b) => (a.C < b.C ? -1 : 1));
            kidsForTherapists = kidsForTherapists.filter(f => therapistIds.indexOf(f.TherapistId) > -1);
            var totals = { "Available": availableTotal, "Pollinate": pollinateTotal, "Services": kidsForTherapists.length, "Staff": totalEmployees };
            var dataFinal = { "Data": therapistsDataBlock, "Group": chartData, Services: kidsForTherapists, "AvailableDiscipline": availableBydiscipline, "Totals": totals, "Facilities": allFinalFacilitites };
            return dataFinal;



            break;
        case "EMPOWERINGKIDS":

            var kidsForTherapists = [];
            var facilityData = masterData.Facilities;
            if (userdata.FData) {
                kidsForTherapists = $.grep(userdata.FData, function (r) { return r.AT == "USERSERVICE" && r.S != "INACTIVE" && r.S != "InActive" && r.RS != "DELETEACTIVITY" && (fids && fids != 0 ? fids.indexOf(r.FId) > -1 : true) });
            }
            else {
                kidsForTherapists = $.grep(userdata.Data, function (r) { return r.AT == "USERSERVICE" && r.S != "INACTIVE" && r.S != "InActive" && r.RS != "DELETEACTIVITY" });

            }


            kidsForTherapists.sort((a, b) => (b.F1 < a.F1 ? 1 : -1));

            var dataFInal = [];
            for (var i = 0; i < kidsForTherapists.length; i++) {
                var kid = kidsForTherapists[i];
                var facility = $.grep(facilityData, function (e) { return e.GUId == kid.FId })[0];

                var already = $.grep(dataFInal, function (e) { return e.TOId == kid.TOId })[0];
                if (already) {
                    already.Slots += ", " + kid.F2;
                    already.Service += ", " + kid.RDT;
                    already.Therapists += ", " + kid.F3;
                }
                else {

                    var allServicesOfKids = $.grep(kidsForTherapists, function (e) { return e.TOId == kid.TOId });
                    var d = {

                        "Facility": facility ? facility.N : "",
                        "Name": kid.F2,
                        "TOId": kid.TOId,
                        "Discipline": allServicesOfKids.map(m => m.RDT).join(","),
                        "Slots": allServicesOfKids.map(m => m.F1).join(","),
                        "Therapists": allServicesOfKids.map(m => m.F3).join(","),
                        "Category": GetCurretnSlot(kid.F1),
                        "Util": allServicesOfKids.length >= 4 ? " >= 4" : allServicesOfKids.length <= 4 && allServicesOfKids.length >= 3 ? "3" : allServicesOfKids.length < 3 && allServicesOfKids.length >= 2 ? "2" : allServicesOfKids.length < 2 && allServicesOfKids.length >= 0 ? "<=1" : ""
                    }

                    dataFInal.push(d);
                }
            }
            var dataSend = { "Data": dataFInal };
            return dataSend;
            break;

        case "PINNACLERENEWALOFFER":
            var array = status.split("DDDDDD");
            var date = array[0]
            var s = array.length > 1 ? array[1] : "";



            var AllOffers = $.grep(userdata.FData, function (e) {
                return e.AT && e.AT.toUpperCase() == "PINNACLEOFFER" && e.S == "RENEWALOFFER" && (!s || s == "pending" ? e.F22 != 'fulfilled' : e.F22 == 'fulfilled') && e.F4 == date && (fids && fids != 0 && fids.length > 0 ? fids.indexOf(e.FId) > -1 : true)
                    && (packagesFilters && packagesFilters != 0 && packagesFilters.length > 0 ? packagesFilters.indexOf(e.F12) > -1 : true)
            });



            var mappedData = [];

            var therapists = groupByMultiple(AllOffers, "F17");
            //console.log(therapists);

            var keys = Object.keys(therapists);

            var lengthContributions = {};
            for (var i = 0; i < keys.length; i++) {

                if (!lengthContributions[therapists[keys[i]].length]) {
                    lengthContributions[therapists[keys[i]].length] = [];
                }

                lengthContributions[therapists[keys[i]].length].push(keys[i]);

            }

            console.log(lengthContributions);

            var filterTherapistsByC = [];
            if (null != responsibilitites && responsibilitites.length > 0) {
                for (var i = 0; i < responsibilitites.length; i++) {
                    filterTherapistsByC.push(...lengthContributions[responsibilitites[i]]);
                }
            }

            for (var i = 0; i < AllOffers.length; i++) {


                var d = {};
                var o = AllOffers[i];

                if (discipline && discipline != 0 && discipline.length > 0) {

                    if (!o.F18 || !(o.F18.split(",").filter(f => discipline.indexOf(f.toLowerCase()) > -1)[0])) {
                        continue;
                    }
                }


                if (filterTherapistsByC && filterTherapistsByC.length > 0) {
                    if (!o.F17 || !(o.F17.split(",").filter(f => filterTherapistsByC.indexOf(f) > -1)[0])) {
                        continue;
                    }
                }


                if (filtertherapists && filtertherapists.length > 0) {
                    if (!o.F17 || !(o.F17.split(",").filter(f => filtertherapists.indexOf(f) > -1)[0])) {
                        continue;
                    }
                }


                d.Status = o.F22 == 'fulfilled' ? 'Renewed' : o.F25 ? o.F25 : "N/A";
                d.Facility = o.F13;
                d.Package = o.F12 + " Credits";
                d.Kid = o.F14;
                d.Call = o.TOId;
                d.Discipline = o.F18;
                d.Time = o.F23;
                try {
                    d.Therapist = o.F17 ? o.F17.split(",").map(m => m + " [" + therapists[m].length + "]").join(",") : "";
                } catch (e) {
                    d.Therapist = o.F17;
                }


                d.TOId = o.TOId;

                d.FId = o.FId;
                d.OId = o;
                mappedData.push(d);


            }

            var dataFinal = { "Data": mappedData, "Reponsible": lengthContributions, "Therapists": therapists };
            return dataFinal;



            break;
    }
}

export function GetFacilitiesByType(facilitites, type) {
    if (!facilitites) {
        return [];
    }

    var guids = [3, 14, 15];
    switch (type.toLowerCase()) {
        case "all centers":

            return facilitites.filter(m => m.Category == "Facility" && m.Name != "Kakinada" && m.Name != "Karimnagar" && m.Name != "Nellore");
            break;
        case "all franchises":

            return facilitites.filter(m => m.Category == "Branch");
            break;
        case "all centers+":
            return facilitites.filter(m => m.Category == "Facility" || m.Category == "NoRoyality" || m.Name == "Kakinada");
            break;
        case "all centers++":
            return facilitites.filter(m => m.Category == "Facility" || m.Category == "NoRoyality" || m.Category == "NoRoyalityFacility" || guids.indexOf(m.Id) > -1);
            break;
    }

}

export function GetCOrrectDtaeFormat(dateString) {
    if (!dateString) {
        return "";
    }

    var d = dateString.split("-");
    if (d.length <= 2) {
        return "";
    }

    return new Date(d[2], parseInt(d[1]) - 1, d[0]);
}

export function GetPRRAData(masterdata, userdata, usersettings) {

    console.log("GetPRRAData");
    var dataToReturn = [];
    var CDNPath = "https://www.pinnacleblooms.org/";
    try {
        var userSettings = getUserSettingsValue("PRAACONFIG");
        if (userSettings) {
            dataToReturn = JSON.parse(userSettings);
            if (dataToReturn) {
                for (var i = 0; i < dataToReturn.length; i++) {
                    dataToReturn[i].URLFORNAVIGATION = "https://www.pinnacleblooms.org/PRAA/" + dataToReturn[i].UId;
                    dataToReturn[i].PUBLICURL = "https://www.pinnacleblooms.org/PRAA/" + dataToReturn[i].UId;
                }
            }
        }
        var tempData = [];
        var allCourses = userdata ? $.grep(userdata, function (e) { return (e.AT == "MIRAVERSETANTRUMS" || e.AT == "MIRAVERSECONDITIONS") && e.RS != "DELETEACTIVITY" }) : [];

        if (allCourses && allCourses.length > 0) {
            tempData.push(...allCourses);
        }

        var allAssessments = masterdata && masterdata.MasterData
            ? $.grep(masterdata.MasterData, function (e) {
                return e.AT && e.AT == 'Assessment' && e.SN != null
            }) : [];
        if (allAssessments && allAssessments.length > 0) {
            tempData.push(...allAssessments);
        }

        $.each(tempData, function (key, data) {
            var objToPush = {};
            objToPush.AT = data.AT;
            objToPush.RDT = data.RDT;
            objToPush.RDD = data.RDD;
            if (data.AT == "MIRAVERSETANTRUMS" || "MIRAVERSECONDITIONS") {

                objToPush.F1 = CDNPath + "/Assets/Materials/" + data.UId + ".jpg";
                objToPush.F8 = 1;
                objToPush.UId = data.UId;
                objToPush.URLFORNAVIGATION = "/miraverse?id=" + data.UId + "&type=" + data.AT;
                objToPush.PUBLICURL = "https://www.pinnacleblooms.org/PRAA/" + data.UId;
            }
            ///ImgUrl
            if (data.AT == "Assessment") {

                objToPush.F1 = data.ImgUrl.indexOf('https') > -1 ? data.ImgUrl.replace("https://iqm-nkywabj.stackpathdns.com/", "https://www.internationalqualitymeasurers.org/") + "?v=22" : CDNPath + data.ImgUrl + "?v=12121";
                objToPush.F8 = 1;
                objToPush.URLFORNAVIGATION = "/assessment/" + (data.SN ? data.SN : data.RDT);
                objToPush.PUBLICURL = window.root + "/viewassessments/" + (data.SN ? data.SN : data.RDT) + "/" + data.RDId;
            }
            dataToReturn.push(objToPush);

        });


        return dataToReturn;

    }
    catch (e) {
        console.log(e);
    }
    return dataToReturn;
}

//#region charts
export function GetDistributionchat($currentState, dataFrom, type, byAmount, legendId, method, property, IsPercentage, displayname, isMulitple) {
    byAmount = byAmount || false;
    IsPercentage = IsPercentage || false; isMulitple = isMulitple || false;

    //if (null == data || null == data || typeof (data) == "undefined") {

    //    return;
    //}


    if (!dataFrom || !type) {

        return;
    }




    var $this = this;
    var keys = [];
    var values = [];



    property = property ? property : "Facility";

    var finaldata = $.grep(dataFrom, function (e) { return e[property] != "<b>Total" });

    var facilities = isMulitple ? groupByMultiple(finaldata, property) : groupBy(finaldata, property);
    // $this.clearPushtoReportFilterList("Facility", "Facilities", Object.keys(facilities));

    var data = Object.entries(facilities);// Object.keys(selfThis.state.Facilities);





    var totalAmount = 0;
    if (byAmount) {


        data.sort(function (a, b) {
            return $currentState.sumOfValuesPaid(a[1]) > $currentState.sumOfValuesPaid(b[1]) ? -1 : 1

        });

        var total = $currentState.sumOfValuesPaid(finaldata);
        totalAmount = total;
        for (var i = 0; i < data.length; i++) {

            if (IsPercentage) {

                var per = Math.round($currentState.sumOfValuesPaid(data[i][1]) * 100 / total, 2)
                if (per > 0) {
                    keys.push(facilities[data[i][0]][0][property] + "[" + per + "%]");
                    values.push(per);
                }
            }
            else {
                var amount = $currentState.sumOfValuesPaid(data[i][1]);
                keys.push(facilities[data[i][0]][0][property] + "[" + numbersafterthousand(amount) + "]");
                values.push(amount);
            }
        }
        //$this.clearPushtoReportFilterList("Header", "Headers", keys);
    }
    else {

        data.sort(function (a, b) {
            return a[1].length > b[1].length ? -1 : 1

        });

        //var facilitiesForComments = [];
        for (var i = 0; i < data.length; i++) {

            //if (this.props.MasterData.Facilities && this.props.currentPersonDetails) {
            //    var facilityData = this.props.MasterData.Facilities.filter(function (e) {
            //        return e.N == facilities[data[i][0]][0][property]


            //    })[0];
            //    if (facilityData) {
            //        facilityData["Count"] = data[i][1].length;

            //        facilitiesForComments.push(facilityData);
            //    }

            //}
            if (IsPercentage) {
                var per = Math.round(data[i][1].length * 100 / dataFrom.length, 2);
                if (per > 0) {
                    keys.push(data[i][0] + "[" + per + "%]");
                    values.push(per);
                }
            }
            else {
                var valuefromKey = data[i][1].length;


                keys.push(data[i][0] + "[" + valuefromKey + "]");
                values.push(valuefromKey);
            }
        }
        // CurrentFacilitites = facilitiesForComments;
    }
    // $this.setState({ CurrentFacilitites: facilitiesForComments})

    if (method) {
        method(property, (displayname ? displayname : "Facilities") + (byAmount ? " [ " + numbersafterthousand(totalAmount) + " ]" : ""), keys, null, $currentState);
    }


    //if (byAmount) {
    //    $("#total-counts-matchedrecords").html("[ " + numbersafterthousand(totalAmount) + " ]");
    //}






    var data2return = {
        labels: keys,
        datasets: [{
            label: type,
            data: values,
            backgroundColor: [
                'rgb(0,164,239)',



                'rgb(255,185,0)',
                'rgb(244,114,22)',
                'rgb(224,30,90)',
                'rgb(46, 182, 125)',

                'rgb(255,0,0)',

                'rgb(91,209,215)',
                'rgb(208,148,234)',
                'rgb(127,186,0)',
                'rgb(115,115,115)',
                'rgb(40, 40, 40)',
                'rgb(224,30,90)',
                'rgb(212,237,49)',
                'rgb(224, 30, 90)',
                'rgb(75, 107, 175)',
                'rgb(0, 0, 0)',
                'rgb(88,81,216)',
                'rgb(5, 10, 230)',
                'rgb(193, 53, 132)'
            ],
            borderColor: [
                'rgb(0,164,239)',



                'rgb(255,185,0)',
                'rgb(244,114,22)',
                'rgb(224,30,90)',
                'rgb(46, 182, 125)',

                'rgb(255,0,0)',

                'rgb(91,209,215)',
                'rgb(208,148,234)',
                'rgb(127,186,0)',
                'rgb(115,115,115)',
                'rgb(40, 40, 40)',
                'rgb(224,30,90)',
                'rgb(212,237,49)',
                'rgb(224, 30, 90)',
                'rgb(75, 107, 175)',
                'rgb(0, 0, 0)',
                'rgb(88,81,216)',
                'rgb(5, 10, 230)',
                'rgb(193, 53, 132)'
            ],
            borderWidth: 1
        }]
    }



    return data2return;

}
//#endregion 

// #region change coverphoto
var cPLS = "selectedcoverphoto";
export function SetCoverPhoto(url) {
    localStorage.setItem(cPLS, url);
}




var expandCollpaseLSKey = "expandedcollpased";
function getTodaysDateString() {
    var dt = new Date();
    return dt.getDate() + "-" + dt.getMonth() + "-" + dt.getFullYear();
}
export function GetExpandCollpaseData(expand) {
    var lsValue = localStorage.getItem(expandCollpaseLSKey);
    //lsValue = lsValue ? lsValue : "{}";
    var items = lsValue ? JSON.parse(lsValue) : {};

    items = items ? items : {};
    var dateString = getTodaysDateString();
    var keys = Object.keys(items);
    keys = keys || [];
    for (var i = 0; i < keys.length; i++) {
        // if (items[keys[i]] && items[keys[i]].D != dateString) {
        //     items[keys[i]].S = expand ? true : false;
        // }
        // else {
        //     if (!expand) {
        //         items[keys[i]].S = false;

        //     }
        // }
    }
    return items;
}
export function ExpandCollapse(key, isItUpdate, isitOpened) {
    var items = GetExpandCollpaseData();
    items[key] = items && items[key] ? items[key] : { S: true };
    //var item = items.filter(function (f) { return f.Key == key })[0];
    //item = item ? item : { Key: key,S: true };

    if (isItUpdate) {
        isitOpened = isitOpened || false;
        items[key].S = isitOpened;

        items[key].D = getTodaysDateString();
        localStorage.setItem(expandCollpaseLSKey, JSON.stringify(items));
    }

    return items;




    return true;


}

export function GetCoverPhoto(url, role, user) {
    var image = user && user.F16 ? user.F16 : localStorage.getItem(cPLS, url);
    return image ? image : role ? role.toLowerCase() == "therapist" ? "/images/coverimages/autism-9.jpg" :
        role.toLowerCase() == "facilityowner" ? "/images/coverimages/autism-17.jpg" :
            role.toLowerCase() == "ncc" ? "/images/coverimages/autism-21.jpg" :
                role.toLowerCase() == "owner" ? "/images/coverimages/autism-3.jpg" :
                    role.toLowerCase() == "boss" ? "/images/coverimages/sanjeevani-400.jpg" :
                        role.toLowerCase() == "receptionist" ? "/images/coverimages/autism-15.jpg" :
                            "/images/mirracle-bg-ex2.jpg"
        : "/images/mirracle-bg-ex2.jpg";
}
// #endregion change cover photo


// #region online/offline

export function getPSDate(d) {
    return d.getFullYear() + "-" + (d.getMonth() > 8 ? (d.getMonth() + 1) : "0" + (d.getMonth() + 1)) +
        "-" + (d.getDate() > 9 ? d.getDate() : "0" + d.getDate()) + " " + (d.getHours() > 9 ? d.getHours() : "0" + d.getHours()) + ":" +
        (d.getMinutes() > 9 ? d.getMinutes() : "0" + d.getMinutes()) + ":" +
        (d.getSeconds() > 9 ? d.getSeconds() : "0" + d.getSeconds())
        ;
}
function HandleFailureConnection(callback, cancel) {
    console.log("callback");
    console.log(callback);
    var guid = CreateGuid();
    // Prepare popup buttons why only buttons - at a time we are going to show only one
    var html = ' <input id="' + guid + '" class=" btn-red btn continue-set" style="font-size: 16px;font-family: camphor;color: #fff;width: 50%;margin-left:0;margin-right:0;float: right;" type="button" value="retry" >' +
        '<input id="' + guid + '-cancel" class="btn-red btn continue-set" style="font-size: 16px;font-family: camphor;color: #fff;width: 49%;margin-left:0;margin-right:0;float: left;background: transparent;border: 1px solid #ee3268;color: #ee3268;" type="button" value="cancel">';
    $(".connection-failed-overlay .reject-app-container").html(html);

    $(".connection-failed-overlay .reject-app-container").on('click', '#' + guid, function () {
        //console.log(callback);
        $(".connection-failed-overlay .reject-app-container").off('click', '#' + guid);
        console.log("calling from handle connection failue");
        if (callback) {
            $('.connection-failed-overlay').removeClass("active");
            $(".connection-failed-overlay .reject-app-container").html('');
            callback();
        };
    });
    $(".connection-failed-overlay .reject-app-container").on('click', '#' + guid + "-cancel", function () {
        $(".connection-failed-overlay .reject-app-container").off('click', '#' + guid + "-cancel");
        if (cancel) {
            cancel();
        }
        //cancelConnectionOverlay();
    });
    $('.connection-failed-overlay').addClass("active");
}

function ping(url, callback) {

    const condition = navigator.onLine ? 'online' : 'offline';


    fetch(url, {
        mode: 'no-cors',
    })
        .then(() => {
            callback(true);
        }).catch(() => callback(false))

    return;




}


function getDateByType(type) {
    var currentDate = new Date();


    if (type == 'today') {

        return currentDate;
    }
    else if (type == 'tomorrow') {

        return currentDate;
    }

    else if (type == 'thisweekstart') {
        var firstdayofWeek = new Date(currentDate.setDate(currentDate.getDate() - currentDate.getDay() + 1));
        return firstdayofWeek;
    }
    else if (type == 'thisweekend') {
        var lastdayofWeek = new Date(currentDate.setDate(currentDate.getDate() - currentDate.getDay() + 6));
        return lastdayofWeek;
    }
    else if (type == 'nextweekend') {
        var lastdayofnextWeek = new Date(currentDate.setDate(currentDate.getDate() - currentDate.getDay() + 13));
        return lastdayofnextWeek;
    }
}

function GetMimeByType(type) {

    if (!type) {
        return "";
    }

    switch (type.toLowerCase()) {

        case "gif": return "image/gif";
        case "jpeg": return "image/jpeg";
        case "oga": return "audio/ogg";
        case "ogv": return "video/ogg";
        case "ogx": return "application/ogg";
        case "opus": return "audio/opus";
        case "png": return "image/png";
        case "pdf": return "application/pdf";
        case "xls": return "application/vnd.ms-excel";
        case "xlsx": return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        case "mp4": return "video/mp4";
        case "mp3": return "audio/mpeg";
        case "mpeg": return "video/mpeg";


    }
}

function GetFileDetails(filename) {
    if (!filename) {
        return { "T": "", "M": "" };
    }
    filename = filename.split("?")[0];
    var type = filename.substring(filename.lastIndexOf('.') + 1);
    type = type == "jpg" ? "jpeg" : type;

    var mime = GetMimeByType(type);
    return { "T": type, "M": mime };

}

export function CopyText(text) {
    navigator.clipboard.writeText(text);
    ShowToastMessage("Copied Successfully...");
}

export function NavigatorSharePlayYourStuff(fileName, title, message, shareurl) {
    var fileData = GetFileDetails(fileName);

    if (fileData && fileData.M && (fileName.indexOf("pinnacleblooms.org") > -1)) {


        //var xhr = new XMLHttpRequest();
        //xhr.open("GET", fileName, true);
        //xhr.setRequestHeader('Access-Control-Allow-Origin', '*');
        //xhr.responseType = "blob";
        //xhr.onload = function () {
        //    console.log(this.response);
        //}
        //xhr.send();

        let origin = new URL(window.location.href);
        let domain = (new URL(fileName));

        fileName = fileName.replace(domain.hostname, origin.hostname);


        fetch(fileName, {
            method: 'GET',
            crossorigin: true,
            mode: 'no-cors',
        })
            .then((response) => response.blob())
            .then((myBlob) => {
                // console.log(response);
                // const blob = response.blob();

                console.log(myBlob);
                const file = new File([myBlob], 'share.' + fileData.T, { type: fileData.M });
                console.log(file);
                if (navigator) {

                    navigator.share({
                        title: title,
                        text: message,
                        url: shareurl,
                        files: [file]
                    })
                        .then(() => console.log('Successful share'))
                        .catch((error) => console.log('Error in sharing', error));

                }
                else {
                    showLockedBox("Sorry we are unable to share, Please do reach NCC", "Error", "Okay")
                }
            });
    }
    else if (fileData && fileData.M) {
        fetch("/api/getblob", {

            // Adding method type
            method: "POST",

            // Adding body or contents to send
            body: JSON.stringify({
                image: fileName
            })

            // Adding headers to the request

        })

            // Converting to JSON
            .then(response => response.blob())

            // Displaying results to console
            .then((myBlob) => {
                // console.log(response);
                // const blob = response.blob();

                console.log(myBlob);
                const file = new File([myBlob], 'share.' + fileData.T, { type: fileData.M });
                console.log(file);
                if (navigator) {

                    navigator.share({
                        title: title,
                        text: message,
                        url: shareurl,
                        files: [file]
                    })
                        .then(() => console.log('Successful share'))
                        .catch((error) => console.log('Error in sharing', error));

                }
                else {
                    showLockedBox("Sorry we are unable to share, Please do reach NCC", "Error", "Okay")
                }
            });
    }
    else {
        if (navigator) {

            var d = shareurl ? {
                title: title,
                text: message,
                url: shareurl
            } : {
                title: title,
                text: message
            };
            //showLockedBox("Sorry we are unable to share, Please do reach NCC", "Error", "Okay")
            navigator.share(d)
                .then(() => console.log('Successful share'))
                .catch((error) => console.log('Error in sharing', error));

        }
        else {
            showLockedBox("Sorry we are unable to share, Please do reach NCC", "Error", "Okay")
        }
    }
}

function IsGooglePingAvailable() {
    return new Promise(function (resolve, reject) {
        ping(googlePingUrl, function (boolvalue) {
            // Network Fails
            if (!boolvalue) {
                reject();
            }
            else {
                // online
                resolve();
            }
        });
    });
}



export function HandleOffline(retry, isSailent, cancel, useGstatic, online) {
    try {
        isSailent = isSailent || false;
        // return true;
        useGstatic = useGstatic || false;
        var online;
        if (window.navigator.onLine) {
            if (useGstatic) {
                IsGooglePingAvailable().then(function () {
                    // online
                    if (online) {
                        online();
                    }

                }).catch(function () {

                    if (!isSailent) {
                        // offline
                        HandleFailureConnection(retry, cancel);
                    }
                });
            }
            else {
                if (online) {
                    online();
                }
            }
            return true;
        }
        else {
            if (!isSailent) {
                // offline
                HandleFailureConnection(retry, cancel);
            }
        }
        return false;
    } catch (e) {
        if (online) {
            online();
        }
        return true;
    }
}
//#endregion

export async function sendwatimessageviaworker(payload, curUser) {
    try {
        var dataURL = 'https://pbn-planetscale-message-process.kgv.workers.dev/';
        let myrequest = new Request(dataURL);
        var model = {};
        model.PayLoad = payload;
        model.CurrentUser = curUser;
        const init = {
            body: JSON.stringify(model),
            mode: 'no-cors',
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
        }

        const response = await fetch(dataURL, init)
        // .then(response => response.json())
        // .then(json => console.log(json))
        // .catch(e => console.error(e));
        console.log("payload for telegram")
        //var resp = await response.text();
        if (response) {

            showLockedBox("Successfully Sent", "Info", "ok");
        }
        else {
            console.log("NOT SENT");
        }
    }
    catch (e) {

    }
}


// #region 
export function PrepareBookAssessment(activity) {
    try {
        console.log("PrepareBookAssessment");

        var state = getStore().getState();

        var obj = new Object();
        var a = new Array();
        a.push(activity.UId);
        obj.F7 = activity.MRP;// amount;
        obj.F5 = state.U.F6;
        obj.F1 = activity.ImgUrl;
        obj.F8 = 0;
        obj.TOId = state.U.UId;
        obj.RDID = activity.RDID;
        obj.RDUId = a;
        obj.RDD = activity.RDD;
        obj.RDT = activity.RDT;
        obj.S = "moneynotneeded";
        obj.AT = "BOOKASSESSMENT";
        // Name + Lead + age + Gender + Faility name
        obj.F3 = state.U.RDT + "{#}" + "" + "{#}" + "" + "{#}" + state.U.S + "{#}" + "" + "{#}" + state.U.F1;
        return obj;
    }
    catch (e) {
        console.log(e);
    }
}

export function CreateBookAssessmentFromGoal(goal, masterData, therapist) {
    if (!goal) {
        return;
    }


    var value = getUserSettingsValue("GoalAssessmentConfig");
    if (!value) {
        return;
    }
    var newId = masterData.Therapies.filter(e => e.Id == goal.TherapyId)[0];
    var newName = masterData.Types.filter(e => e.Id == newId.TypeId)[0];
    var currentassessment = masterData.Types.filter((e) => e.Category == "ASSESSMENT")


    var matchedId = $.grep(value.split("{#}"), function (e) { return e.indexOf(newName.Name) > -1 })[0];
    if (!matchedId) {
        return;
    }

    var activity = currentassessment.filter(e => e.F2 == matchedId.split(":")[1].toLowerCase())[0]
    // var activity = $.grep(masterData.MasterData, function (e) { return e.AT && e.AT.toUpperCase() == "ASSESSMENT" && e.RDId.toLowerCase() == matchedId.split(":")[1].toLowerCase() })[0];
    if (null == activity) {
        return;
    }



    var obj = new Object();
    //var a = new Array();
    //a.push(activity.UId);
    obj.AssessmentTypeId = activity.Id;// amount;
    // obj.F5 = state.U.F6;
    obj.ParentId = newId.BossId;
    // obj.F8 = 0;
    obj.TherapyId = goal.TherapyId;
    //obj.RDID = [activity.RDId];
    // obj.RDUId = a;
    obj.Name = activity.Name;
    obj.Status = "PENDING";
    obj.IQMId = activity.F2;
    //obj.AG = [goal.TOId, therapist.OGID, goal.FId, PBNGID]
    // obj.AT = "BOOKASSESSMENT";
    //obj.F10 = "GOAL";
    //obj.F11 = goal.UId + "";
    //obj.FId = goal.FId;
    //obj.FId = goal.FId;
    obj.CBPI = therapist.Id;
    // obj.CBPN = therapist.RDT;
    // Name + Lead + age + Gender + Faility name
    // obj.F3 = goal.F3 + "{#}" + "" + "{#}" + "" + "{#}" + state.U.S + "{#}" + "" + "{#}" + state.U.F1;
    //var facilityData = masterData.Facilities;

    //var facility = !goal.FId ? null : $.grep(facilityData, function (e) { return e.GUId == goal.FId + "" })[0];


    if (therapist) {
        var designation = "";
        if (therapist.F5) {
            var userDetails = therapist.F5.split("{#}");

            designation = userDetails[0];
        }

        //obj.F6 = therapist.OGID + "{#}" + designation + "{#}" + therapist.RDT + "{#}" + therapist.F1;

    }
    //obj.F12 = null == facility ? "" : facility.N;
    // obj.F3 = "SERVERWILLUPDATE{#}{#}{#}{#}{#}{#}{#}";
    // "F6": "20709089888{#}Behavioural Therapist{#}Madasi Jessy Diayana{#}9121388267",
    return obj;

}
// #endregionv

// Accepts the array and key
export function groupBy(array, key, isLower) {
    // Return the end result
    isLower = isLower || false;
    return array.reduce((result, currentValue) => {
        // If an array already present for key, push it to the array. Else create an array and push the object
        if (currentValue && currentValue[key]) {
            if (isLower) {
                (result[currentValue[key].toLowerCase()] = result[currentValue[key].toLowerCase()] || []).push(
                    currentValue
                );
            }
            else {
                (result[currentValue[key]] = result[currentValue[key]] || []).push(
                    currentValue
                );
            }
        }
        // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
        return result;
    }, {}); // empty object is the initial value for result object
}

export function groupByMultiple(array, key, isLower) {
    // Return the end result
    isLower = isLower || false;
    return array.reduce((result, currentValue) => {
        // If an array already present for key, push it to the array. Else create an array and push the object
        if (currentValue && currentValue[key]) {
            currentValue[key] = currentValue[key] + "" ? currentValue[key] : "";
            var multiple = (currentValue[key] + "").split(",");
            for (var i = 0; i < multiple.length; i++) {
                var value = multiple[i];
                if (value) {
                    value = value.trim();
                    if (isLower) {
                        (result[value.toLowerCase()] = result[value.toLowerCase()] || []).push(
                            currentValue
                        );
                    }
                    else {
                        (result[value] = result[value] || []).push(
                            currentValue
                        );
                    }
                }
            }

        }
        // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
        return result;
    }, {}); // empty object is the initial value for result object
}

export function groupByWithHypen(array, key, isLower) {
    // Return the end result
    array = JSON.parse(JSON.stringify(array));
    isLower = isLower || false;
    return array.reduce((result, currentValue) => {
        // If an array already present for key, push it to the array. Else create an array and push the object
        if (currentValue && currentValue[key]) {
            currentValue[key] = currentValue[key].toLowerCase().indexOf("others") > -1 ? currentValue[key].split("-")[0] : currentValue[key];
            if (isLower) {
                (result[currentValue[key].toLowerCase()] = result[currentValue[key].toLowerCase()] || []).push(
                    currentValue
                );
            }
            else {
                (result[currentValue[key]] = result[currentValue[key]] || []).push(
                    currentValue
                );
            }
        }
        // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
        return result;
    }, {}); // empty object is the initial value for result object
}


export function getUserSettingsValue(key) {
    var configJsonString = localStorage.getItem("UserSettings");

    if (configJsonString) {
        var settings = JSON.parse(configJsonString).filter(function (e) { return e.Name == key })[0];
        if (settings) {
            return settings.Value;
        }
    }
    return "";
}
export function getUserRole() {
    try {
        var jsonString = localStorage.getItem("UserRoles");

        if (jsonString) {
            var rolesList = JSON.parse(jsonString);
            var role = rolesList.some(function (e) { return e.toLowerCase() == "ccc" }) ? "NCC" :
                rolesList.some(function (e) { return e.toLowerCase() == "receptionist" }) ? "Receptionist" : rolesList.some(function (e) { return e.toLowerCase() == "manager" }) ? "Manager" : rolesList.some(function (e) { return e.toLowerCase() == "owner" }) ? "Owner" : rolesList.some(function (e) { return e.toLowerCase() == "facilityowner" }) ? "FacilityOwner" : rolesList.some(function (e) { return e.toLowerCase() == "chieftherapist" }) ? "chieftherapist" : rolesList.some(function (e) { return e.toLowerCase() == "therapist" }) ? "therapist" : "boss";

            return role;
        }
        else {
            return "boss";
        }
    } catch (e) {
        console.error("error in reading clientype from local storage...");
        console.log(e);

        return "";
    }
}

export const isNullOrEmpty = (value) => {

    if (!value || value == "undefined" || null == value || value == "" || value == typeof ("undefined") || $.isEmptyObject(value) || value.length <= 0) {
        return true;
    }

    return false;
}

export function getUserToken() {
    var token = ""
    try {
        token = cookie.load('validatorauth-s');

        if (!token) {
            token = localStorage.getItem("validatorauth-s");
        }

    } catch (e) {
        //console.log("error in reading token from cookie...");
        //console.log(e);
        token = localStorage.getItem("validatorauth-s");
    }

    return token;
}

export function getFastCommentsSSO(user) {
    var fastCommentsObj = {};
    try {
        fastCommentsObj.tenantId = "Hv3JnFStbE";
        var image = user && user.IsProfileSet == 1 ? ('https://images.pinnacleblooms.org/images/ProfileImages/' + user.Id + '.jpg?v=' + CreateGuid()) : "https://mirracle.pinnacleblooms.org/images/logos/pinnacle-logo-amblum-48.png";
        if (user) {
            var email = user.EmailId ? user.EmailId.split(',')[0] : "";
            fastCommentsObj.simpleSSO = { "id": user.Id.toString(), "username": user.Name, "email": email && email.length > 1 ? email : user.Id + "_mirracle@gmail.com", "avatarSrc": image, "avatar": image, "websiteUrl": "https://mirracle.pinnacleblooms.org/" }
        }
        else {
            fastCommentsObj.simpleSSO = {};
        }

        return fastCommentsObj;
    } catch (err) {
        console.log("Error in getFastCommentsSSO : " + err);
    }
}

export function getCurrentDateTime() {

    var currentTime = new Date();

    var currentOffset = currentTime.getTimezoneOffset();

    var ISTOffset = 330; // IST offset UTC +5:30

    var ISTTime = new Date(currentTime.getTime() + (ISTOffset + currentOffset) * 60000);

    return ISTTime;
}

export const shareViaWeb = function () {

}

export const saveAs = (uri, filename) => {
    saveFile(uri, filename);
}

export const GetDiscountPercentage = function (totalAmount, disCountAmout) {
    return getCouponAmount(totalAmount, disCountAmout);

}
export const LoadGuestHandler = function (url, isAuthNeeded, title) {
    return loadGuestHandler(url, isAuthNeeded, title);
}
export const GetRedirectionURL = function (urltype, user, role, openurl, fid) {
    fid = fid || null;
    role = typeof role != "string" ? null : role;
    openurl = typeof openurl != "boolean" ? null : openurl;
    return getRedirectionURL(urltype, user, role, openurl, fid);
}



export const GetCouponAmount = function (totalAmount, percentage) {
    return getCouponAmount(totalAmount, percentage);

}

export const StoreChanakyaInLs = function (activity, config) {
    try {
        this.IsSavingChankya = activity;
        switch (config.toLowerCase()) {
            case "bookmark":
                this.BookMarksData = JSON.parse(localStorage.getItem(this.lsCBMD));
                this.BookMarksData = this.BookMarksData ? this.BookMarksData : [];

                this.BookMarksData.push(activity.Id);
                this.setState({ BookMarksData: this.BookMarksData, BookMarks: this.BookMarksData });
                localStorage.setItem(this.lsCBMD, JSON.stringify(this.BookMarksData));

                break;
            case "love":

                this.LoveData = JSON.parse(localStorage.getItem(this.lsCLD));
                this.LoveData = this.LoveData ? this.LoveData : [];
                this.LoveData.push(activity.Id);
                this.setState({ LoveData: this.LoveData, Favorites: this.LoveData });
                localStorage.setItem(this.lsCLD, JSON.stringify(this.LoveData));

                break;
            case "unbookmark":
                this.BookMarksData = JSON.parse(localStorage.getItem(this.lsCBMD));
                this.BookMarksData = this.BookMarksData ? this.BookMarksData : [];

                this.BookMarksData = $.grep(this.BookMarksData, function (e) { return e != activity.Id });
                this.setState({ BookMarksData: this.BookMarksData, BookMarks: this.BookMarksData });
                localStorage.setItem(this.lsCBMD, JSON.stringify(this.BookMarksData));

                break;
            case "unlove":
                this.LoveData = JSON.parse(localStorage.getItem(this.lsCLD));
                this.LoveData = this.LoveData ? this.LoveData : [];
                this.LoveData = $.grep(this.LoveData, function (e) { return e != activity.Id });
                this.setState({ LoveData: this.LoveData, Favorites: this.LoveData });
                localStorage.setItem(this.lsCLD, JSON.stringify(this.LoveData));
                break;
        }


    } catch (e) {
        console.log(e);
    }
}

export const ValidateDateInputs = (inputs) => {
    var ArrayOfErrorMsg = [];
    ArrayOfErrorMsg = inputs.split("{#}");
    if (ArrayOfErrorMsg != [] && ArrayOfErrorMsg.length > 0) {
        return false;
    } else {
        return true;
    }
    return false;
}
export const ValidateInputsOverlay2 = (tabId) => {
    var ArrayOfErrorMsg = [];
    try {
        ArrayOfErrorMsg = InputValidatorReturnObject(tabId);
        ResetErrorvalidation(ArrayOfErrorMsg);

        if (ArrayOfErrorMsg != [] && ArrayOfErrorMsg.length > 0) {

            if (ArrayOfErrorMsg.length > 20) {
                $('.validation-verify-overlay .status-msg').addClass('lotdatascrolflow');
            }
            else {
                $('.validation-verify-overlay .status-msg').removeClass('lotdatascrolflow');
            }

            var MessagewithHTMLTags = '';
            //console.log('sa:' + JSON.stringify(ArrayOfErrorMsg));
            $.each(ArrayOfErrorMsg, function (index, value) {
                try {
                    MessagewithHTMLTags += "<div id='" + value.id + "'> <b>&nbsp;" + ++index + ".&nbsp;</b>" + value.msg + "</div>\n\n";
                    $("span" + value.id).addClass("active");
                    $("span" + value.id).removeClass("no-display");
                    $("input" + value.id).addClass("caseerror");
                    $("select" + value.id).addClass("caseerror");
                    $("textarea" + value.id).addClass("caseerror");
                    //console.log(value.msg + ": :" + value.id);
                } catch (e) {
                    console.log(e.message);
                }
            });

            //if (overlayRequired) {
            //    ShowValidationStatusOverlay(MessagewithHTMLTags);
            //}

            return false;
        } else {
            return true;
        }

    } catch (e) {
        console.log(JSON.stringify(e));
    }
    return false;
}

export const showConfirmBoxWithCancel = (message, header, buttonvalue, isItError, callback) => {
    showConfirmBoxWithCancel2(message, header, buttonvalue, isItError, callback);
}

export const ShowToastMessage = (message, timeout, type) => {
    ToastMessage(message, timeout, type);
}



export const IsApp = (type) => {
    return (type && (type.toLowerCase().startsWith("ios") || type.toLowerCase().startsWith("android") || type.toLowerCase() == "ios" || type.toLowerCase() == "android"))
}

export const IsAndroid = (type) => {
    return (type && (type.toLowerCase().startsWith("android") || type.toLowerCase() == "android"))
}

export const IsIOS = (type) => {
    return (type && (type.toLowerCase().startsWith("ios") || type.toLowerCase() == "ios"))
}

export const getMobileOS = () => {
    return getMobileOperatingSystem();
}

export const getUsageType = () => {
    return getUsageTypeFromLS();
}

export const IsAppTypePro = () => {
    return IsProType();
}



export const showLockedBox = (message, header, buttonvalue, isItError, callback, image) => {
    showLockedBoxMessage(message, header, buttonvalue, isItError, callback, image);
}

export const ValidatePayload = (payload) => {
    return ValidatePayLoad(payload);
}

export const getDateTime = (date) => {
    return getTimeDay(date);
}

export const getPublishedDateFormat = (date) => {

    var param1 = new Date();
    var start_actual_time1 = new Date(date);

    var start_actual_time = Date.parse(start_actual_time1);//start_actual_time1.setMinutes(start_actual_time1.getMinutes() - 330);
    var epochTime = Date.parse(param1);
    // alert(start_actual_time + ' ' + end_actual_time);
    var diff = epochTime - start_actual_time;

    var diffSeconds = diff / 1000;
    var HH = parseInt(Math.floor(diffSeconds / 3600));
    var MM = parseInt(Math.floor(diffSeconds % 3600) / 60);

    if (HH < 1) {
        if (MM <= 1) {
            return "Few Seconds ago";
        }
        else {
            return MM + " Minutes ago";
        }
    }
    else if (HH < 23) {
        return HH + " Hours ago";
    }
    else if (HH > 23 && HH < 36) {
        return "Yesterday";
    }
    else if (HH > 36) {
        var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        var dayFs = Math.floor(HH / 24);
        // console.log(dayFs);
        if (dayFs > 365) {
            var year = dayFs / 365;
            return year.toFixed(1) + "  YEAR AGO";
        }
        return Math.floor(HH / 24) + ' DAYS AGO'; //+  days[start_actual_time1.getDay()];
    }

}

export function DurationInDays(t1, isAdd) {
    // console.log(t1);
    isAdd = isAdd || false;
    let d = ((isAdd ? new Date(t1).setHours(24) : new Date(t1)) - new Date());
    //console.log(d);


    var diffSeconds = d / 1000;
    var HH = parseInt(Math.floor(diffSeconds / 3600));
    var MM = parseInt(Math.floor(diffSeconds % 3600) / 60);
    var dd = Math.floor(HH / 24);

    //let weekdays = Math.floor(d / 1000 / 60 / 60 / 24 / 7);
    //let days = Math.floor(d / 1000 / 60 / 60 / 24 - weekdays * 7);
    //let hours = Math.floor(d / 1000 / 60 / 60 - weekdays * 7 * 24 - days * 24);
    //let minutes = Math.floor(d / 1000 / 60 - weekdays * 7 * 24 * 60 - days * 24 * 60 - hours * 60);
    //let seconds = Math.floor(d / 1000 - weekdays * 7 * 24 * 60 * 60 - days * 24 * 60 * 60 - hours * 60 * 60 - minutes * 60);
    //let milliseconds = Math.floor(d - weekdays * 7 * 24 * 60 * 60 * 1000 - days * 24 * 60 * 60 * 1000 - hours * 60 * 60 * 1000 - minutes * 60 * 1000 - seconds * 1000);

    //let t = {};
    //['weekdays', 'days', 'hours', 'minutes', 'seconds', 'milliseconds'].forEach(q=>{ if (eval(q)>0) { t[q] = eval(q); } });


    return dd;
}

export function LeftDuration(t1, isAdd) {
    // console.log("t1");
    isAdd = isAdd || false;

    let d = ((isAdd ? new Date(t1).setHours(24) : new Date(t1)) - new Date());
    //  console.log(d);


    var diffSeconds = d / 1000;
    var HH = parseInt(Math.floor(diffSeconds / 3600));
    var MM = parseInt(Math.floor(diffSeconds % 3600) / 60);
    var dd = Math.floor(HH / 24);

    let weekdays = Math.floor(d / 1000 / 60 / 60 / 24 / 7);
    let days = Math.floor(d / 1000 / 60 / 60 / 24 - weekdays * 7);
    let hours = Math.floor(d / 1000 / 60 / 60 - weekdays * 7 * 24 - days * 24);
    let minutes = Math.floor(d / 1000 / 60 - weekdays * 7 * 24 * 60 - days * 24 * 60 - hours * 60);
    let seconds = Math.floor(d / 1000 - weekdays * 7 * 24 * 60 * 60 - days * 24 * 60 * 60 - hours * 60 * 60 - minutes * 60);
    let milliseconds = Math.floor(d - weekdays * 7 * 24 * 60 * 60 * 1000 - days * 24 * 60 * 60 * 1000 - hours * 60 * 60 * 1000 - minutes * 60 * 1000 - seconds * 1000);

    //let t = {};
    //['weekdays', 'days', 'hours', 'minutes', 'seconds', 'milliseconds'].forEach(q=>{ if (eval(q)>0) { t[q] = eval(q); } });


    return dd + " days " + hours + " hours left";
}


export const validationError = (event) => {
    validation(event);
}

export const GetTimeStamp = (data) => {
    //console.log("GetTimeStamp===");
    return getTimeStamp(data);
}

export const GetTimeStampfromTime = (time, add45) => {
    //console.log("GetTimeStamp===from time" + time);
    return getTimeStampfromTime(time, add45);
}

export const GetMonthNamefromDate = (date) => {
    return getMonthNamefromDate(date);
}

export const GetTimeSpan = (date) => {
    return getTimeSpan(date);
}

export const GetDueMessage = (date) => {
    return getDueMessage(date);
}
export const DynamicSort = (property) => {
    return dynamicSort(property);
}

export const convertJsonDateToDate = (data) => {
    //console.log("GetTimeStamp===");
    return convertJsonDateToDate1(data);
}

export const receivePayment = (invoice, $index) => {
    //console.log("GetTimeStamp===");
    return receivePayment(invoice, $index);
}
export const checkToday = (date) => {
    return isToday(date);
}
export const checkTomorrow = (date) => {
    return isTomorrow(date);
}

export const GetAggregateValue = (isleader) => {
    return getAggregateValue(isleader);
}




export const numbersafterthousand = (x) => {
    return Numbersafterthousand(x);
}

export const formatAMPM = (time) => {
    return FormatAMPM(time);
}

export const numberWithCommas = (x) => {
    return NumberWithCommas(x);
}

export const GetJoiningDate = (date) => {
    try {
        //console.log("date=" + date);
        if (!date) {
            return;
        }
        var nDate = new Date(date);
        return (((allMonthShortNames[(nDate.getMonth())])) + " " + nDate.getUTCFullYear());
    } catch (e) {

    }
}
export const DateFromDateTime = (date) => {
    return dateFromDateTime(date);
}
export const DateFromDateTimeWithTime = (date) => {
    return dateFromDateTimeWithTime(date);
}
export const isValidDate = (date) => {
    return isDateValid(date);
}
export const CheckDateBetween = (dateF, dateTo, checkDate) => {
    return checkDateBetween(dateF, dateTo, checkDate);
}
function padTo2Digits(num) {
    return num.toString().padStart(2, '0');
}

export function PSdateFormate(date) {
    return (
        [
            date.getFullYear(),
            padTo2Digits(date.getMonth() + 1),
            padTo2Digits(date.getDate()),
        ].join('-') +
        ' ' +
        [
            padTo2Digits(date.getHours()),
            padTo2Digits(date.getMinutes()),
            padTo2Digits(date.getSeconds()),
        ].join(':')
    );
}
export const GetDateFormat = (date) => {
    return GetDateFormatValue(date);
}

export const GetTimeFormat = (date) => {
    return GetTimeFormatValue(date);
}


export const AddDays = (date, days) => {
    return addDays(date, days);
}

export const CreateNewGuid = () => {

    try {
        return CreateGuid()
    } catch (e) {
        console.log(JSON.stringify(e));
    }
}

function getCouponAmount(totalAmount, percentage) {
    var amount = (totalAmount * percentage) / 100;;

    return amount
}

/**
 * Function to sort alphabetically an array of objects by some specific key.
 * 
 * @param {String} property Key of the object to sort.
 */
function dynamicSort(property) {
    var sortOrder = 1;

    if (property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }

    return function (a, b) {
        if (sortOrder == -1) {
            return b[property].localeCompare(a[property]);
        } else {
            return a[property].localeCompare(b[property]);
        }
    }
}
function addDays(date, days) {
    var one_day = 1000 * 60 * 60 * 24;
    return new Date(date.getTime() + (days * one_day));
}
function convertJsonDateToDate1(jsonDate) {
    var strDate = new Date(jsonDate).toISOString().split("T")[0];
    var time = getTime(jsonDate);

    return strDate + " " + getTimeStamp(new Date(jsonDate));
}


function ValidatePayLoad(payLoad) {
    try {
        let orginalFields = [
            { "Field": "AT", "Type": "string" },
            { "Field": "Id", "Type": "string" },
            { "Field": "CBPI", "Type": "number" },
            { "Field": "CBPN", "Type": "string" },
            { "Field": "CDT", "Type": "date" },
            { "Field": "MG", "Type": "Array" },
            { "Field": "AG", "Type": "Array" },
            { "Field": "RDT", "Type": "string" },
            { "Field": "RDD", "Type": "string" },
            { "Field": "RS", "Type": "string" },
            { "Field": "RDID", "Type": "string" },
            { "Field": "RDUId", "Type": "Array" },
            { "Field": "UId", "Type": "number" },
            { "Field": "TOId", "Type": "number" },
            { "Field": "OGID", "Type": "number" },
            { "Field": "S", "Type": "string" },
            { "Field": "FDT", "Type": "date" },
            { "Field": "TDT", "Type": "date" },
            { "Field": "UDT", "Type": "date" },
            { "Field": "F1", "Type": "string" },
            { "Field": "F2", "Type": "string" },
            { "Field": "F3", "Type": "string" },
            { "Field": "F4", "Type": "string" },
            { "Field": "F5", "Type": "string" },
            { "Field": "F6", "Type": "string" },
            { "Field": "F7", "Type": "number" },
            { "Field": "F8", "Type": "number" },
            { "Field": "F9", "Type": "number" },
            { "Field": "F10", "Type": "string" },
            { "Field": "F11", "Type": "string" },
            { "Field": "O1", "Type": "object" },
            { "Field": "O2", "Type": "object" },
            { "Field": "O3", "Type": "object" },
            { "Field": "O4", "Type": "object" },
            { "Field": "FId", "Type": "number" }
        ];

        for (let field in payLoad) {
            var val = orginalFields.filter(x => x.Field == field);

            if (val && val.length > 0) {
                if ((val[0].Type == "string") && !payLoad[field]) {
                    payLoad[field] = "";
                }
                else if (val[0].Type == "number" && !payLoad[field]) {
                    payLoad[field] = 0;
                }
                else if ((val[0].Type == "Array") && !Array.isArray(payLoad[field])) {
                    payLoad[field] = [];
                }
                else if (val[0].Type == "date") {
                    var fdTimetamp = Date.parse(payLoad[field]);

                    if (isNaN(fdTimetamp)) {
                        payLoad[field] = "0001-01-01T00:00:00.000Z";
                    }
                }
            }
        }

    } catch (e) {
        console.log(e);
    }
    return payLoad;
}


export function isRUToday(someDate) {
    try {
        if (!someDate) {
            return false;
        }

        //console.log(someDate.split("T")[0]);

        someDate = new Date(someDate.split("T")[0])
        var date = new Date();
        var d = date.getDay() == 6 ? 1 : date.getDay() == 0 ? 2 : 0;
        // console.log(date.setDate(date.getDate() - d));
        // date.setDate(date.getDate() - d);// new Date();
        return someDate.getDate() == date.getDate() &&
            someDate.getMonth() == date.getMonth() &&
            someDate.getFullYear() == date.getFullYear()

    } catch (e) {
        console.log("Error in isToday : " + e);
        return false;
    }
}


function isToday(someDate) {
    try {
        if (!someDate) {
            return false;
        }

        //console.log(someDate.split("T")[0]);

        someDate = someDate && someDate.includes("T") ? new Date(someDate.split("T")[0]) : new Date(someDate);
        var date = new Date();
        var d = date.getDay() == 6 ? 1 : date.getDay() == 0 ? 2 : 0;
        // console.log(date.setDate(date.getDate() - d));
        date.setDate(date.getDate() - d);// new Date();
        return someDate.getDate() == date.getDate() &&
            someDate.getMonth() == date.getMonth() &&
            someDate.getFullYear() == date.getFullYear()

    } catch (e) {
        console.log("Error in isToday : " + e);
        return false;
    }
}

function isTomorrow(someDate) {
    if (!someDate) {
        return false;
    }

    someDate = someDate && someDate.includes("T") ? new Date(someDate.split("T")[0]) : new Date(someDate);
    //someDate = new Date(someDate);
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return someDate.getDate() == tomorrow.getDate() &&
        someDate.getMonth() == tomorrow.getMonth() &&
        someDate.getFullYear() == tomorrow.getFullYear()
}

function checkDateBetween(dateFrom, dateTo, dateCheck) {
    try {
        var check = new Date(dateCheck.getFullYear(), dateCheck.getMonth(), dateCheck.getDate());
        //  + "-" + (new Date(dateCheck).getMonth() + 1) + "-" + new Date(dateCheck).getFullYear()
        return dateFromSDateTime(dateTo) >= check && dateFromSDateTime(dateFrom) <= check;


        var from = new Date(dateFrom).getDate() + "-" + (new Date(dateFrom).getMonth() + 1) + "-" + new Date(dateFrom).getFullYear();  // -1 because months are from 0 to 11
        var to = new Date(dateTo).getDate() + "-" + (new Date(dateTo).getMonth() + 1) + "-" + new Date(dateTo).getFullYear();
        var check = new Date(dateCheck).getDate() + "-" + (new Date(dateCheck).getMonth() + 1) + "-" + new Date(dateCheck).getFullYear();
        return check >= from && check <= to;
    } catch (e) {

    }
}
function getTimeStampfromTime(time, add45) {
    if (!time) {
        return;
    }
    var time_part_array = time.split(":");

    var ampm = 'AM';

    if (add45) {
        time_part_array[1] = parseInt(time_part_array[1]) + 45;
        if (time_part_array[1] >= 60) {
            time_part_array[1] = parseInt(time_part_array[1]) - 60;
            time_part_array[0] = parseInt(time_part_array[0]) + 1;
            time_part_array[0] = time_part_array[0] < 9 ? "0" + time_part_array[0] : time_part_array[0];
            time_part_array[1] = time_part_array[1] < 9 ? "0" + time_part_array[1] : time_part_array[1];
        }
    }
    if (time_part_array[0] >= 12) {
        ampm = 'PM';
    }

    if (time_part_array[0] > 12) {
        time_part_array[0] = time_part_array[0] - 12;
    }



    var formatted_time = time_part_array[0] + ':' + time_part_array[1] + '' + ampm;

    return formatted_time;
}

function getFormattedDate(date) {
    if (!date) {
        return;
    }
    //var time_part_array = date.split("T")[1].split(":");
    var newDate = new Date(date);
    var hours = newDate.getHours();
    var minutes = newDate.getMinutes();
    var ampm = 'am';


    if (hours >= 12) {
        ampm = 'pm';
    }

    if (hours > 12) {
        hours = hours - 12;
    }

    var allmonthNames = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];
    var newDate = new Date(date);
    var dd = newDate.getDate();
    var month = allmonthNames[newDate.getMonth()];
    var year = newDate.getFullYear();



    var formatted_time = dd + " " + month + " " + year + ' ' + hours + ':' + minutes + ' ' + ampm;

    return formatted_time;
}

function saveFile(uri, filename) {


    ///HANDLE SAFARI CHROME


    if (navigator.userAgent.match('CriOS')) {

        //alert('i am chrome safari');
        //  var dataURL = uri;
        var blob = window.dataURItoBlob(uri);
        // alert(blob);


        window.URL = window.URL || window.webkitURL;
        var url = window.URL.createObjectURL(blob);

        // downloadURI(url,"name.png");
        //window.open(url,"_blank");

        // location.href = url;
        var html_string = '<img src="' + uri + '" />'

        $('.card-download-overlay').addClass('active');

        // var iframe =  document.getElementById('download-frame'); //$('#download-frame')
        //  var iframedoc = iframe.contentDocument || iframe.contentWindow.document;
        //   iframedoc.body.innerHTML = "<style>html, body {margin: 0;} img{width:100%;}</style>" + html_string;


        $('#download-image').attr('src', uri);

        //download-frame
        //download-image
        return;


    }


    // alert('i am normal');


    var link = document.createElement('a');
    if (typeof link.download === 'string') {
        link.href = uri;
        link.download = filename;
        //Firefox requires the link to be in the body
        document.body.appendChild(link);
        //simulate click
        link.click();
        //remove the link when done
        document.body.removeChild(link);
    } else {
        window.open(uri);
    }
}
function CreateGuid() {
    function _p8(s) {
        var p = (Math.random().toString(16) + "000000000").substr(2, 8);
        return s ? "-" + p.substr(0, 4) + "-" + p.substr(4, 4) : p;
    }
    return _p8() + _p8(true) + _p8(true) + _p8();
}
export function dateFromSDateTime(date) {
    try {
        //console.log("date=" + date);
        if (!date) {
            return;
        }

        if (date.indexOf("Z") == -1 && date.toLowerCase().indexOf("am") == -1 && date.toLowerCase().indexOf("pm") == -1 && date.indexOf("T") > -1) {
            date = date + "Z";
        }

        var nDate = new Date(date);
        // console.log("dateFromSDateTime NEWDATE :"+nDate)
        var re = /-?\d+/;
        var m = re.exec(date);
        //  console.log(m);
        if (null == m || m.index == 0) {
            //nDate.setHours(nDate.getHours() - 5);
            // nDate.setMinutes(nDate.getMinutes() - 30);
        }
        return nDate;
    }
    catch (e) {

        //console.log("PLEASE FF" + e);
    }
    return "N/A";
}



export function mongodateforholidays(date) {
    try {
        //console.log("date=" + date);
        if (!date) {
            return;
        }

        if (date.indexOf("Z") == -1 && date.toLowerCase().indexOf("am") == -1 && date.toLowerCase().indexOf("pm") == -1 && date.indexOf("T") > -1) {
            date = date + "Z";
        }

        var nDate = new Date(date);
        // console.log("dateFromSDateTime NEWDATE :"+nDate)
        var re = /-?\d+/;
        var m = re.exec(date);
        //  console.log(m);
        if (null == m || m.index == 0) {
            nDate.setHours(nDate.getHours() - 5);
            nDate.setMinutes(nDate.getMinutes() - 30);
        }
        return nDate;
    }
    catch (e) {

        //console.log("PLEASE FF" + e);
    }
    return "N/A";
}
function getTimeData(h, m, s, ms, date) {
    var timeNew = new Date(date);
    timeNew.setHours(h, m, s, ms);
    // timeNew.setMinutes(m);
    var timeOfDay = timeNew.getTime();
    return timeOfDay;

}
export function GetAudioFile(data) {
    if (data.AT == "ATTENDANCE") {

        //var tag = data.UId + "-" + data.FId + "-" + data.TOId + "-" + data.CBPI + "-" + data.F6;
        //return window.root + "/Assets/VoiceMemo/" + data.FId + "/" + data.TOId + "/" + data.CBPI + "/" + tag + ".mp3";
        return window.R2Path + "/Assets/VoiceMemo/" + data.Id + ".mp3";
    }
    if (data.AT == "FEEDBACK") {
        //var tag = data.UId + "-" + data.FId + "-" + data.CBPI + "-" + data.TOId + "-" + data.CBPI;
        //return window.root  + "/Assets/VoiceMemo/" + data.FId + "/" + data.CBPI + "/" + data.TOId + "/" + tag + ".mp3";
        return window.R2Path + "/Assets/VoiceMemo/" + data.Id + ".mp3";
    }

    if (data.AT == "MEMO") {
        var tag = data.UId + "-" + data.FId + "-" + data.TOId + "-" + data.CBPI + "-" + data.CBPI;
        return window.R2Path + "/Assets/MemoVoiceMemo/" + data.FId + "/" + data.TOId + "/" + data.CBPI + "/" + tag + ".mp3";
        //return root + "/Assets/MemoVoiceMemo/" + data.FId + "/" + data.CBPI + "/" + data.TOId + "/" + tag + ".mp3";
    }
}

export function GetUTCDateForCreation(date) {
    //var date = new Date();
    var now_utc = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(),
        date.getHours(), date.getMinutes(), date.getSeconds());
    return new Date(now_utc);
}



function convertArrayOfObjectsToCSV(args) {
    var result, ctr, keys, columnDelimiter, lineDelimiter, data;

    data = args.data || null;
    if (data == null || !data.length) {
        return null;
    }

    columnDelimiter = args.columnDelimiter || ',';
    lineDelimiter = args.lineDelimiter || '\n';

    keys = Object.keys(data[0]);

    result = '';
    result += keys.join(columnDelimiter);
    result += lineDelimiter;

    data.forEach(function (item) {
        ctr = 0;
        keys.forEach(function (key) {


            if (ctr > 0) result += columnDelimiter;

            result += item[key] ? ("\"" + ((item[key] + "").replace(/#/gi, " ").replace(/,/gi, " ").replaceAll(/{#}/gi, " ")) + "\"") : item[key];
            ctr++;
        });
        result += lineDelimiter;
    });

    return result;
}

export function GetInformationicon(top, left, color, type, mr) {
    mr = mr || "6";
    return <svg onClick={() => { ShowInformation(type) }} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="24px" height="24px" viewBox="0 0 24 24" style={{ height: '20px', width: '20px', top: top + 'px', position: 'relative', left: left + "px", float: 'right', marginRight: mr + 'px' }}><g transform="translate(0, 0)"><path d="M12,0C5.383,0,0,5.383,0,12s5.383,12,12,12,12-5.383,12-12S18.617,0,12,0Zm1,17c0,.553-.448,1-1,1s-1-.447-1-1v-6c0-.553,.448-1,1-1s1,.447,1,1v6Zm-1-9c-.69,0-1.25-.56-1.25-1.25s.56-1.25,1.25-1.25,1.25,.56,1.25,1.25-.56,1.25-1.25,1.25Z" fill={color} /></g></svg>;
}

export function ShowInformation(type) {
    if (!type) {
        return;
    }

    var message = "";
    var buttonName = "I, Understood";
    switch (type.toLowerCase()) {
        case "pending":
        case "dues":
            type = "Empower Kids, Parents, Families ❤";
            message = `Each pending attendance, compensation, homework, feedbacks, goals to be set, goals to be reviewed, every pending represents real kids, parents, families.

Complete pending work empower Kids, Parents, Families ❤.`;
            buttonName = "Understood, Will Complete.";
            break;
        case "achievements":
            type = "Hearty Congratulations ❤";
            message = `11 years of empowerment, 3+ million of successful therapies with 97%+ proven improvement, 1,400+ therapists, ~9,000 kids, parents, families everyday.`;
            buttonName = "Hearty Congratulations ❤";
            break;
        case "innovations":
            type = "~130 years old problem - Pinnacle Solution ❤";
            message = `160+ Patentable Technologies, Policies, Procedures, Systems, Integration, Ambience, Environment, Apps, Omni Channel Care, Free National Autism Helpline, Goal oriented therapies, Transparent therapies, Responsible, Accountable, Open, Honest, A lot more.

 Many more.. first of their kinds probably started and being imported only by Pinnacle to empower 90+ crore kids, parents, families ❤ to have self-sufficient, being part of mainstream, wonderful life plausible`;
        case "pinnacle wisdom":
            message = `The quality of having experience, knowledge, and good judgement, and experience the knowledge in multi folded direction. 

Many more.. first of their kinds probably started and being imported only by Pinnacle to empower 90+ crore kids, parents, families ❤ to have self-sufficient, being part of mainstream, wonderful life plausible`;
            buttonName = "Let us Empower More";
            break;
        case "policies and procedures":
            type = "Safe Secure Life Empowering ❤";
            message = `3Million + Multi-Sensory, Multi-Disciplinary, Integrated Therapies across India from Delhi to Chennai, Delhi to Visakhapatnam. 

Everything in Pinnacle across any Pinnacle in the country and world follows innovative policies, procedures check balanced through patentable technological systems deep rooted in Kids, Parents, Families Pinnacle Life Changing Therapeutic Empowerment ❤`;

            break;

        case "empowering":
            type = "Pinnacle Empowering 90+ Crore Kids, Parents, Families ❤";
            message = `Empower Kids, Parents, Families ❤

Empowering 90+ Crore Kids, Parents, Families to have Self-Sufficient, being part of Mainstream Society, Wonderful LIFE plausible, Bring smiles into their lives is the core purpose of Pinnacle existence. 

Your role in the organization is to do your part - Contribute in this Devineful Opportunity, Noble Deed.`;

            break;
        case "proven improvement":
            type = "Pinnacle Proven Improvement ❤";
            message = `3+ Million Successful Multi-Sensory, Multi-Disciplinary, Integrated Autism therapy services with 97%+ Proven Improvement. 

Directly hear it from parents across Delhi-Chennai, Delhi - Visakhapatnam, Probably Pinnacle is the only organization providing this wonderful therapeutic empowerment ❤`;
            break;
        case "renewals":
            type = "Pinnacle Life Renewal ❤";
            message = `Kids, Parents, Families on the name of god counting on Pinnacle to empower them to have Self-Sufficient, part of Mainstream Society, Wonderful Life Plausible. 

Work with Parents, Families upfront by utilizing this wisdom in successfully completing Pinnacle Life Renewal ❤, Empower Kids, Parents, Families ❤`;
            break;
            case "invoices":
                type = "Pinnacle Credits ❤";
                message = `Pinnacle all credits for you`;
                break;
        case "service requests":
            type = "Pinnacle Service Requests ❤";
            message = `Being Open, Being Honest, Being Transparent, Being Self-Critical are the core values of Pinnacle Blooms Network. 

Raise a Concern, Ask a Question, Seek Clarity, Suggest Betterment, Entire Pinnacle Staff & Leadership at your disposal in hearing you out and provide needed clarity, information, take necessary action .. Making Pinnacle as the most Responsible, Accountable organization across the world ❤`;
            break;
        case "compensations":
            type = "Pinnacle Leaves & Compensations ❤";
            message = `Pinnacle Life Changing Therapeutic Empowerment ❤ is the right of every kid, parent, family. 

Ensure to provide all compensations duly before the month itself as Compensations refreshes upon beginning of the month.`;
            break;
        case "recent":
            type = "Latest Activities for You ";
            message = `Here are your latest activities within Pinnacle.`;
            break;
            case "leaves":
                type = "Leaves for You ";
                message = `Leaves applied so far and approved so far`;
                break;
                case "absent":
                    type = "Absent & Compos";
                    message = `Kids empowerment is taken hault through leaves and wants to epower those also through compos`;
                    break;

    }

    showLockedBox(message, type, buttonName, false, null, "/images/alert.png");
}

export function DownloadFile(fileurl, filename, id) {
    ShowToastMessage("Downloading...");
    if ($("#" + id).hasClass("downloading")) {
        return;
    }
    $("#" + id).addClass("downloading");
    fetch("https://mirracle.pinnacleblooms.org/api/getblob", {

        // Adding method type
        method: "POST",
        crossorigin: true,
        mode: 'no-cors',
        // Adding body or contents to send
        body: JSON.stringify({
            image: fileurl
        })

        // Adding headers to the request

    })
        .then(resp => resp.blob())
        .then(blob => {
            console.log(blob);

            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            // the filename you want
            a.download = "proven-improvement-" + filename + ".mp4";
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            $("#" + id).removeClass("downloading");
            ShowToastMessage("Successfully Downloaded...");
            // or you know, something with better UX...
        })
        .catch(function () { $("#" + id).removeClass("downloading"); });
    return;
    let tag = document.createElement('a');
    tag.href = fileurl;
    //link.setAttribute('download', "proven-improvement-" + (filename ? filename : "")+".mp4");
    tag.download = "proven-improvement-" + (filename ? filename : "") + ".mp4";
    document.body.appendChild(tag);
    tag.click();
    document.body.removeChild(tag);
}
export function downloadCSV(args, dataList) {
    var data, filename, link;
    var csv = convertArrayOfObjectsToCSV({
        data: dataList
    });
    if (csv == null) return;

    filename = args.filename || 'export.csv';

    if (!csv.match(/^data:text\/csv/i)) {
        csv = 'data:text/csv;charset=utf-8,' + csv;
    }
    data = encodeURI(csv);

    link = document.createElement('a');
    link.setAttribute('href', data);
    link.setAttribute('download', filename);
    link.click();
}


export function dateFromDateIncludeTime(date) {
    try {
        //console.log("date=" + date);
        if (!date) {
            return;
        }


        try {
            if (date.indexOf("Z") == -1 && date.toLowerCase().indexOf("am") == -1 && date.toLowerCase().indexOf("pm") == -1 && date.toLowerCase().indexOf("T") > -1) {
                date = date + "Z";
            }
        }
        catch {

        }
        var nDate = new Date(date);


        var re = /-?\d+/;
        var m = re.exec(date);
        //  console.log(m);
        // if (null == m || m.index == 0) {
        //     nDate.setHours(nDate.getHours() - 5);
        //     nDate.setMinutes(nDate.getMinutes() - 30);
        // }

        // var nDate = new Date(date);
        // // console.log(date);

        // var re = /-?\d+/;
        // var m = re.exec(date);
        // // console.log(m);
        // if ((null == m || m.index == 0) && date.indexOf("+05:30") == -1) {
        //     nDate.setHours(nDate.getHours() - 5);
        //     nDate.setMinutes(nDate.getMinutes() - 30);
        // }

        //if (date.endsWith("Z")) {
        //    nDate.setHours(nDate.getHours() - 5);
        //    nDate.setMinutes(nDate.getMinutes() - 30);
        //}

        var returnString = ((("0" + (nDate.getDate())).slice(-2)) + "-" + (("0" + (nDate.getMonth() + 1)).slice(-2)) + "-" + nDate.getUTCFullYear()) + " " + ((("0" + (nDate.getHours())).slice(-2)) + ":" + (("0" + (nDate.getMinutes())).slice(-2)));
        return returnString;
    } catch (e) {

        //console.log("PLEASE FF" + e);
    }
    return "N/A";
}

export function dateFromDateIncludeOnlyTimeForPendings(date) {
    try {
        //console.log("date=" + date);
        if (!date) {
            return;
        }
        try {
            if (date.indexOf("Z") == -1 && date.toLowerCase().indexOf("am") == -1 && date.toLowerCase().indexOf("pm") == -1 && date.toLowerCase().indexOf("T") > -1) {
                date = date + "Z";
            }
        }
        catch {

        }
        var nDate = new Date(date);
        // console.log(date);

        var re = /-?\d+/;
        var m = re.exec(date);
        // console.log(m);
        // if ((null == m || m.index == 0) && date.indexOf("+05:30") == -1) {
        //     nDate.setHours(nDate.getHours() - 5);
        //     nDate.setMinutes(nDate.getMinutes() - 30);
        // }

        //if (date.endsWith("Z")) {
        //    nDate.setHours(nDate.getHours() - 5);
        //    nDate.setMinutes(nDate.getMinutes() - 30);
        //}
        // console.log("dateFromDateIncludeOnlyTimeForPendings: " + date);
        // console.log("dateFromDateIncludeOnlyTimeForPendings New: " + nDate);
        return (("0" + (nDate.getDate())).slice(-2)) + "/" + (("0" + (nDate.getHours())).slice(-2)) + ":" + (("0" + (nDate.getMinutes())).slice(-2)) + ":" + (("0" + (nDate.getSeconds())).slice(-2));

    } catch (e) {

        //console.log("PLEASE FF" + e);
    }
    return "N/A";
}

export function dateFromDateIncludeOnlyTime(date) {
    try {
        //console.log("date=" + date);
        if (!date) {
            return;
        }

        var nDate = new Date(date);
        // console.log(date);

        var re = /-?\d+/;
        var m = re.exec(date);
        // console.log(m);
        if ((null == m || m.index == 0) && date.indexOf("+05:30") == -1) {
            nDate.setHours(nDate.getHours() - 5);
            nDate.setMinutes(nDate.getMinutes() - 30);
        }

        //if (date.endsWith("Z")) {
        //    nDate.setHours(nDate.getHours() - 5);
        //    nDate.setMinutes(nDate.getMinutes() - 30);
        //}

        var returnString = ((("0" + (nDate.getDate())).slice(-2)) + "-" + (("0" + (nDate.getMonth() + 1)).slice(-2)) + "-" + nDate.getUTCFullYear()) + " " + ((("0" + (nDate.getHours())).slice(-2)) + ":" + (("0" + (nDate.getMinutes())).slice(-2)));

        var todayDate = new Date();
        if (nDate.getDate() == todayDate.getDate()) {
            returnString = ((("0" + (nDate.getHours())).slice(-2)) + ":" + (("0" + (nDate.getMinutes())).slice(-2)) + ":" + (("0" + (nDate.getSeconds())).slice(-2)));
        }


        return returnString;
    } catch (e) {

        //console.log("PLEASE FF" + e);
    }
    return "N/A";
}


function dateFromDateTime(date) {
    try {
        //console.log("date=" + date);
        if (!date) {
            return;
        }

        var nDate = new Date(date);


        var re = /-?\d+/;
        var m = re.exec(date);
        //  console.log(m);
        if (null == m || m.index == 0) {
            nDate.setHours(nDate.getHours() - 5);
            nDate.setMinutes(nDate.getMinutes() - 30);
        }

        //if (date.endsWith("Z")) {
        //    nDate.setHours(nDate.getHours() - 5);
        //    nDate.setMinutes(nDate.getMinutes() - 30);
        //}

        var returnString = ((("0" + (nDate.getDate())).slice(-2)) + "-" + (("0" + (nDate.getMonth() + 1)).slice(-2)) + "-" + nDate.getUTCFullYear());
        return returnString;
    } catch (e) {

        //console.log("PLEASE FF" + e);
    }
    return "N/A";
}

export function dateFromDateTimeForRoyalty(date) {
    try {
        //console.log("date=" + date);
        if (!date) {
            return;
        }

        var nDate = new Date(date);


        var re = /-?\d+/;
        var m = re.exec(date);
        //  console.log(m);

        //if (date.endsWith("Z")) {
        //    nDate.setHours(nDate.getHours() - 5);
        //    nDate.setMinutes(nDate.getMinutes() - 30);
        //}

        var returnString = ((("0" + (nDate.getDate())).slice(-2)) + "-" + (("0" + (nDate.getMonth() + 1)).slice(-2)) + "-" + nDate.getUTCFullYear());
        return returnString;
    } catch (e) {

        //console.log("PLEASE FF" + e);
    }
    return "N/A";
}


function dateFromDateTimeWithTime(date) {
    try {
        //console.log("date=" + date);
        if (!date) {
            return;
        }

        var nDate = new Date(date);


        var re = /-?\d+/;
        var m = re.exec(date);
        //  console.log(m);
        if (null == m || m.index == 0) {
            nDate.setHours(nDate.getHours() - 5);
            nDate.setMinutes(nDate.getMinutes() - 30);
        }

        //if (date.endsWith("Z")) {
        //    nDate.setHours(nDate.getHours() - 5);
        //    nDate.setMinutes(nDate.getMinutes() - 30);
        //}

        var returnString = ((("0" + (nDate.getDate())).slice(-2)) + "-" + (("0" + (nDate.getMonth() + 1)).slice(-2)) + "-" + nDate.getUTCFullYear()) + " " + (("0" + (nDate.getHours())).slice(-2)) + ":" + (("0" + (nDate.getMinutes())).slice(-2));
        return returnString;
    } catch (e) {

        //console.log("PLEASE FF" + e);
    }
    return "N/A";
}
function Numbersafterthousand(x) {
    if (!x || x == "" || x == "NaN") {
        return 0;
    }
    try {
        var num = x;

        if (num.toString().length > 5) {
            x = (((num / 100000)).toFixed(2)) + "L";
        }
        else if (num.toString().length > 3) {
            x = (((num / 1000)).toFixed(2)) + "K";
        }



    } catch (e) {

    }
    var data = x.toString().replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");

    var value = data.split('.').length > 1 ? data : data.trim();
    return data.split('.').length > 1 ? data : data.trim();
}
function FormatAMPM(time) {
    // Check correct time format and split into components
    time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) { // If time format correct
        time = time.slice(1);  // Remove full string match value
        time[5] = +time[0] < 12 ? 'AM' : 'PM'; // Set AM/PM
        time[0] = +time[0] % 12 || 12; // Adjust hours
    }
    return time.join(''); // return adjusted time or original string
}
function NumberWithCommas(x) {
    if (!x) {
        return x;
    }
    // x = parseFloat(x.toFixed(2));
    x = parseFloat(x);
    var data = x.toString().replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");

    var value = data.split('.').length > 1 ? data : data.trim();
    return '₹' + value + '.00';
}
function getMonthNamefromDate(date) {
    var newDate = new Date(date);
    var month = newDate.toLocaleString('default', { month: 'long' });
    return month;
}

function getTimeStamp(data) {
    //var now = new Date();

    var dateStamp = new Date(data.getUTCFullYear(), data.getUTCMonth(), data.getUTCDate(), data.getUTCHours(), data.getUTCMinutes(), data.getUTCSeconds());

    //var dateStamResult = GetTimeStamp(dateStamp);
    //console.log(dateStamResult);
    // return dateStamResult;

    var hh = dateStamp.getHours();
    var min = dateStamp.getMinutes();
    var s = dateStamp.getSeconds();
    var ampm = (hh >= 12) ? 'PM' : 'AM';
    hh = hh % 12;

    var time = hh + ":" + min + " " + ampm;
    return time;
}

function getDueMessage(fDate) {
    var date = new Date();

    if (new Date(fDate) > date) {
        var diff = new Date(new Date(fDate) - date);
        var days = diff / 1000 / 60 / 60 / 24;
        return "Due in next " + Math.floor(days) + " days";
    }
    else {
        var diff = new Date(date - new Date(fDate));

        var days = diff / 1000 / 60 / 60 / 24;
        var text = Math.floor(days) == 0 ? "overdue started from today" : "overdue from last " + Math.floor(days) + " days";
        //activity.F16 = "red";
        return text;
    }
}


export function sundaysInMonth(m, y) {
    var days = new Date(y, m, 0).getDate();
    var start = 8 - (new Date(m + '/01/' + y).getDay());
    var sundays = [new Date(y, (m - 1), start)];

    for (var i = start + 7; i < days; i += 7) {
        sundays.push(new Date(y, m - 1, i));
    }
    return sundays;
}
export function SendTelegramMessageToAdminGroup(fid, message, buttons, imageURL, callback) {



    var token = getUserToken();

    var request = {
        "token": token,
        "fileName": imageURL,
        "parameters": buttons,
        "message": message,
        "fIds": fid

    };

    $.ajax({
        url: '/api/unsecuredapi/SendTelegramMessageWiFacilityId',
        data: JSON.stringify(request),
        cache: false,
        async: true,
        contentType: "application/json; charset=UTF-8",
        type: 'POST',
        timeout: 15 * 60 * 1000,
        success: function (result) {
            //showLockedBox("Image Updated successfully", "", "Ok", true);

            //window.URL = window.URL || window.webkitURL;
            //var url true window.URL.createObjectURL(result);
            callback(true);

        },
        error: function (xhr, ajaxOptions, thrownError) {
            //HideLoading();
            console.log(xhr);
            console.log(ajaxOptions);
            console.log(thrownError);
            // selfObj.setState({ IsSendingTheMessage: false });
            $('.submit-wrapper').removeClass('is-saving');
            callback(false);
            showLockedBox(thrownError, "Error", "Ok", true);
        }
    });




}


export async function PushTelegramMessage(payload) {
    var dataURL = 'https://telegram.kgvpl.com/api/sendtelegramwithbutton';
    try {
        let myrequest = new Request(dataURL);
        // console.log("Came to ProcessWhatsAppMessages Method ");
        // await LogForFuturePupose("ExpensesNotEnteredTodayV1", payload);

        const init = {
            body: JSON.stringify(payload),
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
        }

        const response = await fetch(dataURL, init);
        console.log("payload for telegram")
        var res = await response.text();
        console.log(res)

        if (null != res) {

        };
        return JSON.parse(res);
    } catch (err) {

        // logger.Log("PostAssessmentsDataToIQMServer", 4, err.message + "\n\n" + err.stack, err.message);
        console.log(err);
        console.log("Exception Came While sending PostDataToServer " + err);
    }

    return true;
}

export function GetHolidaysList(fid) {
    var holidaysList = getUserSettingsValue("HOLIDAYSLIST");
    var holidays = holidaysList ? JSON.parse(holidaysList) : [];
    const dates = [];
    for (var i = 0; i < holidays.length; i++) {


        dates.push(...getDatesInRange(dateFromSDateTime(holidays[i].OccasionFrom), dateFromSDateTime(holidays[i].OccasionTo)));
    }
    var bonaluStartDate = "2023-07-17T00:00:00Z";
    var bonaluEndDate = "2023-07-17T23:59:59Z";
    dates.push(...getDatesInRange(dateFromSDateTime(bonaluStartDate), dateFromSDateTime(bonaluEndDate)));
    return dates;
}


function IsSunDayOrSecondOrFourthSaturday(date) {
    if (date.getDay() == 0 || date.getDay() != 6) {

        return date.getDay() == 0 ? true : false;
    }

    var yesSaturday = ((date.getDate() >= 8 && date.getDate() <= 14) || (date.getDate() >= 22 && date.getDate() <= 28));


    return yesSaturday;

}

function IsSunDayOrSaturday(date) {

    return date.getDay() == 0 || date.getDay() == 6 ? true : false;



}

function getMonthShortName(monthNo) {
    const date = new Date();
    date.setMonth(monthNo - 1);

    return date.toLocaleString('en-US', { month: 'short' });
}

export function GetShortDateandMonth(date) {
    var month = getMonthShortName(date.getMonth() + 1);
    var day = date.getDate();
    var dtString = (day <= 9 ? "0" + day : day) + "-" + month;
    return dtString;
}

export function GetTelegramTagString(user, altName = "") {
    if (!user || !user.Name) {
        return !altName ? "" : altName;
    }
    else if (!user.TelegramId) {
        return user.Name;
    }
    else {
        return "[" + user.Name + "]" + "(tg://user?id=" + user.TelegramId + ")";
    }

}

export function GetShortMonth(date) {
    var month = getMonthShortName(date.getMonth() + 1);
    return month;
}

export function GetDiffDays(startDate, endDate) {
    var Difference_In_Time = new Date(endDate.toDateString()).getTime() - new Date(startDate.toDateString()).getTime();
    return (Difference_In_Time / (1000 * 3600 * 24));
}

export function GetTotalWorkingDays(startDate, endDate) {
    //console.log('GetTotalWorkingDays');

    endDate = endDate > new Date ? new Date() : endDate;
    var Difference_In_Time = new Date(endDate.toDateString()).getTime() - new Date(startDate.toDateString()).getTime();

    // To calculate the no. of days between two dates
    var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
    var holidayList = GetHolidaysList();
    var dates = GetDatesInRange(startDate, endDate);
    $.map(dates, function (date) {
        var dt = holidayList.filter(function (e) { return e.toDateString() == date.toDateString() })[0];
        // console.log(dt);
        if (IsSunDayOrSecondOrFourthSaturday(date) || dt) {
            //console.log(date + " - Is Excluded" );
            Difference_In_Days = Difference_In_Days - 1
        }
    });

    return Difference_In_Days;

}

export function GetTotalWorkingDaysExcludingSaturdays(startDate, endDate) {
    //console.log('GetTotalWorkingDays');

    endDate = endDate > new Date ? new Date() : endDate;
    //var Difference_In_Time = new Date(endDate.toDateString()).getTime() - new Date(startDate.toDateString()).getTime();
    var Difference_In_Time = new Date(endDate).getTime() - new Date(startDate).getTime();

    // To calculate the no. of days between two dates
    var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
    var holidayList = GetHolidaysList();
    var dates = GetDatesInRange(startDate, endDate);
    $.map(dates, function (date) {
        var dt = holidayList.filter(function (e) { return e.toDateString() == date.toDateString() })[0];
        // console.log(dt);
        if (IsSunDayOrSaturday(date) || dt) {
            //console.log(date + " - Is Excluded" );
            Difference_In_Days = Difference_In_Days - 1
        }
    });

    return Math.ceil(Difference_In_Days);

}


export function GetDatesInRange(startDate, endDate) {
    return getDatesInRange(startDate, endDate)
}


export function GetTimeSlotTotal(slot) {
    if (!slot) {
        return 0;
    }

    var values = slot.split(":");
    if (!values || values.length == 0) {
        return 0;
    }

    return (parseInt(values[0]) * 60) + (values.length > 1 && values[1] ? parseInt(values[1]) : 0)
}

export function GetCurretnSlot(slot) {
    var exact930 = 9 * 60 + 30;
    var exact11 = 11 * 60;
    var exact13 = 13 * 60;
    var exact16 = 16 * 60;
    var exact18 = 18 * 60;
    var exact19 = 19 * 60;

    var timeslot = GetTimeSlotTotal(slot);
    if (timeslot < exact930) {
        return "Before 9:30 AM";
    }
    else if (timeslot >= exact930 && timeslot <= exact11) {
        return "9:30 AM - 11:00 AM";
    }
    else if (timeslot > exact11 && timeslot <= exact13) {
        return "11:00 AM - 01:00 PM";
    }
    else if (timeslot > exact13 && timeslot <= exact16) {
        return "01:00 PM - 04:00 PM";
    }
    else if (timeslot > exact16 && timeslot <= exact18) {
        return "04:00 PM - 06:00 AM";
    }
    else if (timeslot > exact18 && timeslot <= exact19) {
        return "06:00 PM - 07:00 PM";
    }
    else if (timeslot > exact19) {
        return "After 7:00 PM";
    }
}


export function GetPendingMinutes(date) {

    var dateToCheck = dateFromSDateTime(date);

    var diff = Math.abs(new Date() - dateToCheck);
    var minutes1 = Math.floor((diff / 1000) / 60);


    let days = diff / (24 * 60 * 60 * 1000);
    let hours = (days % 1) * 24;
    let minutes = (hours % 1) * 60;

    [days, hours, minutes] = [Math.floor(days), Math.floor(hours), Math.floor(minutes)]

    var stringToSend = days > 0 ? days + ' day ' : "";
    stringToSend += hours > 0 ? hours + ' hrs ' : "";
    stringToSend += minutes + ' min'
    return stringToSend;
}
export function GetShortDesignation(type) {
    if (!type) {
        return type;
    }

    switch (type.toLowerCase().trim()) {
        case "behavioural therapist":
            return "BT";
            break;
        case "occupational therapist":
            return "OT";
            break;
        case "special educator":
            return "SE";
            break;
        case "speech therapist":
            return "ST";
            break;
    }

    return type;
}

export function GetServiceType(type) {
    if (!type) {
        return type;
    }

    switch (type.toLowerCase()) {
        case "behavioural therapist":
            return "Behavioral Modification";
            break;
        case "occupational therapist":
            return "Occupational Therapy";
            break;
        case "special educator":
            return "Special Education";
            break;
        case "speech therapist":
            return "Speech Therapy";
            break;
    }

    return type;
}
export function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
}

export function GetDesignationByServiceType(type) {
    if (!type) {
        return type;
    }

    switch (type.toLowerCase()) {
        case "behavioural modification":
        case "behavioral modification":
            return "behavioural therapist";
            break;
        case "occupational therapy":
            return "occupational therapist";
            break;
        case "special education":
            return "special educator";
            break;
        case "speech therapy":
            return "speech therapist";
            break;
    }

    return type;
}

export function GetGraceCompoCount(dataSource, startDate, endDate, kids) {
    var date = new Date();
    date.setDate(date.getDate() - 1);
    endDate = endDate > new Date() ? new Date() : endDate;
    kids = kids || [];

    //var typeId = dataSource.Types.filter(f => f.Name == "ATTENDANCE" && a.Category == "ActionType")[0].Id;
    var gracetypeId = dataSource.Types.filter(f => f.Name == "Grace Compensation Request" && f.Category == "Service Request")[0].Id;
    var servicerequestAnalytics = Object.entries(groupBy((dataSource.ServiceRequestAnalytics || []), "SRId")).map(m => m[1].sort((a, b) => (new Date(b.CDT) > new Date(a.CDT) ? -1 : 1))[0]);

    var srData = groupBy((dataSource.ServiceRequestAnalytics || []), "SRId");
    var requests = (dataSource.ServiceRequests || []).filter(f => f.TypeId == gracetypeId && srData[f.Id] && srData[f.Id].Status == "CLOSED" && srData[f.Id].CBPI == f.CBPI && kids.indexOf(f.TOId) > -1 && (dateFromSDateTime(f.FDT) >= startDate) && (dateFromSDateTime(f.FDT) <= endDate) && srData[f.Id].Amount > 0);
    requests = requests || [];
    /* var requests = $.grep(dataSource, function (e) { return e.AT == "SERVICEREQUESTANALYTIC" && e.F1 == "Grace Compensation Request" && kids.indexOf(e.OGID) > -1 && (dateFromSDateTime(e.FDT) >= startDate) && (dateFromSDateTime(e.FDT) <= endDate) && e.TOId == e.CBPI && e.F7 > 0 });*/

    var services = [];
    if (requests && requests.length > 0) {

        for (var i = 0; i < requests.length; i++) {

            var leave = requests[i];
            for (var j = 0; j < leave.Amount; j++) {
                var service = { "FDT": leave.FDT, "TDT": leave.FDT, "ServiceId": leave.Package, "TOId": leave.TOId, "Status": "Absent", "F3": leave.F4, "UId": leave.Id };
                services.push(service);
            }
        }
    }

    return services;




}

export function GetLeavesCompoCount(dataSource, startDate, endDate, user, servicesData) {
    var date = new Date();
    date.setDate(date.getDate() - 1);
    endDate = endDate > new Date() ? new Date() : endDate;
    var newservicesData = servicesData.filter(e => e.RS != "DELETEACTIVITY" && e.Status != "INACTIVE")
    var therapistIds = newservicesData ? newservicesData.map(function (m) { return m.TherapistId }) : [];
    var leavesData = dataSource.Leaves;
    if (!leavesData) {
        var leaveId = GetTypeIdByName(dataSource.Types, "LEAVEREQUEST");
        leavesData = dataSource.PeopleNotes ? dataSource.PeopleNotes.filter(f => f.TypeId == leaveId) : [];
    }
    var leaveRequests = $.grep(leavesData, function (e) {
        return e.RS != "DELETEACTIVITY" && new Date(e.TDT) >= startDate && new Date(e.TDT) <= endDate && (null == user ? true : (e.TOId == user.Id || (therapistIds && therapistIds.length > 0 ? therapistIds.indexOf(e.TOId) > -1 : false)))


    });



    //&& e.F10 == "Parent" e.S == "Approved"
    if (!leaveRequests || leaveRequests.length == 0) {
        return [];
    }
    var leaves = [];
    var services = [];
    for (var i = 0; i < leaveRequests.length; i++) {
        var leave = leaveRequests[i]
        var already = $.grep(leaves, function (r) { return r.TDT == leave.TDT && leave.F10 == r.F10 })[0];
        if (!already) {

            if (leave.F1 == "Therapist" || leave.F1 == "AdminForTherapist") {

                var servicesData1 = $.grep(newservicesData, function (r) { return (null == user ? true : r.BossId == user.Id) && r.TherapistId == leave.TOId && new Date(r.StartDate) <= new Date(leave.FDT) });
                if (servicesData1) {
                    servicesData1.forEach(function (e) {
                        var alreadyCompo = services.filter(function (f) { return f.ServiceId == e.Id && e.TDT == leave.TDT })[0];
                        if (!alreadyCompo) {
                            var service = { "AT": "ATTENDANCE", "FDT": leave.TDT, "TDT": leave.TDT, "F5": e.RDT, "TOId": e.TOId, "Status": "Absent", "F3": e.F2, "ServiceId": e.Id };
                            services.push(service);
                        }
                    });
                }
            }
            else {

                var servicesData1 = $.grep(newservicesData, function (r) { return (null == user ? true : r.BossId == user.Id) && r.BossId == leave.TOId && new Date(r.StartDate) <= new Date(leave.FDT) });

                servicesData1.forEach(function (e) {
                    var alreadyCompo = services.filter(function (f) { return f.ServiceId == e.Id && e.TDT == leave.TDT })[0];
                    if (!alreadyCompo) {
                        var service = { "AT": "ATTENDANCE", "FDT": leave.TDT, "TDT": leave.TDT, "F5": e.Title, "TOId": leave.TOId, "Status": "Absent", "F3": e.F2, "ServiceId": e.Id };
                        services.push(service);
                    }
                });
            }
            leaves.push(leave);
        }
    }

    return services;

}


export function getSlotsByDataByTherapist(therapies, compos, leaves, types, user, date) {

    var isSaturDay = false;
    try {
        var date = new Date(date);
        var data = []; //CF ERROR FIXING NEED TO FIND DATA
        isSaturDay = date.getDay() === 6;
        if (isSaturDay && data && data.length > 0) {

            data = data.filter(function (e) { return e.AT != "USERSERVICE" });
        }

    } catch (e) {

    }


    var tleave = leaves.map(m => m.TOId == user.Id);
    if (tleave && tleave.length > 0) {
        showLockedBox("Sorry, The therapist is leave on " + date, "Info", "Okay");
        return;
    }
    try {
        var parentLeaves = leaves.map(function (e) { return e.TOId });


        therapies = therapies.filter(function (e) { return !(parentLeaves.indexOf(e.BossId) > -1) && e.RS != "DELETEACTIVITY" });
    } catch (e) {

    }

    therapies = therapies || [];

    if (compos && compos.length > 0) {
        var obj = {};
        for (var i = 0; i < compos.length; i++) {
            try {
                obj.TherapistId = compos[i].CBPI;
                obj.Time = compos[i].Status;
                obj.TypeId = parseInt(compos[i].TypeId);
                obj.BossId = parseInt(compos[i].HomeWork);
                therapies.push(obj);
            } catch (e) {

            }

        }

    }
    var serviceType = GetServiceType(user.Designation.trim());
    var summary = [];
    var serviceId = types.filter(f => f.Name && f.Name == serviceType)[0].Id;

    if (!therapies || therapies.length == 0) {


        var cloud =
        {
            TherapistId: user.Id,
            Name: user.Name,
            TypeId: serviceId,
            CenterId: user.CenterId
        }

        var cservices = CalcSlotsMC("8:45", "19:01", cloud);
        if (cservices && cservices.length > 0) {
            summary.push(...cservices);
        }



    }
    else {
        if (therapies && therapies.length > 0) {
            var sortedServices = therapies.sort(function (a, b) {
                return GetTimeSlotTotal(a.Time) - GetTimeSlotTotal(b.Time);
            });
            console.log(sortedServices);

            var first = sortedServices[0];
            var last = sortedServices[sortedServices.length - 1];
            if (GetTimeSlotTotal(first.Time) > 570) {
                var cservices = CalcSlotsMC("8:45", first.Time, first);
                if (cservices && cservices.length > 0) {
                    summary.push(...cservices);
                }
            }
            for (var i = 0; i <= sortedServices.length - 1; i++) {
                // tServices[i].RS = Utility.GetMeridiem(time1);
                sortedServices[i].S = "Fill";
                sortedServices[i].F7 = GetTimeSlotTotal(sortedServices[i].Time);
                summary.push(sortedServices[i]);
                if (sortedServices.length - 1 != i) {
                    var cservices = CalcSlotsMC(sortedServices[i].Time, sortedServices[i + 1].Time, first);
                    if (cservices && cservices.length > 0) {
                        summary.push(...cservices);
                    }
                }
            }

            if (GetTimeSlotTotal(last.Time) + 45 < 1140) {
                var cservices = CalcSlotsMC(last.Time, "19:01", first);
                if (cservices && cservices.length > 0) {
                    summary.push(...cservices);
                }
            }




        }
    }
    try {
        if (isSaturDay && summary && summary.length > 0) {
            var alreadybooked = summary.filter(function (e) { return e.S != 'Fill' && GetTimeSlotTotal(e.Time) >= 660 && GetTimeSlotTotal(e.Time) < 750 });
            if (alreadybooked && alreadybooked.length > 0) {
                for (var i = 0; i < alreadybooked.length; i++) {
                    alreadybooked[i].S = 'Fill';
                }
            }
        }
    } catch (e) {

    }


    try {

    } catch (e) {

    }
    return summary;
}

function getDatesInRange(startDate, endDate) {
    const date = new Date(startDate.getTime());

    const dates = [];

    while (date <= endDate) {
        dates.push(new Date(date));
        date.setDate(date.getDate() + 1);
    }

    return dates;
}

function getTimeDay(date) {
    var param1 = new Date();
    var start_actual_time = new Date(date);
    // alert(start_actual_time + ' ' + end_actual_time);
    var diff = param1 - start_actual_time;
    var diffSeconds = diff / 1000;

    var hh = start_actual_time.getHours();
    var min = start_actual_time.getMinutes();
    var s = start_actual_time.getSeconds();

    var ampm = (hh >= 12) ? 'PM' : 'AM';
    hh = hh % 12;

    var time = hh + ":" + min + " " + ampm;


    // alert(HH);
    if (start_actual_time.getDate() == param1.getDate()) {
        return "Today " + time;
    }
    else if (start_actual_time.getDate() == (param1.getDate() - 1)) {
        return "Yesterday " + time;
    }
    else {
        // return HH + " Hours ago";
        var monthstring = parseInt(start_actual_time.getMonth() + 1);
        if (monthstring <= 9) {
            monthstring = "0" + monthstring;
        }

        return start_actual_time.getDate() + "/" + monthstring + "/" + start_actual_time.getFullYear() + " " + time;
    }
}

function getTimeSpan(date) {
    var param1 = new Date();
    var start_actual_time1 = new Date(date);

    var start_actual_time = Date.parse(start_actual_time1);//start_actual_time1.setMinutes(start_actual_time1.getMinutes() - 330);

    var epochTime = Date.parse(param1);
    var diff = epochTime - start_actual_time;

    var diffSeconds = diff / 1000;
    var HH = parseInt(Math.floor(diffSeconds / 3600));
    var MM = parseInt(Math.floor(diffSeconds % 3600) / 60);

    if (HH < 1) {
        if (MM <= 1) {
            return "Few Seconds ago";
        }
        else {
            return MM + " Minutes ago";
        }
    }
    else if (HH < 23) {
        return HH + " Hours ago";
    }
    else if (HH > 23 && HH < 36) {
        return "Yesterday";
    }
    else if (HH > 36 && HH < 150) {
        var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        return days[start_actual_time1.getDay()];
    }
    else {
        return start_actual_time1.getDate() + "-" + (start_actual_time1.getMonth() + 1) + "-" + start_actual_time1.getFullYear();
    }
}

function getTime(date) {
    var param1 = new Date();
    var start_actual_time = new Date(date);
    var min = start_actual_time.getMinutes();
    if (min <= 9) {
        min = "0" + min
    }
    return start_actual_time.getHours() + " : " + min;
}


var invoicePrices = [18000, 15000, 16333, 14500, 14000, 10417, 12000, 10000, 8333, 9999, 8334, 9416, 9417, 9360, 9333, 10416, 10418, 9167, 9166, 8335, 21960, 19926, 19927, 17690, 14640];
var servicesOfeering = [
    { Name: "behavioral modification", Id: 4, ShortName: "BT" },
    { Name: "occupational therapy", Id: 3, ShortName: "OT" },
    { Name: "special education", Id: 6, ShortName: "SE" },
    { Name: "speech therapy", Id: 1, ShortName: "ST" }
];
export function GetTypeIdByName(types, name) {
    try {
        let returnData = types.filter(f => f.Name == name)[0];
        if (returnData) {
            return returnData.Id;
        }
        return 0;
    } catch (e) {

    }
}

export function GetTypeNameById(types, Id) {
    try {
        let returnData = types.filter(f => f.Id == Id)[0];
        if (returnData) {
            return returnData.Name;
        }
        return 0;
    } catch (e) {

    }
}


function CalcSlotsMC(start, end, service) {
    try {

        var tsStart = GetTimeSlotTotal(start);
        var tsEnd = GetTimeSlotTotal(end);

        var availableSlots = [];
        //  console.log(tsStart);
        //  console.log(tsEnd);
        var time = 45;

        while (tsStart < tsEnd) {
            tsStart = tsStart + time;
            if (tsStart + time <= tsEnd) {
                var timeString = (tsStart % 60) + "";
                timeString = timeString.length == 0 ? "00" : timeString.length == 1 ? "0" + timeString : timeString;
                availableSlots.push(
                    {
                        TherapistId: service.TherapistId,
                        TypeId: service.TypeId,
                        Time: Math.floor(tsStart / 60) + ":" + timeString,

                        S: "available",
                        F7: tsStart
                    });
            }


        }
        return availableSlots;
    }
    catch (Exception) {

        console.log(Exception);
    }
}

export function getSlotsByData(therapies, therapistsData) {
    console.log('getSlotsByData')
    var summary = [];

    therapies = therapies || [];
    var therapists = Object.entries(groupBy(therapies, "TherapistId"));
    var alreadyTaking = therapists.map(m => parseInt(m[0]));
    var nottaking = therapistsData.filter(f => alreadyTaking.indexOf(f.Id) == -1);
    if (nottaking && nottaking.length > 0) {
        nottaking.forEach(function (e) {
            /* var fId = (data.Facilities.filter(function (m) { return (null != e.MG && e.MG.indexOf(parseInt(m._key)) > -1) || (null != e.AG && e.AG.indexOf(parseInt(m._key)) > -1) })[0]);*/
            var fId = 0;
            var cloud =
            {
                F3: e.RDT,
                TypeId: GetServiceType(e.Designation ? e.Designation : ""),
                FId: 0,
                TherapistId: e.Id,
            }

            var cservices = CalcSlotsMC("8:45", "19:00", cloud);
            if (cservices && cservices.length > 0) {
                summary.push(...cservices);
            }

        });
    }

    if (therapists && therapists.length > 0) {

        therapists.forEach(function (e) {
            var services = e[1];
            if (services && services.length > 0) {
                var sortedServices = services.sort(function (a, b) {
                    return GetTimeSlotTotal(a.Time) - GetTimeSlotTotal(b.Time);
                });

                var first = sortedServices[0];
                var last = sortedServices[sortedServices.length - 1];

                if (GetTimeSlotTotal(first.Time) > 570) {


                    var cservices = CalcSlotsMC("8:45", first.Time, first);
                    if (cservices && cservices.length > 0) {
                        summary.push(...cservices);
                    }

                }


                for (var i = 0; i <= sortedServices.length - 1; i++) {


                    // tServices[i].RS = Utility.GetMeridiem(time1);
                    // summary.Add(tServices[i]);

                    if (sortedServices.length - 1 != i) {
                        var cservices = CalcSlotsMC(sortedServices[i].Time, sortedServices[i + 1].Time, first);
                        if (cservices && cservices.length > 0) {
                            summary.push(...cservices);
                        }
                    }
                }

                if (GetTimeSlotTotal(last.Time) + 45 < 1140) {
                    var cservices = CalcSlotsMC(last.Time, "19:00", first);
                    if (cservices && cservices.length > 0) {
                        summary.push(...cservices);
                    }
                }




            }

        });


    }
    return summary;
}

export function SaveCleintWaufli(exception, type, module) {
    try {

        var lsd = localStorage.getItem("LastPSSyncDataTime");
        var configJsonString = localStorage.getItem("UserSettings");
        var UserData = localStorage.getItem("UserData");
        UserData = UserData ? JSON.parse(UserData) : null;

        var settingsSWV = "";
        if (configJsonString) {
            try {
                var settingsSW = JSON.parse(configJsonString).filter(function (e) { return e.Name == "SWVERSION" });
                if (settingsSW && settingsSW.length > 0) {
                    settingsSWV = settingsSW[0].Value;
                }
            } catch (e) {

            }
        }

        var exObj = {};
        var v = (UserData ? UserData.Handle + "," : "") + " Version: " + window.swVersion + " USERSETTINGS: " + settingsSWV + " lsd: " + lsd + "\n\n *Browser Details:*" + GetBrowser();

        exObj.Message = (exception.Message ? exception.Message : exception.message) + ("\n\n" + module ? module : "") + "\n\n" + v + "\n\n" + (exception.stack ? exception.stack : "");
        exObj.Type = type;


        var clientWaufliURL = "https://psapi.pinnacleblooms.org/api/gl/clientlogexception";

        $.ajax({
            url: clientWaufliURL,
            type: "POST",
            headers: {
                "content-type": "application/json",
            },
            data: JSON.stringify(exObj),
            success: function (data, textStatus, jqXHR) {
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.log(jqXHR);
            }
        });
    } catch (err) {
        console.log("Error in SaveExceptionToSentry :: " + err);
    }
}


export function GetAllTherapistsData(data, isUserTherapist, fids) {

    var startDate = new Date();
    if (!(data && data.People)) {
        return;
    }

    var people = data.People.filter(e => e.RS != "DELETEACTIVITY" && e.F8 != 1);
    var therapiesAll = data.Therapies ? data.Therapies.filter(e => e.RS != "DELETEACTIVITY" && e.Status != "INACTIVE") : [];
    therapiesAll = therapiesAll || [];
    people = people || [];
    var facilityTherapies = data.FacilityTherapies || [];
    var facilityPeople = data.FacilityPeople || [];
    people.push(...facilityPeople);
    therapiesAll.push(...facilityTherapies);

    console.log("COWORKERS WISDOM", GetDateDiff(startDate, new Date()));
    try {
        //var fids = [];
        if (!fids) {
            fids = data.Centers.map(m => m.Id);
        }


        var therapistRoleId = GetTypeIdByName(data.Types, "Therapist");
        var therapists = Object.entries(groupBy(people.filter(f => therapistRoleId == f.RoleId && fids.indexOf(f.CenterId) > -1 && f.RS != "DELETEACTIVITY" && f.F8 != 1), "Id")).map(m => m[1][0]);
        var therapies = therapiesAll ? therapiesAll.filter(f => fids.indexOf(f.CenterId) > -1) : [];

        var serviceIds = Object.entries(groupBy(therapiesAll, "BossId"));


        console.log("COWORKERS WISDOM - 1", GetDateDiff(startDate, new Date()));

        var pollination = [];
        for (var i = 0; i < servicesOfeering.length; i++) {
            var boss = serviceIds.filter(f => f[1].map(m => m.TypeId).indexOf(servicesOfeering[i].Id) == -1).map(m => m[0]);
            boss = (boss || []);

            for (var b = 0; b < boss.length; b++) {
                pollination.push({ BossId: boss[b], ServiceId: servicesOfeering[i].Id, ShortName: servicesOfeering[i].ShortName });
            }
        }
        console.log("COWORKERS WISDOM - POLLINATION", GetDateDiff(startDate, new Date()));
        var therapistsData = [];
        var therpistsGroup = groupBy(therapiesAll, "TherapistId");
        for (var i = 0; i < therapists.length; i++) {
            var therapist = { ...therapists[i] };
            var bossIds = therpistsGroup && therpistsGroup[therapist.Id + ""] && therpistsGroup[therapist.Id + ""].map(m => m.BossId + "");


            therapist.C = 0;
            if (bossIds) {
                var pollinations = pollination.filter(f => bossIds.indexOf(f.BossId) > -1);
                pollinations = pollinations || [];
                var psString = Object.entries(groupBy(pollinations, "ShortName")).map(m => m[0] + ":" + m[1].length);
                therapist.Pollination = pollinations;
                therapist.PC = pollinations.length;
                therapist.C = bossIds.length;
                therapist.Pollinate = psString;
                if (!isUserTherapist) {
                    therapist.Totals = therapies.length;
                }
            }
            therapist.F1 = GetShortDesignation(therapist.Designation) + ", " + therapist.C + " kids";

            therapistsData.push(therapist);
        }

        console.log("COWORKERS WISDOM - END", GetDateDiff(startDate, new Date()));
        //var therapistsData = [];
        return therapistsData;
    } catch (e) {
        return [];
    }
}

export function twitterLink(url, _a) {
    var title = _a.title, via = _a.via, _b = _a.hashtags, hashtags = _b === void 0 ? [] : _b, _c = _a.related, related = _c === void 0 ? [] : _c;
    //(0, assert_1.default)(url, 'twitter.url');
    // (0, assert_1.default)(Array.isArray(hashtags), 'twitter.hashtags is not an array');
    // (0, assert_1.default)(Array.isArray(related), 'twitter.related is not an array');
    return 'https://twitter.com/share' + objectToGetParams({
        url: url,
        text: title,
        via: via,
        hashtags: hashtags.length > 0 ? hashtags.join(',') : undefined,
        related: related.length > 0 ? related.join(',') : undefined,
    });
}
export function linkedinLink(url, _a) {
    var title = _a.title, summary = _a.summary, source = _a.source;
    // (0, assert_1.default)(url, 'linkedin.url');
    return ('https://linkedin.com/shareArticle' +
        objectToGetParams({ url: url, mini: 'true', title: title, summary: summary, source: source }));
}


export function differenceInMonths(date1, date2) {
    const monthDiff = date1.getMonth() - date2.getMonth();
    const yearDiff = date1.getYear() - date2.getYear();

    return monthDiff + yearDiff * 12;
}

export function objectToGetParams(object) {
    var params = Object.entries(object)
        .filter(function (_a) {
            var value = _a[1];
            return value !== undefined && value !== null;
        })
        .map(function (_a) {
            var key = _a[0], value = _a[1];
            return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(String(value)));
        });
    return params.length > 0 ? "?".concat(params.join('&')) : '';
}


export function GetReportsData(type, dataConst, isItKPI, FDT, TDT, facility) {
    try {


        isItKPI = isItKPI || false;



        /*DateTime seetaDateString = DateTime.Now.Date < to.Date ? DateTime.Now.Date.AddDays(-8) : to.Date.AddDays(-8);*/

        switch (type.toLowerCase()) {
            case "kuberamonthlyfee":
                if (dataConst.Fee && dataConst.Fee.length > 0) {
                    var filtered = dataConst.Fee.filter(m => m.Amount == 21960).map(m => m.BOSSId).filter(onlyUnique);
                    if (isItKPI) {
                        return filtered;
                    }
                }
                else {
                    return [];
                }
                break;
            case "kuberamissing":

                if (dataConst.Therapies) {
                    dataConst.Fee = dataConst.Fee || [];
                    var ids = dataConst.Fee ? dataConst.Fee.filter(f => f.Type && f.Type.toLowerCase() == "services").map(m => m.ServiceId) : [];
                    TDT = TDT >= new Date() ? new Date() : TDT;
                    return dataConst.Therapies.filter(f => ids.indexOf(f.Id) == -1 && dateFromSDateTime(f.StartDate) <= TDT && f.RS != "DELETEACTIVITY" && f.Status != "INACTIVE");

                }
                else {
                    return [];
                }

                break;
            case "kuberaabnormal":

                if (dataConst.Fee && dataConst.Fee.length > 0) {

                    var filtered = dataConst.Fee.filter(f => f.Type && f.Type.toLowerCase() == "services").filter(m => invoicePrices.indexOf(m.Amount) == -1);
                    if (isItKPI) {
                        return filtered;
                    }
                }
                else {
                    return [];
                }

                break;
            case "allinvoicesthismonth":

                if (dataConst.Fee && dataConst.Fee.length > 0) {

                    var filtered = dataConst.Fee;
                    if (isItKPI) {
                        return filtered;
                    }
                }
                else {
                    return [];
                }

                break;
            case "empwoer2monthly":
                var filtered = dataConst.Fee.filter(m => m.NoOfTherapies == 1).map(m => m.BOSSId).filter(onlyUnique);
                if (isItKPI) {
                    return filtered;
                }
                break;
            case "empwoer2single":
                var therapy = dataConst.Therapies.filter(e => e.RS != "DELETEACTIVITY" && e.Status != "INACTIVE")
                var filtered = groupBy(therapy, "BossId");
                if (isItKPI) {
                    return Object.values(filtered).filter(f => f.length == 1);
                }
                break;
            case "empwoer2lostparents":
                var filtered = groupBy(dataConst.InActive, "BossId");
                if (isItKPI) {
                    return Object.keys(filtered);
                }
                break;
            case "mirraclestotal":
                var filtered = dataConst.MirraclesData ? dataConst.MirraclesData : "";
                if (isItKPI) {
                    return filtered;
                }
                break;
            case "mirraclescontributed":
                var filtered = dataConst.MirraclesData ? Object.keys(groupBy(dataConst.MirraclesData, "PersonId")) : "";
                if (isItKPI) {
                    return filtered;
                }
                break;
            case "mnotcontributed":
                var adminId = dataConst.Types.filter(m => m.Name == "Receptionist")[0].Id;
                var therapistId = dataConst.Types.filter(m => m.Name == "Therapist")[0].Id
                var filtered = Object.keys(groupBy(dataConst.People.filter(m => (m.RoleId == therapistId || m.RoleId == adminId) && m.F8 != 1 && m.RS != "DELETEACTIVITY"), "Id"))

                return filtered;

                break;
            case "allmirraclesviews":
                var mirraclesview = dataConst.MirraclesData ? dataConst.MirraclesData.filter(f => (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT) || (f.UDT && dateFromSDateTime(f.UDT) >= FDT && dateFromSDateTime(f.UDT) <= TDT)) : "";
                var filtered = (mirraclesview || []).reduce(function (accumulator, item) {
                    return accumulator + item.F8;
                }, 0);
                if (isItKPI) {
                    return filtered;
                }
                break
            case "mirraclestop100":
                var top100Mirracles = (dataConst.MirraclesData || []).slice(0, 99).map(m => m.Id);

                var filtered = dataConst.MirraclesData ? dataConst.MirraclesData.filter(f => (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT) || (f.UDT && dateFromSDateTime(f.UDT) >= FDT && dateFromSDateTime(f.UDT) <= TDT)).filter(m => top100Mirracles.indexOf(m.Id) > -1) : "";
                if (isItKPI) {
                    return filtered;
                }
                break;
            case "mirraclesbottom100":
                var bottom100Mirracles = (dataConst.MirraclesData || []).slice(-100).map(m => m.Id);
                var filtered = dataConst.MirraclesData ? dataConst.MirraclesData.filter(f => (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT) || (f.UDT && dateFromSDateTime(f.UDT) >= FDT && dateFromSDateTime(f.UDT) <= TDT)).filter(m => bottom100Mirracles.indexOf(m.Id) > -1) : "";
                if (isItKPI) {
                    return filtered;
                }
                break;
            case "mirracleslc":
                var filtered = Object.keys(groupBy(dataConst.MirraclesData, "LanguageId"));
                if (isItKPI) {
                    return filtered;
                }
                break;
            case "mirraclesnotcovered":
                var languageIds = dataConst.Types.filter(m => m.Category == "Languages").map(m => m.Id);
                var languages = Object.keys(groupBy(dataConst.MirraclesData, "LanguageId"));
                var filtered = languageIds.length - languages.length;
                if (isItKPI) {
                    return filtered;
                }
                break;



            case "renewals":
                dataConst.FutureInvoices = dataConst.FutureInvoices || [];
                var currentInvoices = dataConst.Fee.filter(f => f.NoOfTherapies > 1);
                var ids = (currentInvoices || []).map(m => m.BOSSId)
                var futureInvoiceCreatedOld = dataConst.FutureInvoices.filter(f => dateFromSDateTime(f.CDT) < FDT);
                var futureInvoiceCreatedInthisMonth = dataConst.FutureInvoices.filter(f => dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT);

                var bossIds = Object.entries(groupBy(dataConst.Therapies.filter(f => ids.indexOf(f.BossId) > -1 && f.RS != "DELETEACTIVITY" && f.Status != "INACTIVE"), "BossId"));
                var renewals = [];
                futureInvoiceCreatedOld = futureInvoiceCreatedOld || [];
                futureInvoiceCreatedInthisMonth = futureInvoiceCreatedInthisMonth || [];
                for (var i = 0; i < bossIds.length; i++) {
                    var bid = parseInt(bossIds[i][0]);
                    var length = bossIds[i][1].length;
                    var invoiceslength = futureInvoiceCreatedOld.filter(f => f.BOSSId == bid).length;
                    if (length > invoiceslength) {
                        var status = futureInvoiceCreatedInthisMonth.filter(f => f.BOSSId == bid);
                        var currentInvoice = currentInvoices.filter(f => f.BOSSId == bid);
                        var invoice = {
                            ...bossIds[i][1][0], Renewed: status && status.length > 0 ? "Yes" : "No", Package: (currentInvoice[0].NoOfTherapies)
                        }
                        renewals.push(invoice);
                    }
                }

                if (isItKPI) {
                    return renewals;
                }

            case "seetatotal":
            case "seetapending":
            case "seetapartiallypaid":
            case "seetapaid":
            case "seetakids":
                var cDT = TDT > new Date() ? new Date() : TDT;// new Date(TDT.toString());
                cDT.setDate(cDT.getDate() - 8);
                var t = dataConst.Attendance.filter(f => dateFromSDateTime(f.ForDate) >= cDT);
                t = t || [];

                var values = Object.entries(groupBy(t, "ServiceId"));

                var filtered = values.filter(f => f[1][0] && f[1][0].Status == "Absent" && f[1][1] && f[1][1].Status == "Absent" && f[1][2] && f[1][2].Status == "Absent");
                if (type.toLowerCase() == "seetatotal") {
                    return filtered;
                }

                if (filtered && filtered.length > 0) {

                    var ids = filtered.map(m => parseInt(m[0]));
                    var bossIds = Object.keys(groupBy(dataConst.Therapies.filter(f => ids.indexOf(f.Id) > -1 && f.RS != "DELETEACTIVITY" && (!f.Status || f.Status.toUpperCase() != "INACTIVE")), "BossId"));


                    dataConst.Fee = dataConst.Fee || [];
                    var invoices = dataConst.Fee.filter(f => f.Type != "ASSESSMENTS" && bossIds.indexOf(f.BOSSId + "") > -1);
                    if (type.toLowerCase() == "seetapending") {
                        return invoices.filter(f => !f.Status);
                    }
                    else if (type.toLowerCase() == "seetapartiallypaid") {
                        return invoices.filter(f => f.Status == "PARTIALLYPAID");
                    }
                    else if (type.toLowerCase() == "seetapaid") {
                        return invoices.filter(f => f.Status == "PAID");
                    }
                    else if (type.toLowerCase() == "seetakids") {
                        return bossIds;
                    }
                }


                if (isItKPI) {
                    return filtered;
                }
                break;
            case "goalspending":
                try {

                    var therapiesfiltered = dataConst.Therapies && dataConst.Therapies.length > 0 ? dataConst.Therapies.filter(e => e.RS != "DELETEACTIVITY" && e.Status != "INACTIVE").map(t => t.Id) : [];

                    var filteredgoaldata = dataConst && dataConst.Goals && dataConst.Goals.length > 0 && therapiesfiltered.length > 0 ? dataConst.Goals.filter(t => therapiesfiltered.indexOf(t.TherapyId) > -1).sort((a, b) => (new Date(b.CDT) > new Date(a.CDT) ? -1 : 1)).map(x => [x.TherapyId, dateFromSDateTime(x.CDT)]) : []

                    var goalDictionary = filteredgoaldata && filteredgoaldata.length > 0 && dataConst.Goals.length > 0 ? Object.fromEntries(filteredgoaldata) : null;

                    var attendanceForGoals = goalDictionary != null && dataConst.Attendance ? dataConst.Attendance.filter(m => m.Status == 'Present' && goalDictionary && goalDictionary[m.ServiceId] && dateFromSDateTime(m.ForDate) >= (goalDictionary[m.ServiceId])) : [];

                    var attendanceDictionary = attendanceForGoals ? groupBy(attendanceForGoals, "ServiceId") : null;

                    var allGoalsPending = attendanceDictionary && dataConst && dataConst.Goals && dataConst.Goals.length > 0 ? dataConst.Goals.filter(m => (therapiesfiltered.indexOf(m.TherapyId) > -1) && attendanceDictionary && attendanceDictionary[m.TherapyId] && (m.Services - 1) <= attendanceDictionary[m.TherapyId].length && m.Review == null) : [];

                    return allGoalsPending;
                } catch (error) {
                    console.log(error)
                    return [];
                }
                break;
            case "goalsnotset":
                var filtered = [];
                var therapiesfiltered = dataConst.Therapies.filter(e => e.RS != "DELETEACTIVITY" && e.Status != "INACTIVE")
                $.each(therapiesfiltered, function (key, therapy) {
                    let currentGoal = $.grep(dataConst.Goals, function (e) { return e.TherapyId == therapy.Id })[0];
                    if (!currentGoal) {
                        filtered.push(therapy);
                    }
                });
                return filtered;
                break;
            case "homeworkpending":
                var filtered = dataConst.Attendance.filter(m => m.Status == 'Present' && m.Feedback == 0);
                if (isItKPI) {
                    return filtered;
                }
                break;
            case "homeworkgiven":
                var filtered = dataConst.Attendance.filter(m => m.Status == 'Present');
                if (isItKPI) {
                    return filtered;
                }
                break;
            case "feespending":
                return [];
                break;
            case "attendancepending":
                var filtered = [];

                //var totalAttendance = dataConst.TWD * dataConst.Therapies.length;
                var todayDate = new Date();
                TDT = TDT >= todayDate ? todayDate : TDT;
                var todatlWorkingDays = GetTotalWorkingDaysExcludingSaturdays(FDT, TDT);
                var currentTime = GetTimeSlotTotal(todayDate.getHours() + ":" + todayDate.getMinutes()) - 45;

                var filteredoftherapies = dataConst && dataConst.Therapies && dataConst.Therapies.length > 0 ? dataConst.Therapies.filter(e => e.RS != "DELETEACTIVITY" && e.Status != "INACTIVE") : [];

                var leavsOfAll = dataConst.Leaverequestall.filter(m => FDT <= dateFromSDateTime(m.FDT) && dateFromSDateTime(m.FDT) <= TDT)
                var composOfAll = dataConst.Compos.filter(m => m.ForDate && FDT <= dateFromSDateTime(m.ForDate) && dateFromSDateTime(m.ForDate) <= TDT);
                var leavesGroup = groupBy(leavsOfAll, "TOId");
                var composGroup = groupBy(composOfAll, "ServiceId");
                var totalAttendance = filteredoftherapies.reduce(function (accumulator, item) {

                    // item.StartDate=new Date(item.StartDate).setHours(0,0,0,0)
                    var due = (leavesGroup[item.BossId] || []);
                    due.push(...(leavesGroup[item.TherapistId] || []));
                    var filters = [];// due.filter(m=> (dateFromSDateTime(item.StartDate)) <=  dateFromSDateTime(m.FDT));
                    // var filters =  dataConst.Leaverequestall.filter(m=> (m.TOId == item.BossId || m.TOId == item.TherapistId) && (dateFromSDateTime(item.StartDate)) <=  dateFromSDateTime(m.FDT) && FDT <= dateFromSDateTime(m.FDT) && dateFromSDateTime(m.FDT) <= TDT);
                    var compos = [];// (composGroup[item.Id] || []);// dataConst.Compos.filter(m=> m.ForDate && m.ServiceId == item.Id &&  FDT <= dateFromSDateTime(m.ForDate) && dateFromSDateTime(m.ForDate) <= TDT);

                    var total = (dateFromSDateTime(item.StartDate) <= FDT ? todatlWorkingDays : ((dateFromSDateTime(item.StartDate) > FDT && dateFromSDateTime(item.StartDate) <= TDT) ? GetTotalWorkingDaysExcludingSaturdays(dateFromSDateTime(item.StartDate), TDT) : 0)) - (filters || []).length + (compos || []).length;
                    var completed = (dataConst.Attendance.filter(m => m.ServiceId == item.Id) || []).length;
                    if (new Date().getDay() != 6 && new Date().getDay() != 0 && TDT.toDateString() == (new Date()).toDateString() && GetTimeSlotTotal(item.Time) > currentTime) {
                        total -= 1;
                    }
                    var pending = total - completed;
                    pending = pending > 0 ? pending : 0;
                    if (!isItKPI) {
                        item.totalAttendance = total;
                        item.CompletedAttendance = completed;
                        item.PendingAttendance = pending;


                        item.Present = (dataConst.Attendance.filter(m => m.ServiceId == item.Id && m.Status && m.Status.toLowerCase() == "present")).length;
                        item.Absent = (dataConst.Attendance.filter(m => m.ServiceId == item.Id && (!m.Status || m.Status.toLowerCase() != "present"))).length;
                    }
                    return pending + accumulator;

                }, 0);

                if (isItKPI) {
                    return totalAttendance;
                }


                return dataConst.Therapies;
                //if (isItKPI) {
                //    return pending;
                //}
                // return dataConst.Attendance;
                break;
            case "credits":
            case "availablecredits":
                return dataConst.FutureInvoices ? dataConst.FutureInvoices : [];
                break;
            case "compospending":
                var filtered = [];

                var leaves = GetLeavesCompoCount(dataConst, FDT, TDT, null, dataConst.Therapies);

                var absent = dataConst.Attendance.filter(f => f.Status == "Absent");
                var filterdcompospending = dataConst.Compos.filter(e => new Date(e.ForDate) > FDT)
                return (leaves.length + absent.length) - filterdcompospending.length;
                //var absent = dataConst.Compos.length;
                //return filtered;
                break;

            case "compos":
                return dataConst.Compos;

                break;
            case "mirraclepending":
                var pendingmirracle = dataConst.MirraclesAssigned.filter(f => !f.Status || f.Status == "pending");
                return pendingmirracle;
                break;
            case "inactivations":
                var now = new Date();
                var fromDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);
                return dataConst.InActive && dataConst.InActive.length > 0 ? dataConst.InActive.filter(t => dateFromSDateTime(t.F14) >= fromDate) : [];
                break;
            case "admissions":
                var totalAdmissions = 0;
                var allServices = dataConst.Therapies;
                var currentUserServices = $.grep(allServices, function (r) { return dateFromSDateTime(r.StartDate) >= FDT && dateFromSDateTime(r.StartDate) <= TDT });
                var previousUserServices = $.grep(allServices, function (r) { return dateFromSDateTime(r.StartDate) < FDT });
                if (currentUserServices) {
                    var groupedKidIds = groupBy(currentUserServices, "BossId");
                    var previousKidIds = groupBy(previousUserServices, "BossId");
                    // console.log(groupedKidIds);
                    var currentMonthKids = Object.keys(groupedKidIds);
                    var prevMonthKids = Object.keys(previousKidIds);
                    totalAdmissions = $.grep(currentMonthKids, function (e) { return prevMonthKids.indexOf(e) <= -1 });

                }
                return totalAdmissions;
                break;
            case "additions":
                var totalAdditions = 0;
                var allServices = dataConst.Therapies;
                var currentUserServices = $.grep(allServices, function (r) { return dateFromSDateTime(r.StartDate) >= FDT && dateFromSDateTime(r.StartDate) <= TDT });
                var previousUserServices = $.grep(allServices, function (r) { return dateFromSDateTime(r.StartDate) < FDT });
                if (currentUserServices) {
                    var groupedKidIds = groupBy(currentUserServices, "BossId");
                    var previousKidIds = groupBy(previousUserServices, "BossId");
                    // console.log(groupedKidIds);
                    var currentMonthKids = Object.keys(groupedKidIds);
                    var prevMonthKids = Object.keys(previousKidIds);
                    // totalAdmissions = $.grep(currentMonthKids, function (e) { return prevMonthKids.indexOf(e) <= -1 }).length;
                    totalAdditions = $.grep(currentMonthKids, function (e) { return prevMonthKids.indexOf(e) >= 0 });


                    //var inactive = this.props.currentAggregate && this.props.currentAggregate.TCS ? parseInt(this.props.currentAggregate.TCS) : 0;
                    //var result = (40 / 100) * inactive;
                    //console.log(result);
                    //flagInactivations = (inactive + result) > totalAdditions

                    //  console.log(totalAdmissions);
                    //  console.log(totalAdditions);

                }
                return totalAdditions;
                break;
            case "walkinsold":
                var availableLeads = [];
                for (let i = 0; i < dataConst.Leads.length; ++i) {
                    var leadObj = {};
                    leadObj = dataConst.Leads[i];
                    if (leadObj.F3) {
                        var f3Index = leadObj.F3.indexOf("{");
                        leadObj.F3 = leadObj.F3.slice(0, f3Index);
                        availableLeads.push(leadObj);
                    }
                    else {
                        continue;
                    }

                }
                var leads = Object.entries(groupBy(availableLeads, "F3"));
                var resultleads = leads.map(f => f[1].sort((a, b) => (new Date(b.CDT) > new Date(a.CDT) ? -1 : 1))[0]);
                var filteredData = resultleads.filter((k) => k.F1.toLowerCase() == "walkin");
                return filteredData;

                break;
            case "paymentpending":
                var typeId = GetTypeIdByName(dataConst.Types, "Seva");
                var thismonthInvoice = dataConst.Fee ? dataConst.Fee.filter(f => ((dateFromSDateTime(f.CDT) <= TDT && dateFromSDateTime(f.CDT) >= FDT) || (f.Remarks && f.Remarks.toLowerCase() == "system automation"))) : [];
                var data = thismonthInvoice.map(m => m.Id);


                if (isItKPI && false) {
                    const paymnet = dataConst.FeeReceipt ? dataConst.FeeReceipt.filter(f => data.indexOf(f.FeeId) > -1 && typeId != f.TypeId) : [];

                    var invoiceamount = thismonthInvoice.reduce(function (accumulator, item) {
                        return accumulator + (item.Amount - item.SevaAmount);
                    }, 0);
                    var paymentamount = paymnet ? paymnet.reduce(function (accc, items) {
                        return accc + items.Amount;
                    }, 0) : 0;
                    var filtered = invoiceamount - paymentamount;
                    return filtered;
                }
                else {
                    const paymnets = dataConst.FeeReceipt ? dataConst.FeeReceipt.filter(f => data.indexOf(f.FeeId) > -1 && typeId != f.TypeId) : [];

                    var paymentsGroup = groupBy(paymnets, "FeeId");


                    var paymentsWithGrouping = Object.entries(paymentsGroup);

                    var paymentDict = Object.assign({}, ...(paymentsWithGrouping.map(m => ({
                        [m[0]]: m[1].reduce(function (accc, items) {
                            return accc + items.Amount;
                        }, 0)
                    }))));

                    var amounts = thismonthInvoice.filter(f => (f.Amount - f.SevaAmount) > (paymentDict[f.Id] ? paymentDict[f.Id] : 0));


                    if (isItKPI) {
                        var invoiceamount = amounts.reduce(function (accumulator, item) {

                            var amount = (item.Amount - item.SevaAmount - (paymentDict[item.Id] ? paymentDict[item.Id] : 0));
                            amount = amount > 0 ? amount : 0;
                            return accumulator + amount;
                        }, 0);

                        return invoiceamount;
                    }

                    var peopleGroup = groupBy(dataConst.People, "Id");
                    var typesGroup = groupBy(dataConst.Types, "Id");
                    var facilitiesGroup = groupBy(dataConst.Centers, "Id");

                    var data = [];
                    $.each(amounts, function (k, a) {
                        var obj = {};
                        var opending = a.Amount - a.SevaAmount - (paymentDict[a.Id] ? paymentDict[a.Id] : 0);
                        opending = opending ? opending : 0;
                        obj.Facility = facilitiesGroup[a.CenterId][0].Name;//peopleGroup[a.BOSSId] ? facilitiesGroup[peopleGroup[a.BOSSId][0].CenterId] ? facilitiesGroup[peopleGroup[a.BOSSId][0].CenterId][0].Name : "" : "";
                        obj.MonthId = window.appMonthNames[dateFromSDateTime(a.CDT).getMonth()];
                        obj.Id = a.Id;
                        obj.Kid = peopleGroup[a.BOSSId] ? peopleGroup[a.BOSSId][0].Name : "";
                        obj.KidId = a.BOSSId;
                        obj.Created = a.CDT;
                        obj.From = a.FDT;
                        obj.To = a.TDT;
                        obj.ETA = a.ETA;
                        obj.Total = a.Amount;
                        obj.Seva = a.SevaAmount;
                        //obj.PaymentType = paymentsGroup[a.Id] ? paymentsGroup[a.Id].map(m => typesGroup[m.TypeId] ? typesGroup[m.TypeId][0].Name : "").join() : "";
                        obj.ReceivedDates = paymentsGroup[a.Id] ? paymentsGroup[a.Id].map(m => m.CDT ? m.CDT : "").join(",") : "";
                        obj.PaidAmt = paymentDict[a.Id] ? paymentDict[a.Id] : 0;
                        obj.PendingAmt = opending;
                        data.push(obj);
                    });

                    return data;
                }
                break;
            case "inflow":
                var typeId = GetTypeIdByName(dataConst.Types, "Seva");
                var allPayments = dataConst.FeeReceipt.filter(f => typeId != f.TypeId && (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT));
                var invoiceIds = allPayments.map(m => m.FeeId);
                var amounts = dataConst.FeeAll.filter(f => invoiceIds.indexOf(f.Id) > -1);

                const inflowpaymnets = dataConst.FeeReceipt ? dataConst.FeeReceipt.filter(f => invoiceIds.indexOf(f.FeeId) > -1 && typeId != f.TypeId) : [];

                var paymentsGroup = groupBy(inflowpaymnets, "FeeId");
                var paymentsWithGrouping = Object.entries(paymentsGroup);
                var paymentDict = Object.assign({}, ...paymentsWithGrouping.map(m => ({
                    [m[0]]: m[1].reduce(function (accc, items) {
                        return accc + items.Amount;
                    }, 0)
                })));


                var peopleGroup = groupBy(dataConst.People, "Id");
                var typesGroup = groupBy(dataConst.Types, "Id");
                var facilitiesGroup = groupBy(dataConst.Centers, "Id");
                var data = [];
                $.each(amounts, function (k, a) {
                    var obj = {};
                    obj.Facility = facilitiesGroup[a.CenterId][0].Name;//peopleGroup[a.BOSSId] ? facilitiesGroup[peopleGroup[a.BOSSId][0].CenterId] ? facilitiesGroup[peopleGroup[a.BOSSId][0].CenterId][0].Name : "" : "";
                    obj.MonthId = window.appMonthNames[dateFromSDateTime(a.CDT).getMonth()];
                    obj.Id = a.Id;
                    obj.Kid = peopleGroup[a.BOSSId] ? peopleGroup[a.BOSSId][0].Name : "";
                    obj.Created = a.CDT;
                    obj.From = a.FDT;
                    obj.To = a.TDT;
                    obj.Total = a.Amount;

                    obj.Seva = a.SevaAmount;
                    obj.Amount = paymentDict[a.Id] ? paymentDict[a.Id] : 0;
                    obj.PaymentType = paymentsGroup[a.Id] ? paymentsGroup[a.Id].map(m => typesGroup[m.TypeId] ? typesGroup[m.TypeId][0].Name : "").join() : "";
                    obj.ReceivedDates = paymentsGroup[a.Id] ? paymentsGroup[a.Id].map(m => m.CDT ? m.CDT : "").join(",") : "";
                    obj.PaidAmt = paymentDict[a.Id] ? paymentDict[a.Id] : 0;
                    obj.PendingAmt = a.Amount - a.SevaAmount - (paymentDict[a.Id] ? paymentDict[a.Id] : 0);
                    data.push(obj);
                });
                return data;

                break;

            case "business":
                var advancedata = dataConst.FeeAll.filter(f => (f.Remarks && f.Remarks.toLowerCase() == "system automation") ? ((dateFromSDateTime(f.FDT) >= FDT && dateFromSDateTime(f.FDT) <= TDT)) : (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT));
                var advances = advancedata ? advancedata.map(m => m.Id) : [];
                const buspaymnets = dataConst.FeeReceipt ? dataConst.FeeReceipt.filter(f => advances.indexOf(f.FeeId) > -1) : [];

                var paymentsGroup = groupBy(buspaymnets, "FeeId");


                var paymentsWithGrouping = Object.entries(paymentsGroup);

                var paymentDict = Object.assign({}, ...(paymentsWithGrouping.map(m => ({
                    [m[0]]: m[1].reduce(function (accc, items) {
                        return accc + items.Amount;
                    }, 0)
                }))));

                var amounts = advancedata;
                var peopleGroup = groupBy(dataConst.People, "Id");
                var typesGroup = groupBy(dataConst.Types, "Id");
                var facilitiesGroup = groupBy(dataConst.Centers, "Id");
                var data = [];
                $.each(amounts, function (k, a) {
                    var obj = {};
                    obj.Facility = facilitiesGroup[a.CenterId][0].Name;//peopleGroup[a.BOSSId] ? facilitiesGroup[peopleGroup[a.BOSSId][0].CenterId] ? facilitiesGroup[peopleGroup[a.BOSSId][0].CenterId][0].Name : "" : "";
                    obj.MonthId = window.appMonthNames[dateFromSDateTime(a.CDT).getMonth()];
                    obj.Id = a.Id;
                    obj.Kid = peopleGroup[a.BOSSId] ? peopleGroup[a.BOSSId][0].Name : "";
                    obj.Created = a.CDT;
                    obj.From = a.FDT;
                    obj.To = a.TDT;
                    obj.Total = a.Amount;

                    obj.Seva = a.SevaAmount;
                    obj.Amount = a.Amount - a.SevaAmount;
                    obj.PaymentType = paymentsGroup[a.Id] ? paymentsGroup[a.Id].map(m => typesGroup[m.TypeId] ? typesGroup[m.TypeId][0].Name : "").join() : "";
                    obj.ReceivedDates = paymentsGroup[a.Id] ? paymentsGroup[a.Id].map(m => m.CDT ? m.CDT : "").join(",") : "";
                    obj.PaidAmt = paymentDict[a.Id] ? paymentDict[a.Id] : 0;
                    obj.PendingAmt = a.Amount - a.SevaAmount - (paymentDict[a.Id] ? paymentDict[a.Id] : 0);
                    data.push(obj);
                });






                return data;

            case "advancepending":
                var advancedata = dataConst.FutureInvoices ? dataConst.FutureInvoices.filter(f => (dateFromSDateTime(f.CDT) <= TDT && dateFromSDateTime(f.CDT) >= FDT) && (!f.Remarks || f.Remarks.toLowerCase() != "system automation")) : [];
                var advances = advancedata ? advancedata.map(m => m.Id) : [];
                var typeId = GetTypeIdByName(dataConst.Types, "Seva");
                const adpaymnets = dataConst.FeeReceipt ? dataConst.FeeReceipt.filter(f => f.TypeId != typeId && advances.indexOf(f.FeeId) > -1) : [];


                if (isItKPI && false) {

                    var paymentsGroup = groupBy(adpaymnets, "FeeId");


                    var paymentsWithGrouping = Object.entries(paymentsGroup);

                    var paymentDict = Object.assign({}, ...(paymentsWithGrouping.map(m => ({
                        [m[0]]: m[1].reduce(function (accc, items) {
                            return accc + items.Amount;
                        }, 0)
                    }))));

                    advancedata = advancedata.filter(f => (f.Amount - f.SevaAmount) > (paymentDict[f.Id] ? paymentDict[f.Id] : 0))


                    var invoicesamount = advancedata ? advancedata.reduce(function (accumulator, item) {
                        return accumulator + (item.Amount - item.SevaAmount);
                    }, 0) : 0;

                    advances = advancedata.map(f => f.Id);
                    var paymentsamount = adpaymnets ? adpaymnets.filter(a => advances.indexOf(a.Id) > -1).reduce(function (accc, items) {
                        return accc + items.Amount;
                    }, 0) : 0;
                    var filtered = invoicesamount - paymentsamount;
                    return filtered;
                }
                else {
                    const paymnets = adpaymnets;

                    var paymentsGroup = groupBy(paymnets, "FeeId");


                    var paymentsWithGrouping = Object.entries(paymentsGroup);

                    var paymentDict = Object.assign({}, ...(paymentsWithGrouping.map(m => ({
                        [m[0]]: m[1].reduce(function (accc, items) {
                            return accc + items.Amount;
                        }, 0)
                    }))));
                    dataConst.Centers = dataConst.Centers ? dataConst.Centers : [];
                    var amounts = advancedata.filter(f => (f.Amount - f.SevaAmount) > (paymentDict[f.Id] ? paymentDict[f.Id] : 0));
                    var peopleGroup = groupBy(dataConst.People, "Id");
                    var typesGroup = groupBy(dataConst.Types, "Id");
                    var facilitiesGroup = groupBy(dataConst.Centers, "Id");
                    var data = [];
                    $.each(amounts, function (k, a) {
                        var obj = {};
                        obj.Facility = facilitiesGroup[a.CenterId] ? facilitiesGroup[a.CenterId][0].Name : '';//peopleGroup[a.BOSSId] ? facilitiesGroup[peopleGroup[a.BOSSId][0].CenterId] ? facilitiesGroup[peopleGroup[a.BOSSId][0].CenterId][0].Name : "" : "";
                        obj.MonthId = window.appMonthNames[dateFromSDateTime(a.CDT).getMonth()];
                        obj.Id = a.Id;
                        obj.Kid = peopleGroup[a.BOSSId] ? peopleGroup[a.BOSSId][0].Name : "";
                        obj.KidId = a.BOSSId;
                        obj.Created = a.CDT;
                        obj.From = a.FDT;
                        obj.To = a.TDT;
                        obj.Total = a.Amount;
                        obj.Seva = a.SevaAmount;
                        // obj.PaymentType = paymentsGroup[a.Id] ? paymentsGroup[a.Id].map(m => typesGroup[m.TypeId] ? typesGroup[m.TypeId][0].Name : "").join() : "";
                        obj.ReceivedDates = paymentsGroup[a.Id] ? paymentsGroup[a.Id].map(m => m.CDT ? m.CDT : "").join(",") : "";
                        obj.PaidAmt = paymentDict[a.Id] ? paymentDict[a.Id] : 0;
                        obj.PendingAmt = a.Amount - a.SevaAmount - (paymentDict[a.Id] ? paymentDict[a.Id] : 0);
                        data.push(obj);
                    });

                    if (isItKPI) {
                        var invoicesamount = data ? data.reduce(function (accumulator, item) {
                            return accumulator + (item.PendingAmt);
                        }, 0) : 0;
                        return invoicesamount;
                    }

                    return data;
                }
                break;
            case "overallpending":
            case "etapending":
                var bids = dataConst.Therapies.map(m => m.BossId);
                var allData = dataConst.FeeAll ? dataConst.FeeAll.filter(f => f.RS != "DELETEACTIVITY" && f.Status != "PAID" && bids.indexOf(f.BOSSId) > -1) : [];
                var typeId = GetTypeIdByName(dataConst.Types, "Seva");
                const paymnets = dataConst.FeeReceipt ? dataConst.FeeReceipt.filter(f => f.TypeId != typeId) : [];



                var paymentsGroup = groupBy(paymnets, "FeeId");


                var paymentsWithGrouping = Object.entries(paymentsGroup);

                var paymentDict = Object.assign({}, ...(paymentsWithGrouping.map(m => ({
                    [m[0]]: m[1].reduce(function (accc, items) {
                        return accc + items.Amount;
                    }, 0)
                }))));
                dataConst.Centers = dataConst.Centers ? dataConst.Centers : [];
                var amounts = allData.filter(f => (f.Amount - f.SevaAmount) > (paymentDict[f.Id] ? paymentDict[f.Id] : 0));
                var peopleGroup = groupBy(dataConst.People, "Id");
                var typesGroup = groupBy(dataConst.Types, "Id");
                var facilitiesGroup = groupBy(dataConst.Centers, "Id");
                var data = [];
                $.each(amounts, function (k, a) {
                    var obj = {};
                    obj.Facility = facilitiesGroup[a.CenterId] ? facilitiesGroup[a.CenterId][0].Name : '';//peopleGroup[a.BOSSId] ? facilitiesGroup[peopleGroup[a.BOSSId][0].CenterId] ? facilitiesGroup[peopleGroup[a.BOSSId][0].CenterId][0].Name : "" : "";
                    obj.MonthId = window.appMonthNames[dateFromSDateTime(a.CDT).getMonth()];
                    obj.Id = a.Id;
                    obj.Kid = peopleGroup[a.BOSSId] ? peopleGroup[a.BOSSId][0].Name : "";
                    obj.KidId = a.BOSSId;
                    obj.Created = a.CDT;
                    obj.From = a.FDT;
                    if (type.toLowerCase() == "etapending") {
                        obj.ETA = a.ETA;
                    }
                    obj.To = a.TDT;
                    obj.Total = a.Amount;
                    obj.Seva = a.SevaAmount;
                    // obj.PaymentType = paymentsGroup[a.Id] ? paymentsGroup[a.Id].map(m => typesGroup[m.TypeId] ? typesGroup[m.TypeId][0].Name : "").join() : "";
                    obj.ReceivedDates = paymentsGroup[a.Id] ? paymentsGroup[a.Id].map(m => m.CDT ? m.CDT : "").join(",") : "";
                    obj.PaidAmt = paymentDict[a.Id] ? paymentDict[a.Id] : 0;
                    obj.PendingAmt = a.Amount - a.SevaAmount - (paymentDict[a.Id] ? paymentDict[a.Id] : 0);
                    data.push(obj);
                });

                if (isItKPI && type.toLowerCase() != "etapending") {
                    var invoicesamount = data ? data.reduce(function (accumulator, item) {
                        return accumulator + (item.PendingAmt);
                    }, 0) : 0;
                    return invoicesamount;
                }
                if (type.toLowerCase() == "etapending") {

                    var data = data.filter(e => !e.ETA);
                    if (isItKPI) {
                        var invoicesamount = data ? data.reduce(function (accumulator, item) {
                            return accumulator + (item.PendingAmt);
                        }, 0) : 0;
                        return invoicesamount;
                    }
                    return data;
                }

                return data;

                break;
            case "pastpending":

                var bids = dataConst.Therapies.map(m => m.BossId);
                var advancedata = dataConst.FeeAll ? dataConst.FeeAll.filter(f => bids.indexOf(f.BOSSId) > -1 && (dateFromSDateTime(f.CDT) < FDT)) : [];

                var advances = advancedata ? advancedata.map(m => m.Id) : [];
                const papaymnets = dataConst.FeeReceipt ? dataConst.FeeReceipt.filter(f => advances.indexOf(f.FeeId) > -1) : [];

                if (isItKPI) {

                    var paymentsGroup = groupBy(papaymnets, "FeeId");


                    var paymentsWithGrouping = Object.entries(paymentsGroup);

                    var paymentDict = Object.assign({}, ...(paymentsWithGrouping.map(m => ({
                        [m[0]]: m[1].reduce(function (accc, items) {
                            return accc + items.Amount;
                        }, 0)
                    }))));

                    advancedata = advancedata.filter(f => (f.Amount - f.SevaAmount) > (paymentDict[f.Id] ? paymentDict[f.Id] : 0));

                    var invoicesamount = advancedata ? advancedata.reduce(function (accumulator, item) {
                        return accumulator + item.Amount;
                    }, 0) : 0;
                    advances = advancedata.map(f => f.Id);
                    var paymentsamount = papaymnets ? papaymnets.filter(a => advances.indexOf(a.Id) > -1).reduce(function (accc, items) {
                        return accc + items.Amount;
                    }, 0) : 0;
                    var filtered = invoicesamount - paymentsamount;
                    return filtered;
                }
                else {
                    const paymnets = papaymnets;

                    var paymentsGroup = groupBy(paymnets, "FeeId");


                    var paymentsWithGrouping = Object.entries(paymentsGroup);

                    var paymentDict = Object.assign({}, ...(paymentsWithGrouping.map(m => ({
                        [m[0]]: m[1].reduce(function (accc, items) {
                            return accc + items.Amount;
                        }, 0)
                    }))));

                    var amounts = advancedata.filter(f => (f.Amount - f.SevaAmount) > (paymentDict[f.Id] ? paymentDict[f.Id] : 0));
                    var peopleGroup = groupBy(dataConst.People, "Id");
                    var typesGroup = groupBy(dataConst.Types, "Id");
                    var facilitiesGroup = groupBy(dataConst.Centers, "Id");
                    var data = [];
                    $.each(amounts, function (k, a) {
                        var obj = {};
                        obj.Facility = facilitiesGroup[a.CenterId] && facilitiesGroup[a.CenterId][0] ? facilitiesGroup[a.CenterId][0].Name : "";//peopleGroup[a.BOSSId] ? facilitiesGroup[peopleGroup[a.BOSSId][0].CenterId] ? facilitiesGroup[peopleGroup[a.BOSSId][0].CenterId][0].Name : "" : "";
                        obj.MonthId = window.appMonthNames[dateFromSDateTime(a.CDT).getMonth()];
                        obj.Id = a.Id;
                        obj.Kid = peopleGroup[a.BOSSId] && peopleGroup[a.BOSSId][0] ? peopleGroup[a.BOSSId][0].Name : "";
                        obj.KidId = a.BOSSId;
                        obj.Created = a.CDT;
                        obj.From = a.FDT;
                        obj.To = a.TDT;
                        obj.Total = a.Amount;
                        obj.Seva = a.SevaAmount;
                        obj.Remarks = a.Remarks;
                        // obj.PaymentType = paymentsGroup[a.Id] ? paymentsGroup[a.Id].map(m => typesGroup[m.TypeId] ? typesGroup[m.TypeId][0].Name : "").join() : "";
                        obj.ReceivedDates = paymentsGroup[a.Id] ? paymentsGroup[a.Id].map(m => m.CDT ? m.CDT : "").join(",") : "";
                        obj.PaidAmt = paymentDict[a.Id] ? paymentDict[a.Id] : 0;
                        obj.PendingAmt = a.Amount - a.SevaAmount - (paymentDict[a.Id] ? paymentDict[a.Id] : 0);
                        data.push(obj);
                    });

                    if (isItKPI) {
                        var invoicesamount = data ? data.reduce(function (accumulator, item) {
                            return accumulator + (item.PendingAmt);
                        }, 0) : 0;
                        return invoicesamount;
                    }


                    return data;
                }
                break;
            case "leadspending":
            case "closedleadsdata":
            case "activeleadsdata":
            case "leadselsewhere":
            case "leadstoadmission":
            case "newleads":
            case "additionleads":
            case "admissionleads":
            case "joinedelsewhere":
            case "assessmentsleads":
            case "walkinleads":
            case "closedleadsnew":
            case "newleadsnew":
            case "pendingleads":
            case "activeleadsnew":
            case "activeleads":
            case "closedleads":
            case "totalleads":
            case "walkins":
                let leadsClosedSTatus = ['CLOSED', 'NOT INTRESTED', 'ALREADY JOINED SOMEWHERE', 'WRONG CALL', 'ENROLED', 'ENROLLED', 'ENROLLED AGAIN', 'ENQUIRED FOR JOB', 'VENDOR'];
                var availLeads = [];
                var leadsGroups = dataConst.Leads ? Object.entries(groupBy(dataConst.Leads, "F17")) : [];
                var leadsData = leadsGroups && leadsGroups.length ? leadsGroups.map(m => m[1].sort((a, b) => (new Date(a.CDT) > new Date(b.CDT) ? -1 : 1))) : [];


                if (type.toLowerCase() == "leadspending" || type.toLowerCase() == "pendingleads") {

                    return leadsData.filter(f => (!f[0].Status || leadsClosedSTatus.indexOf(f[0].Status.toUpperCase()) == -1) && (!f[0].FDT || dateFromSDateTime(f[0].FDT) <= (TDT > new Date() ? new Date() : TDT)));
                }
                if (type.toLowerCase() == "newleads" || type.toLowerCase() == "additionleads" || type.toLowerCase() == "newleadsnew") {

                    var newLeads = leadsData.filter(f => new Date(f[f.length - 1].CDT >= new Date(FDT) && new Date(f[f.length - 1].CDT) <= new Date(TDT)));
                    return newLeads;
                }
                else if (type.toLowerCase() == "closedleadsdata" || type.toLowerCase() == "closedleads" || type.toLowerCase() == "closedleadsnew") {
                    return leadsData.filter(f => f[0].Status && leadsClosedSTatus.indexOf(f[0].Status.toUpperCase()) > -1);
                }
                else if (type.toLowerCase() == "activeleadsdata" || type.toLowerCase() == "activeleadsnew" || type.toLowerCase() == "activeleads") {
                    return leadsData.filter(f => !f[0].Status || leadsClosedSTatus.indexOf(f[0].Status.toUpperCase()) == -1);
                }
                else if (type.toLowerCase() == "leadselsewhere" || type.toLowerCase() == "joinedelsewhere") {
                    leadsClosedSTatus = ['ALREADY JOINED SOMEWHERE'];
                    return leadsData.filter(f => f[0].Status && leadsClosedSTatus.indexOf(f[0].Status.toUpperCase()) > -1);
                }
                else if (type.toLowerCase() == "leadstoadmission" || type.toLowerCase() == "admissionleads") {
                    leadsClosedSTatus = ["enrolled", "enroled"];
                    var newLeadSData = leadsData.filter(f => f[0].Status && leadsClosedSTatus.indexOf(f[0].Status.toLowerCase()) > -1);
                    var filteredleads = newLeadSData ? dataConst.People.map(e => e.Id) : []
                    return newLeadSData.filter(e => filteredleads.indexOf(e[0].TOId) > -1)
                }
                else if (type.toLowerCase() == "walkins" || type.toLowerCase() == "walkinleads") {

                    var mobiles = dataConst.Leads.filter(f => dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT && f.Status && f.Status.toLowerCase() == "walkin").map(m => m.F3);
                    return leadsGroups.filter(f => mobiles.indexOf(f[0]) > -1).map(m => m[1]);
                }
                else if (type.toLowerCase() == "totalleads") {

                    return leadsData.filter(f => (f[0].Status && leadsClosedSTatus.indexOf(f[0].Status.toUpperCase()) > -1) || (!f[0].Status || leadsClosedSTatus.indexOf(f[0].Status.toUpperCase()) == -1));
                }

                for (let i = 0; i < dataConst.Leads.length; ++i) {
                    var leadObj = {};
                    leadObj = dataConst.Leads[i];
                    if (leadObj.F3) {
                        var f3Index = leadObj.F3.indexOf("{");
                        leadObj.F3 = leadObj.F3.slice(0, f3Index);
                        availLeads.push(leadObj);
                    }
                    else {
                        continue;
                    }

                }
                var leads = Object.entries(groupBy(availLeads, "F3"));
                leads.filter(f => !f[1] || leadsClosedSTatus.indexOf(f[1].sort((a, b) => (new Date(b.CDT) > new Date(a.CDT) ? -1 : 1))[0].Status) == -1);

                return leads;

                break;
            case "assessmentpending":
                var filteredasss = dataConst.Assessmentsdata ? dataConst.Assessmentsdata.filter(m => m.Status && m.Status == "PENDING") : [];
                if (isItKPI) {
                    return filteredasss;
                }

                break;
            case "assessmentcompleted":
                var filteredasss = dataConst.Assessmentsdata ? dataConst.Assessmentsdata.filter(m => m.Status && m.Status.toLowerCase() == "completed") : [];
                if (isItKPI) {
                    return filteredasss;
                }

                break;
            case "assessmentall":
                var filteredasss = dataConst.Assessmentsdata ? dataConst.Assessmentsdata : [];
                if (isItKPI) {
                    return filteredasss;
                }

                break;
            case "leavespending":
                var filtered = dataConst.Leaverequestall ? dataConst.Leaverequestall.filter(m => m.Status != "APPROVED" && m.Status != "CANCELED" && m.F8 == "" && m.F1 != "Parent") : [];
                if (isItKPI) {
                    return filtered;
                }
                break;
            case "leavesall":
                var filtered = dataConst.Leaverequestall ? dataConst.Leaverequestall.filter(m => m.F1 != "Parent") : [];
                if (isItKPI) {
                    return filtered;
                }
                break;
            case "leavesapproved":
                var filtered = dataConst.Leaverequestall ? dataConst.Leaverequestall.filter(m => m.Status == "APPROVED" && m.F1 != "Parent") : [];
                if (isItKPI) {
                    return filtered;
                }
                break;
            case "leavesunapproved":
                var filtered = dataConst.Leaverequestall ? dataConst.Leaverequestall.filter(m => m.Status == "UNAPPROVED" && m.F1 != "Parent") : [];
                if (isItKPI) {
                    return filtered;
                }
                break;
            case "servicerequestpending":

                var serviceRequests = dataConst.ServiceRequest && dataConst.ServiceRequest.length > 0 ? dataConst.ServiceRequest.filter(e => (!e.RS || e.RS != "DELETEACTIVITY")) : [];
                var analytics = dataConst.ServiceRequestAnalytic.sort((a, b) => (dateFromSDateTime(a.CDT) > dateFromSDateTime(b.CDT) ? -1 : 1));
                var responses = groupBy(analytics, "SRId");

                var srs = serviceRequests.map(function (m) {
                    return {
                        ...m, "LastAnalytic"
                            : ((responses[m.Id + ""] && responses[m.Id + ""].length > 0) ? responses[m.Id + ""][0] : null)
                    }
                });

                var service = serviceRequests ? serviceRequests.map(m => m.Id) : [];
                const analticsdta = dataConst.ServiceRequestAnalytic ? dataConst.ServiceRequestAnalytic.filter(f => service.indexOf(f.SRId) > -1) : [];
                var filtered = srs.LastAnalytic ? srs.filter(m => m.LastAnalytic.Status != "CLOSED") : "";

                if (isItKPI) {
                    return filtered;
                }
                break;
            case "servicerequestall":
                //var filtered = [];
                var serviceRequests = dataConst.ServiceRequest && dataConst.ServiceRequest.length > 0 ? dataConst.ServiceRequest.filter(e => (!e.RS || e.RS != "DELETEACTIVITY")) : [];
                var analytics = dataConst.ServiceRequestAnalytic.sort((a, b) => (dateFromSDateTime(a.CDT) > dateFromSDateTime(b.CDT) ? -1 : 1));
                var responses = groupBy(analytics, "SRId");

                var srs = serviceRequests.map(function (m) {
                    return {
                        ...m, "LastAnalytic"
                            : ((responses[m.Id + ""] && responses[m.Id + ""].length > 0) ? responses[m.Id + ""][0] : null)
                    }
                });
                //var empty = []
                var servicee = serviceRequests ? serviceRequests.map(m => m.Id) : [];
                var SRRO = srs.filter(m => m.LastAnalytic && m.LastAnalytic.Status == "REOPEN");

                var SRR = srs.filter(m => dateFromSDateTime(m.CDT) >= FDT && dateFromSDateTime(m.CDT) <= TDT && m.LastAnalytic && m.LastAnalytic.Status == "CLOSED" && m.CBPI == m.LastAnalytic.CBPI);
                var SRW = srs.filter(m => m.LastAnalytic && m.LastAnalytic.Status == "CLOSED" && m.CBPI != m.LastAnalytic.CBPI)
                var SRIPdata = dataConst.ServiceRequestAnalytic ? dataConst.ServiceRequestAnalytic.filter(f => servicee.indexOf(f.SRId) > -1) : [];
                var SRIP = SRIPdata.filter(m => m.Status != "CLOSED");

                //empty.push(...SRRO, ...SRR, ...SRIP, ...SRW)
                var newdata = SRRO.concat(SRR, SRW)
                //var filtered = aggregate.SRRO + aggregate.SRR + aggregate.SRW + aggregate.SRIP;
                var filtered = newdata;
                if (isItKPI) {
                    return filtered;
                }
                break;
            case "servicerequestactive":
                var filtered = [];

                //var filtered = aggregate.SRT + aggregate.SRW + aggregate.SRIP + aggregate.SRRO;
                if (isItKPI) {
                    return filtered;
                }
                break;
            case "servicerequestwaiting":
                var serviceRequests = dataConst.ServiceRequest && dataConst.ServiceRequest.length > 0 ? dataConst.ServiceRequest.filter(e => (!e.RS || e.RS != "DELETEACTIVITY")) : [];
                var analytics = dataConst.ServiceRequestAnalytic.sort((a, b) => (dateFromSDateTime(a.CDT) > dateFromSDateTime(b.CDT) ? -1 : 1));
                var responses = groupBy(analytics, "SRId");

                var srs = serviceRequests.map(function (m) {
                    return {
                        ...m, "LastAnalytic"
                            : ((responses[m.Id + ""] && responses[m.Id + ""].length > 0) ? responses[m.Id + ""][0] : null)
                    }
                });
                var filtered = srs.filter(m => m.LastAnalytic && m.LastAnalytic.Status == "CLOSED" && m.CBPI != m.LastAnalytic.CBPI);
                if (isItKPI) {
                    return filtered;
                }
                break;

            case "servicerequestresolved":
                var serviceRequests = dataConst.ServiceRequest && dataConst.ServiceRequest.length > 0 ? dataConst.ServiceRequest.filter(e => (!e.RS || e.RS != "DELETEACTIVITY")) : [];
                var analytics = dataConst.ServiceRequestAnalytic.sort((a, b) => (dateFromSDateTime(a.CDT) > dateFromSDateTime(b.CDT) ? -1 : 1));
                var responses = groupBy(analytics, "SRId");

                var srs = serviceRequests.map(function (m) {
                    return {
                        ...m, "LastAnalytic"
                            : ((responses[m.Id + ""] && responses[m.Id + ""].length > 0) ? responses[m.Id + ""][0] : null)
                    }
                });
                var filtered = srs.filter(m => dateFromSDateTime(m.CDT) >= FDT && dateFromSDateTime(m.CDT) <= TDT && m.LastAnalytic && m.LastAnalytic.Status == "CLOSED" && m.CBPI == m.LastAnalytic.CBPI);
                if (isItKPI) {
                    return filtered;
                }
                break;
            case "servicerequestreopened":
                var serviceRequests = dataConst.ServiceRequest && dataConst.ServiceRequest.length > 0 ? dataConst.ServiceRequest.filter(e => (!e.RS || e.RS != "DELETEACTIVITY")) : [];
                var analytics = dataConst.ServiceRequestAnalytic.sort((a, b) => (dateFromSDateTime(a.CDT) > dateFromSDateTime(b.CDT) ? -1 : 1));
                var responses = groupBy(analytics, "SRId");

                var srs = serviceRequests.map(function (m) {
                    return {
                        ...m, "LastAnalytic"
                            : ((responses[m.Id + ""] && responses[m.Id + ""].length > 0) ? responses[m.Id + ""][0] : null)
                    }
                });
                var filtered = srs.filter(m => m.LastAnalytic && m.LastAnalytic.Status == "REOPEN")
                if (isItKPI) {
                    return filtered;
                }
                break;
            case "servicerequestrating5":
                var serviceRequests = dataConst.ServiceRequest && dataConst.ServiceRequest.length > 0 ? dataConst.ServiceRequest.filter(e => (!e.RS || e.RS != "DELETEACTIVITY")) : [];
                var analytics = dataConst.ServiceRequestAnalytic.sort((a, b) => (dateFromSDateTime(a.CDT) > dateFromSDateTime(b.CDT) ? -1 : 1));
                var responses = groupBy(analytics, "SRId");

                var srs = serviceRequests.map(function (m) {
                    return {
                        ...m, "LastAnalytic"
                            : ((responses[m.Id + ""] && responses[m.Id + ""].length > 0) ? responses[m.Id + ""][0] : null)
                    }
                });
                var filtered = srs.filter(m => m.Rating == 5)
                if (isItKPI) {
                    return filtered;
                }
                break;
            case "servicerequestrating4":
                var serviceRequests = dataConst.ServiceRequest && dataConst.ServiceRequest.length > 0 ? dataConst.ServiceRequest.filter(e => (!e.RS || e.RS != "DELETEACTIVITY")) : [];
                var analytics = dataConst.ServiceRequestAnalytic.sort((a, b) => (dateFromSDateTime(a.CDT) > dateFromSDateTime(b.CDT) ? -1 : 1));
                var responses = groupBy(analytics, "SRId");

                var srs = serviceRequests.map(function (m) {
                    return {
                        ...m, "LastAnalytic"
                            : ((responses[m.Id + ""] && responses[m.Id + ""].length > 0) ? responses[m.Id + ""][0] : null)
                    }
                });
                var filtered = srs.filter(m => m.Rating == 4)
                if (isItKPI) {
                    return filtered;
                }
                break;
            case "servicerequestrating3":
                var serviceRequests = dataConst.ServiceRequest && dataConst.ServiceRequest.length > 0 ? dataConst.ServiceRequest.filter(e => (!e.RS || e.RS != "DELETEACTIVITY")) : [];
                var analytics = dataConst.ServiceRequestAnalytic.sort((a, b) => (dateFromSDateTime(a.CDT) > dateFromSDateTime(b.CDT) ? -1 : 1));
                var responses = groupBy(analytics, "SRId");

                var srs = serviceRequests.map(function (m) {
                    return {
                        ...m, "LastAnalytic"
                            : ((responses[m.Id + ""] && responses[m.Id + ""].length > 0) ? responses[m.Id + ""][0] : null)
                    }
                });
                var filtered = srs.filter(m => m.Rating == 3)
                if (isItKPI) {
                    return filtered;
                }
                break;
            case "servicerequestrating2":
                var serviceRequests = dataConst.ServiceRequest && dataConst.ServiceRequest.length > 0 ? dataConst.ServiceRequest.filter(e => (!e.RS || e.RS != "DELETEACTIVITY")) : [];
                var analytics = dataConst.ServiceRequestAnalytic.sort((a, b) => (dateFromSDateTime(a.CDT) > dateFromSDateTime(b.CDT) ? -1 : 1));
                var responses = groupBy(analytics, "SRId");

                var srs = serviceRequests.map(function (m) {
                    return {
                        ...m, "LastAnalytic"
                            : ((responses[m.Id + ""] && responses[m.Id + ""].length > 0) ? responses[m.Id + ""][0] : null)
                    }
                });
                var filtered = srs.filter(m => m.Rating == 2)
                if (isItKPI) {
                    return filtered;
                }
                break;
            case "servicerequestrating1":
                var serviceRequests = dataConst.ServiceRequest && dataConst.ServiceRequest.length > 0 ? dataConst.ServiceRequest.filter(e => (!e.RS || e.RS != "DELETEACTIVITY")) : [];
                var analytics = dataConst.ServiceRequestAnalytic.sort((a, b) => (dateFromSDateTime(a.CDT) > dateFromSDateTime(b.CDT) ? -1 : 1));
                var responses = groupBy(analytics, "SRId");

                var srs = serviceRequests.map(function (m) {
                    return {
                        ...m, "LastAnalytic"
                            : ((responses[m.Id + ""] && responses[m.Id + ""].length > 0) ? responses[m.Id + ""][0] : null)
                    }
                });
                var filtered = srs.filter(m => m.Rating == 1)
                if (isItKPI) {
                    return filtered;
                }
                break;
            case "chipending":
                dataConst.Types = dataConst.Types || [];
                var typeId = dataConst.Types.filter(m => m.Name == "CHI" && m.Category == "ASSESSMENT")[0].Id;
                var ids = dataConst.Responses ? dataConst.Responses.map(m => m.CenterNoteId) : [];
                return dataConst.CenterNotes.filter(m => !(m.Status == "COMPLETED" || ids.indexOf(m.Id) > -1) && m.TypeId == typeId);
                break;
            case "whipending":
                dataConst.Types = dataConst.Types || [];
                var typeId = dataConst.Types.filter(m => m.Name == "WHI" && m.Category == "ASSESSMENT")[0].Id;
                var ids = dataConst.Responses ? dataConst.Responses.map(m => m.PeopleNoteId) : [];
                return dataConst.PeopleNotes.filter(m => !(m.Status == "COMPLETED" || ids.indexOf(m.Id) > -1) && ids.indexOf(m.Id) == -1 && m.TypeId == typeId);

                // return [];
                break;

            case "pisipending":
                dataConst.Types = dataConst.Types || [];
                var ids = dataConst.Responses ? dataConst.Responses.map(m => m.PeopleNoteId) : [];
                var typeId = dataConst.Types.filter(m => m.Name == "PISI" && m.Category == "ASSESSMENT")[0].Id
                return dataConst.PeopleNotes.filter(m => !(m.Status == "COMPLETED" || ids.indexOf(m.Id) > -1) && m.TypeId == typeId);

                // return [];
                break;

            case "therapiesprovided":
                return dataConst.Therapies;
                break;
            case "activeservices":

                TDT = TDT > new Date() ? new Date() : TDT;
                return dataConst.Therapies.filter(m => dateFromSDateTime(m.StartDate) <= TDT && ((m.UDT >= dateFromSDateTime(TDT) ? (m.Status && m.Status.toLowerCase() == "inactive") : false) || (!m.Status || m.Status && m.Status.toLowerCase() != "inactive")));
                break;

            case "futureservices":

                TDT = TDT > new Date() ? new Date() : TDT;
                return dataConst.Therapies.filter(m => dateFromSDateTime(m.StartDate) > TDT && ((m.UDT >= dateFromSDateTime(TDT) ? (m.Status && m.Status.toLowerCase() == "inactive") : false) || (!m.Status || m.Status && m.Status.toLowerCase() != "inactive")));
                break;

            case "newservices":
                return dataConst.Therapies.filter(m => dateFromSDateTime(m.CDT) >= FDT && dateFromSDateTime(m.CDT) <= TDT && m.RS != "DELETEACTIVITY" && m.Status != "INACTIVE")
                break;
            case "newservicesst":
                dataConst.Types = dataConst.Types || [];
                var typeId = dataConst.Types.filter(m => m.Name == "Speech Therapy" && m.Category && m.Category.toLowerCase() == "service")[0].Id;
                return dataConst.Therapies.filter(m => dateFromSDateTime(m.CDT) >= FDT && dateFromSDateTime(m.CDT) <= TDT && m.TypeId == typeId && m.RS != "DELETEACTIVITY" && m.Status != "INACTIVE");
                break;
            case "newservicesbt":
                dataConst.Types = dataConst.Types || [];
                var typeId = dataConst.Types.filter(m => m.Name == "Behavioral Modification" && m.Category && m.Category.toLowerCase() == "service")[0].Id;
                return dataConst.Therapies.filter(m => dateFromSDateTime(m.CDT) >= FDT && dateFromSDateTime(m.CDT) <= TDT && m.TypeId == typeId && m.RS != "DELETEACTIVITY" && m.Status != "INACTIVE");
                break;

            case "newservicesse":
                dataConst.Types = dataConst.Types || [];
                var typeId = dataConst.Types.filter(m => m.Name == "Special Education" && m.Category && m.Category.toLowerCase() == "service")[0].Id;
                return dataConst.Therapies.filter(m => dateFromSDateTime(m.CDT) >= FDT && dateFromSDateTime(m.CDT) <= TDT && m.TypeId == typeId && m.RS != "DELETEACTIVITY" && m.Status != "INACTIVE");
                break;
            case "newservicesot":
                dataConst.Types = dataConst.Types || [];
                var typeId = dataConst.Types.filter(m => m.Name == "Occupational Therapy" && m.Category && m.Category.toLowerCase() == "service")[0].Id;
                return dataConst.Therapies.filter(m => dateFromSDateTime(m.CDT) >= FDT && dateFromSDateTime(m.CDT) <= TDT && m.TypeId == typeId && m.RS != "DELETEACTIVITY" && m.Status != "INACTIVE");
                break;

            case "inactiveservices":
                var now = new Date();
                var fromDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);
                return dataConst.InActive && dataConst.InActive.length > 0 ? dataConst.InActive.filter(t => dateFromSDateTime(t.F14) >= fromDate) : [];
                break;
            case "inactivecausepending":
                var now = new Date();
                var fromDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);
                return dataConst.InActive && dataConst.InActive.length > 0 ? dataConst.InActive.filter(t => dateFromSDateTime(t.F14) >= fromDate && (!t.F23 || !t.F24)) : [];
                break;

            case "attendancepresent":
                return dataConst.Attendance.filter(m => m.Status == "Present");
                break;
            case "attendanceabsent":
                return dataConst.Attendance.filter(m => m.Status == "Absent");
                break;
            case "renewalclarityall":
            case "renewalclarityoverdue":
            case "renewalclaritytoday":
            case "renewalclaritytomorrow":
            case "renewalclaritythisweek":
            case "renewalclaritynextweek":
            case "renewalclaritythismonth":
            case "renewalclaritynextmonth":
            case "renewalclarityothers":
            case "renewalclaritypending":
            case "renewalclarityrenewed":
            case "renewalclaritytoberenewed":
                var allPinnacleClarity = dataConst && dataConst.PinnacleClarity && dataConst.PinnacleClarity.length > 0 ? dataConst.PinnacleClarity.filter(e => (e.RS != "DELETEACTIVITY" && e.Category && e.Category.toLowerCase().indexOf("renewal") > -1 && dateFromSDateTime(e.CDT) >= FDT && dateFromSDateTime(e.CDT) <= TDT)) : [];
                var inactivationType = allPinnacleClarity && allPinnacleClarity.length > 0 ? allPinnacleClarity[0].Category.replace("Renewals", "Inactivation") : "";
                var inactivations = dataConst && dataConst.PinnacleClarity && dataConst.PinnacleClarity.length > 0 ? dataConst.PinnacleClarity.filter(e => (e.RS != "DELETEACTIVITY" && e.Category && e.Category == inactivationType && e.Reply)) : [];
                inactivations = inactivations ? inactivations : [];
                var inactivationsByKid = groupBy(inactivations, "ForId");
                var todayDate = new Date();
                todayDate.setHours(0, 0, 0, 0);
                var tomorrowRC = new Date();
                tomorrowRC.setDate(tomorrowRC.getDate() + 1);
                var peopleGroup = groupBy(dataConst.People, "Id");
                var typesGroup = groupBy(dataConst.Types, "Id");
                var facilitiesGroup = groupBy(dataConst.Centers, "Id");






                var data = [];

                var ncc = dataConst.UserSettings.filter(f => f.Name == "NCC")[0];
                var nccArray = [];
                try {
                    nccArray = dataConst.IsUserOwner ? ncc.Value.split("{##}").map(m => ({ "Centers": m.split("{==}")[1], "Name": m.split("{==}")[3] })) : [];

                }
                catch (e) {
                    nccArray = []
                }
                //var nccIds = ncc ? ncc.split("{==}") : [];


                var activetherapies = dataConst.Therapies ? dataConst.Therapies.filter(e => e.RS != "DELETEACTIVITY" && e.Status != "INACTIVE") : [];
                if (allPinnacleClarity) {
                    var forIds = allPinnacleClarity.map(m => m.ForId + "");
                    var dt = new Date();
                    var usedCredits = dataConst.FeeAll.filter(f => dateFromSDateTime(f.FDT) <= dt && forIds.indexOf(f.BOSSId + "") > -1);
                    var usedCreditsOfBoss = groupBy(usedCredits, "BOSSId");
                    $.each(allPinnacleClarity, function (k, a) {

                        var obj = {};
                        var details = a.F5 == "RENEWED" || a.F5 == "Renewed" ? "Renewed" : !a.Reply ? "Pending" : (dateFromSDateTime(a.Reply) <= 0 || dateFromSDateTime(a.Reply) == "Invalid Date") ? "Others" : dateFromSDateTime(a.Reply) < todayDate ? "OverDue" : (dateFromSDateTime(a.Reply)).toDateString() == todayDate.toDateString() ? "Today" :
                            (dateFromSDateTime(a.Reply)).toDateString() == tomorrowRC.toDateString() ? "Tomorrow" :
                                (dateFromSDateTime(a.Reply) > getDateByType("thisweekstart") && dateFromSDateTime(a.Reply) <= getDateByType("thisweekend")) ? "ThisWeek" :
                                    dateFromSDateTime(a.Reply) > getDateByType("thisweekend") && dateFromSDateTime(a.Reply) <= getDateByType("nextweekend") ? "NextWeek" :
                                        (dateFromSDateTime(a.Reply)).getMonth() == todayDate.getMonth() ? "ThisMonth" :
                                            (dateFromSDateTime(a.Reply)).getMonth() == (todayDate.getMonth() + 1) ? "NextMonth" :
                                                "Future";

                        try {
                            if (isItKPI) {
                                obj.Details = details.toLowerCase();
                            }
                            else {


                                var therapistName = "";
                                var therapistNames = "";
                                var nccCat = "";
                                if (!isItKPI) {
                                    var alltherapiesforkid = activetherapies.filter(e => e.BossId == a.ForId)
                                    for (i = 0; i < alltherapiesforkid.length; i++) {
                                        var names = dataConst.People.filter(e => e.Id && e.Id == alltherapiesforkid[i].TherapistId)[0]
                                        therapistName += names.Id + "#" + names.Name + "{#}"
                                        therapistNames += names.Name + ",";
                                    }
                                    try {
                                        nccCat = nccArray.filter(f => f.Centers.indexOf(a.CenterId) > -1)[0].Name;
                                    }
                                    catch (e) {
                                        console.log(e);
                                    }
                                }
                                var myRegExp = /[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1]) (2[0-3]|[01][0-9]):[0-5][0-9]:[0-5][0-9]/g;


                                var noOfMonths = peopleGroup[a.ForId] && peopleGroup[a.ForId][0] ? differenceInMonths(new Date(), dateFromSDateTime(peopleGroup[a.ForId][0].CDT)) : 0;



                                obj.Facility = facilitiesGroup[a.CenterId] && facilitiesGroup[a.CenterId][0] ? facilitiesGroup[a.CenterId][0].Name : "";
                                obj.For = peopleGroup[a.ForId] && peopleGroup[a.ForId][0] ? peopleGroup[a.ForId][0].Name : "";

                                obj.HBDT = a.HBDT;
                                obj.Category = nccCat;
                                obj.Package = a.F4;
                                obj.Message = a.Message;
                                obj.KidId = a.ForId;
                                obj.MobileId = peopleGroup[a.ForId] && peopleGroup[a.ForId][0] ? peopleGroup[a.ForId][0].Handle : "";
                                obj.Therapist = therapistName ? therapistName : null;
                                obj.TherapistId = therapistNames ? therapistNames : "";

                                obj.Details = details;
                                obj.ETAs = a.Reply && (a.Reply).match(myRegExp) ? (a.Reply).split(" ")[0] : "Other";
                                obj.TOId = a.UBPI;
                                obj.Remarks = a.F5;
                                obj.Reply = a.Reply && a.Reply.trim() != "" ? a.Reply : "Pending";

                                obj.Amount = a.F2 ? a.F2 : a.Message.replace(obj.For + " ", "").replace(" Fee Clearing ETA ?", "");
                                obj.Longitivity = noOfMonths == 0 ? "" : noOfMonths >= 12 ? "L" : noOfMonths >= 6 ? "M" : "S";
                                obj.OfferAmount = a.F1;
                                obj.AdminDiscontinueMarked = inactivationsByKid && inactivationsByKid[a.ForId] ? inactivationsByKid[a.ForId].filter(f => (f.Reply && f.Reply.toLowerCase().indexOf("continue empowerment") > -1))[0] ? "" : "Discontinue" : "";
                                obj.TherapistDiscontinueMarked = inactivationsByKid && inactivationsByKid[a.ForId] ? inactivationsByKid[a.ForId].filter(f => (f.TherapistReply && f.TherapistReply.toLowerCase().indexOf("continue empowerment") > -1))[0] ? "" : "Discontinue" : "";
                                obj.CreditsUsed = usedCreditsOfBoss && usedCreditsOfBoss[a.ForId + ""] ? usedCreditsOfBoss[a.ForId + ""].length : 0;
                                if (a.Category.indexOf("Renewals") > -1) {
                                    obj.TherapistReply = a.TherapistReply && a.TherapistReply.trim() != "" ? a.TherapistReply : "Pending";
                                    obj.Uneven = obj.Reply == obj.TherapistReply ? "No" : "Yes";
                                }
                                obj.NCCReply = a.NCCReply && a.NCCReply.trim() != "" ? a.NCCReply : "Pending";
                                obj.UnevenNCC = obj.Reply == obj.TherapistReply == obj.NCCReply ? "No" : "Yes";
                            }
                            data.push(obj);
                        }
                        catch (e) {
                            console.log(e);
                        }
                    });
                }

                var tobeRenewed = ["others", "renewed", "pending"];

                var AllFeeETA = data.filter(e => (type.toLowerCase() == "renewalclarityall" ? true : type.toLowerCase() == "renewalclaritytoberenewed" ? tobeRenewed.indexOf(e.Details.toLowerCase()) == -1 : type.toLowerCase() == "renewalclarity" + e.Details.toLowerCase() + ""));
                //    if (isItKPI) {
                //        return AllFeeETA.length;
                //    }


                return AllFeeETA;


                break;
            case "pollinationclaritypromised":
            case "pollinationclaritycompleted":
            case "pollinationclarityyetto":
            case "pollinationclarityzero":
            case "pollinationclaritylessthanthree":
            case "pollinationclaritygreaterthanthree":
            case "pollinationopty":

                var allPinnacleClarity = dataConst && dataConst.PinnacleClarity && dataConst.PinnacleClarity.length > 0 ? dataConst.PinnacleClarity.filter(e => (e.RS != "DELETEACTIVITY" && e.Category && e.Category.toLowerCase().indexOf("therapist pollination") > -1)) : [];

                var data = groupBy(allPinnacleClarity, 'ForId');

                var peopleGroup = groupBy(dataConst.People, "Id");
                var facilitiesGroup = groupBy(dataConst.Centers, "Id");
                var addedSessions = dataConst.Therapies.filter(f => dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT && peopleGroup[f.BossId] && dateFromSDateTime(peopleGroup[f.BossId][0].CDT) < FDT);
                addedSessions = addedSessions || [];
                var newelyAddeddSessionGroup = groupBy(addedSessions, 'TherapistId');
                var allOppertunities = [];
                $.each(data, function (k, byGroupData) {
                    var obj = {};

                    // const reducer = (accumulator, curr) => accumulator + parseInt(curr.Reply);
                    //var promise = (byGroupData.filter(m=> !isNaN(m.Reply)) || []).reduce(reducer);
                    var tobeprocessed = byGroupData.filter(m => m.Reply && !isNaN(m.Reply));
                    var promise = tobeprocessed && tobeprocessed.length > 0 ? tobeprocessed.reduce(function (accumulator, item) {
                        return accumulator + parseInt(item.Reply);
                    }, 0) : 0;

                    obj.Facility = facilitiesGroup[byGroupData[0].CenterId] && facilitiesGroup[byGroupData[0].CenterId][0] ? facilitiesGroup[byGroupData[0].CenterId][0].Name : "";//peopleGroup[a.BOSSId] ? facilitiesGroup[peopleGroup[a.BOSSId][0].CenterId] ? facilitiesGroup[peopleGroup[a.BOSSId][0].CenterId][0].Name : "" : "";

                    obj.Therapist = peopleGroup[k] && peopleGroup[k][0].Name;
                    obj.Discipline = peopleGroup[k] && peopleGroup[k][0].Designation;

                    obj.ThrapistId = k;
                    obj.Promise = parseInt(promise);
                    obj.Completed = newelyAddeddSessionGroup[k] ? newelyAddeddSessionGroup[k].length : 0;
                    obj.YetTo = obj.Promise - obj.Completed > 0 ? obj.Promise - obj.Completed : 0;

                    obj.ShortName = GetShortDesignation(peopleGroup[k] && peopleGroup[k][0].Designation);
                    obj.Opty = byGroupData[0].F2;
                    obj.Count = type.toLowerCase() == "pollinationclaritypromised" ? parseInt(promise) :
                        type.toLowerCase() == "pollinationclaritycompleted" ? obj.Completed :
                            type.toLowerCase() == "pollinationclarityyetto" ? obj.YetTo :
                                type.toLowerCase() == "pollinationclarityzero" ? promise == 0 ? 1 : 0 :
                                    type.toLowerCase() == "pollinationopty" ? parseInt(obj.Opty) :
                                        type.toLowerCase() == "pollinationoptyst" ? obj.ShortName == "ST" ? obj.Promise : 0 :
                                            type.toLowerCase() == "pollinationoptyot" ? obj.ShortName == "OT" ? obj.Promise : 0 :
                                                type.toLowerCase() == "pollinationoptyaba" ? obj.ShortName == "BT" ? obj.Promise : 0 :
                                                    type.toLowerCase() == "pollinationoptyse" ? obj.ShortName == "SE" ? obj.Promise : 0 :
                                                        type.toLowerCase() == "pollinationclaritylessthanthree" ? promise < 3 ? 1 : 0 :
                                                            type.toLowerCase() == "pollinationclaritygreaterthanthree" ? promise >= 3 ? 1 : 0 : 0
                    allOppertunities.push(obj);
                });

                //    console.log("---ALL-CLARTIY--");
                //    console.log(type.toLowerCase());
                //    console.log(allOppertunities);

                var allcount = "Count"
                if (isItKPI) {
                    var invoicesamount = allOppertunities ? allOppertunities.reduce(function (accumulator, item) {
                        return accumulator + parseInt(item[allcount]);
                    }, 0) : 0;
                    return invoicesamount;
                }
                return allOppertunities;



                break;

            case "dueall":
            case "dueoverdue":
            case "duetoday":
            case "duetomorrow":
            case "duethisweek":
            case "duenextweek":
            case "duethismonth":
            case "duenextmonth":
            case "duefuture":

                var todayDate = new Date();
                todayDate.setHours(0, 0, 0, 0);
                let tomorrow = new Date();
                tomorrow.setDate(tomorrow.getDate() + 1);

                var bids = dataConst.Therapies.map(m => m.BossId);

                var advancedata = dataConst.FeeAll ? dataConst.FeeAll.filter(f => !f.ETA) : [];


                var advancedata = dataConst.FeeAll ? dataConst.FeeAll.filter(f => f.ETA && f.ETA != null) : [];

                var advances = advancedata ? advancedata.map(m => m.Id) : [];
                let feereciepts = dataConst.FeeReceipt ? dataConst.FeeReceipt.filter(f => advances.indexOf(f.FeeId) > -1) : [];

                var paymentsGroup = groupBy(feereciepts, "FeeId");


                var paymentsWithGrouping = Object.entries(paymentsGroup);

                var paymentDict = Object.assign({}, ...(paymentsWithGrouping.map(m => ({
                    [m[0]]: m[1].reduce(function (accc, items) {
                        return accc + items.Amount;
                    }, 0)
                }))));

                var amounts = advancedata.filter(f => (f.Amount - f.SevaAmount) > (paymentDict[f.Id] ? paymentDict[f.Id] : 0));
                var peopleGroup = groupBy(dataConst.People, "Id");
                var typesGroup = groupBy(dataConst.Types, "Id");
                var facilitiesGroup = groupBy(dataConst.Centers, "Id");
                var data = [];
                $.each(amounts, function (k, a) {

                    var obj = {};
                    if (isItKPI) {
                    }
                    else {
                        obj.Facility = facilitiesGroup[a.CenterId] && facilitiesGroup[a.CenterId][0] ? facilitiesGroup[a.CenterId][0].Name : "";//peopleGroup[a.BOSSId] ? facilitiesGroup[peopleGroup[a.BOSSId][0].CenterId] ? facilitiesGroup[peopleGroup[a.BOSSId][0].CenterId][0].Name : "" : "";
                        obj.MonthId = window.appMonthNames[dateFromSDateTime(a.CDT).getMonth()];
                        obj.Id = a.Id;
                        obj.Kid = peopleGroup[a.BOSSId] && peopleGroup[a.BOSSId][0] ? peopleGroup[a.BOSSId][0].Name : "";
                        obj.KidId = a.BOSSId;
                        obj.Created = a.CDT;
                        obj.From = a.FDT;
                        obj.To = a.TDT;
                        obj.Total = a.Amount;
                        obj.Seva = a.SevaAmount;
                        obj.PayingDate = a.ETA;
                    }


                    obj.ETA = !a.ETA ? null : dateFromSDateTime(a.ETA) < todayDate ? "OverDue" : (dateFromSDateTime(a.ETA)).toDateString() == todayDate.toDateString() ? "Today" :
                        (dateFromSDateTime(a.ETA)).toDateString() == tomorrow.toDateString() ? "Tomorrow" :
                            (dateFromSDateTime(a.ETA) > getDateByType("thisweekstart") && dateFromSDateTime(a.ETA) <= getDateByType("thisweekend")) ? "ThisWeek" :
                                dateFromSDateTime(a.ETA) > getDateByType("thisweekend") && dateFromSDateTime(a.ETA) <= getDateByType("nextweekend") ? "NextWeek" :
                                    (dateFromSDateTime(a.ETA)).getMonth() == todayDate.getMonth() ? "ThisMonth" :
                                        (dateFromSDateTime(a.ETA)).getMonth() == (todayDate.getMonth() + 1) ? "NextMonth" :
                                            "Future";
                    // obj.PaymentType = paymentsGroup[a.Id] ? paymentsGroup[a.Id].map(m => typesGroup[m.TypeId] ? typesGroup[m.TypeId][0].Name : "").join() : "";

                    obj.Amount = a.Amount - a.SevaAmount - (paymentDict[a.Id] ? paymentDict[a.Id] : 0);


                    if (!isItKPI) {
                        obj.ReceivedDates = paymentsGroup[a.Id] ? paymentsGroup[a.Id].map(m => m.CDT ? m.CDT : "").join(",") : "";
                        obj.PaidAmt = paymentDict[a.Id] ? paymentDict[a.Id] : 0;
                    }
                    data.push(obj);
                });



                // return data;

                var amountField = "Amount";

                var AllFeeETA = data.filter(e => e.ETA && null != e.ETA && (type.toLowerCase() == "dueall" ? true : type.toLowerCase() == "due" + e.ETA.toLowerCase() + ""));
                //  if (isItKPI) {
                //     var invoicesamount = AllFeeETA ? AllFeeETA.reduce(function (accumulator, item) {
                //         return accumulator + (item[amountField]);
                //     }, 0) : 0;
                //     return invoicesamount;
                // }
                return AllFeeETA;

                if (type.toLowerCase() == "dueall") {
                    var AllFeeETA = data.filter(e => e.ETA && null != e.ETA)
                    if (isItKPI) {
                        var invoicesamount = AllFeeETA ? AllFeeETA.reduce(function (accumulator, item) {
                            return accumulator + (item[amountField]);
                        }, 0) : 0;
                        return invoicesamount;
                    }

                    return AllFeeETA
                }
                if (type.toLowerCase() == "dueoverdue") {
                    var DueETA = data.filter(e => e.ETA && new Date(e.ETA) < todayDate);

                    if (isItKPI) {
                        var invoicesamount = DueETA ? DueETA.reduce(function (accumulator, item) {
                            return accumulator + (item[amountField]);
                        }, 0) : 0;
                        return invoicesamount;
                    }
                    return DueETA
                }
                if (type.toLowerCase() == "duetoday") {
                    var TodayETA = data.filter(e => e.ETA && (new Date(e.ETA)).toDateString() == todayDate.toDateString())

                    if (isItKPI) {
                        var invoicesamount = TodayETA ? TodayETA.reduce(function (accumulator, item) {
                            return accumulator + (item[amountField]);
                        }, 0) : 0;
                        return invoicesamount;
                    }
                    return TodayETA
                }
                if (type.toLowerCase() == "duetomorrow") {
                    let currentDate = todayDate;
                    currentDate.setDate(currentDate.getDate() + 1);
                    var TomorrowETA = data.filter(e => e.ETA && (new Date(e.ETA)).toDateString() == currentDate.toDateString());

                    if (isItKPI) {
                        var invoicesamount = TomorrowETA ? TomorrowETA.reduce(function (accumulator, item) {
                            return accumulator + (item[amountField]);
                        }, 0) : 0;
                        return invoicesamount;
                    }

                    return TomorrowETA
                }

                if (type.toLowerCase() == "duethisweek") {
                    var ThisWeek = data.filter(e => e.ETA && (new Date(e.ETA) > getDateByType("thisweekstart") && new Date(e.ETA) <= getDateByType("thisweekend")))
                    if (isItKPI) {
                        var invoicesamount = ThisWeek ? ThisWeek.reduce(function (accumulator, item) {
                            return accumulator + (item[amountField]);
                        }, 0) : 0;
                        return invoicesamount;
                    }


                    return ThisWeek;
                }
                if (type.toLowerCase() == "duenextweek") {
                    var NextWeeek = data.filter(e => e.ETA && new Date(e.ETA) > getDateByType("thisweekend") && new Date(e.ETA) > getDateByType("nextweekend"))

                    if (isItKPI) {
                        var invoicesamount = NextWeeek ? NextWeeek.reduce(function (accumulator, item) {
                            return accumulator + (item[amountField]);
                        }, 0) : 0;
                        return invoicesamount;
                    }
                    return NextWeeek
                }
                if (type.toLowerCase() == "duethismonth") {
                    var Thismonth = data.filter(e => e.ETA && (new Date(e.ETA)).getMonth() == todayDate.getMonth());
                    if (isItKPI) {
                        var invoicesamount = Thismonth ? Thismonth.reduce(function (accumulator, item) {
                            return accumulator + (item[amountField]);
                        }, 0) : 0;
                        return invoicesamount;
                    }
                    return Thismonth;
                }
                if (type.toLowerCase() == "duenextmonth") {
                    var NextMonth = data.filter(e => e.ETA && (new Date(e.ETA)).getMonth() == (todayDate.getMonth() + 1));
                    if (isItKPI) {
                        var invoicesamount = NextMonth ? NextMonth.reduce(function (accumulator, item) {
                            return accumulator + (item[amountField]);
                        }, 0) : 0;
                        return invoicesamount;
                    }
                    return NextMonth;
                }
                if (type.toLowerCase() == "duefuture") {
                    var FutureDues = data.filter(e => e.ETA && (new Date(e.ETA)).getMonth() > (todayDate.getMonth() + 1))
                    if (isItKPI) {
                        var invoicesamount = FutureDues ? FutureDues.reduce(function (accumulator, item) {
                            return accumulator + (item[amountField]);
                        }, 0) : 0;
                        return invoicesamount;
                    }
                    return FutureDues;
                }
                //  if (type.toLowerCase() == "etapending") {   
                //     var etapendigamount=data.filter(e=>!e.ETA)
                //     if (isItKPI) {
                //         var invoicesamount = etapendigamount ? etapendigamount.reduce(function (accumulator, item) {
                //             return accumulator + (item[amountField]);
                //         }, 0) : 0;
                //         return invoicesamount;
                //     }
                //     return etapendigamount;
                //  }


                break;


            case "compenstationcompleted":

                var compoIds = dataConst.Compos.map(m => m.Id + "");
                var composGivenIds = dataConst.Attendance.filter(m => compoIds.indexOf(m.F2) > -1).map(m => m.F2);
                return dataConst.Compos.filter(m => composGivenIds.indexOf(m.Id + "") > -1);
                // return dataConst.Attendance.filter(m => compoIds.indexOf(m.F2) > -1);
                break;
            case "compenstationfuture":
                var cdt = new Date();
                return dataConst.Compos.filter(m => m.ForDate && dateFromSDateTime(m.ForDate) > cdt && m.RS != "DELETEACTIVITY");

                // return dataConst.Attendance.filter(m => compoIds.indexOf(m.F2) > -1);
                break;
            case "compenstationtoday":
                var cdt = new Date();
                return dataConst.Compos.filter(m => m.ForDate && dateFromSDateTime(m.ForDate).toDateString() == cdt.toDateString() && m.RS != "DELETEACTIVITY");

                // return dataConst.Attendance.filter(m => compoIds.indexOf(m.F2) > -1);
                break;
            case "compenstationcanceled":

                return dataConst.Compos.filter(m => m.RS == "DELETEACTIVITY");

                // return dataConst.Attendance.filter(m => compoIds.indexOf(m.F2) > -1);
                break;

            case "compenstationorphan":
                var cdt = TDT > new Date() ? new Date() : TDT;
                var compoids = dataConst.Attendance.filter(f => f.F2).map(m => m.F2);
                return dataConst.Compos.filter(m => dateFromSDateTime(m.ForDate) <= cdt && m.RS != "DELETEACTIVITY" && compoids.indexOf(m.Id + "") == -1);
                // return dataConst.Attendance.filter(m => compoIds.indexOf(m.F2) > -1);
                break;
            case "totalgoals":
                var totalgoaldata = dataConst.Goals ? dataConst.Goals : []
                return totalgoaldata
                break;

            case "activegoals":
                var goalsreview = dataConst.Goals ? dataConst.Goals.filter(m => m.Status != "REVIEWED") : []
                return goalsreview;
                break;
            case "todaypendinggoals":
                var goalDictionary = dataConst && dataConst.Goals && dataConst.Goals.length > 0 ? Object.fromEntries(dataConst.Goals.map(x => [x.TherapyId, x.CDT])) : null;
                var attendanceForGoals = goalDictionary != null && dataConst && dataConst.Attendance && dataConst.Attendance.length > 0 ? dataConst.Attendance.filter(m => m.Status == 'Present' && goalDictionary[m.ServiceId] && new Date(goalDictionary[m.ServiceId]) > new Date(m.ForDate)) : null;
                var attendanceDictionary = attendanceForGoals ? groupBy(attendanceForGoals, "ServiceId") : null;
                var allGoalsPending = attendanceDictionary && dataConst && dataConst.Goals && dataConst.Goals.length > 0 ? dataConst.Goals.filter(m => attendanceDictionary[m.TherapyId] && m.Services == attendanceDictionary[m.TherapyId].length) : [];
                return allGoalsPending
                break;
            case "goalreviewed":
                var goalsreview = dataConst.Goals ? dataConst.Goals.filter(m => m.Status == "REVIEWED" && dateFromSDateTime(m.UDT) >= FDT && dateFromSDateTime(m.UDT) < TDT) : []
                return goalsreview;
                break;

            case "activeleadsdataOLD":
                var leadsClosedStatusesforactive = ['CLOSED', 'NOT INTRESTED', 'ALREADY JOINED SOMEWHERE', 'WRONG CALL', 'ENROLED', 'ENROLLED', 'ENROLLED AGAIN', 'ENQUIRED FOR JOB', 'VENDOR'];
                var availableLeads = [];
                for (let i = 0; i < dataConst.Leads.length; ++i) {
                    var leadObj = {};
                    leadObj = dataConst.Leads[i];
                    if (leadObj.F3) {
                        var f3Index = leadObj.F3.indexOf("{");
                        leadObj.F3 = leadObj.F3.slice(0, f3Index);
                        availableLeads.push(leadObj);
                    }
                    else {
                        continue;
                    }

                }
                var leads = Object.entries(groupBy(availableLeads, "F3"));
                var resultleads = leads.map(f => f[1].sort((a, b) => (new Date(b.CDT) > new Date(a.CDT) ? -1 : 1))[0]);
                var filteredData = resultleads.filter((k) => leadsClosedStatusesforactive.indexOf(k.Status) == -1);
                return filteredData;
                break;
            case "closedleadsdataOLD":
                let closedLeadsStatus = ['CLOSED', 'NOT INTRESTED', 'ALREADY JOINED SOMEWHERE', 'WRONG CALL', 'ENROLED', 'ENROLLED', 'ENROLLED AGAIN', 'ENQUIRED FOR JOB', 'VENDOR'];
                var closedLeads = [];
                for (let i = 0; i < dataConst.Leads.length; ++i) {
                    var leadObj = {};
                    leadObj = dataConst.Leads[i];
                    if (leadObj.F3) {
                        var f3Index = leadObj.F3.indexOf("{");
                        leadObj.F3 = leadObj.F3.slice(0, f3Index);
                        closedLeads.push(leadObj);
                    }
                    else {
                        continue;
                    }

                }
                var leads = Object.entries(groupBy(closedLeads, "F3"));

                var resultleads = leads.map(f => f[1].sort((a, b) => (new Date(b.CDT) > new Date(a.CDT) ? -1 : 1))[0]);
                var filteredData = resultleads.filter((k) => closedLeadsStatus.indexOf(k.Status) > -1);
                return filteredData;

                break;
            case "leadselsewhereOLD":
                var closedLeads = [];
                for (let i = 0; i < dataConst.Leads.length; ++i) {
                    var leadObj = {};
                    leadObj = dataConst.Leads[i];
                    if (leadObj.F3) {
                        var f3Index = leadObj.F3.indexOf("{");
                        leadObj.F3 = leadObj.F3.slice(0, f3Index);
                        closedLeads.push(leadObj);
                    }
                    else {
                        continue;
                    }

                }
                var leads = Object.entries(groupBy(closedLeads, "F3"));

                var resultleads = leads.map(f => f[1].sort((a, b) => (new Date(b.CDT) > new Date(a.CDT) ? -1 : 1))[0]);
                var filteredData = resultleads.filter((k) => k.Status.toLowerCase() == "already joined somewhere");
                return filteredData;

                break;
            case "leadstoadmissionOLD":
                var LeadAdmission = ["enrolled", "enroled"];
                var closedLeads = [];
                for (let i = 0; i < dataConst.Leads.length; ++i) {
                    var leadObj = {};
                    leadObj = dataConst.Leads[i];
                    if (leadObj.F3) {
                        var f3Index = leadObj.F3.indexOf("{");
                        leadObj.F3 = leadObj.F3.slice(0, f3Index);
                        closedLeads.push(leadObj);
                    }
                    else {
                        continue;
                    }

                }
                var leads = Object.entries(groupBy(closedLeads, "F3"));

                var resultleads = leads.map(f => f[1].sort((a, b) => (new Date(b.CDT) > new Date(a.CDT) ? -1 : 1))[0]);
                var filteredData = resultleads.filter((k) => LeadAdmission.indexOf(k.Status.toLowerCase()) > -1);
                return filteredData;

                break;
            //case "goalontime":
            //    return []
            //    break;
            //case "goallate":
            //    return []
            //    break;
            case "goalmet":

                var met = dataConst.Goals ? dataConst.Goals.filter(m => m.Status == "REVIEWED" && dateFromSDateTime(m.UDT) >= FDT && dateFromSDateTime(m.UDT) <= TDT && m.Review && m.Review.indexOf("F") == -1) : [];

                return met;
                break;
            case "goalnotmet":
                var notmet = dataConst.Goals ? dataConst.Goals.filter(m => m.Status == "REVIEWED" && dateFromSDateTime(m.UDT) >= FDT && dateFromSDateTime(m.UDT) <= TDT && m.Review && m.Review.indexOf("F") > -1) : [];

                return notmet;
                break;


            case "pollinate":
                var services = dataConst.Therapies;
                var serviceIds = Object.entries(groupBy(dataConst.Therapies, "BossId"));

                var total = 0;
                for (var i = 0; i < servicesOfeering.length; i++) {
                    var boss = serviceIds.filter(f => f[1].map(m => m.TypeId).indexOf(servicesOfeering[i].Id) == -1);
                    total += (boss || []).length;
                }
                return total;

            case "pollinatedata":
            case "pollinationoptyst":
            case "pollinationoptyot":
            case "pollinationoptyaba":
            case "pollinationoptyse":
                var people = dataConst && dataConst.People && dataConst.People.length > 0 ? dataConst.People.filter((e) => e.RS != "DELETEACTIVITY" && e.F8 != 1) : [];
                var therapiesAll = dataConst && dataConst.Therapies && dataConst.Therapies.length > 0 ? dataConst.Therapies.filter((e) => e.RS != "DELETEACTIVITY" && e.Status != "INACTIVE") : [];
                therapiesAll = therapiesAll || [];
                people = people || [];
                var facilityTherapies = dataConst.FacilityTherapies || [];
                var facilityPeople = dataConst.FacilityPeople || [];
                people.push(...facilityPeople);
                therapiesAll.push(...facilityTherapies);

                //var fids = [];
                //if (!fids) {
                //    fids = dataConst.Centers.map(m => m.Id);
                //}


                var therapistRoleId = GetTypeIdByName(dataConst.Types, "Therapist");
                var therapists = Object.entries(groupBy(people.filter(f => therapistRoleId == f.RoleId), "Id")).map(m => m[1][0]);
                var therapies = therapiesAll ? therapiesAll : [];
                var kidsServices = groupBy(therapiesAll, "BossId");
                var serviceIds = Object.entries(kidsServices);

                var peopleGroup = groupBy(people, "Id");
                var centersGroup = groupBy(dataConst.Centers, "Id");

                var pollination = [];
                var sofferings = servicesOfeering;
                switch (type.toLowerCase()) {
                    case "pollinationoptyst":
                        sofferings = servicesOfeering.filter(f => f.ShortName == "ST");
                        break;
                    case "pollinationoptyot":
                        sofferings = servicesOfeering.filter(f => f.ShortName == "OT");
                        break;
                    case "pollinationoptyaba":
                        sofferings = servicesOfeering.filter(f => f.ShortName == "BT");
                        break;
                    case "pollinationoptyse":
                        sofferings = servicesOfeering.filter(f => f.ShortName == "SE");
                        break;
                }

                if (type && (type.toLowerCase() == "pollinationoptyst" || type.toLowerCase() == "pollinationoptyot" || type.toLowerCase() == "pollinationoptyaba" || type.toLowerCase() == "pollinationoptyse")) {

                }

                for (var i = 0; i < sofferings.length; i++) {
                    var boss = serviceIds.filter(f => f[1].map(m => m.TypeId).indexOf(sofferings[i].Id) == -1).map(m => m[0]);
                    boss = (boss || []);

                    for (var b = 0; b < boss.length; b++) {
                        var tids = kidsServices[boss[b]] ? kidsServices[boss[b]].map(m => peopleGroup && peopleGroup[m.TherapistId] && peopleGroup[m.TherapistId][0] ? peopleGroup[m.TherapistId][0].Name + "\n\n" : "\n\n") : [];
                        //therapistName+= names.Id+"#"+names.Name+"{#}"

                        var therapistNames = kidsServices[boss[b]] ? kidsServices[boss[b]].map(m => peopleGroup && peopleGroup[m.TherapistId] && peopleGroup[m.TherapistId][0] ? m.TherapistId + "#" + peopleGroup[m.TherapistId][0].Name + "\n\n" : "\n\n").join("{#}") : "";

                        var FId = kidsServices[boss[b]] ? kidsServices[boss[b]].map(m => m.CenterId)[0] : null;


                        pollination.push({ BossId: boss[b], TOId: boss[b], ServiceId: sofferings[i].Id, "KidName": (peopleGroup[boss[b]] && peopleGroup[boss[b]][0] ? peopleGroup[boss[b]][0].Name : ""), "Facility": (peopleGroup[boss[b]] && peopleGroup[boss[b]][0] && centersGroup[peopleGroup[boss[b]][0].CenterId] ? centersGroup[peopleGroup[boss[b]][0].CenterId][0].Name : ""), "Discipline": sofferings[i].ShortName, "ServiceName": sofferings[i].Name, Therapist: therapistNames, FId: FId });
                    }
                }




                return pollination;

            case "available":


                var therapists = dataConst.Therapists;
                therapists = therapists && therapists.length > 0 ? therapists.filter(e => (!e.RS || e.RS != "DELETEACTIVITY")) : therapists;

                var slots = getSlotsByData(dataConst.Therapies, therapists);
                return slots;
                break;


            case "activestaff":
                var bossRoleId = dataConst.Types.filter(m => m.Name == "Boss")[0].Id;
                // f.RoleId == therapistId && 
                var filteredStaff = dataConst.People.filter(f => f.RS && f.RoleId != bossRoleId && f.F8 != 1 && f.F21 != "CENTERNUMBER" && f.F21 != "NONSTAFF" && f.RS != "DELETEACTIVITY");
                return filteredStaff;
                break;
            case "activeparents":
                var pIds = dataConst.Therapies.map(m => m.BossId);
                var parentsTofilter = dataConst && dataConst.Parents ? dataConst.Parents : dataConst.People;
                var filteredParents = parentsTofilter.filter(p => pIds.indexOf(p.Id) > -1);
                var groupedParents = Object.entries(groupBy(filteredParents, "Handle"));
                var uniqParents = groupedParents.map(m => m[1][0]);
                return uniqParents;
                break;
            case "leftparents":
                var pIds = dataConst.InActive.map(m => m.BossId);
                var parentsTofilter = dataConst && dataConst.Parents ? dataConst.Parents : dataConst.People;
                return parentsTofilter.filter(p => pIds.indexOf(p.Id) > -1);
                break;
            case "addedparents":
                var bossId = dataConst.Types.filter(m => m.Name == "Boss")[0].Id
                var filteredStaff = dataConst.People.filter(f => f.RoleId == bossId && f.F8 != 1 && f.RS != "DELETEACTIVITY");
                return filteredStaff.filter(p => dateFromSDateTime(p.CDT) >= FDT);
                break;
            case "addedstaff":
                var therapistId = dataConst.Types.filter(m => m.Name == "Therapist")[0].Id
                var filteredStaff = dataConst.People.filter(f => f.RoleId == therapistId && f.F8 != 1 && f.F21 != "CENTERNUMBER" && f.F21 != "NONSTAFF");
                return filteredStaff.filter(f => dateFromSDateTime(f.CDT) >= FDT);
                break;
            case "leftstaff":
                var therapistId = dataConst.Types.filter(m => m.Name == "Therapist")[0].Id
                var filteredStaff = dataConst.People.filter(f => f.RoleId == therapistId && f.F8 == 1 && f.F21 != "CENTERNUMBER" && f.F21 != "NONSTAFF");
                return filteredStaff.filter(f => f.UDT && dateFromSDateTime(f.UDT) >= FDT);
                break;
            case "activememos":
                return dataConst.Memos.filter(f => f.Status != "CLOSED");
                break;
            case "closedmemos":
                return dataConst.Memos.filter(f => f.Status == "CLOSED" && dateFromSDateTime(f.UDT) >= FDT && dateFromSDateTime(f.UDT) <= TDT);
                break;


            case "viewpayslips":

                var typeId = GetTypeIdByName(dataConst.Types, "VIEWPAYSLIP")



                return dataConst.PeopleNotes ? dataConst.PeopleNotes.filter(f => f.TypeId == typeId) : [];


                break;
            case "downloadpayslips":
                var typeId = GetTypeIdByName(dataConst.Types, "DOWNLOADPAYSLIP")



                return dataConst.PeopleNotes ? dataConst.PeopleNotes.filter(f => f.TypeId == typeId) : [];
                break;
            case "salary":

                var typeId = GetTypeIdByName(dataConst.Types, "PAYSLIP")



                return dataConst.PeopleNotes ? dataConst.PeopleNotes.filter(f => f.TypeId == typeId && dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT) : [];
                break;
            case "paid":
                var typeId = GetTypeIdByName(dataConst.Types, "Seva")
                var thismonth = dataConst.Fee.filter(f => (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT) || (f.Remarks && f.Remarks.toLowerCase() == "system automation")).map(m => m.Id);
                return dataConst.FeeReceipt.filter(f => thismonth.indexOf(f.FeeId) > -1 && dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT && f.TypeId != typeId);
            case "paidseva":
                var typeId = GetTypeIdByName(dataConst.Types, "Seva")
                var thismonth = dataConst.Fee.filter(f => (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT) || (f.Remarks && f.Remarks.toLowerCase() == "system automation")).map(m => m.Id);
                return dataConst.FeeReceipt.filter(f => thismonth.indexOf(f.FeeId) > -1 && dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT && f.TypeId == typeId);

            case "advancepaid":
                var typeId = GetTypeIdByName(dataConst.Types, "Seva")
                var thismonth = dataConst.FutureInvoices.filter(f => (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT) && (!f.Remarks || f.Remarks.toLowerCase() != "system automation")).map(m => m.Id);
                return dataConst.FeeReceipt.filter(f => thismonth.indexOf(f.FeeId) > -1 && dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT && f.TypeId != typeId);

            case "advancepaidseva":
                var typeId = GetTypeIdByName(dataConst.Types, "Seva")
                var thismonth = dataConst.FutureInvoices.filter(f => (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT) && (!f.Remarks || f.Remarks.toLowerCase() != "system automation")).map(m => m.Id);
                return dataConst.FeeReceipt.filter(f => thismonth.indexOf(f.FeeId) > -1 && dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT && f.TypeId == typeId);

            case "pastpaid":
                var typeId = GetTypeIdByName(dataConst.Types, "Seva")
                var futuremonth = dataConst.FutureInvoices.filter(f => (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT) && (!f.Remarks || f.Remarks.toLowerCase() != "system automation")).map(m => m.Id);

                var thismonth = dataConst.Fee.filter(f => (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT) || (f.Remarks && f.Remarks.toLowerCase() == "system automation")).map(m => m.Id);

                return dataConst.FeeReceipt.filter(f => thismonth.indexOf(f.FeeId) == -1 && futuremonth.indexOf(f.FeeId) == -1 && dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT && f.TypeId != typeId);

            case "alreadyfulfilled":
                var typeId = GetTypeIdByName(dataConst.Types, "Seva")
                var oldInvoices = dataConst.Fee.filter(f => f.Type != "ASSESSMENTS" && (dateFromSDateTime(f.CDT) < FDT) && (!f.Remarks || f.Remarks.toLowerCase() != "system automation")).map(m => m.Id);

                return dataConst.FeeReceipt.filter(f => oldInvoices.indexOf(f.FeeId) > -1 && dateFromSDateTime(f.CDT) < FDT && f.TypeId != typeId);

            case "tobefulfilled":
                var typeId = GetTypeIdByName(dataConst.Types, "Seva")
                var allinvoices = dataConst.FeeAll.filter(f => (dateFromSDateTime(f.FDT) >= FDT) && f.Type != "ASSESSMENTS");

                return allinvoices;

            case "pastpaidseva":
                var typeId = GetTypeIdByName(dataConst.Types, "Seva")
                var futuremonth = dataConst.FutureInvoices.filter(f => dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT).map(m => m.Id);

                var thismonth = dataConst.Fee.filter(f => dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT).map(m => m.Id);

                return dataConst.FeeReceipt.filter(f => thismonth.indexOf(f.FeeId) == -1 && futuremonth.indexOf(f.FeeId) == -1 && dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT && f.TypeId == typeId);

            case "discount":
                return dataConst.FeeAll.filter(f => ((f.Remarks && f.Remarks.toLowerCase() == "system automation") ? (dateFromSDateTime(f.FDT) >= FDT && dateFromSDateTime(f.FDT) <= TDT) : (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) < TDT)) && f.Discount > 0 && f.Remarks != "Renewal Offer" && f.Remarks != "PINNACLEGIFTVOUCHER");


            case "expenses":

                var typeId = dataConst.Types.filter(f => f.Name.toLowerCase() == "expenses" && f.Category == "Activitytype")[0].Id;



                return dataConst.CenterNotes ? dataConst.CenterNotes.filter(f => f.TypeId == typeId && dateFromSDateTime(f.FDT) >= FDT && dateFromSDateTime(f.FDT) <= TDT) : [];
                break;

            //feedbacksgiven
            case "feedbacksgiven":

                return dataConst.Feedback ? dataConst.Feedback : [];
                break;

            case "totalstaff":
                var staffdata = dataConst.People ? dataConst.People.filter((e) => e.RoleId != 28) : []
                return staffdata;
                break;
            case "biometricabsent":
                var biometricabsent = []
                return biometricabsent;
                break;
            case "biometricpresent":
                var biometricpresent = []
                //var biometricpresent = groupBy(dataConst.Biometric,new Date("FDT").getDate());
                //var present = groupBy(dataConst.Biometric,m=> new Date(m.FDT).getDate());
                //var biometricpresent = dataConst.Biometric.groupBy(m => new Date(m.FDT).Date + "#" + m.TOId).map(m => m.OrderByDescending(o => o.CDT)[0]);
                return biometricpresent;
                break;
            case "biometricentryearly":
                var biometricentryearly = dataConst.Biometric ? dataConst.Biometric.filter(m => m.F2 == 1 ? new Date(m.FDT).getTime() < getTimeData(9, 30, 0, 0, m.FDT) : new Date(m.FDT).getTime() < getTimeData(8, 35, 0, 0, m.FDT)) : [];
                return biometricentryearly;
                break;
            case "biometricentryontime":
                var biometricentryontime = dataConst.Biometric ? dataConst.Biometric.filter(m => m.F2 == 1 ? (new Date(m.FDT).getTime() >= getTimeData(9, 30, 0, 0, m.FDT) && new Date(m.FDT).getTime() <= getTimeData(9, 35, 0, 0, m.FDT)) : (new Date(m.FDT).getTime() >= getTimeData(8, 30, 0, 0, m.FDT) && new Date(m.FDT).getTime() <= getTimeData(8, 35, 0, 0, m.FDT))) : [];
                return biometricentryontime;
                break;
            case "biometricentrylate":
                var biometricentrylate = dataConst.Biometric ? dataConst.Biometric.filter(m => m.F2 == 1 ? new Date(m.FDT).getTime() > getTimeData(9, 35, 0, 0, m.FDT) && new Date(m.FDT).getTime() < getTimeData(12, 0, 0, 0, m.FDT) : new Date(m.FDT).getTime() > getTimeData(8, 35, 0, 0, m.FDT)) : [];
                return biometricentrylate;
                break;
            case "biometricexitearly":
                var biometricexitearly = dataConst.Biometric ? dataConst.Biometric.filter(m => new Date(m.FDT).getTime() < getTimeData(19, 0, 0, 0, m.FDT)) : [];
                return biometricexitearly;
                break;
            case "biometricexitontime":
                var biometricexitontime = dataConst.Biometric ? dataConst.Biometric.filter(m => (new Date(m.FDT).getTime() >= getTimeData(19, 0, 0, 0, m.FDT) && new Date(m.FDT).getTime() <= getTimeData(19, 5, 0, 0, m.FDT))) : [];
                return biometricexitontime;
                break;
            case "biometricexitlate":
                var biometricexits = dataConst.Biometric ? dataConst.Biometric.filter((m) => new Date(m.FDT).getTime() > getTimeData(19, 5, 0, 0, m.FDT)) : [];
                return biometricexits;
                break;

            case "feedbackratings":
                var allFeedbacks = dataConst.Feedback ? dataConst.Feedback : [];

                var totalRating = allFeedbacks.reduce(function (accumulator, item) {
                    return accumulator + item.Rating;
                }, 0);
                return totalRating;
                break;

            case "servicerequests":
                var serviceRequests = dataConst.ServiceRequest && dataConst.ServiceRequest.length > 0 ? dataConst.ServiceRequest.filter(e => (!e.RS || e.RS != "DELETEACTIVITY")) : [];
                var analytics = dataConst.ServiceRequestAnalytic.sort((a, b) => (dateFromSDateTime(a.CDT) > dateFromSDateTime(b.CDT) ? -1 : 1));
                var responses = groupBy(analytics, "SRId");

                var srs = serviceRequests.map(function (m) {
                    return {
                        ...m, "LastAnalytic"
                            : ((responses[m.Id + ""] && responses[m.Id + ""].length > 0) ? responses[m.Id + ""][0] : null)
                    }
                });
                //})
                return srs;
                break;
            case "chilatest":
                var CHITypeId = dataConst.Types.filter(f => f.Name == "CHI")[0].Id;
                var allCHIData = dataConst.CenterNotes.filter(f => f.TypeId == CHITypeId);
                var latestCHIDate = allCHIData && allCHIData.length > 0 ? allCHIData.sort((a, b) => (dateFromSDateTime(a.CDT) > dateFromSDateTime(b.CDT) ? -1 : 1))[0].CDT : null;
                var returnData = {};
                if (latestCHIDate) {
                    var latestCHIDateValue = new Date(latestCHIDate);
                    var startCHI = new Date(latestCHIDateValue.getFullYear(), latestCHIDateValue.getMonth(), 1);

                    var allAssessments = allCHIData.filter(f => dateFromSDateTime(f.CDT) >= startCHI);
                    returnData.Assessments = allAssessments;

                    var assmids = allAssessments.map(m => m.Id);
                    var allResposnese = dataConst.Responses ? dataConst.Responses.filter(f => assmids.indexOf(f.CenterNoteId) > -1 || assmids.indexOf(f.PeopleNoteId) > -1) : [];
                    if (allResposnese) {
                        allResposnese = Object.entries(allResposnese.reduce((result, currentValue) => {
                            var key = currentValue.Question + "_" + currentValue.CenterNoteId + "_" + currentValue.PeopleNoteId + "_" + currentValue.Type + "_" + currentValue.CBPI + "_" + currentValue.TOId;
                            if (!result[key]) {
                                result[key] = currentValue
                            }
                            return result;
                        }, {})).map(m => m[1]);


                    }

                    allResposnese = allResposnese || [];
                    returnData.Reponses = allResposnese;

                }

                return returnData;
                break;
            case "pisilatest":
                var PISITypeId = dataConst.Types.filter(f => f.Name == "PISI")[0].Id;
                var allCHIData = dataConst.PeopleNotes ? dataConst.PeopleNotes.filter(f => f.TypeId == PISITypeId) : [];
                var latestCHIDate = allCHIData.length > 0 ? allCHIData.sort((a, b) => (dateFromSDateTime(a.CDT) > dateFromSDateTime(b.CDT) ? -1 : 1))[0].CDT : [];

                var returnData = {};
                if (latestCHIDate) {
                    var latestCHIDateValue = new Date(latestCHIDate);
                    var startCHI = new Date(latestCHIDateValue.getFullYear(), latestCHIDateValue.getMonth(), 1);

                    var allAssessments = allCHIData.filter(f => dateFromSDateTime(f.CDT) >= startCHI);
                    returnData.Assessments = allAssessments;

                    var assmids = allAssessments.map(m => m.Id);
                    var allResposnese = dataConst.Responses ? dataConst.Responses.filter(f => assmids.indexOf(f.CenterNoteId) > -1 || assmids.indexOf(f.PeopleNoteId) > -1) : [];
                    if (allResposnese && allResposnese.length > 0) {
                        allResposnese = Object.entries(allResposnese.reduce((result, currentValue) => {
                            var key = currentValue.Question + "_" + currentValue.CenterNoteId + "_" + currentValue.PeopleNoteId + "_" + currentValue.Type + "_" + currentValue.CBPI + "_" + currentValue.TOId;
                            if (!result[key]) {
                                result[key] = currentValue
                            }
                            return result;
                        }, {})).map(m => m[1]);


                    }

                    allResposnese = allResposnese || [];
                    returnData.Reponses = allResposnese;

                }

                return returnData;
                break;
            case "whilatest":
                var WHITypeId = dataConst.Types.filter(f => f.Name == "WHI")[0].Id;
                var allWHIData = dataConst.PeopleNotes ? dataConst.PeopleNotes.filter(f => f.TypeId == WHITypeId) : [];
                var latest = allWHIData && allWHIData.length > 0 ? allWHIData.sort((a, b) => (dateFromSDateTime(a.CDT) > dateFromSDateTime(b.CDT) ? -1 : 1))[0].CDT : null;

                var returnData = {};

                if (latest) {

                    var latestDate = new Date(latest);
                    var start = new Date(latestDate.getFullYear(), latestDate.getMonth(), 1);
                    var allAssessments = allWHIData.filter(f => dateFromSDateTime(f.CDT) >= start);
                    returnData.Assessments = allAssessments;

                    var assmids = allAssessments.map(m => m.Id);
                    var allResposnese = dataConst.Responses ? dataConst.Responses.filter(f => assmids.indexOf(f.CenterNoteId) > -1 || assmids.indexOf(f.PeopleNoteId) > -1) : [];

                    if (allResposnese) {
                        allResposnese = Object.entries(allResposnese.reduce((result, currentValue) => {
                            var key = currentValue.Question + "_" + currentValue.CenterNoteId + "_" + currentValue.PeopleNoteId + "_" + currentValue.Type + "_" + currentValue.CBPI + "_" + currentValue.TOId;
                            if (!result[key]) {
                                result[key] = currentValue
                            }
                            return result;
                        }, {})).map(m => m[1]);



                    }
                    allResposnese = allResposnese || [];
                    returnData.Reponses = allResposnese;
                    var ranks = allResposnese.filter(f => f.Type == "RANK");
                    var suggestions = allResposnese.filter(f => f.Type == "SUGGESTION");

                    returnData.Suggestions = suggestions;

                    //var peopleData = groupBy(dataConst.People, "Id");
                    //var centers = groupBy(dataConst.Centers, "Id");
                    var final = [];
                    for (const [indexval, values] of Object.entries(groupBy(ranks, 'IQMId'))) {


                        var ranks = Object.entries(groupBy(values, 'TOId')).map(function (m) { return { "Id": m[0], "TOId": m[0], "RDId": indexval, "Weightage": (m[1].reduce((partialSum, a) => partialSum + parseInt(a.Response), 0)) } });

                        var length = ranks.length;


                        var P10 = Math.ceil((length * 10.0 / 100));
                        var M50 = Math.ceil((length * 50.0 / 100));
                        var B90 = Math.ceil((length * 90.0 / 100));


                        ranks = ranks.sort((a, b) => (a.Weightage > b.Weightage ? 1 : -1));


                        var weightage = groupBy(ranks, "Weightage");
                        var rank = 0;

                        for (const [index, content] of Object.entries(weightage)) {
                            rank++;
                            content.forEach(function (a) {
                                var rankTextId = rank <= P10 ? "top10" : rank <= M50 ? "top40" : rank <= B90 ? "bottom40" : "bottom10";
                                a = { "Rank": rank, "RankTextId": rankTextId, ...a };

                                final.push(a);
                            });


                        }


                    }

                    returnData.Ranks = final;
                    // console.log("returnData.Ranks");
                    //console.log(returnData.Ranks);



                }

                return returnData;


                break;

            case "leaverequestnonparentcompleted":
                var currentDate = new Date();
                const types1 = dataConst.Types ? dataConst.Types : [];
                var leaverequestId = GetTypeIdByName(types1, "LEAVEREQUEST");

                var allLeaves = dataConst.PeopleNotes ? dataConst.PeopleNotes.filter(f => f.TypeId == leaverequestId && (dateFromSDateTime(f.FDT) >= FDT || (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT))) : [];

                var completednpLeaves = allLeaves.filter(m => (!m.F1 || m.F1.toLowerCase() != "parent") && dateFromSDateTime(m.FDT) <= currentDate && m.Status != "Cancelled");
                return completednpLeaves;
                break;
            case "leaverequestcomposlt4":
                var currentDate = new Date();
                const types2 = dataConst.Types ? dataConst.Types : [];
                var leaverequestIds = GetTypeIdByName(types2, "LEAVEREQUEST");

                var allLeavesData = dataConst.PeopleNotes ? dataConst.PeopleNotes.filter(f => f.TypeId == leaverequestIds && (dateFromSDateTime(f.FDT) >= FDT || (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT))) : [];

                var leaverequestcomposlt4 = allLeavesData.filter(m => m.F1 && (m.F1.toLowerCase() == "therapist" || m.F1.toLowerCase() == "adminfortherapist") && m.F2 && parseInt(m.F2) < 4);
                return leaverequestcomposlt4;
                break;
            case "leaverequestanalytic":
                var currentDate = new Date();
                const types3 = dataConst.Types ? dataConst.Types : [];
                var leaverequestIdsforapproved = GetTypeIdByName(types3, "LEAVEREQUEST");

                var allLeavesData1 = dataConst.PeopleNotes ? dataConst.PeopleNotes.filter(f => f.TypeId == leaverequestIdsforapproved && (dateFromSDateTime(f.FDT) >= FDT || (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT))) : [];

                var approvedLeaves = allLeavesData1.filter(m => (!m.F1 || m.F1.toLowerCase() != "parent") && m.Status && m.Status.toUpperCase() == "APPROVED");

                return approvedLeaves;
                break;
            case "leaverequestnonparentcanceled":
                var currentDate = new Date();
                const types4 = dataConst.Types ? dataConst.Types : [];
                var leaverequestIdforCanceledleaves = GetTypeIdByName(types4, "LEAVEREQUEST");

                var allLeavesData2 = dataConst.PeopleNotes ? dataConst.PeopleNotes.filter(f => f.TypeId == leaverequestIdforCanceledleaves && (dateFromSDateTime(f.FDT) >= FDT || (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT))) : [];
                var cancellednpLeaved = allLeavesData2 ? allLeavesData2.filter(m => (!m.F1 || m.F1.toLowerCase() != "parent") && m.Status == "Cancelled" && m.UDT && dateFromSDateTime(m.UDT) >= FDT && dateFromSDateTime(m.UDT) <= TDT) : [];
                return cancellednpLeaved;
                break;
            case "leaverequestanalyticunapproved":
                var currentDate = new Date();
                const types5 = dataConst.Types ? dataConst.Types : [];
                var leaverequestIdforCanceledleaves = GetTypeIdByName(types5, "LEAVEREQUEST");
                var allLeavesData3 = dataConst.PeopleNotes ? dataConst.PeopleNotes.filter(f => f.TypeId == leaverequestIdforCanceledleaves && (dateFromSDateTime(f.FDT) >= FDT || (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT))) : [];
                var unapprovedLeaves = allLeavesData3.filter(m => (!m.F1 || m.F1.toLowerCase() != "parent") && m.Status && m.Status.toUpperCase() == "UNAPPROVED");
                return unapprovedLeaves;
                break;
            case "leavespendingapproval":
                var currentDate = new Date();
                const types10 = dataConst.Types ? dataConst.Types : [];
                var leaverequestIdforPendingleaves = GetTypeIdByName(types10, "LEAVEREQUEST");
                var allLeavesData3 = dataConst.PeopleNotes ? dataConst.PeopleNotes.filter(f => f.TypeId == leaverequestIdforPendingleaves && (dateFromSDateTime(f.FDT) >= FDT || (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT))) : [];
                var pendingleaves = allLeavesData3.filter(m => (!m.F1 || m.F1.toLowerCase() != "parent") && (!m.Status || m.Status == null || m.Status == '' || m.Status == 'Pending') && m.RS != "DELETEACTIVITY");
                return pendingleaves;
                break;
            //leavespendingapproval
            // var pendingLeaves = GetReportsData("leavespendingapproval", dataConst, true, fdt, tdt, facility);

            case "leaverequestnonparentfuture":
                var currentDate = new Date();
                const types6 = dataConst.Types ? dataConst.Types : [];
                var leaverequestIdforCanceledleaves = GetTypeIdByName(types6, "LEAVEREQUEST");
                var allLeavesData4 = dataConst.PeopleNotes ? dataConst.PeopleNotes.filter(f => f.TypeId == leaverequestIdforCanceledleaves && (dateFromSDateTime(f.FDT) >= FDT || (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT))) : [];
                var futurenpLeaves = allLeavesData4.filter(m => (!m.F1 || m.F1.toLowerCase() != "parent") && dateFromSDateTime(m.FDT) > currentDate && m.Status != "Cancelled");
                return futurenpLeaves;
                break;
            case "leaverequestparentfuture":
                var currentDate = new Date();
                const types7 = dataConst.Types ? dataConst.Types : [];
                var leaverequestIds = GetTypeIdByName(types7, "LEAVEREQUEST");
                var allLeavesData5 = dataConst.PeopleNotes ? dataConst.PeopleNotes.filter(f => f.TypeId == leaverequestIds && (dateFromSDateTime(f.FDT) >= FDT || (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT))) : [];
                var futurenpLeavesParent = allLeavesData5.filter(m => m.F1 && m.F1.toLowerCase() == "parent" && dateFromSDateTime(m.FDT) > currentDate && m.Status != "Cancelled");
                return futurenpLeavesParent;
                break;
            case "leaverequestparentcompleted":
                var currentDate = new Date();
                const types8 = dataConst.Types ? dataConst.Types : [];
                var leaverequestIds = GetTypeIdByName(types8, "LEAVEREQUEST");
                var allLeavesData6 = dataConst.PeopleNotes ? dataConst.PeopleNotes.filter(f => f.TypeId == leaverequestIds && (dateFromSDateTime(f.FDT) >= FDT || (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT))) : [];
                var completedParentleaves = allLeavesData6.filter(m => m.F1 && m.F1.toLowerCase() == "parent" && dateFromSDateTime(m.FDT) <= currentDate && m.Status != "Cancelled");
                return completedParentleaves;
                break;
            case "leaverequestparentcanceled":
                var currentDate = new Date();
                const types9 = dataConst.Types ? dataConst.Types : [];
                var leaverequestIds = GetTypeIdByName(types9, "LEAVEREQUEST");
                var allLeavesData4 = dataConst.PeopleNotes ? dataConst.PeopleNotes.filter(f => f.TypeId == leaverequestIds && (dateFromSDateTime(f.FDT) >= FDT || (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT))) : [];
                var cancelledLeaved = allLeavesData4.filter(m => m.F1 && m.F1.toLowerCase() == "parent" && m.Status == "Cancelled" && m.UDT && dateFromSDateTime(m.UDT) >= FDT && dateFromSDateTime(m.UDT) <= TDT);
                return cancelledLeaved;
                break;
            case "awardswon":
                var awards = dataConst.Awards;
                return awards;
                break;
            case "lockedaccounts":
                var adminId = GetTypeIdByName(dataConst.Types, "Receptionist")
                var TherapistId = GetTypeIdByName(dataConst.Types, "Therapist")
                var caretakerId = GetTypeIdByName(dataConst.Types, "CareTaker")
                var accounts = dataConst.People ? dataConst.People.filter(e => ((e.F8 != 0 || e.F8 != null) || (e.RS != "ACTIVE" || e.RS != null)) && (e.RoleId == adminId || e.RoleId == TherapistId || e.RoleId == caretakerId) && e.F17 && (e.F17).indexOf("SYSTEM INACTIVATED DUE TO CONSEQUITE LEAVES MORE THAN") > -1) : [];
                // var accounts=[];
                var key = 'Handle';
                var arrayUniqueByKey = [...new Map(accounts.map(item => [item[key], item])).values()];
                return arrayUniqueByKey;
                break;
            case "unlockedaccounts":
                var adminId = GetTypeIdByName(dataConst.Types, "Receptionist")
                var TherapistId = GetTypeIdByName(dataConst.Types, "Therapist")
                var caretakerId = GetTypeIdByName(dataConst.Types, "CareTaker")
                var accounts = dataConst.People ? dataConst.People.filter(e => e.F8 == 0 || e.RS == "ACTIVE" && (e.RoleId == adminId || e.RoleId == TherapistId || e.RoleId == caretakerId) && e.F17 && (e.F17).indexOf("SYSTEM ACTIVATED THE ACCOUNT FROM BIOMETRIC SYNC") > -1) : [];
                var key = 'Handle';
                var arrayUniqueByKey = [...new Map(accounts.map(item => [item[key], item])).values()];
                return arrayUniqueByKey;
                break;
            case "staffutil":
                var TherapistId = GetTypeIdByName(dataConst.Types, "Therapist")
                var accounts = dataConst.People ? dataConst.People.filter(e => e.F8 != 1 && e.RS != "DELETEACTIVITY" && e.RoleId == TherapistId) : [];
                var key = 'Handle';
                var arrayUniqueByKey = [...new Map(accounts.map(item => [item[key], item])).values()];
                return arrayUniqueByKey;
                break;
            case "birthdayreports":
                var adminId = GetTypeIdByName(dataConst.Types, "Receptionist")
                var TherapistId = GetTypeIdByName(dataConst.Types, "Therapist")
                var caretakerId = GetTypeIdByName(dataConst.Types, "CareTaker")
                var ownerId = GetTypeIdByName(dataConst.Types, "Owner");
                var accounts = dataConst.People ? dataConst.People.filter(e => e.F8 != 1 && e.RS != "DELETEACTIVITY" && (e.RoleId == adminId || e.RoleId == TherapistId || e.RoleId == caretakerId || e.RoleId == ownerId) && (new Date(e.DOB).getMonth() == new Date(FDT).getMonth())) : [];
                return accounts;

                break;
            case "gracecompensation":
                var gracetypeId = dataConst.Types.filter(f => f.Name == "Grace Compensation Request" && f.Category == "Service Request")[0].Id;
                var servicerequestAnalytics = Object.entries(groupBy((dataConst.ServiceRequestAnalytic || []), "SRId")).map(m => m[1].sort((a, b) => (new Date(b.CDT) > new Date(a.CDT) ? -1 : 1))[0]);
                var allPeople = dataConst.People;
                var parentId = GetTypeIdByName(dataConst.Types, "Boss");
                var filterKids = allPeople && allPeople.length > 0 ? allPeople.filter(e => e.RoleId != parentId && (null == e.RS || e.RS != "DELETEACTIVITY")) : [];
                var kids = filterKids && filterKids.length > 0 ? filterKids.map(e => e.Id) : []; //NEED TO FIX STOPPEd FOR CF ERRORS
                var srData = groupBy((dataConst.ServiceRequestAnalytic || []), "SRId");
                // var requests = dataConst && dataConst.ServiceRequest && dataConst.ServiceRequest.length > 0 ? dataConst.ServiceRequest.filter(f => f.TypeId == gracetypeId && srData[f.Id] && srData[f.Id].Status == "CLOSED" && srData[f.Id].CBPI == f.CBPI && kids.indexOf(f.TOId) > -1 && (dateFromSDateTime(f.FDT) >= FDT) && (dateFromSDateTime(f.FDT) <= TDT) && srData[f.Id].Amount > 0) : [];
                var requests = dataConst && dataConst.ServiceRequest && dataConst.ServiceRequest.length > 0 ? dataConst.ServiceRequest.filter(f => f.TypeId == gracetypeId && (dateFromSDateTime(f.FDT) >= FDT) && (dateFromSDateTime(f.FDT) <= TDT)) : [];

                return requests;
                break;
            case "noprofileusers":
                var allPeople = dataConst.People;
                var leadId = GetTypeIdByName(dataConst.Types, "Lead");
                var parentId = GetTypeIdByName(dataConst.Types, "Boss");
                var filteredByPeople = allPeople.filter(e => e.RoleId != leadId && e.RoleId != parentId);
                var filtereByProfile = filteredByPeople.filter(e => e.IsProfileSet != 1);
                return filtereByProfile;
                break;
            case "dangpendingtoday":
                var dangAnalyticTypeId = GetTypeIdByName(dataConst.Types, "DANGANALYTIC");
                var dangType = dataConst && dataConst.Types && dataConst.Types.length > 0 ? dataConst.Types.filter(e => e.Name == "DANG")[0] : '';

                var currentDang = dataConst && dataConst.PeopleNotes && dataConst.PeopleNotes.length > 0 ? dataConst.PeopleNotes.filter(f => f.TypeId == dangAnalyticTypeId && new Date(f.CDT) >= FDT && new Date(f.CDT) <= TDT) : [];
                var dtN = new Date();
                dtN.setHours(5);
                dtN.setMinutes(30);
                var todayDang = currentDang.filter(f => dateFromSDateTime(f.CDT).toDateString() == new Date().toDateString());
                var pendingorToday = CalculateDangPendingForToday(todayDang, dangType, new Date(), new Date(), facility, dataConst.People);
                return pendingorToday;
                break;
            case "allpendingcourses":
                var totalPending = 0;
                var totalTantrumsPending = 0;
                var totalConditionsPending = 0;
                var ptiPendingAssesmsnets = 0;
                var leaveApprovalPending = 0;

                var pendingObj = {};

                var allCourses = dataConst && dataConst.MirracleTypes && dataConst.MirracleTypes.length > 0 ? $.grep(dataConst.MirracleTypes, function (e) { return (e.Category == "MIRAVERSETANTRUMS" || e.Category == "MIRAVERSECONDITIONS") && e.RS != "DELETEACTIVITY" }) : [];
                var coursesCompleted = dataConst && dataConst.PeopleNotes && dataConst.PeopleNotes.length > 0 ? $.grep(dataConst.PeopleNotes, function (e) { return (e.AT == "MIRACOURSECOMPLETED") && e.RS != "DELETEACTIVITY" }) : [];
                totalPending = allCourses && allCourses.length > 0 ? allCourses.length : 0;
                if (totalPending > 0 && coursesCompleted && coursesCompleted.length > 0) {
                    totalPending = totalPending - coursesCompleted.length;

                }
                if (allCourses) {
                    var allTantrumsCourses = dataConst && dataConst.MirracleTypes && dataConst.MirracleTypes.length > 0 ? $.grep(dataConst.MirracleTypes, function (e) { return (e.Category == "MIRAVERSETANTRUMS") && e.RS != "DELETEACTIVITY" }) : [];
                    var tantrumcoursesCompleted = dataConst && dataConst.PeopleNotes && dataConst.PeopleNotes.length > 0 ? $.grep(dataConst.PeopleNotes, function (e) { return (e.Category == "MIRACOURSECOMPLETED" && e.F5 == "MIRAVERSETANTRUMS") && e.RS != "DELETEACTIVITY" }) : [];

                    totalTantrumsPending = tantrumcoursesCompleted && tantrumcoursesCompleted.length > 0 ? allTantrumsCourses.length - tantrumcoursesCompleted.length : allTantrumsCourses.length;


                    var allConditionCourses = dataConst && dataConst.MirracleTypes && dataConst.MirracleTypes.length > 0 ? $.grep(dataConst.MirracleTypes, function (e) { return (e.Category == "MIRAVERSECONDITIONS") && e.RS != "DELETEACTIVITY" }) : [];
                    var conditioncoursesCompleted = dataConst && dataConst.PeopleNotes && dataConst.PeopleNotes.length > 0 ? $.grep(dataConst.PeopleNotes, function (e) { return (e.AT == "MIRACOURSECOMPLETED" && e.F5 == "MIRAVERSECONDITIONS") && e.RS != "DELETEACTIVITY" }) : [];

                    totalConditionsPending = conditioncoursesCompleted && conditioncoursesCompleted.length > 0 ? allConditionCourses.length - conditioncoursesCompleted.length : allConditionCourses.length;
                }
                pendingObj.totalPending = totalPending;
                pendingObj.totalTantrumsPending = totalTantrumsPending;
                pendingObj.totalConditionsPending = totalConditionsPending;
                pendingObj.ptiPendingAssesmsnets = ptiPendingAssesmsnets;
                pendingObj.leaveApprovalPending = leaveApprovalPending;

                return pendingObj;

                break;
            case "bossachivements":

                var bossObj = {};
                var bossTherapies = dataConst && dataConst.Therapies && dataConst.Therapies.length > 0 ? dataConst.Therapies.filter(e => e.RS != "DELETEACTIVITY") : [];
                var bossGoals = dataConst && dataConst.Goals && dataConst.Goals.length > 0 ? dataConst.Goals.filter(e => e.RS != "DELETEACTIVITY") : [];
                var bossFeedBacks = 0;
                bossObj.totalBossTherapies = bossTherapies.length;
                bossObj.totalBossGoals = bossGoals.length;
                bossObj.totalBossFeedback = 0;

                return bossObj;

                break;
            case "bosspendingfee":
                var pendingAmount = 0;
                var typeId = GetTypeIdByName(dataConst.Types, "Seva");
                var paymentsParent = dataConst && dataConst.Fee && dataConst.Fee.length > 0 ? dataConst.Fee.filter(t => t.ServiceId && t.ServiceId != null) : [];
                var mapids = paymentsParent ? paymentsParent.map(m => m.Id) : []
                var receiptpayment = dataConst && dataConst.FeeReceipt && dataConst.FeeReceipt ? dataConst.FeeReceipt.filter(f => mapids.indexOf(f.FeeId) > -1 && typeId != f.TypeId) : [];


                var invoiceamount = paymentsParent.reduce(function (accumulator, item) {
                    return accumulator + item.Amount;
                }, 0);
                var paymentamount = receiptpayment ? receiptpayment.reduce(function (accc, items) {
                    return accc + items.Amount;
                }, 0) : 0;
                pendingAmount = invoiceamount - paymentamount;

                return pendingAmount
                break;
            case "pinnacleclaritypending":
                var allPinnacleClarity = dataConst && dataConst.PinnacleClarity && dataConst.PinnacleClarity.length > 0 ? dataConst.PinnacleClarity.filter(e => (e.RS != "DELETEACTIVITY")) : [];
                if (isItKPI) {
                    return allPinnacleClarity;
                }

                // allPinnacleClarity = dataConst && dataConst.PinnacleClarity && dataConst.PinnacleClarity.length > 0 ? dataConst.PinnacleClarity : [];


                var data = [];
                var facilitiesGroup = groupBy(dataConst.Centers, "Id");
                var peopleGroup = groupBy(dataConst.People, "Id");
                var activetherapies = dataConst.Therapies ? dataConst.Therapies.filter(e => e.RS != "DELETEACTIVITY" && e.Status != "INACTIVE") : [];
                var dt = new Date();
                var futureCredits = dataConst.FeeAll.filter(f => f.Type == "services" && f.FDT == "9999-01-01 00:00:00");

                //var futureCredits = dataConst.FeeAll;


                var futureCreditsOfBoss = groupBy(futureCredits, "BOSSId");
                if (allPinnacleClarity) {

                    var forIds = allPinnacleClarity.map(m => m.ForId + "");

                    var usedCredits = dataConst.FeeAll.filter(f => f.Type == "services" && forIds.indexOf(f.BOSSId + "") > -1);


                    var usedCreditsOfBoss = groupBy(usedCredits, "BOSSId");

                    var groupedClarity = groupBy(allPinnacleClarity, "ForId");

                    // console.log(groupedClarity);


                    $.each(allPinnacleClarity, function (k, a) {
                        var obj = {};

                        if (a.Category.indexOf("Inactivation") > -1 && !isItKPI) {

                            var numberOfTherapies = usedCreditsOfBoss && usedCreditsOfBoss[a.ForId] && usedCreditsOfBoss[a.ForId].length > 0 ? usedCreditsOfBoss[a.ForId].sort((a, b) => (new Date(b.CDT) > new Date(a.CDT) ? 1 : -1))[0].NoOfTherapies : 1;
                            obj.Facility = facilitiesGroup[a.CenterId] && facilitiesGroup[a.CenterId][0] ? facilitiesGroup[a.CenterId][0].Name : "";
                            obj.Kid = peopleGroup[a.ForId] && peopleGroup[a.ForId][0] ? peopleGroup[a.ForId][0].Name : "";
                            obj.AdminReply = a.Reply && a.Reply.trim() != "" ? a.Reply : "Pending";
                            obj.TherapistReply = a.TherapistReply && a.TherapistReply.trim() != "" ? a.TherapistReply : "Pending";
                            //futureCreditsOfBoss[a.ForId] && futureCreditsOfBoss[a.ForId].length > 0 ? futureCreditsOfBoss[a.ForId][0].NoOfTherapies
                            //peopleGroup[a.ForId] && peopleGroup[a.ForId][0] ? peopleGroup[a.ForId][0].F12  : 1;
                            obj.Package = numberOfTherapies;
                            obj.Credits = futureCreditsOfBoss[a.ForId] ? futureCreditsOfBoss[a.ForId].length : 0;
                            obj.CDT = peopleGroup[a.ForId] && peopleGroup[a.ForId][0] ? peopleGroup[a.ForId][0].CDT : "";
                            obj.Uneven = obj.TherapistReply == "Pending" || obj.AdminReply == "Pending" || obj.TherapistReply.split("-")[0].trim() == obj.AdminReply.split("-")[0].trim() ? "No" : "Yes";
                            obj.KidId = a.ForId;
                            obj.ServiceId = a.F2;
                            obj.AllServices = groupedClarity && groupedClarity[a.ForId] && groupedClarity[a.ForId].length > 0 ? groupedClarity[a.ForId].filter(e => e && e.Reply && e.Reply.toLowerCase() == "continue empowerment").length > 0 ? "Continue" : "Discontinue" : "Pending";

                            try {
                                var therapistId = activetherapies.filter(f => a.F2 + "" == f.Id + "")[0].TherapistId;
                                // obj.For = (peopleGroup[therapistId] && peopleGroup[therapistId][0] ? peopleGroup[therapistId][0].Name : "");
                                obj.Therapist = therapistId + "#" + (peopleGroup[therapistId] && peopleGroup[therapistId][0] ? peopleGroup[therapistId][0].Name : "");
                            }
                            catch {

                            }

                            obj.Category = a.Category;
                            obj.Reply = obj.TherapistReply == "Pending" || obj.AdminReply == "Pending" || obj.TherapistReply.split("-")[0].trim() == obj.AdminReply.split("-")[0].trim() ? obj.AdminReply : "Uneven";
                        }
                        else if (a.Category.indexOf("Pollination") > -1 && !isItKPI) {
                            if (!data.filter(f => f.ForId == a.ForId)[0]) {
                                obj.Facility = facilitiesGroup[a.CenterId] && facilitiesGroup[a.CenterId][0] ? facilitiesGroup[a.CenterId][0].Name : "";
                                obj.Name = peopleGroup[a.ForId] && peopleGroup[a.ForId][0] ? peopleGroup[a.ForId][0].Name : "";
                                obj.ForId = a.ForId;
                                obj.Category = a.Category;
                                var filteredData1St = groupedClarity && groupedClarity[a.ForId] && groupedClarity[a.ForId].length > 0 ? groupedClarity[a.ForId].filter(e => (e.Category == 'September Admin Pollination' || e.Category == 'September Therapist Pollination') && e.Message.indexOf("1st September") > -1)[0] : '';
                                var filteredData2nd = groupedClarity && groupedClarity[a.ForId] && groupedClarity[a.ForId].length > 0 ? groupedClarity[a.ForId].filter(e => (e.Category == 'September Admin Pollination' || e.Category == 'September Therapist Pollination') && e.Message.indexOf("5th September") > -1)[0] : '';
                                obj["Total Pollination sessions"] = a.F2;
                                obj["By 1st"] = filteredData1St && filteredData1St.Reply && filteredData1St.Reply.indexOf("0 - Others") == -1 ? filteredData1St.Reply : 0;
                                obj["By 5th"] = filteredData2nd && filteredData2nd.Reply && filteredData2nd.Reply.indexOf("0 - Others") == -1 ? filteredData2nd.Reply : 0;
                            }
                        }
                        else {
                            var alltherapiesforkid = activetherapies.filter(e => e.BossId == a.ForId)
                            var therapistName = ""
                            var speechtherapy = ""
                            var specialeducation = ""
                            var behavioraltherapy = ""
                            var occupationaltherapy = ""
                            for (i = 0; i < alltherapiesforkid.length; i++) {

                                var names = dataConst.People.filter(e => e.Id == alltherapiesforkid[i].TherapistId)[0]
                                // if(names!=null &&alltherapiesforkid ){
                                //     alltherapiesforkid.filter(e=>e.TherapistId == names.Id && )
                                // }
                                //  if(names!=null){
                                //  therapistName+= names.Id+"#"+names.Name+"{#}"
                                //  }

                                //obj.Therapist=therapistName ? therapistName :null;
                                if (names.Designation && names.Designation == "Occupational Therapist") {
                                    occupationaltherapy += names.Id + "#" + names.Name + "{#}";
                                } else if (names.Designation && names.Designation == "Behavioural Therapist") {
                                    behavioraltherapy += names.Id + "#" + names.Name + "{#}";
                                }
                                else if (names.Designation && names.Designation == "Speech Therapist") {
                                    speechtherapy += names.Id + "#" + names.Name + "{#}";
                                }
                                else if (names.Designation && names.Designation == "Special Educator ") {
                                    specialeducation += names.Id + "#" + names.Name + "{#}";
                                }

                            }

                            obj.Facility = facilitiesGroup[a.CenterId] && facilitiesGroup[a.CenterId][0] ? facilitiesGroup[a.CenterId][0].Name : "";
                            obj.For = peopleGroup[a.ForId] && peopleGroup[a.ForId][0] ? peopleGroup[a.ForId][0].Name : "";
                            obj.HBDT = a.HBDT;
                            obj.Category = a.Category;
                            obj.Message = a.Message;
                            obj.KidId = a.ForId;

                            if (a.Category.indexOf("Fee Pending") > -1 || a.Category.indexOf("Renewals") > -1) {



                                obj.OT = occupationaltherapy ? occupationaltherapy : null;

                                obj.BT = behavioraltherapy ? behavioraltherapy : null;

                                obj.ST = speechtherapy ? speechtherapy : null;

                                obj.SE = specialeducation ? specialeducation : null;

                            }
                            obj.Remarks = a.F5;
                            obj.TOId = a.UBPI;

                            obj.Reply = a.Reply && a.Reply.trim() != "" ? a.Reply : "Pending";
                            if (a.Category.indexOf("Inactivation") > -1 && !isItKPI) {
                                obj.TherapistReply = a.TherapistReply && a.TherapistReply.trim() != "" ? a.TherapistReply : "Pending";
                                obj.Uneven = obj.TherapistReply == "Pending" || obj.Reply == "Pending" || a.TherapistReply == a.Reply ? "" : "Uneven";
                                try {
                                    var therapistId = activetherapies.filter(f => a.F2 + "" == f.Id + "")[0].TherapistId;
                                    obj.For = (peopleGroup[therapistId] && peopleGroup[therapistId][0] ? peopleGroup[therapistId][0].Name : "");
                                    obj.Therapist = therapistId + "#" + (peopleGroup[therapistId] && peopleGroup[therapistId][0] ? peopleGroup[therapistId][0].Name : "");
                                }
                                catch {

                                }

                            }
                            if (a.Category.indexOf("Renewals") > -1 && !isItKPI) {
                                obj.TherapistReply = a.TherapistReply && a.TherapistReply.trim() != "" ? a.TherapistReply : "Pending";
                                obj.Uneven = obj.Reply == obj.TherapistReply ? "No" : "Yes";
                                obj["Offer Amount"] = a.F1;
                                obj.Package = a.F4;
                            }

                            obj.Amount = a.F2 ? a.F2 : a.Message.replace(obj.For + " ", "").replace(" Fee Clearing ETA ?", "");
                        }
                        data.push(obj);
                    });
                }

                return data;

                break;

            default:
                return [];
                break;


        }
    } catch (e) {
        console.log("EXCEPTION IN REPORTS FOR: " + type + " isItKPI: " + isItKPI + "  FDT: " + FDT + " TDT: " + TDT);
        console.log(e);

        SaveCleintWaufli(e, "Client Reports Failed", " GetReportsData " + type);
        return [];
    }
}
export function GetDateDiff(date1, date2) {
    return date2.getTime() - date1.getTime();
}


export var fixedExpenses = [
    "rent",
    "internet",
    "internet charges",
    "establishment",
    "maintenance"

];

export var benefitExpenses = [
    "team out"

];


export var incentiveExpenses = [
    "incentives"


];
function CalculateDangPendingForToday(list, config, from, to, fids, people) {
    list = (list || []);
    var facilititesLength = ((fids || []).length);
    var startDate = new Date(2022, 9, 12);
    from = from <= startDate ? startDate : from;
    var currentDateTime = new Date();
    var currentCDT = new Date();
    currentCDT.setDate(currentCDT.getDate() + 1)
    var toDate = currentDateTime.getDate() <= to ? currentCDT : to;
    to = currentDateTime.getDate() <= to ? currentDateTime : to;

    var noofWorkingDays = Math.ceil(GetTotalWorkingDays(from, toDate));

    var stringArray = config && config.Description && config.Description.includes("{=}") ? config.Description.split("{=}") : [];
    var timespanList = [];
    if (stringArray.length > 0) {
        for (let i = 0; i < stringArray.length; ++i) {
            var val = stringArray[i].split("{#}")[0];
            timespanList.push(val);
        }
    }
    //var total = noofWorkingDays * timespanList.length;

    var mappedPeople = list && list.length > 0 ? list.map(e => e.CBPI) : [];

    list.forEach(function (e) {
        var filterByDang = people && people.length > 0 ? people.filter(k => k.Id == e.CBPI)[0] : '';
        e.CenterId = filterByDang && filterByDang.CenterId ? filterByDang.CenterId : 0;
    });

    // var filterPeople = people && people.length > 0 ? people.filter(e=>mappedPeople.indexOf(e.CBPI) > -1) : [];

    // var mappedCenters = filterPeople && filterPeople.length > 0 ? filterPeople.map(e=>e.CenterId):[];

    // var filterFacilities = fids && fids.length > 0 ? fids.filter(e=>mappedCenters.indexOf(e.Id)==-1) : [];

    var returnObj = [];
    for (var i = 0; i < fids.length; ++i) {
        var fac = fids[i];
        for (var j = 0; j < timespanList.length; ++j) {
            var currTime = timespanList[j];
            var listFilter = list && list.length > 0 ? list.filter(e => e.CenterId == fac.Id && currTime == e.F1)[0] : '';
            if (!listFilter) {
                var obj = {};
                obj.Facility = fac.Name;
                obj.Time = currTime;
                obj.FId = fac.Id;
                returnObj.push(obj);
            }
        }
    }
    return returnObj;
}
function CalculateDangPendingCount(list, config, from, to, fids) {
    list = (list || []);
    var facilititesLength = ((fids || []).length);
    var startDate = new Date(2022, 9, 12);
    from = from <= startDate ? startDate : from;
    var currentDateTime = new Date();
    var currentCDT = new Date();
    currentCDT.setDate(currentCDT.getDate() + 1)
    var toDate = currentDateTime.getDate() <= to ? currentCDT : to;
    to = currentDateTime.getDate() <= to ? currentDateTime : to;

    var noofWorkingDays = Math.ceil(GetTotalWorkingDays(from, toDate));

    var stringArray = config && config.F1 && config.F1.includes("{=}") ? config.F1.split("{=}") : [];
    var timespanList = [];
    if (stringArray.length > 0) {
        for (let i = 0; i < stringArray.length; ++i) {
            var val = stringArray[i].split("{#}")[0];
            timespanList.push(GetTimeSlotTotal(val));
        }
    }

    var total = noofWorkingDays * timespanList.length;
    if (currentDateTime.getDate() == to.getDate()) {
        var currentHoursMins = currentDateTime.getHours() * 60 + currentDateTime.getMinutes();
        total += timespanList.filter(m => currentHoursMins >= m).length;
    }
    var totalPendings = (facilititesLength * total) - list.length;
    return totalPendings > 0 ? totalPendings : 0;

}

var dangConfig = {
    "F1": "8:30{#}Biometric Punch-In,  Supervise Readiness: Cleaning, Hygiene, Ambience, Organize, Lead Follow-Up, Red KPI, NCC, Harvest, Finance Sync{=}9:00{#}Supervise Readiness: Ambience, Organize Reception, Therapy Rooms, Playzone, Pantry. Clear Pending: Goals, Attendance, Fee, Seeta, Kubera, Lead Follow-Up, Red KPI, NCC, Harvest, Finance Sync{=}9:30{#}Staff Check-In, Biometric Sync, Staff Leaves, Handle unapproved leaves, Compensations. Welcome Parents, Greet Kids, Offer Water, Call Absented Kids. Clear Pending: Goals, Attendance, Fee, Seeta, Kubera, Lead Follow-Up, Red KPI, NCC, Harvest, Finance Sync,  Parents 1:1{=}10:00{#}Welcome Parents, Greet Kids, Offer Water, Call Absented Kids. Attention to Cleanliness, Hygiene, Organize, Clear Pending: Goals, Attendance, Seeta, Kubera, Lead Follow-Up, Red KPI, NCC, Harvest, Finance Sync,  Parents 1:1{=}11:00{#}Welcome Parents, Greet Kids, Offer Water, Call Absented Kids. Attention to Cleanliness, Hygiene, Organize. Clear Pending: Goals, Attendance, Seeta, Kubera, Lead Follow-Up, Red KPI, NCC, Harvest, Finance Sync, Parents 1:1{=}12:00{#}Welcome Parents, Greet Kids, Offer Water, Call Absented Kids. Attention to Cleanliness, Hygiene, Organize. Clear Pending: Goals, Attendance, Seeta, Kubera, Lead Follow-Up, Red KPI, NCC, Harvest, Finance Sync, Parents 1:1{=}13:00{#}Welcome Parents, Greet Kids, Offer Water, Call Absented Kids. Attention to Cleanliness, Hygiene, Organize. Clear Pending: Goals, Attendance, Seeta, Kubera, Lead Follow-Up, Red KPI, NCC, Harvest, Finance Sync, Parents 1:1{=}14:00{#}Welcome Parents, Greet Kids, Offer Water, Call Absented Kids. Attention to Cleanliness, Hygiene, Organize. Clear Pending: Goals, Attendance, Seeta, Kubera, Lead Follow-Up, Red KPI, NCC, Harvest, Finance Sync, Parents 1:1{=}15:00{#}Welcome Parents, Greet Kids, Offer Water, Call Absented Kids. Attention to Cleanliness, Hygiene, Organize. Clear Pending: Goals, Attendance, Seeta, Kubera, Lead Follow-Up, Red KPI, NCC, Harvest, Finance Sync, Parents 1:1{=}16:00{#}Welcome Parents, Greet Kids, Offer Water, Call Absented Kids. Attention to Cleanliness, Hygiene, Organize. Clear Pending: Goals, Attendance, Seeta, Kubera, Lead Follow-Up, Red KPI, NCC, Harvest, Finance Sync, Parents 1:1{=}16:30{#}Welcome Parents, Greet Kids, Offer Water, Call Absented Kids. Attention to Cleanliness, Hygiene, Organize. Clear Pending: Goals, Attendance, Seeta, Kubera, Lead Follow-Up, Red KPI, NCC, Harvest, Finance Sync, Parents 1:1{=}17:00{#}Welcome Parents, Greet Kids, Offer Water, Call Absented Kids. Attention to Cleanliness, Hygiene, Organize. Clear Pending: Goals, Attendance, Seeta, Kubera, Lead Follow-Up, Red KPI, NCC, Harvest, Finance Sync, Parents 1:1{=}17:30{#}Welcome Parents, Greet Kids, Offer Water, Call Absented Kids. Attention to Cleanliness, Hygiene, Organize. Clear Pending: Goals, Attendance, Seeta, Kubera, Lead Follow-Up, Red KPI, NCC, Harvest, Finance Sync, Parents 1:1{=}18:00{#}Welcome Parents, Greet Kids, Offer Water, Call Absented Kids. Attention to Cleanliness, Hygiene, Organize. Clear Pending: Goals, Attendance, Seeta, Kubera, Lead Follow-Up, Red KPI, NCC, Harvest, Finance Sync, Parents 1:1{=}18:30{#}Welcome Parents, Greet Kids, Offer Water, Call Absented Kids. Attention to Cleanliness, Hygiene, Organize. Clear Pending: Goals, Attendance, Seeta, Kubera, Lead Follow-Up, Red KPI, NCC, Harvest, Finance Sync, Parents 1:1",
    "F2": "LEP,AP,GP,TGNS,PP,KUM,SETP",
    "F7": 15,
    "S": "ADMINISTRATOR"
}


export function SumOfAllAggregates(aggreagates) {
    var aggregate = {};
    $.each(aggreagates, function (k, v) {
        // var facilityName = $.grep(allfacilities, function (e) { return e.Id == v.GID })[0];
        // v["FACSFT"] = facilityName && facilityName.SFT > 0 ? facilityName.SFT : 0;
        var business = (v.PP + v.PPE + v.PA + v.APEN);
        v["BUSINESS"] = business;
        var keys = Object.keys(v);
        // console.log(keys);

        v["PROFIT"] = business - (v.E + v.TS);
        //v["FACILITY"] = facilityName ? facilityName.N : "";



        //v["COSTPEREXPENSE"] = facilityName && facilityName.SFT > 0 ? (v.E + v.TS) / facilityName.SFT : 0;
        //v["COSTPEREARNING"] = facilityName && facilityName.SFT > 0 ? (v.PP + v.PPE + v.PA + v.APEN) / facilityName.SFT : 0;

        //v["EXPENSEPERPERSON"] = 
        //console.log(keys);
        keys.forEach((key, index) => {

            if (key == "WD" || key == "PROLM" || key == "PROLY" || key == "PTILY" || key == "PTILM") {
                aggregate[key] = v[key];
            }
            else {
                if (!aggregate.hasOwnProperty(key)) {
                    if (key == "L") {
                        aggregate[key] = [];
                    }
                    else if (key == "CDT" || key == "UDT" || key == "FDT" || key == "TDT") {
                        aggregate[key] = new Date();
                    }
                    else {
                        aggregate[key] = 0;
                    }
                }
                if (typeof v[key] == "object") {

                    if (v[key] && v[key].length > 0) {
                        Array.prototype.push.apply(aggregate[key], v[key]);
                    }
                }
                else if (key == "CDT" || key == "UDT" || key == "FDT" || key == "TDT") {
                    aggregate[key] = v[key];
                }
                else if (typeof v[key] != "string") {
                    aggregate[key] = aggregate[key] + v[key];
                }
            }
        });
    });

    return aggregate;
}


function GetPrepData(role, data, fromDate, toDate, fids, $this) {
    var todayDate = new Date();

    var fdt = fromDate ? fromDate : new Date(todayDate.getFullYear(), todayDate.getMonth(), 1);
    var tdt = toDate ? toDate : new Date(todayDate.getFullYear(), todayDate.getMonth() + 1, 0, 23, 59, 59);
    var FDT = fdt;
    var TDT = tdt;
    var logs = [];
    var inittialStart = new Date();
    var startDate = new Date();

    var fsIds = fids.map(m => m + "");

    const totalworkingdays = GetTotalWorkingDays(FDT, TDT);
    const therapies = data.Therapies ? data.Therapies.filter(f => fids.indexOf(f.CenterId) > -1 && f.RS != "DELETEACTIVITY" && f.Status != "INACTIVE" && ($this.IsUserTherapist && role != "Senior" ? data.CFUser.Id == f.TherapistId : true)) : [];
    const pinnacleClarities = data.PinnacleClarity ? data.PinnacleClarity.filter(f => fids.indexOf(f.CenterId) > -1 && f.RS != "DELETEACTIVITY") : [];



    var therapyIds = therapies ? therapies.map(m => m.Id) : [];
    const goals = data.Goals ? data.Goals.filter(f => therapyIds.indexOf(f.TherapyId) > -1) : [];
    const types = data.Types ? data.Types : [];
    const usersettings = data.UserSettings;

    const holidays = GetHolidaysList();

    var people = (data.People || []).filter(f => fids.indexOf(f.CenterId) > -1 && ($this.IsUserTherapist && role != "Senior" ? data.CFUser.Id == f.Id : true));
    const leads = (data.Leads || []).filter(f => fids.indexOf(f.CenterId) > -1);
    people = people || [];
    var pIds = people.map(m => m.Id);
    const allPeopleNotes = data.PeopleNotes ? data.PeopleNotes.filter(f => pIds.indexOf(f.TOId) > -1) : [];
    data.Mirracles = (data.Mirracles || []);
    const mirracles = data.Mirracles.filter(m => pIds.indexOf(m.PersonId) > -1 && dateFromSDateTime(m.CDT) >= FDT && dateFromSDateTime(m.CDT) <= TDT);

    data.Dang = (data.Dang || []);
    const dang = data.Dang.filter(f => fids.indexOf(f.CenterId) > -1 && dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT);

    const allCenterNotes = data.CenterNotes ? data.CenterNotes.filter(f => fids.indexOf(f.CenterId) > -1) : [];


    const allLeaveRequests = allPeopleNotes ? allPeopleNotes.filter(f => f.TypeId == GetTypeIdByName(types, "LEAVEREQUEST")) : [];

    var compoTypeId = GetTypeIdByName(types, "SERVICECOMPENSATION");
    const allCompensations = data.Attendance ? data.Attendance.filter(f => f.TypeId == compoTypeId && therapyIds.indexOf(f.ServiceId) > -1) : [];
    //pIds.indexOf(f.BOSSId) > -1 ||
    data.Fee = data.Fee ? data.Fee.filter(f => f.BOSSId ? true : false) : [];

    var feeThisMonth = data.Fee ? data.Fee.filter(f => dateFromSDateTime(f.FDT) >= FDT && dateFromSDateTime(f.TDT) <= TDT && (fids.indexOf(f.CenterId) > -1 || fsIds.indexOf(f.CenterId) > -1) && f.RS != "DELETEACTIVITY") : [];

    var inactiveServices = data.Therapies ? data.Therapies.filter(m => null != m.F14 && dateFromSDateTime(m.F14) <= TDT && m.Status.toUpperCase() == "INACTIVE" && fids.indexOf(m.CenterId) > -1) : [];

    var fututreMonthInvoices = data.Fee ? data.Fee.filter(f => dateFromSDateTime(f.FDT) > TDT && (fids.indexOf(f.CenterId) > -1 || fsIds.indexOf(f.CenterId) > -1) && f.RS != "DELETEACTIVITY") : [];

    var attendance = data.Attendance ? data.Attendance.filter(f => dateFromSDateTime(f.ForDate) >= FDT && dateFromSDateTime(f.ForDate) <= TDT && therapyIds.indexOf(f.ServiceId) > -1) : [];
    var paymentsThisMonth = data.FeeReceipt ? data.FeeReceipt.filter(e => e.RS != "DELETEACTIVITY" && (fids.indexOf(e.CenterId) > -1 || fsIds.indexOf(e.CenterId) > -1)) : [];
    var servicerequest = data.ServiceRequests ? data.ServiceRequests.filter(m => pIds.indexOf(m.TOId) > -1 || pIds.indexOf(m.CBPI) > -1 && (!m.RS || m.RS != "DELETEACTIVITY")) : [];
    var ServiceRequestAnalytic = data.ServiceRequestsAnalytics ? data.ServiceRequestsAnalytics.filter(m => m.RS != "DELETEACTIVITY") : [];

    var memoTypeId = GetTypeIdByName(types, "MEMO")
    var leaverequestId = GetTypeIdByName(types, "LEAVEREQUEST");
    var awardId = GetTypeIdByName(types, "AWARD");
    var mirracleAssignId = GetTypeIdByName(types, "MIRRACLEASSIGNED");

    var allLeaves = data.PeopleNotes ? data.PeopleNotes.filter(f => f.TypeId == leaverequestId && (dateFromSDateTime(f.FDT) >= FDT || (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) <= TDT))) : [];

    var allMirraclesAssigned = data.PeopleNotes ? data.PeopleNotes.filter(f => f.TypeId == mirracleAssignId) : [];

    var allMemos = data.PeopleNotes ? data.PeopleNotes.filter(f => f.TypeId == memoTypeId) : [];
    var allawards = data.PeopleNotes ? data.PeopleNotes.filter(f => f.TypeId == awardId) : [];

    var feeAllMonths = data.Fee ? data.Fee.filter(e => (fids.indexOf(e.CenterId) > -1 || fsIds.indexOf(e.CenterId) > -1) && e.RS != "DELETEACTIVITY") /*.filter(f => dateFromSDateTime(f.FDT) >= FDT && dateFromSDateTime(f.TDT) < TDT)*/ : [];
    var allassessmentdata = data.Assessments ? data.Assessments : [];

    var dataConst = {};

    dataConst.Therapies = therapies;
    dataConst.Goals = goals;

    dataConst.Types = types;
    dataConst.Centers = data.Centers;
    dataConst.UserSettings = usersettings;
    dataConst.Holidays = holidays;
    dataConst.People = people;
    dataConst.TWD = totalworkingdays;
    dataConst.Leaves = allLeaveRequests;
    dataConst.Compos = allCompensations;
    dataConst.Fee = feeThisMonth;
    dataConst.InActive = inactiveServices;
    dataConst.Attendance = attendance;
    dataConst.FutureInvoices = fututreMonthInvoices;
    dataConst.FeeReceipt = paymentsThisMonth;
    dataConst.ServiceRequest = servicerequest;
    dataConst.ServiceRequestAnalytic = ServiceRequestAnalytic;
    dataConst.Leaverequestall = allLeaves;
    dataConst.MirraclesAssigned = allMirraclesAssigned;
    dataConst.FeeAll = feeAllMonths;
    dataConst.PeopleNotes = allPeopleNotes;
    dataConst.CenterNotes = allCenterNotes;
    dataConst.Assessmentsdata = allassessmentdata;
    dataConst.Leads = leads;
    dataConst.Memos = allMemos;
    dataConst.Responses = data.Responses;
    dataConst.Awards = allawards;
    dataConst.Feedback = data.Feedback;
    dataConst.Biometric = data.Biometric;
    dataConst.MirraclesData = mirracles;
    dataConst.MirracleTypes = data.MirracleTypes;
    dataConst.Dang = dang;
    dataConst.PinnacleClarity = pinnacleClarities;
    return dataConst;
}

function PrepBossAggregates(fids, dataConst, fdt, tdt, facility, $this, onlyThese) {
    var logs = [];
    //credits available
    var aggregate = {};
    var startDate = new Date();
    var FDT = fdt;
    var TDT = tdt;
    aggregate.FCI = GetReportsData("availablecredits", dataConst, true, fdt, tdt, facility).length;
    logs.push("FCI:" + GetDateDiff(startDate, new Date()));

    //goals
    startDate = new Date();
    aggregate.TAG = GetReportsData("activegoals", dataConst, true, fdt, tdt, facility).length;
    logs.push("TAG:" + GetDateDiff(startDate, new Date()));
    //Goal Reviewed

    startDate = new Date();
    aggregate.GR = GetReportsData("goalreviewed", dataConst, true, fdt, tdt, facility).length;
    logs.push("GR:" + GetDateDiff(startDate, new Date()));

    //Goal Pending
    startDate = new Date();
    aggregate.GP = GetReportsData("goalspending", dataConst, true, fdt, tdt, facility).length;
    logs.push("GP:" + GetDateDiff(startDate, new Date()));


    // Pending - assessments

    aggregate.ASP = dataConst.Assessmentsdata.filter(m => m.Status.toLowerCase() == "pending").length;

    // Completed -assessments
    aggregate.AST = dataConst.Assessmentsdata.filter(m => m.Status.toLowerCase() == "completed").length;

    // pending attendance
    //startDate = new Date();
    //aggregate.AP = GetReportsData("attendancepending", dataConst, true, fdt, tdt, facility);
    //logs.push("AP:" + GetDateDiff(startDate, new Date()));


    // attendance present

    startDate = new Date();
    aggregate.AGP = GetReportsData("attendancepresent", dataConst, true, fdt, tdt, facility).length;
    logs.push("AGP:" + GetDateDiff(startDate, new Date()));

    //attendance absent
    startDate = new Date();
    aggregate.AGA = GetReportsData("attendanceabsent", dataConst, true, fdt, tdt, facility).length;
    logs.push("AGA:" + GetDateDiff(startDate, new Date()));

    // attendance 
    aggregate.AG = aggregate.AGP + aggregate.AGA;

    // Homework pending
    startDate = new Date();
    aggregate.RP = GetReportsData("homeworkpending", dataConst, true, fdt, tdt, facility).length;
    logs.push("RP:" + GetDateDiff(startDate, new Date()));

    // Homework pending
    startDate = new Date();
    aggregate.RG = GetReportsData("homeworkgiven", dataConst, true, fdt, tdt, facility).length;
    logs.push("RG:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    var servicerequests = GetReportsData("servicerequests", dataConst, true, fdt, tdt, facility);
    var inprocess = servicerequests.filter(m => !m.LastAnalytic);
    aggregate.SRIP = (inprocess || []).length;
    logs.push("srip:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    var waiting = servicerequests.filter(m => m.LastAnalytic && m.LastAnalytic.Status == "CLOSED" && m.CBPI != m.LastAnalytic.CBPI);
    aggregate.SRW = (waiting || []).length;
    logs.push("SRW:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    var closed = servicerequests.filter(m => dateFromSDateTime(m.CDT) >= FDT && dateFromSDateTime(m.CDT) <= TDT && m.LastAnalytic && m.LastAnalytic.Status == "CLOSED" && m.CBPI == m.LastAnalytic.CBPI);
    aggregate.SRR = (closed || []).length;
    logs.push("SRR:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    var reopen = servicerequests.filter(m => m.LastAnalytic && m.LastAnalytic.Status == "REOPEN");
    aggregate.SRRO = (reopen || []).length;
    logs.push("SRRO:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.SRT = aggregate.SRRO + aggregate.SRR + aggregate.SRW + aggregate.SRIP;

    startDate = new Date();
    var compodataa = GetReportsData("compospending", dataConst, true, fdt, tdt, facility);
    aggregate.CPC = compodataa > 0 ? compodataa : 0;
    logs.push("CPC:" + GetDateDiff(startDate, new Date()));

    var pendingCourses = GetReportsData("allpendingcourses", dataConst, true, fdt, tdt, facility);

    aggregate.TCOP = pendingCourses.totalPending;
    aggregate.TTP = pendingCourses.totalTantrumsPending;
    aggregate.TCNP = pendingCourses.totalConditionsPending;
    aggregate.TPISIP = pendingCourses.ptiPendingAssesmsnets;

    aggregate.HWP = 0;


    var bossAchivements = GetReportsData("bossachivements", dataConst, true, fdt, tdt, facility);

     //   aggregate.TBOT = bossAchivements.totalBossTherapies;
    aggregate.TBOG = bossAchivements.totalBossGoals;
    aggregate.TBOF = bossAchivements.totalBossFeedback;

    var bossPendingFee = GetReportsData("bosspendingfee", dataConst, true, fdt, tdt, facility);

    aggregate.BPF = bossPendingFee;


    return aggregate;
}


function PrepTherapistAggregates(fids, dataConst, fdt, tdt, facility, $this, onlyThese) {
    var aggregate = {};
    var logs = [];
    var startDate = new Date();
    var FDT = fdt;
    var TDT = tdt;

    var logs = [];
    var therapistId = dataConst.Types.filter(m => m.Name == "Therapist")[0].Id;

    aggregate.FId = fids;

    dataConst.Therapists = Object.entries(groupBy(dataConst.People.filter(f => f.RoleId == therapistId && f.F8 != 1 && f.F21 != "CENTERNUMBER" && f.F21 != "NONSTAFF"), 'Id')).map(m => m[1][0]);
    aggregate.PCP = GetReportsData("pollinationclaritypromised", dataConst, true, fdt, tdt, facility);
    logs.push("PCP:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.TGNS = GetReportsData("goalsnotset", dataConst, true, fdt, tdt, facility).length;
    logs.push("TGNS:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.GP = GetReportsData("goalspending", dataConst, true, fdt, tdt, facility).length;
    logs.push("GP:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.AP = GetReportsData("attendancepending", dataConst, true, fdt, tdt, facility);
    logs.push("AP:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    var compodataa = GetReportsData("compospending", dataConst, true, fdt, tdt, facility);
    aggregate.CPC = compodataa > 0 ? compodataa : 0;
    logs.push("CPC:" + GetDateDiff(startDate, new Date()));

    //startDate = new Date();
    //aggregate.AGP = GetReportsData("therapiesprovided", dataConst, true, fdt, tdt, facility).length;
    //logs.push("AGP:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    aggregate.AGP = GetReportsData("attendancepresent", dataConst, true, fdt, tdt, facility).length;
    logs.push("AGP:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    aggregate.AGA = GetReportsData("attendanceabsent", dataConst, true, fdt, tdt, facility).length;
    logs.push("AGA:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.GR = GetReportsData("goalreviewed", dataConst, true, fdt, tdt, facility).length;
    logs.push("GR:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    aggregate.AWARDS = GetReportsData("awardswon", dataConst, true, fdt, tdt, facility).length;
    logs.push("AWARDS:" + GetDateDiff(startDate, new Date()));

    ///POLLINATION

    startDate = new Date();
    aggregate.PCP = GetReportsData("pollinationclaritypromised", dataConst, true, fdt, tdt, facility);
    logs.push("PCP:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.PCC = GetReportsData("pollinationclaritycompleted", dataConst, true, fdt, tdt, facility);
    logs.push("PCC:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.PCYT = GetReportsData("pollinationclarityyetto", dataConst, true, fdt, tdt, facility);
    logs.push("RPCYTCTD:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.PCZ = GetReportsData("pollinationclarityzero", dataConst, true, fdt, tdt, facility);
    logs.push("PCZ:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    aggregate.PCLT = GetReportsData("pollinationclaritylessthanthree", dataConst, true, fdt, tdt, facility);
    logs.push("PCLT:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.PCGT = GetReportsData("pollinationclaritygreaterthanthree", dataConst, true, fdt, tdt, facility);
    logs.push("PCGT:" + GetDateDiff(startDate, new Date()));


    //  startDate = new Date();
    //  aggregate.PAO=GetReportsData("pollinationopty", dataConst, true, fdt, tdt, facility);
    //  logs.push("PAO:" + GetDateDiff(startDate, new Date()));





    ///POLLINATION


    /*startDate = new Date();
    var pisiLatesttherapy = GetReportsData("pisilatest", dataConst, true, fdt, tdt, facility);

    var pisiids = pisiLatesttherapy.Reponses.map(m => m.PeopleNoteId);


    startDate = new Date();
    var TOA = pisiLatesttherapy.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("overall efficacy"));
    aggregate.TOE = !TOA || TOA.length == 0 ? 0 : Math.round(TOA.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (TOA.length * 5), 2);;
    logs.push("TOE:" + GetDateDiff(startDate, new Date()));

    var TAS = pisiLatesttherapy && pisiLatesttherapy.length > 0 ? pisiLatesttherapy.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("appreciations / suggestions") && m.Response) : [];



    aggregate.TASS = TAS.length;
    //aggregate.TCA = pisiLatest && pisiLatest.length > 0 ? pisiLatest.Assessments.length : 0 - aggregate.TPA;
    logs.push("TASS:" + GetDateDiff(startDate, new Date()));
    */

    // #region PISI
    startDate = new Date();
    var pisiLatest = GetReportsData("pisilatest", dataConst, true, fdt, tdt, facility);

    var pisiids = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.map(m => m.PeopleNoteId) : [];

    aggregate.TPA = pisiLatest && pisiLatest.Assessments && pisiLatest.Assessments.length > 0 ? pisiLatest.Assessments.filter(f => pisiids.indexOf(f.Id) == -1).length : 0;
    logs.push("TPA:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    var TOA = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("overall efficacy")) : [];
    aggregate.TOE = !TOA || TOA.length == 0 ? 0 : Math.round(TOA.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (TOA.length * 5), 2);;
    logs.push("TOE:" + GetDateDiff(startDate, new Date()));

    // therapy improvemnet
    startDate = new Date();
    var TTI = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("improvemnet")) : [];
    aggregate.TIP = !TTI || TTI.length == 0 ? 0 : Math.round(TTI.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (TTI.length * 5), 2);;
    logs.push("TTI:" + GetDateDiff(startDate, new Date()));

    // Daily Homework Feedback
    startDate = new Date();
    var TDH = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("daily homework feedback")) : [];

    aggregate.TDH = !TDH || TDH.length == 0 ? 0 : Math.round(TDH.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (TDH.length * 5), 2);
    logs.push("TDH:" + GetDateDiff(startDate, new Date()));
    // Daily after therapy interaction

    startDate = new Date();
    var TDA = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("daily after therapy interaction")) : [];
    aggregate.TDA = !TDA || TDA.length == 0 ? 0 : Math.round(TDA.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (TDA.length * 5), 2);
    logs.push("TDA:" + GetDateDiff(startDate, new Date()));
    // Daily Homework Feedback

    startDate = new Date();
    var TAS = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("appreciations / suggestions") && m.Response) : [];



    aggregate.TASS = TAS.length;
    aggregate.TCA = pisiLatest && pisiLatest.Assessments && pisiLatest.Assessments.length > 0 ? pisiLatest.Assessments.length : 0 - aggregate.TPA;
    logs.push("TASS:" + GetDateDiff(startDate, new Date()));
    // #endregion PISI

    startDate = new Date();
    var whiLatest = GetReportsData("WHILATEST", dataConst, true, fdt, tdt, facility);
    var whiids = whiLatest && whiLatest.Reponses && whiLatest.Reponses.length > 0 ? whiLatest.Reponses.map(m => m.PeopleNoteId) : [];
    aggregate.PROA = whiLatest && whiLatest.Assessments && whiLatest.Assessments.length > 0 > 0 ? whiLatest.Assessments.length : 0;
    logs.push("PROA:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.PROS = whiLatest && whiLatest.length > 0 ? whiLatest.Suggestions.length : 0;
    logs.push("PROS:" + GetDateDiff(startDate, new Date()));


    //if (role == "Therapist") {
    //    startDate = new Date();
    //    aggregate.TOE = GetReportsData("pisirating", dataConst, true, fdt, tdt, facility).length;
    //    logs.push("TOE:" + GetDateDiff(startDate, new Date()));
    //}



    //startDate = new Date();
    //aggregate.MIRT = GetReportsData("mirracles", dataConst, true, fdt, tdt, facility).length;
    //logs.push("MIRT:" + GetDateDiff(startDate, new Date()));

    /*startDate = new Date();
    aggregate.RP = GetReportsData("feedbackspending", dataConst, true, fdt, tdt, facility).length;
    logs.push("RP:" + GetDateDiff(startDate, new Date()));*/
    //Change below like above


    startDate = new Date();
    aggregate.RG = GetReportsData("feedbacksgiven", dataConst, true, fdt, tdt, facility).length;
    logs.push("RG:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.RP = aggregate.AGP - aggregate.RG;//  GetReportsData("homeworkpending", dataConst, true, fdt, tdt, facility).length;
    logs.push("RP:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.RGT = GetReportsData("feedbackratings", dataConst, true, fdt, tdt, facility);
    logs.push("RGT:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    aggregate.RAT = aggregate.RG ? (aggregate.RGT / aggregate.RG).toFixed(2) : 0;
    logs.push("RAT:" + GetDateDiff(startDate, new Date()));

    //TOE
    //AGP
    //CPC
    //Goals for therapist
    startDate = new Date();
    aggregate.GR = GetReportsData("goalreviewed", dataConst, true, fdt, tdt, facility).length;
    logs.push("GR:" + GetDateDiff(startDate, new Date()));

    //Goal Pending for therapist
    startDate = new Date();
    aggregate.GP = GetReportsData("goalspending", dataConst, true, fdt, tdt, facility).length;
    logs.push("GP:" + GetDateDiff(startDate, new Date()));

    //services 

    startDate = new Date();
    aggregate.SF = GetReportsData("activeservices", dataConst, true, fdt, tdt, facility).length;
    logs.push("CST:" + GetDateDiff(startDate, new Date()));

    //Assessments

    startDate = new Date();
    var allAssessmentsData = dataConst.Assessmentsdata;

    startDate = new Date();
    aggregate.ASP = allAssessmentsData.filter(m => m.Status && m.Status.toLowerCase() == "pending").length;
    logs.push("ASP:" + GetDateDiff(startDate, new Date()));

    // Completed assessment
    startDate = new Date();
    aggregate.AST = GetReportsData("assessmentcompleted", dataConst, true, fdt, tdt, facility).length;
    logs.push("AST:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    var whiLatest = GetReportsData("WHILATEST", dataConst, true, fdt, tdt, facility);
    var whiids = whiLatest && whiLatest.Reponses && whiLatest.Reponses.length > 0 ? whiLatest.Reponses.map(m => m.PeopleNoteId) : [];
    aggregate.PROA = whiLatest && whiLatest.Assessments && whiLatest.Assessments.length > 0 ? whiLatest.Assessments.length : 0;
    logs.push("PROA:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.PROS = whiLatest && whiLatest.Suggestions && whiLatest.Suggestions.length > 0 ? whiLatest.Suggestions.length : 0;
    logs.push("PROS:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.PROP = whiLatest && whiLatest.Assessments && whiLatest.Assessments.length > 0 ? whiLatest.Assessments.filter(f => whiids.indexOf(f.Id) == -1).length : 0;
    logs.push("PROP:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.PROT10 = whiLatest && whiLatest.Ranks && whiLatest.Ranks.length > 0 ? whiLatest.Ranks.filter(m => m.RankTextId == "top10").length : 0;
    logs.push("PROT10:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.PROT40 = whiLatest && whiLatest.Ranks && whiLatest.Ranks.length > 0 ? whiLatest.Ranks.filter(m => m.RankTextId == "top40").length : 0;
    logs.push("PROT40:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.PROB40 = whiLatest && whiLatest.Ranks && whiLatest.Ranks.length > 0 ? whiLatest.Ranks.filter(m => m.RankTextId == "bottom40").length : 0;
    logs.push("PROT40:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.PROB10 = whiLatest && whiLatest.Ranks && whiLatest.Ranks.length > 0 ? whiLatest.Ranks.filter(m => m.RankTextId == "bottom10").length : 0;
    logs.push("PROB10:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    var allrenewalClarity = GetReportsData("renewalclarityall", dataConst, true, fdt, tdt, facility);
    // var AllFeeETA = data.filter(e =>  (type.toLowerCase() == "renewalclarityall" ? true : type.toLowerCase() == "renewalclaritytoberenewed" ? tobeRenewed.indexOf(e.Details.toLowerCase()) == -1 : type.toLowerCase() == "renewalclarity"+e.Details.toLowerCase()+""));

    aggregate.RCA = allrenewalClarity.length;
    logs.push("RCA:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();

    aggregate.RCOD = allrenewalClarity.filter(f => f.Details == "overdue").length;//  GetReportsData("renewalclarityoverdue", dataConst, true, fdt, tdt, facility);
    logs.push("RCOD:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.RCTD = allrenewalClarity.filter(f => f.Details == "today").length; //GetReportsData("renewalclaritytoday", dataConst, true, fdt, tdt, facility);
    logs.push("RCTD:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.RCTR = allrenewalClarity.filter(f => f.Details == "tomorrow").length; //GetReportsData("renewalclaritytomorrow", dataConst, true, fdt, tdt, facility);
    logs.push("RCTR:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    aggregate.RCTW = allrenewalClarity.filter(f => f.Details == "thisweek").length; //GetReportsData("renewalclaritythisweek", dataConst, true, fdt, tdt, facility);
    logs.push("RCTW:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.RCNW = allrenewalClarity.filter(f => f.Details == "nextweek").length; //GetReportsData("renewalclaritynextweek", dataConst, true, fdt, tdt, facility);
    logs.push("RCNW:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    aggregate.RCTM = allrenewalClarity.filter(f => f.Details == "thismonth").length; //GetReportsData("renewalclaritythismonth", dataConst, true, fdt, tdt, facility);
    logs.push("RCTM:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.RCNM = allrenewalClarity.filter(f => f.Details == "nextmonth").length; //GetReportsData("renewalclaritynextmonth", dataConst, true, fdt, tdt, facility);
    logs.push("RCNM:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.RCOT = allrenewalClarity.filter(f => f.Details == "others").length; //GetReportsData("renewalclarityothers", dataConst, true, fdt, tdt, facility);
    logs.push("RCOT:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.RCP = allrenewalClarity.filter(f => f.Details == "pending").length; //GetReportsData("renewalclaritypending", dataConst, true, fdt, tdt, facility);
    logs.push("RCP:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.RCR = allrenewalClarity.filter(f => f.Details == "renewed").length; //GetReportsData("renewalclarityrenewed", dataConst, true, fdt, tdt, facility);
    logs.push("RCR:" + GetDateDiff(startDate, new Date()));
    startDate = new Date();
    aggregate.RCTBR = aggregate.RCA - aggregate.RCR - aggregate.RCP - aggregate.RCOT;
    logs.push("RCTBR:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    var servicerequests = GetReportsData("servicerequests", dataConst, true, fdt, tdt, facility);
    var inprocess = servicerequests.filter(m => !m.LastAnalytic);
    aggregate.SRIP = (inprocess || []).length;
    logs.push("srip:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    var waiting = servicerequests.filter(m => m.LastAnalytic && m.LastAnalytic.Status == "CLOSED" && m.CBPI != m.LastAnalytic.CBPI);
    aggregate.SRW = (waiting || []).length;
    logs.push("SRW:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    var closed = servicerequests.filter(m => dateFromSDateTime(m.CDT) >= FDT && dateFromSDateTime(m.CDT) <= TDT && m.LastAnalytic && m.LastAnalytic.Status == "CLOSED" && m.CBPI == m.LastAnalytic.CBPI);
    aggregate.SRR = (closed || []).length;
    logs.push("SRR:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    var reopen = servicerequests.filter(m => m.LastAnalytic && m.LastAnalytic.Status == "REOPEN");
    aggregate.SRRO = (reopen || []).length;
    logs.push("SRRO:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.SRT = aggregate.SRRO + aggregate.SRR + aggregate.SRW + aggregate.SRIP;

    startDate = new Date();
    aggregate.LVP = GetReportsData("leavespending", dataConst, true, fdt, tdt, facility).length;
    logs.push("LVP:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.LVAL = GetReportsData("leavesall", dataConst, true, fdt, tdt, facility).length;
    logs.push("LVAL:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.LVAP = GetReportsData("leavesapproved", dataConst, true, fdt, tdt, facility).length;
    logs.push("LVAP:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.LVUA = GetReportsData("leavesunapproved", dataConst, true, fdt, tdt, facility).length;
    logs.push("LVUA:" + GetDateDiff(startDate, new Date()));


    var services = dataConst.Therapies;
    var serviceIds = Object.entries(groupBy(dataConst.Therapies, "BossId"));

    var total = 0;
    var totalST = 0;
    var totalOT = 0;
    var totalBT = 0;
    var totalSE = 0;
    for (var i = 0; i < servicesOfeering.length; i++) {
        var boss = serviceIds.filter(f => f[1].map(m => m.TypeId).indexOf(servicesOfeering[i].Id) == -1);
        total += (boss || []).length;
        if (servicesOfeering[i].ShortName == "ST") {
            totalST += (boss || []).length;
        }
        else if (servicesOfeering[i].ShortName == "BT") {
            totalBT += (boss || []).length;
        }
        else if (servicesOfeering[i].ShortName == "OT") {
            totalOT += (boss || []).length;
        }
        else if (servicesOfeering[i].ShortName == "SE") {
            totalSE += (boss || []).length;
        }
    }


    startDate = new Date();
    aggregate.POL = total;
    logs.push("POL:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.AVL = GetReportsData("available", dataConst, true, fdt, tdt, facility).length;
    logs.push("AVL:" + GetDateDiff(startDate, new Date()));

    var pendingCourses = GetReportsData("allpendingcourses", dataConst, true, fdt, tdt, facility);

    aggregate.TCOP = pendingCourses.totalPending;
    aggregate.TTP = pendingCourses.totalTantrumsPending;
    aggregate.TCNP = pendingCourses.totalConditionsPending;
    aggregate.TPISI = pendingCourses.ptiPendingAssesmsnets;

    return aggregate;
}


function PrepOwnerAggregates(fids, dataConst, fdt, tdt, facility, $this, onlyThese, role) {

    var logs = [];
    var therapistId = dataConst.Types.filter(m => m.Name == "Therapist")[0].Id;
    var startDate = new Date();
    var aggregate = {};
    var FDT = fdt;
    var TDT = tdt;

    var adminId = dataConst.Types.filter(m => m.Name == "Receptionist")[0].Id;
    var bossid = dataConst.Types.filter(m => m.Name == "Boss")[0].Id
    dataConst.Therapists = Object.entries(groupBy(dataConst.People.filter(f => f.RoleId == therapistId && f.F8 != 1 && f.F21 != "CENTERNUMBER" && f.F21 != "NONSTAFF"), 'Id')).map(m => m[1][0]);


    dataConst.LeftTherapists = Object.entries(groupBy(dataConst.People.filter(f => f.RoleId == therapistId && f.F8 == 1 && f.F21 != "CENTERNUMBER" && f.F21 != "NONSTAFF"), 'Id')).map(m => m[1][0]);

    dataConst.Parents = Object.entries(groupBy(dataConst.People.filter(f => f.RoleId == bossid && f.F8 != 1), 'Id')).map(m => m[1][0]);;

    if (null == onlyThese || onlyThese.indexOf("kubera") > -1) {
        // #region kubera



        startDate = new Date();

        var aggregateKu18 = GetReportsData("kuberamonthlyfee", dataConst, true, fdt, tdt, facility);
        aggregate.KU18 = aggregateKu18 && aggregateKu18.length > 0 ? aggregateKu18.length : 0;
        logs.push("KU18:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        aggregate.KUM = GetReportsData("kuberamissing", dataConst, true, fdt, tdt, facility).length;
        logs.push("KUM:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        var aggregateKUAB = GetReportsData("kuberaabnormal", dataConst, true, fdt, tdt, facility);
        aggregate.KUAB = aggregateKUAB && aggregateKUAB.length > 0 ? aggregateKUAB.length : 0;
        logs.push("KUAB:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        var aggregateTotalInvoices = GetReportsData("allinvoicesthismonth", dataConst, true, fdt, tdt, facility);

        var filtered = [...aggregateKu18, ...aggregateKUAB];
        var totalInvoices = aggregateTotalInvoices && aggregateTotalInvoices.length > 0 ? aggregateTotalInvoices.filter(val => !filtered.includes(val)).length : 0;

        //aggregate.KUR = totalInvoices - aggregate.KU18 - aggregate.KUAB;
        aggregate.KUR = totalInvoices;
        logs.push("KUR:" + GetDateDiff(startDate, new Date()));
        // #endregion kubera
    }

    if (null == onlyThese || onlyThese.indexOf("empower2") > -1) {
        // #region Empower2empwoer2single
        startDate = new Date();
        aggregate.EMPM = GetReportsData("empwoer2monthly", dataConst, true, fdt, tdt, facility).length;
        logs.push("EMPM:" + GetDateDiff(startDate, new Date()));


        startDate = new Date();
        aggregate.EMPS = GetReportsData("empwoer2single", dataConst, true, fdt, tdt, facility).length;
        logs.push("EMPS:" + GetDateDiff(startDate, new Date()));


        startDate = new Date();
        aggregate.EMPRNW = GetReportsData("empwoer2lostparents", dataConst, true, fdt, tdt, facility).length;
        logs.push("EMPRNW:" + GetDateDiff(startDate, new Date()));


        // startDate = new Date();

        // var renewalsData = GetReportsData("renewals", dataConst, true, fdt, tdt, facility);
        // renewalsData = renewalsData || [];
        // aggregate.RWT = renewalsData.length;
        // logs.push("RWT:" + GetDateDiff(startDate, new Date()));

        // startDate = new Date();
        // aggregate.RWP = (renewalsData.filter(f => f.Renewed == "No") || []).length;
        // logs.push("RWP:" + GetDateDiff(startDate, new Date()));
        // startDate = new Date();
        // aggregate.RWC = (renewalsData.filter(f => f.Renewed == "Yes") || []).length;
        // logs.push("RWC:" + GetDateDiff(startDate, new Date()));
        // startDate = new Date();
        // aggregate.RW3 = (renewalsData.filter(f => f.Renewed == "No" && f.Package >= 2 && f.Package <= 3) || []).length;
        // logs.push("RW3:" + GetDateDiff(startDate, new Date()));
        // startDate = new Date();
        // aggregate.RW6 = (renewalsData.filter(f => f.Renewed == "No" && f.Package > 3 && f.Package <= 6) || []).length;;
        // logs.push("RW6:" + GetDateDiff(startDate, new Date()));
        // startDate = new Date();
        // aggregate.RW12 = (renewalsData.filter(f => f.Renewed == "No" && f.Package > 6 && f.Package <= 48) || []).length;;
        // logs.push("RW12:" + GetDateDiff(startDate, new Date()));
        // startDate = new Date();

        // aggregate.RWC3 = (renewalsData.filter(f => f.Renewed == "Yes" && f.Package >= 2 && f.Package <= 3) || []).length;
        // logs.push("RWC3:" + GetDateDiff(startDate, new Date()));
        // startDate = new Date();
        // aggregate.RWC6 = (renewalsData.filter(f => f.Renewed == "Yes" && f.Package > 3 && f.Package <= 6) || []).length;;
        // logs.push("RWC6:" + GetDateDiff(startDate, new Date()));
        // startDate = new Date();
        // aggregate.RWC12 = (renewalsData.filter(f => f.Renewed == "Yes" && f.Package > 6 && f.Package <= 48) || []).length;;

        // logs.push("RWC12:" + GetDateDiff(startDate, new Date()));

        // #endregion Empwoer2
    }

    if (null == onlyThese || onlyThese.indexOf("seeta") > -1) {
        // #region Seeta
        startDate = new Date();
        aggregate.SETT = GetReportsData("seetatotal", dataConst, true, fdt, tdt, facility).length;
        logs.push("SETT:" + GetDateDiff(startDate, new Date()));


        startDate = new Date();
        aggregate.SETP = GetReportsData("seetapending", dataConst, true, fdt, tdt, facility).length;
        logs.push("SETP:" + GetDateDiff(startDate, new Date()));


        startDate = new Date();
        aggregate.SETPP = GetReportsData("seetapartiallypaid", dataConst, true, fdt, tdt, facility).length;
        logs.push("SETPP:" + GetDateDiff(startDate, new Date()));


        startDate = new Date();
        aggregate.SETPA = GetReportsData("seetapaid", dataConst, true, fdt, tdt, facility).length;
        logs.push("SETPA:" + GetDateDiff(startDate, new Date()));


        startDate = new Date();
        aggregate.SETKI = GetReportsData("seetakids", dataConst, true, fdt, tdt, facility).length;
        logs.push("SETKI:" + GetDateDiff(startDate, new Date()));
        // #endregion Seeta
    }

    if (null == onlyThese || onlyThese.indexOf("achievements") > -1) {
        // #region Achievements
        startDate = new Date();
        aggregate.OW = GetReportsData("walkins", dataConst, true, fdt, tdt, facility).length;
        logs.push("OW:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        aggregate.FCI = GetReportsData("credits", dataConst, true, fdt, tdt, facility).length;
        logs.push("FCI:" + GetDateDiff(startDate, new Date()));

        //credits

        startDate = new Date();
        aggregate.ADM = GetReportsData("admissionleads", dataConst, true, fdt, tdt, facility).length;
        logs.push("ADM:" + GetDateDiff(startDate, new Date()));


        startDate = new Date();
        aggregate.ADD = GetReportsData("additions", dataConst, true, fdt, tdt, facility).length;
        logs.push("ADD:" + GetDateDiff(startDate, new Date()));


        startDate = new Date();
        aggregate.TCS = GetReportsData("inactivations", dataConst, true, fdt, tdt, facility).length;
        logs.push("TCS:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        aggregate.AC = GetReportsData("availablecredits", dataConst, true, fdt, tdt, facility).length;
        logs.push("AC:" + GetDateDiff(startDate, new Date()));
        // #endregion Achievements
    }


    if (null == onlyThese || onlyThese.indexOf("pendings") > -1) {
        // #region Pendings


        var services = dataConst.Therapies;
        var serviceIds = Object.entries(groupBy(dataConst.Therapies, "BossId"));

        var total = 0;
        var totalST = 0;
        var totalOT = 0;
        var totalBT = 0;
        var totalSE = 0;
        for (var i = 0; i < servicesOfeering.length; i++) {
            var boss = serviceIds.filter(f => f[1].map(m => m.TypeId).indexOf(servicesOfeering[i].Id) == -1);
            total += (boss || []).length;
            if (servicesOfeering[i].ShortName == "ST") {
                totalST += (boss || []).length;
            }
            else if (servicesOfeering[i].ShortName == "BT") {
                totalBT += (boss || []).length;
            }
            else if (servicesOfeering[i].ShortName == "OT") {
                totalOT += (boss || []).length;
            }
            else if (servicesOfeering[i].ShortName == "SE") {
                totalSE += (boss || []).length;
            }
        }


        startDate = new Date();
        aggregate.POL = total;
        logs.push("POL:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        aggregate.PAST = totalST;
        logs.push("PAST:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        aggregate.PAOT = totalOT;
        logs.push("PAOT:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        aggregate.PAABA = totalBT;
        logs.push("RCP:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        aggregate.PASE = totalSE;
        logs.push("RCR:" + GetDateDiff(startDate, new Date()));
        startDate = new Date();




        startDate = new Date();
        aggregate.AVL = GetReportsData("available", dataConst, true, fdt, tdt, facility).length;
        logs.push("AVL:" + GetDateDiff(startDate, new Date()));








        startDate = new Date();
        aggregate.ASP = GetReportsData("assessmentpending", dataConst, true, fdt, tdt, facility).length;
        logs.push("ASP:" + GetDateDiff(startDate, new Date()));


        //startDate = new Date();
        //aggregate.CPC = GetReportsData("compospending", dataConst, true, fdt, tdt, facility);
        //logs.push("CPC:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        aggregate.LVP = GetReportsData("leavespending", dataConst, true, fdt, tdt, facility).length;
        logs.push("LVP:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        aggregate.LVAL = GetReportsData("leavesall", dataConst, true, fdt, tdt, facility).length;
        logs.push("LVAL:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        aggregate.LVAP = GetReportsData("leavesapproved", dataConst, true, fdt, tdt, facility).length;
        logs.push("LVAP:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        aggregate.LVUA = GetReportsData("leavesunapproved", dataConst, true, fdt, tdt, facility).length;
        logs.push("LVUA:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        aggregate.SRIP = GetReportsData("servicerequestpending", dataConst, true, fdt, tdt, facility).length;
        logs.push("SRIP:" + GetDateDiff(startDate, new Date()));


        startDate = new Date();
        aggregate.CPA = 0;// GetReportsData("chipending", dataConst, true, fdt, tdt, facility).length;
        logs.push("CPA:" + GetDateDiff(startDate, new Date()));


        startDate = new Date();
        aggregate.WPA = 0;// GetReportsData("whipending", dataConst, true, fdt, tdt, facility).length;
        logs.push("WPA:" + GetDateDiff(startDate, new Date()));


        startDate = new Date();
        aggregate.TPA = 0;// GetReportsData("pisipending", dataConst, true, fdt, tdt, facility).length;
        logs.push("TPA:" + GetDateDiff(startDate, new Date()));


        startDate = new Date();
        aggregate.CST = GetReportsData("compos", dataConst, true, fdt, tdt, facility).length;
        logs.push("CST:" + GetDateDiff(startDate, new Date()));

        // #endregion pendings
    }


    if (null == onlyThese || onlyThese.indexOf("services") > -1) {
        startDate = new Date();
        aggregate.SF = GetReportsData("activeservices", dataConst, true, fdt, tdt, facility).length;
        logs.push("CST:" + GetDateDiff(startDate, new Date()));


        startDate = new Date();
        aggregate.TCS = GetReportsData("inactiveservices", dataConst, true, fdt, tdt, facility).length;
        logs.push("TCS:" + GetDateDiff(startDate, new Date()));

        //INACTIVATION ROOT CAUSE PENDING
        startDate = new Date();
        aggregate.TCSR = GetReportsData("inactivecausepending", dataConst, true, fdt, tdt, facility).length;
        logs.push("TCSR:" + GetDateDiff(startDate, new Date()));


        startDate = new Date();
        aggregate.TFADD = GetReportsData("futureservices", dataConst, true, fdt, tdt, facility).length;
        logs.push("TFADD:" + GetDateDiff(startDate, new Date()));


        startDate = new Date();
        aggregate.ADDS = GetReportsData("newservices", dataConst, true, fdt, tdt, facility).length;
        logs.push("ADDS:" + GetDateDiff(startDate, new Date()));


        startDate = new Date();
        aggregate.TSTS = GetReportsData("newservicesst", dataConst, true, fdt, tdt, facility).length;
        logs.push("TSTS:" + GetDateDiff(startDate, new Date()));


        startDate = new Date();
        aggregate.TBTS = GetReportsData("newservicesbt", dataConst, true, fdt, tdt, facility).length;
        logs.push("TBTS:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        aggregate.TSES = GetReportsData("newservicesse", dataConst, true, fdt, tdt, facility).length;
        logs.push("TSES:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        aggregate.TOTS = GetReportsData("newservicesot", dataConst, true, fdt, tdt, facility).length;
        logs.push("TOTS:" + GetDateDiff(startDate, new Date()));
    }
    if (null == onlyThese || onlyThese.indexOf("attendance") > -1) {
        startDate = new Date();
        aggregate.CSC = GetReportsData("compenstationcompleted", dataConst, true, fdt, tdt, facility).length;
        logs.push("CSC:" + GetDateDiff(startDate, new Date()));


        startDate = new Date();
        aggregate.CSF = GetReportsData("compenstationfuture", dataConst, true, fdt, tdt, facility).length;
        logs.push("CSF:" + GetDateDiff(startDate, new Date()));


        startDate = new Date();
        aggregate.CSTO = GetReportsData("compenstationtoday", dataConst, true, fdt, tdt, facility).length;
        logs.push("CSTO:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        aggregate.CSO = GetReportsData("compenstationorphan", dataConst, true, fdt, tdt, facility).length;
        logs.push("CSO:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        aggregate.CCL = GetReportsData("compenstationcanceled", dataConst, true, fdt, tdt, facility).length;
        logs.push("CCL:" + GetDateDiff(startDate, new Date()));

    }


    if (null == onlyThese || onlyThese.indexOf("misc") > -1) {
        startDate = new Date();
        aggregate.TStaff = GetReportsData("activestaff", dataConst, true, fdt, tdt, facility).length;
        logs.push("TStaff:" + GetDateDiff(startDate, new Date()));


        startDate = new Date();
        aggregate.ASTAFF = GetReportsData("addedstaff", dataConst, true, fdt, tdt, facility).length;
        logs.push("ASTAFF:" + GetDateDiff(startDate, new Date()));


        startDate = new Date();
        aggregate.TLStaff = GetReportsData("leftstaff", dataConst, true, fdt, tdt, facility).length;
        logs.push("TLStaff:" + GetDateDiff(startDate, new Date()));


        startDate = new Date();
        aggregate.KIDS = GetReportsData("activeparents", dataConst, true, fdt, tdt, facility).length;
        logs.push("KIDS:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        aggregate.TLKIDS = GetReportsData("leftparents", dataConst, true, fdt, tdt, facility).length;
        logs.push("TLKIDS:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        aggregate.AKIDs = GetReportsData("addedparents", dataConst, true, fdt, tdt, facility).length;
        logs.push("AKIDs:" + GetDateDiff(startDate, new Date()));


        startDate = new Date();
        aggregate.AMEMO = GetReportsData("activememos", dataConst, true, fdt, tdt, facility).length;
        logs.push("AMEMO:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        aggregate.CMEMO = GetReportsData("closedmemos", dataConst, true, fdt, tdt, facility).length;
        logs.push("CMEMO:" + GetDateDiff(startDate, new Date()));


        startDate = new Date();
        aggregate.TVPS = GetReportsData("viewpayslips", dataConst, true, fdt, tdt, facility).length;
        logs.push("TVPS:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        aggregate.TDPS = GetReportsData("downloadpayslips", dataConst, true, fdt, tdt, facility).length;
        logs.push("TDPS:" + GetDateDiff(startDate, new Date()));

    }

    if (null == onlyThese || onlyThese.indexOf("money") > -1) {
        startDate = new Date();
        aggregate.PP = GetReportsData("paymentpending", dataConst, true, fdt, tdt, facility);
        logs.push("PP:" + GetDateDiff(startDate, new Date()));


        startDate = new Date();
        aggregate.APEN = GetReportsData("advancepending", dataConst, true, fdt, tdt, facility);
        logs.push("APEN:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        aggregate.PPE = GetReportsData("paid", dataConst, true, fdt, tdt, facility).reduce(function (accc, items) {
            return accc + items.Amount;
        }, 0);
        logs.push("PPE:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        aggregate.PA = GetReportsData("advancepaid", dataConst, true, fdt, tdt, facility).reduce(function (accc, items) {
            return accc + items.Amount;
        }, 0);
        logs.push("PA:" + GetDateDiff(startDate, new Date()));


        startDate = new Date();
        var allexpenses = GetReportsData("expenses", dataConst, true, fdt, tdt, facility);
        aggregate.E = allexpenses.reduce(function (accc, items) {
            return accc + items.Amount;
        }, 0);
        logs.push("E:" + GetDateDiff(startDate, new Date()));


        startDate = new Date();
        var fixedHeaderIds = (dataConst.Types.filter(f => f.Category == "Expenses" && fixedExpenses.indexOf(f.Name.toLowerCase()) > -1).map(m => m.Id) || []);

        aggregate.EF = allexpenses.filter(f => fixedHeaderIds.indexOf(f.TOId) > -1).reduce(function (accc, items) {
            return accc + items.Amount;
        }, 0);

        logs.push("EF:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        var benefitsHeadersIds = (dataConst.Types.filter(f => f.Category == "Expenses" && benefitExpenses.indexOf(f.Name.toLowerCase()) > -1).map(m => m.Id) || []);

        aggregate.EBT = allexpenses.filter(f => benefitsHeadersIds.indexOf(f.TOId) > -1).reduce(function (accc, items) {
            return accc + items.Amount;
        }, 0);

        logs.push("EBT:" + GetDateDiff(startDate, new Date()));



        startDate = new Date();
        var incentivesHeadersIds = (dataConst.Types.filter(f => f.Category == "Expenses" && incentiveExpenses.indexOf(f.Name.toLowerCase()) > -1).map(m => m.Id) || []);

        aggregate.EIT = allexpenses.filter(f => incentivesHeadersIds.indexOf(f.TOId) > -1).reduce(function (accc, items) {
            return accc + items.Amount;
        }, 0);

        logs.push("EIT:" + GetDateDiff(startDate, new Date()));

        aggregate.EVE = aggregate.E - aggregate.EF - aggregate.EBT - aggregate.EIT;
        aggregate.EVE = aggregate.EVE > 0 ? aggregate.EVE : 0;


        startDate = new Date();
        aggregate.PIP = GetReportsData("pastpending", dataConst, true, fdt, tdt, facility);
        logs.push("PIP:" + GetDateDiff(startDate, new Date()));

    }




    if (null == onlyThese && (role == "Owner" || role == "FacilityOwner")) {
        startDate = new Date();
        aggregate.TS = GetReportsData("salary", dataConst, true, fdt, tdt, facility).reduce(function (accc, items) {
            return accc + items.Amount;
        }, 0);
        logs.push("TS:" + GetDateDiff(startDate, new Date()));



        // startDate = new Date();
        // aggregate.PPE = GetReportsData("paid", dataConst, true, fdt, tdt, facility).reduce(function (accc, items) {
        //     return accc + items.Amount;
        // }, 0);
        // logs.push("PPE:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        aggregate.PTS = GetReportsData("paidseva", dataConst, true, fdt, tdt, facility).reduce(function (accc, items) {
            return accc + items.Amount;
        }, 0);
        logs.push("PTS:" + GetDateDiff(startDate, new Date()));




        startDate = new Date();
        aggregate.AS = GetReportsData("advancepaidseva", dataConst, true, fdt, tdt, facility).reduce(function (accc, items) {
            return accc + items.Amount;
        }, 0);
        logs.push("AS:" + GetDateDiff(startDate, new Date()));


        startDate = new Date();
        aggregate.TPMPA = GetReportsData("pastpaid", dataConst, true, fdt, tdt, facility).reduce(function (accc, items) {
            return accc + items.Amount;
        }, 0);
        logs.push("TPMPA:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        aggregate.TPMSPA = GetReportsData("pastpaidseva", dataConst, true, fdt, tdt, facility).reduce(function (accc, items) {
            return accc + items.Amount;
        }, 0);
        logs.push("TPMSPA:" + GetDateDiff(startDate, new Date()));


        startDate = new Date();
        aggregate.ALFP = GetReportsData("alreadyfulfilled", dataConst, true, fdt, tdt, facility).reduce(function (accc, items) {
            return accc + items.Amount;
        }, 0);
        logs.push("ALFP:" + GetDateDiff(startDate, new Date()));


        startDate = new Date();
        aggregate.ATBF = GetReportsData("tobefulfilled", dataConst, true, fdt, tdt, facility).reduce(function (accc, items) {
            return accc + (items.Amount - items.SevaAmount);
        }, 0);
        logs.push("ALFP:" + GetDateDiff(startDate, new Date()));


        startDate = new Date();
        aggregate.TDB = GetReportsData("discount", dataConst, true, fdt, tdt, facility).reduce(function (accc, items) {
            return accc + items.Discount;
        }, 0);
        logs.push("TDB:" + GetDateDiff(startDate, new Date()));

    }
    else {
        aggregate.TS = 0;
        aggregate.PTS = 0;
        aggregate.AS = 0;
        aggregate.TPMPA = 0;
        aggregate.TPMSPA = 0;
        aggregate.ALFP = 0;
        aggregate.ATBF = 0;
        aggregate.TDB = 0;

    }








    if (null == onlyThese || onlyThese.indexOf("servicerequests") > -1) {

        // #region servicerequests



        startDate = new Date();
        var servicerequests = GetReportsData("servicerequests", dataConst, true, fdt, tdt, facility);
        var inprocess = servicerequests.filter(m => !m.LastAnalytic);
        aggregate.SRIP = (inprocess || []).length;
        logs.push("srip:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        var waiting = servicerequests.filter(m => m.LastAnalytic && m.LastAnalytic.Status == "CLOSED" && m.CBPI != m.LastAnalytic.CBPI);
        aggregate.SRW = (waiting || []).length;
        logs.push("SRW:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        var closed = servicerequests.filter(m => dateFromSDateTime(m.CDT) >= FDT && dateFromSDateTime(m.CDT) <= TDT && m.LastAnalytic && m.LastAnalytic.Status == "CLOSED" && m.CBPI == m.LastAnalytic.CBPI);
        aggregate.SRR = (closed || []).length;
        logs.push("SRR:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        var reopen = servicerequests.filter(m => m.LastAnalytic && m.LastAnalytic.Status == "REOPEN");
        aggregate.SRRO = (reopen || []).length;
        logs.push("SRRO:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        aggregate.SRT = aggregate.SRRO + aggregate.SRR + aggregate.SRW + aggregate.SRIP;
        //aggregate.SRT = GetReportsData("servicerequestall", dataConst, true, fdt, tdt, facility).length;

        aggregate.SR5 = servicerequests.filter(m => m.Rating == 5).length;
        logs.push("SR5:" + GetDateDiff(startDate, new Date()));
        startDate = new Date();
        aggregate.SR4 = servicerequests.filter(m => m.Rating == 4).length;
        logs.push("SR4:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        aggregate.SR3 = servicerequests.filter(m => m.Rating == 3).length;
        logs.push("SR3:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        aggregate.SR2 = servicerequests.filter(m => m.Rating == 2).length;
        logs.push("SR2:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        aggregate.SR1 = servicerequests.filter(m => m.Rating == 1).length;
        logs.push("SR1:" + GetDateDiff(startDate, new Date()));

        // #endregion servicerequests

    }
    if (null == onlyThese || onlyThese.indexOf("leads") > -1) {

        // #region lead

        startDate = new Date();
        aggregate.LEP = GetReportsData("leadspending", dataConst, true, fdt, tdt, facility).length;
        logs.push("LEP:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        var allLeads = dataConst.Leads;


        //active
        startDate = new Date();
        var activeLeads = GetReportsData("activeleadsdata", dataConst, true, fdt, tdt, facility);
        aggregate.LA = activeLeads.length;
        logs.push("LA:" + GetDateDiff(startDate, new Date()));


        //closed
        startDate = new Date();
        var closedLeads = GetReportsData("closedleadsdata", dataConst, true, fdt, tdt, facility);
        aggregate.LC = closedLeads.length;
        logs.push("LC:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        aggregate.LTO = aggregate.LA + aggregate.LC;
        logs.push("LTO:" + GetDateDiff(startDate, new Date()));

        // New 
        startDate = new Date();
        aggregate.LN = GetReportsData("newleads", dataConst, true, fdt, tdt, facility).length;
        logs.push("LN:" + GetDateDiff(startDate, new Date()));


        // Else where

        startDate = new Date();
        var elseWhere = GetReportsData("leadselsewhere", dataConst, true, fdt, tdt, facility);
        aggregate.JSW = elseWhere.length;
        logs.push("JSW:" + GetDateDiff(startDate, new Date()));
        // Assessments - Doubt
        //var lIds = groupBy(allLeads,"TOId").map(m => m.Id);
        //aggregate.LASM = data.ANALYTICS.Where(m => m.AT == EnumSharb.ActivityType.BookAssessment.ToString().ToUpper() && lIds.Contains(m.TOId)).Count();

        // Admissions

        startDate = new Date();
        var filteredLta = GetReportsData("leadstoadmission", dataConst, true, fdt, tdt, facility);
        aggregate.LTA = filteredLta.length;
        logs.push("LTA:" + GetDateDiff(startDate, new Date()));

        // #endregion lead
    }
    if (null == onlyThese || onlyThese.indexOf("goals") > -1) {

        // #region Goals 

        //total goals

        startDate = new Date();
        aggregate.TGO = GetReportsData("totalgoals", dataConst, true, fdt, tdt, facility).length;
        logs.push("TGO:" + GetDateDiff(startDate, new Date()));


        //active goals

        startDate = new Date();
        aggregate.TAG = GetReportsData("activegoals", dataConst, true, fdt, tdt, facility).length;
        logs.push("TAG:" + GetDateDiff(startDate, new Date()));

        // Today pending goals
        startDate = new Date();
        aggregate.TGP = GetReportsData("todaypendinggoals", dataConst, true, fdt, tdt, facility).length;
        logs.push("TGP:" + GetDateDiff(startDate, new Date()));

        //Goal Reviewed

        startDate = new Date();
        aggregate.GR = GetReportsData("goalreviewed", dataConst, true, fdt, tdt, facility).length;
        logs.push("GR:" + GetDateDiff(startDate, new Date()));


        // Goal ontime
        //startDate = new Date();
        //aggregate.TGONT = GetReportsData("goalontime", dataConst, true, fdt, tdt, facility).length;
        //logs.push("TGONT:" + GetDateDiff(startDate, new Date()));


        //// Goal late
        //startDate = new Date();
        //aggregate.TGOOT = GetReportsData("goallate", dataConst, true, fdt, tdt, facility).length;
        //logs.push("TGOOT:" + GetDateDiff(startDate, new Date()));


        // Goal Met
        startDate = new Date();
        aggregate.TGM = GetReportsData("goalmet", dataConst, true, fdt, tdt, facility).length;
        logs.push("TGM:" + GetDateDiff(startDate, new Date()));

        // Goal Not Met
        startDate = new Date();
        aggregate.GNM = GetReportsData("goalnotmet", dataConst, true, fdt, tdt, facility).length;
        logs.push("GNM:" + GetDateDiff(startDate, new Date()));

        // #endregion Goals
    }

    if (null == onlyThese || onlyThese.indexOf("assessments") > -1) {

        // #region assessments
        startDate = new Date();
        var allAssessmentsData = dataConst.Assessmentsdata;
        aggregate.TAB = GetReportsData("assessmentall", dataConst, true, fdt, tdt, facility).length;
        logs.push("TAB:" + GetDateDiff(startDate, new Date()));
        // Pending - NIPL

        startDate = new Date();
        aggregate.ASP = allAssessmentsData.filter(m => m.Status && m.Status.toLowerCase() == "pending").length;
        logs.push("ASP:" + GetDateDiff(startDate, new Date()));

        // Completed assessment
        startDate = new Date();
        aggregate.AST = GetReportsData("assessmentcompleted", dataConst, true, fdt, tdt, facility).length;
        // aggregate.AST = allAssessmentsData.filter(m => m.Status.toLowerCase() == "completed").length;
        logs.push("AST:" + GetDateDiff(startDate, new Date()));


        /*   var assessmentIds = allAssessmentsData.map(m => m.Id);
           var assessmnetInvoices = facilityInvoices.Where(m => null != m.RDUId && m.RDUId.Count() > 0 && assessmentIds.Contains(m.RDUId[0].ToString())).ToList();
           aggregate.TPFA = assessmnetInvoices.Sum(m => m.F7);
           aggregate.TSPFA = assessmnetInvoices.Sum(m => m.F8);*/

        // #endregion assessments
    }

    if (null == onlyThese || onlyThese.indexOf("leaves") > -1) {

        // #region Leave Requests


        var currentDate = new Date();

        startDate = new Date();
        var futureLeaves = GetReportsData("leaverequestparentfuture", dataConst, true, fdt, tdt, facility);
        aggregate.PLF = (futureLeaves || []).length;
        logs.push("PLF:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        var completedLeaves = GetReportsData("leaverequestparentcompleted", dataConst, true, fdt, tdt, facility);
        aggregate.PLC = (completedLeaves || []).length;
        logs.push("PLC:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        var cancelledLeaved = GetReportsData("leaverequestparentcanceled", dataConst, true, fdt, tdt, facility);
        aggregate.PLCA = (cancelledLeaved || []).length;
        logs.push("PLCA:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        aggregate.TOPL = aggregate.PLF + aggregate.PLC + aggregate.PLCA;
        logs.push("TOPL:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        var futurenpLeaves = GetReportsData("leaverequestnonparentfuture", dataConst, true, fdt, tdt, facility);
        aggregate.SLF = (futurenpLeaves || []).length;
        logs.push("SLF:" + GetDateDiff(startDate, new Date()));



        startDate = new Date();
        var lrclt4 = GetReportsData("leaverequestcomposlt4", dataConst, true, fdt, tdt, facility);
        aggregate.SLCLT4 = (lrclt4 || []).length;
        logs.push("SLCLT4:" + GetDateDiff(startDate, new Date()));


        startDate = new Date();
        var completednpLeaves = GetReportsData("leaverequestnonparentcompleted", dataConst, true, fdt, tdt, facility);
        aggregate.SLC = (completednpLeaves || []).length;
        logs.push("SLC:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        var cancellednpLeaved = GetReportsData("leaverequestnonparentcanceled", dataConst, true, fdt, tdt, facility);
        aggregate.SLCA = (cancellednpLeaved || []).length;
        logs.push("SLCA:" + GetDateDiff(startDate, new Date()));


        startDate = new Date();
        aggregate.TOSL = aggregate.SLF + aggregate.SLC + aggregate.SLCA;
        logs.push("TOSL:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        var approvedLeaves = GetReportsData("leaverequestanalytic", dataConst, true, fdt, tdt, facility);
        aggregate.SLA = (approvedLeaves || []).length;
        logs.push("SLA:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        var unapprovedLeaves = GetReportsData("leaverequestanalyticunapproved", dataConst, true, fdt, tdt, facility);
        aggregate.SLUA = (unapprovedLeaves || []).length;
        logs.push("SLUA:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        aggregate.SLAP = aggregate.SLF + aggregate.SLC - aggregate.SLA - aggregate.SLUA;
        logs.push("SLAP:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        var pendingLeaves = GetReportsData("leavespendingapproval", dataConst, true, fdt, tdt, facility);
        aggregate.SLPA = (pendingLeaves || []).length;
        logs.push("SLPA:" + GetDateDiff(startDate, new Date()));



        // #endregion Leave Requests
    }

    if (null == onlyThese || onlyThese.indexOf("whi") > -1) {

        // #region WHI
        startDate = new Date();
        var whiLatest = GetReportsData("WHILATEST", dataConst, true, fdt, tdt, facility);
        var whiids = whiLatest && whiLatest.Reponses && whiLatest.Reponses.length > 0 ? whiLatest.Reponses.map(m => m.PeopleNoteId) : [];
        aggregate.PROA = whiLatest && whiLatest.Assessments && whiLatest.Assessments.length > 0 ? whiLatest.Assessments.length : 0;
        logs.push("PROA:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        aggregate.PROS = whiLatest && whiLatest.Suggestions && whiLatest.Suggestions.length > 0 ? whiLatest.Suggestions.length : 0;
        logs.push("PROS:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        aggregate.PROP = whiLatest && whiLatest.Assessments && whiLatest.Assessments.length > 0 ? whiLatest.Assessments.filter(f => whiids.indexOf(f.Id) == -1).length : 0;
        logs.push("PROP:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        aggregate.PROT10 = whiLatest && whiLatest.Ranks && whiLatest.Ranks.length > 0 ? whiLatest.Ranks.filter(m => m.RankTextId == "top10").length : 0;
        logs.push("PROT10:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        aggregate.PROT40 = whiLatest && whiLatest.Ranks && whiLatest.Ranks.length > 0 ? whiLatest.Ranks.filter(m => m.RankTextId == "top40").length : 0;
        logs.push("PROT40:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        aggregate.PROB40 = whiLatest && whiLatest.Ranks && whiLatest.Ranks.length > 0 ? whiLatest.Ranks.filter(m => m.RankTextId == "bottom40").length : 0;
        logs.push("PROT40:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        aggregate.PROB10 = whiLatest && whiLatest.Ranks && whiLatest.Ranks.length > 0 ? whiLatest.Ranks.filter(m => m.RankTextId == "bottom10").length : 0;
        logs.push("PROB10:" + GetDateDiff(startDate, new Date()));
        // #endregion WHI
        // start biometric

        //totalstaff


        /*  startDate = new Date();
          aggregate.TStaff = GetReportsData("totalstaff", dataConst, true, fdt, tdt, facility).length;
          logs.push("TStaff:" + GetDateDiff(startDate, new Date()));
  */
        // biometric absent
        startDate = new Date();
        aggregate.BMA = GetReportsData("biometricabsent", dataConst, true, fdt, tdt, facility).length;
        logs.push("BMA:" + GetDateDiff(startDate, new Date()));

        // biometric present
        startDate = new Date();
        aggregate.BMP = GetReportsData("biometricpresent", dataConst, true, fdt, tdt, facility).length;
        logs.push("BMP:" + GetDateDiff(startDate, new Date()));
        // biometric entry early
        startDate = new Date();
        aggregate.BMENE = GetReportsData("biometricentryearly", dataConst, true, fdt, tdt, facility).length;
        logs.push("BMENE:" + GetDateDiff(startDate, new Date()));
        // biometric entry ontime
        startDate = new Date();
        aggregate.BMENOT = GetReportsData("biometricentryontime", dataConst, true, fdt, tdt, facility).length;
        logs.push("BMENOT:" + GetDateDiff(startDate, new Date()));
        // biometric entry late
        startDate = new Date();
        aggregate.BMENL = GetReportsData("biometricentrylate", dataConst, true, fdt, tdt, facility).length;
        logs.push("BMENL:" + GetDateDiff(startDate, new Date()));
        // biometric exit early
        startDate = new Date();
        aggregate.BMEXE = GetReportsData("biometricexitearly", dataConst, true, fdt, tdt, facility).length;
        logs.push("BMEXE:" + GetDateDiff(startDate, new Date()));
        // biometric exit ontime
        startDate = new Date();
        aggregate.BMEXOT = GetReportsData("biometricexitontime", dataConst, true, fdt, tdt, facility).length;
        logs.push("BMEXOT:" + GetDateDiff(startDate, new Date()));
        // biometric exit late
        startDate = new Date();
        aggregate.BMEXL = GetReportsData("biometricexitlate", dataConst, true, fdt, tdt, facility).length;
        logs.push("BMEXL:" + GetDateDiff(startDate, new Date()));


        // #endregion biometric
    }


    if (null == onlyThese || onlyThese.indexOf("chi") > -1) {

        // #region CHI 
        startDate = new Date();
        var chiLatest = GetReportsData("chilatest", dataConst, true, fdt, tdt, facility);

        var chiids = chiLatest && chiLatest.Reponses && chiLatest.Reponses.length > 0 ? chiLatest.Reponses.map(m => m.CenterNoteId) : [];

        aggregate.CPA = chiLatest && chiLatest.Assessments && chiLatest.Assessments.length > 0 ? chiLatest.Assessments.filter(f => chiids.indexOf(f.Id) == -1).length : 0;

        logs.push("CPA:" + GetDateDiff(startDate, new Date()));
        // Overall efficacy

        startDate = new Date();
        var COA = chiLatest && chiLatest.Reponses && chiLatest.Reponses.length > 0 ? chiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("overall efficacy")) : [];
        logs.push("COA:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        aggregate.COE = !COA || COA.length == 0 ? 0 : Math.round(COA.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (COA.length * 5), 2);
        logs.push("COE:" + GetDateDiff(startDate, new Date()));



        // center hygiene
        startDate = new Date();
        var CHG = chiLatest && chiLatest.Reponses && chiLatest.Reponses.length > 0 ? chiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("center hygiene")) : [];


        aggregate.CHG = !CHG || CHG.length == 0 ? 0 : Math.round(CHG.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (CHG.length * 5), 2);
        logs.push("CHG:" + GetDateDiff(startDate, new Date()));

        // washroom hygiene
        startDate = new Date();
        var CWH = chiLatest && chiLatest.Reponses && chiLatest.Reponses.length > 0 ? chiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("washroon hygiene")) : [];

        aggregate.CWH = !CWH || CWH.length == 0 ? 0 : Math.round(CWH.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (CWH.length * 5), 2);
        logs.push("CWH:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        // center welcomeness
        var CWN = chiLatest && chiLatest.Reponses && chiLatest.Reponses.length > 0 ? chiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("center welcomeness")) : [];

        aggregate.CWN = !CWN || CWN.length == 0 ? 0 : Math.round(CWN.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (CWN.length * 5), 2);
        logs.push("CWN:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        // Suggestions
        var suggestions = chiLatest && chiLatest.Reponses && chiLatest.Reponses.length > 0 ? chiLatest.Reponses.filter(m => m.Question && -1 < m.Question.indexOf("Appreciations / Suggestions") && m.Response) : [];
        aggregate.CAS = suggestions.length;
        logs.push("CAS:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        aggregate.CCA = chiLatest && chiLatest.Assessments && chiLatest.Assessments.length > 0 ? chiLatest.Assessments.length : 0 - aggregate.CPA;
        logs.push("CCA:" + GetDateDiff(startDate, new Date()));

        // #endregion CHI
    }
    if (null == onlyThese || onlyThese.indexOf("pisi") > -1) {

        // #region PISI
        startDate = new Date();
        var pisiLatest = GetReportsData("pisilatest", dataConst, true, fdt, tdt, facility);

        var pisiids = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.map(m => m.PeopleNoteId) : [];

        aggregate.TPA = pisiLatest && pisiLatest.Assessments && pisiLatest.Assessments.length > 0 ? pisiLatest.Assessments.filter(f => pisiids.indexOf(f.Id) == -1).length : 0;
        logs.push("TPA:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        var TOA = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("overall efficacy")) : [];
        aggregate.TOE = !TOA || TOA.length == 0 ? 0 : Math.round(TOA.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (TOA.length * 5), 2);;
        logs.push("TOE:" + GetDateDiff(startDate, new Date()));

        // therapy improvemnet
        startDate = new Date();
        var TTI = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("improvemnet")) : [];
        aggregate.TIP = !TTI || TTI.length == 0 ? 0 : Math.round(TTI.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (TTI.length * 5), 2);;
        logs.push("TTI:" + GetDateDiff(startDate, new Date()));

        // Daily Homework Feedback
        startDate = new Date();
        var TDH = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("daily homework feedback")) : [];

        aggregate.TDH = !TDH || TDH.length == 0 ? 0 : Math.round(TDH.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (TDH.length * 5), 2);
        logs.push("TDH:" + GetDateDiff(startDate, new Date()));
        // Daily after therapy interaction

        startDate = new Date();
        var TDA = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("daily after therapy interaction")) : [];
        aggregate.TDA = !TDA || TDA.length == 0 ? 0 : Math.round(TDA.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (TDA.length * 5), 2);
        logs.push("TDA:" + GetDateDiff(startDate, new Date()));
        // Daily Homework Feedback

        startDate = new Date();
        var TAS = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("appreciations / suggestions") && m.Response) : [];



        aggregate.TASS = TAS.length;
        aggregate.TCA = pisiLatest && pisiLatest.Assessments && pisiLatest.Assessments.length > 0 ? pisiLatest.Assessments.length : 0 - aggregate.TPA;
        logs.push("TASS:" + GetDateDiff(startDate, new Date()));
        // #endregion PISI

        // #region Mirracles*/

        startDate = new Date();
        aggregate.MIRT = GetReportsData("mirraclestotal", dataConst, true, fdt, tdt, facility).length;
        logs.push("MIRT:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        aggregate.MIRC = GetReportsData("mirraclescontributed", dataConst, true, fdt, tdt, facility).length;
        logs.push("MIRC:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        aggregate.MIRNC = GetReportsData("mnotcontributed", dataConst, true, fdt, tdt, facility).length;
        logs.push("MIRNC:" + GetDateDiff(startDate, new Date()));


        startDate = new Date();
        aggregate.MIRV = GetReportsData("allmirraclesviews", dataConst, true, fdt, tdt, facility);
        logs.push("MIRV:" + GetDateDiff(startDate, new Date()));


        startDate = new Date();
        aggregate.MIRT100 = GetReportsData("mirraclestop100", dataConst, true, fdt, tdt, facility).length;
        logs.push("MIRT100:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        aggregate.MIRB100 = GetReportsData("mirraclesbottom100", dataConst, true, fdt, tdt, facility).length;
        logs.push("MIRB100:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        aggregate.MIRLC = GetReportsData("mirracleslc", dataConst, true, fdt, tdt, facility).length;
        logs.push("MIRLC:" + GetDateDiff(startDate, new Date()));

        startDate = new Date();
        aggregate.MIRLNC = GetReportsData("mirraclesnotcovered", dataConst, true, fdt, tdt, facility);
        logs.push("MIRLNC:" + GetDateDiff(startDate, new Date()));


        startDate = new Date();
        aggregate.MAC = GetReportsData("mirraclepending", dataConst, true, fdt, tdt, facility).length;
        logs.push("MAC:" + GetDateDiff(startDate, new Date()));

        //var mirraclesFiltered = (mirracles || []).filter(f => dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) < TDT);
        //var allmirracles = data.Mirracles.filter(f => (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) < TDT) || (f.UDT && dateFromSDateTime(f.UDT) >= FDT && dateFromSDateTime(f.UDT) < TDT)).sort((a, b) => (b.F8 < a.F8 ? -1 : 1));

        //var top100Mirracles = (allmirracles || []).slice(0, 99).map(m=> m.Id);
        //var bottom100Mirracles = (allmirracles || []).slice(-100).map(m=> m.Id);

        //var mirraclesFilteredIncludingUpdate = (mirracles || []).filter(f => (dateFromSDateTime(f.CDT) >= FDT && dateFromSDateTime(f.CDT) < TDT) || (f.UDT && dateFromSDateTime(f.UDT) >= FDT && dateFromSDateTime(f.UDT) < TDT));

        //aggregate.MIRT100 =  mirraclesFilteredIncludingUpdate.filter(m => top100Mirracles.indexOf(m.Id) > -1).length;

        //aggregate.MIRB100 = mirraclesFilteredIncludingUpdate.filter(m => bottom100Mirracles.indexOf(m.Id) > -1).length;


        //mirraclesFiltered = mirraclesFiltered || [];

        //aggregate.MIRT = mirraclesFiltered.length;
        //try {
        //    aggregate.MIRC = Object.keys(groupBy(mirraclesFiltered, "PersonId")).length;
        //} catch (e) {

        //}



        //aggregate.MIRNC = Object.keys(groupBy(dataConst.People.filter(m => (m.RoleId == therapistId || m.RoleId == adminId) && m.F8 != 1 && m.RS != "DELETEACTIVITY"), "Id")).length - aggregate.MIRC;


        //aggregate.MIRV = (mirraclesFilteredIncludingUpdate || []).reduce(function (accumulator, item) {
        //    return accumulator + item.F8;
        //}, 0);


        //var languageIds = data.Types.filter(m => m.Category == "Languages").map(m => m.Id);
        //aggregate.MIRLC = Object.keys(groupBy(mirraclesFiltered, "LanguageId")).length;
        //aggregate.MIRLNC = languageIds.length - aggregate.MIRLC;

        // #endregion Mirracles*/
    }
    if (null == onlyThese || onlyThese.indexOf("dang") > -1) {

        // #region Dang*/
        var dangTypeId = GetTypeIdByName(dataConst.Types, "DANGANALYTIC");
        var currentDang = dataConst && dataConst.PeopleNotes && dataConst.PeopleNotes.length > 0 ? dataConst.PeopleNotes.filter(f => f.TypeId == dangTypeId && new Date(f.CDT) >= FDT && new Date(f.CDT) <= TDT) : [];

        aggregate.DYES = currentDang && currentDang && currentDang.length > 0 ? currentDang.filter(f => f.F7 == 1).length : 0;
        aggregate.DNO = currentDang && currentDang && currentDang.length > 0 ? currentDang.filter(f => f.F7 != 1).length : 0;

        // aggregate.DYES = dang.filter(f => f.IsDone == 1).length;
        // aggregate.DNO = dang.filter(f => f.IsDone != 1).length;
        aggregate.DOT = currentDang.filter(f => f.F6 != 1).length;
        aggregate.DLATE = currentDang.filter(f => f.F6 == 1).length;

        aggregate.DPM = CalculateDangPendingCount(currentDang, dangConfig, FDT, TDT, fids);

        var todayDang = currentDang.filter(f => dateFromSDateTime(f.CDT).toDateString() == new Date().toDateString());
        aggregate.DPD = CalculateDangPendingCount(todayDang, dangConfig, new Date(), new Date(), fids);
        // #endregion Dang*/
    }


    // startDate = new Date();
    // aggregate.DA=GetReportsData("pollincationclarity", dataConst, true, fdt, tdt, facility);
    // logs.push("DA:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    var dueAll = GetReportsData("dueall", dataConst, true, fdt, tdt, facility);


    //     return invoicesamount;
    aggregate.DA = dueAll ? dueAll.reduce(function (accumulator, item) {
        return accumulator + (item["Amount"]);
    }, 0) : 0;
    logs.push("DA:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();

    aggregate.DO = dueAll.filter(f => f.ETA && f.ETA.toLowerCase() == "overdue").reduce(function (accumulator, item) {
        return accumulator + (item["Amount"]);
    }, 0);//  GetReportsData("dueoverdue", dataConst, true, fdt, tdt, facility);
    logs.push("DO:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.DT = dueAll.filter(f => f.ETA && f.ETA.toLowerCase() == "today").reduce(function (accumulator, item) {
        return accumulator + (item["Amount"]);
    }, 0);  // GetReportsData("duetoday", dataConst, true, fdt, tdt, facility);
    logs.push("DT:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.DTM = dueAll.filter(f => f.ETA && f.ETA.toLowerCase() == "tomorrow").reduce(function (accumulator, item) {
        return accumulator + (item["Amount"]);
    }, 0); //  GetReportsData("duetomorrow", dataConst, true, fdt, tdt, facility);
    logs.push("DTM:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    aggregate.DTW = dueAll.filter(f => f.ETA && f.ETA.toLowerCase() == "thisweek").reduce(function (accumulator, item) {
        return accumulator + (item["Amount"]);
    }, 0); //GetReportsData("duethisweek", dataConst, true, fdt, tdt, facility);
    logs.push("DTW:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.DNW = dueAll.filter(f => f.ETA && f.ETA.toLowerCase() == "nextweek").reduce(function (accumulator, item) {
        return accumulator + (item["Amount"]);
    }, 0);  //GetReportsData("duenextweek", dataConst, true, fdt, tdt, facility);
    logs.push("DNW:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    aggregate.DTMN = dueAll.filter(f => f.ETA && f.ETA.toLowerCase() == "thismonth").reduce(function (accumulator, item) {
        return accumulator + (item["Amount"]);
    }, 0); //GetReportsData("duethismonth", dataConst, true, fdt, tdt, facility);
    logs.push("DTMN:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.DNM = dueAll.filter(f => f.ETA && f.ETA.toLowerCase() == "nextmonth").reduce(function (accumulator, item) {
        return accumulator + (item["Amount"]);
    }, 0); //GetReportsData("duenextmonth", dataConst, true, fdt, tdt, facility);
    logs.push("DNM:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.DF = dueAll.filter(f => f.ETA && f.ETA.toLowerCase() == "future").reduce(function (accumulator, item) {
        return accumulator + (item["Amount"]);
    }, 0);//GetReportsData("duefuture", dataConst, true, fdt, tdt, facility);
    logs.push("DF:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.DEP = GetReportsData("etapending", dataConst, true, fdt, tdt, facility);
    logs.push("DEP:" + GetDateDiff(startDate, new Date()));













    startDate = new Date();
    aggregate.WD = dataConst.TWD;
    logs.push("TWD:" + GetDateDiff(startDate, new Date()));

    var pendingClarity = GetReportsData("pinnacleclaritypending", dataConst, true, fdt, tdt, facility);
    var pinnacleClarityPending = (pendingClarity || []).filter(e => (!e.Reply || e.Reply == ''));
    var pinnacleClarityCompleted = (pendingClarity || []).filter(e => !(!e.Reply || e.Reply == ''));
    aggregate.PCLAP = pinnacleClarityPending && pinnacleClarityPending.length > 0 ? pinnacleClarityPending.length : 0;
    aggregate.PCLAC = pinnacleClarityCompleted && pinnacleClarityCompleted.length > 0 ? pinnacleClarityCompleted.length : 0;

    aggregate.BUSINESS = (parseInt(aggregate.PP) + parseInt(aggregate.PPE) + parseInt(aggregate.PA) + parseInt(aggregate.APEN));


    startDate = new Date();
    aggregate.PCP = GetReportsData("pollinationclaritypromised", dataConst, true, fdt, tdt, facility);
    logs.push("PCP:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.TGNS = GetReportsData("goalsnotset", dataConst, true, fdt, tdt, facility).length;
    logs.push("TGNS:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.GP = GetReportsData("goalspending", dataConst, true, fdt, tdt, facility).length;
    logs.push("GP:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.AP = GetReportsData("attendancepending", dataConst, true, fdt, tdt, facility);
    logs.push("AP:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    var compodataa = GetReportsData("compospending", dataConst, true, fdt, tdt, facility);
    aggregate.CPC = compodataa > 0 ? compodataa : 0;
    logs.push("CPC:" + GetDateDiff(startDate, new Date()));

    //startDate = new Date();
    //aggregate.AGP = GetReportsData("therapiesprovided", dataConst, true, fdt, tdt, facility).length;
    //logs.push("AGP:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    aggregate.AGP = GetReportsData("attendancepresent", dataConst, true, fdt, tdt, facility).length;
    logs.push("AGP:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    aggregate.AGA = GetReportsData("attendanceabsent", dataConst, true, fdt, tdt, facility).length;
    logs.push("AGA:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    aggregate.TOA = aggregate.AP + aggregate.AGP + aggregate.AGA;
    logs.push("TOA:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.ABS = (aggregate.AGA - aggregate.CST) > 0 ? (aggregate.AGA - aggregate.CST) : 0;
    logs.push("ABS:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.GR = GetReportsData("goalreviewed", dataConst, true, fdt, tdt, facility).length;
    logs.push("GR:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    aggregate.AWARDS = GetReportsData("awardswon", dataConst, true, fdt, tdt, facility).length;
    logs.push("AWARDS:" + GetDateDiff(startDate, new Date()));

    ///POLLINATION

    // startDate = new Date();
    // aggregate.PCP =GetReportsData("pollinationclaritypromised", dataConst, true, fdt, tdt, facility);
    // logs.push("PCP:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.PCC = GetReportsData("pollinationclaritycompleted", dataConst, true, fdt, tdt, facility);
    logs.push("PCC:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.PCYT = GetReportsData("pollinationclarityyetto", dataConst, true, fdt, tdt, facility);
    logs.push("RPCYTCTD:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.PCZ = GetReportsData("pollinationclarityzero", dataConst, true, fdt, tdt, facility);
    logs.push("PCZ:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    aggregate.PCLT = GetReportsData("pollinationclaritylessthanthree", dataConst, true, fdt, tdt, facility);
    logs.push("PCLT:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.PCGT = GetReportsData("pollinationclaritygreaterthanthree", dataConst, true, fdt, tdt, facility);
    logs.push("PCGT:" + GetDateDiff(startDate, new Date()));


    //  startDate = new Date();
    //  aggregate.PAO=GetReportsData("pollinationopty", dataConst, true, fdt, tdt, facility);
    //  logs.push("PAO:" + GetDateDiff(startDate, new Date()));





    ///POLLINATION


    /*startDate = new Date();
    var pisiLatesttherapy = GetReportsData("pisilatest", dataConst, true, fdt, tdt, facility);

    var pisiids = pisiLatesttherapy.Reponses.map(m => m.PeopleNoteId);


    startDate = new Date();
    var TOA = pisiLatesttherapy.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("overall efficacy"));
    aggregate.TOE = !TOA || TOA.length == 0 ? 0 : Math.round(TOA.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (TOA.length * 5), 2);;
    logs.push("TOE:" + GetDateDiff(startDate, new Date()));

    var TAS = pisiLatesttherapy && pisiLatesttherapy.length > 0 ? pisiLatesttherapy.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("appreciations / suggestions") && m.Response) : [];



    aggregate.TASS = TAS.length;
    //aggregate.TCA = pisiLatest && pisiLatest.length > 0 ? pisiLatest.Assessments.length : 0 - aggregate.TPA;
    logs.push("TASS:" + GetDateDiff(startDate, new Date()));
    */

    // #region PISI
    startDate = new Date();
    var pisiLatest = GetReportsData("pisilatest", dataConst, true, fdt, tdt, facility);

    var pisiids = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.map(m => m.PeopleNoteId) : [];

    aggregate.TPA = pisiLatest && pisiLatest.Assessments && pisiLatest.Assessments.length > 0 ? pisiLatest.Assessments.filter(f => pisiids.indexOf(f.Id) == -1).length : 0;
    logs.push("TPA:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    var TOA = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("overall efficacy")) : [];
    aggregate.TOE = !TOA || TOA.length == 0 ? 0 : Math.round(TOA.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (TOA.length * 5), 2);;
    logs.push("TOE:" + GetDateDiff(startDate, new Date()));

    // therapy improvemnet
    startDate = new Date();
    var TTI = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("improvemnet")) : [];
    aggregate.TIP = !TTI || TTI.length == 0 ? 0 : Math.round(TTI.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (TTI.length * 5), 2);;
    logs.push("TTI:" + GetDateDiff(startDate, new Date()));

    // Daily Homework Feedback
    startDate = new Date();
    var TDH = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("daily homework feedback")) : [];

    aggregate.TDH = !TDH || TDH.length == 0 ? 0 : Math.round(TDH.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (TDH.length * 5), 2);
    logs.push("TDH:" + GetDateDiff(startDate, new Date()));
    // Daily after therapy interaction

    startDate = new Date();
    var TDA = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("daily after therapy interaction")) : [];
    aggregate.TDA = !TDA || TDA.length == 0 ? 0 : Math.round(TDA.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (TDA.length * 5), 2);
    logs.push("TDA:" + GetDateDiff(startDate, new Date()));
    // Daily Homework Feedback

    startDate = new Date();
    var TAS = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("appreciations / suggestions") && m.Response) : [];



    aggregate.TASS = TAS.length;
    aggregate.TCA = pisiLatest && pisiLatest.Assessments && pisiLatest.Assessments.length > 0 ? pisiLatest.Assessments.length : 0 - aggregate.TPA;
    logs.push("TASS:" + GetDateDiff(startDate, new Date()));
    // #endregion PISI

    startDate = new Date();
    var whiLatest = GetReportsData("WHILATEST", dataConst, true, fdt, tdt, facility);
    var whiids = whiLatest && whiLatest.Reponses && whiLatest.Reponses.length > 0 ? whiLatest.Reponses.map(m => m.PeopleNoteId) : [];
    aggregate.PROA = whiLatest && whiLatest.Assessments && whiLatest.Assessments.length > 0 > 0 ? whiLatest.Assessments.length : 0;
    logs.push("PROA:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.PROS = whiLatest && whiLatest.length > 0 ? whiLatest.Suggestions.length : 0;
    logs.push("PROS:" + GetDateDiff(startDate, new Date()));


    //if (role == "Therapist") {
    //    startDate = new Date();
    //    aggregate.TOE = GetReportsData("pisirating", dataConst, true, fdt, tdt, facility).length;
    //    logs.push("TOE:" + GetDateDiff(startDate, new Date()));
    //}



    //startDate = new Date();
    //aggregate.MIRT = GetReportsData("mirracles", dataConst, true, fdt, tdt, facility).length;
    //logs.push("MIRT:" + GetDateDiff(startDate, new Date()));

    /*startDate = new Date();
    aggregate.RP = GetReportsData("feedbackspending", dataConst, true, fdt, tdt, facility).length;
    logs.push("RP:" + GetDateDiff(startDate, new Date()));*/
    //Change below like above


    startDate = new Date();
    aggregate.RG = GetReportsData("feedbacksgiven", dataConst, true, fdt, tdt, facility).length;
    logs.push("RG:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.RP = aggregate.AGP - aggregate.RG;//  GetReportsData("homeworkpending", dataConst, true, fdt, tdt, facility).length;
    logs.push("RP:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.RGT = GetReportsData("feedbackratings", dataConst, true, fdt, tdt, facility);
    logs.push("RGT:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.RAT = aggregate.RG ? (aggregate.RGT / aggregate.RG).toFixed(2) : 0;
    logs.push("RAT:" + GetDateDiff(startDate, new Date()));
    //TOE
    //AGP
    //CPC
    //Goals for therapist
    startDate = new Date();
    aggregate.GR = GetReportsData("goalreviewed", dataConst, true, fdt, tdt, facility).length;
    logs.push("GR:" + GetDateDiff(startDate, new Date()));

    //Goal Pending for therapist
    startDate = new Date();
    aggregate.GP = GetReportsData("goalspending", dataConst, true, fdt, tdt, facility).length;
    logs.push("GP:" + GetDateDiff(startDate, new Date()));

    //services 

    startDate = new Date();
    aggregate.SF = GetReportsData("activeservices", dataConst, true, fdt, tdt, facility).length;
    logs.push("CST:" + GetDateDiff(startDate, new Date()));

    //Assessments

    startDate = new Date();
    var allAssessmentsData = dataConst.Assessmentsdata;

    startDate = new Date();
    aggregate.ASP = allAssessmentsData.filter(m => m.Status && m.Status.toLowerCase() == "pending").length;
    logs.push("ASP:" + GetDateDiff(startDate, new Date()));

    // Completed assessment
    startDate = new Date();
    aggregate.AST = GetReportsData("assessmentcompleted", dataConst, true, fdt, tdt, facility).length;
    logs.push("AST:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    var whiLatest = GetReportsData("WHILATEST", dataConst, true, fdt, tdt, facility);
    var whiids = whiLatest && whiLatest.Reponses && whiLatest.Reponses.length > 0 ? whiLatest.Reponses.map(m => m.PeopleNoteId) : [];
    aggregate.PROA = whiLatest && whiLatest.Assessments && whiLatest.Assessments.length > 0 ? whiLatest.Assessments.length : 0;
    logs.push("PROA:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.PROS = whiLatest && whiLatest.Suggestions && whiLatest.Suggestions.length > 0 ? whiLatest.Suggestions.length : 0;
    logs.push("PROS:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.PROP = whiLatest && whiLatest.Assessments && whiLatest.Assessments.length > 0 ? whiLatest.Assessments.filter(f => whiids.indexOf(f.Id) == -1).length : 0;
    logs.push("PROP:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.PROT10 = whiLatest && whiLatest.Ranks && whiLatest.Ranks.length > 0 ? whiLatest.Ranks.filter(m => m.RankTextId == "top10").length : 0;
    logs.push("PROT10:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.PROT40 = whiLatest && whiLatest.Ranks && whiLatest.Ranks.length > 0 ? whiLatest.Ranks.filter(m => m.RankTextId == "top40").length : 0;
    logs.push("PROT40:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.PROB40 = whiLatest && whiLatest.Ranks && whiLatest.Ranks.length > 0 ? whiLatest.Ranks.filter(m => m.RankTextId == "bottom40").length : 0;
    logs.push("PROT40:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.PROB10 = whiLatest && whiLatest.Ranks && whiLatest.Ranks.length > 0 ? whiLatest.Ranks.filter(m => m.RankTextId == "bottom10").length : 0;
    logs.push("PROB10:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    var allrenewalClarity = GetReportsData("renewalclarityall", dataConst, true, fdt, tdt, facility);
    // var AllFeeETA = data.filter(e =>  (type.toLowerCase() == "renewalclarityall" ? true : type.toLowerCase() == "renewalclaritytoberenewed" ? tobeRenewed.indexOf(e.Details.toLowerCase()) == -1 : type.toLowerCase() == "renewalclarity"+e.Details.toLowerCase()+""));

    aggregate.RCA = allrenewalClarity.length;
    logs.push("RCA:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();

    aggregate.RCOD = allrenewalClarity.filter(f => f.Details == "overdue").length;//  GetReportsData("renewalclarityoverdue", dataConst, true, fdt, tdt, facility);
    logs.push("RCOD:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.RCTD = allrenewalClarity.filter(f => f.Details == "today").length; //GetReportsData("renewalclaritytoday", dataConst, true, fdt, tdt, facility);
    logs.push("RCTD:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.RCTR = allrenewalClarity.filter(f => f.Details == "tomorrow").length; //GetReportsData("renewalclaritytomorrow", dataConst, true, fdt, tdt, facility);
    logs.push("RCTR:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    aggregate.RCTW = allrenewalClarity.filter(f => f.Details == "thisweek").length; //GetReportsData("renewalclaritythisweek", dataConst, true, fdt, tdt, facility);
    logs.push("RCTW:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.RCNW = allrenewalClarity.filter(f => f.Details == "nextweek").length; //GetReportsData("renewalclaritynextweek", dataConst, true, fdt, tdt, facility);
    logs.push("RCNW:" + GetDateDiff(startDate, new Date()));


    startDate = new Date();
    aggregate.RCTM = allrenewalClarity.filter(f => f.Details == "thismonth").length; //GetReportsData("renewalclaritythismonth", dataConst, true, fdt, tdt, facility);
    logs.push("RCTM:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.RCNM = allrenewalClarity.filter(f => f.Details == "nextmonth").length; //GetReportsData("renewalclaritynextmonth", dataConst, true, fdt, tdt, facility);
    logs.push("RCNM:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.RCOT = allrenewalClarity.filter(f => f.Details == "others").length; //GetReportsData("renewalclarityothers", dataConst, true, fdt, tdt, facility);
    logs.push("RCOT:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.RCP = allrenewalClarity.filter(f => f.Details == "pending").length; //GetReportsData("renewalclaritypending", dataConst, true, fdt, tdt, facility);
    logs.push("RCP:" + GetDateDiff(startDate, new Date()));

    startDate = new Date();
    aggregate.RCR = allrenewalClarity.filter(f => f.Details == "renewed").length; //GetReportsData("renewalclarityrenewed", dataConst, true, fdt, tdt, facility);
    logs.push("RCR:" + GetDateDiff(startDate, new Date()));
    startDate = new Date();
    aggregate.RCTBR = aggregate.RCA - aggregate.RCR - aggregate.RCP - aggregate.RCOT;
    logs.push("RCTBR:" + GetDateDiff(startDate, new Date()));

    var pendingCourses = GetReportsData("allpendingcourses", dataConst, true, fdt, tdt, facility);

    aggregate.TCOP = pendingCourses.totalPending;
    aggregate.TTP = pendingCourses.totalTantrumsPending;
    aggregate.TCNP = pendingCourses.totalConditionsPending;
    aggregate.TPISI = pendingCourses.ptiPendingAssesmsnets;
    return aggregate;
}

export function PrepAggregates(role, data, aggregateType, facility, $this, onlyThese, fromDate, toDate, prepedData) {
    try {
        onlyThese = onlyThese || null;
        if (!data || !data.Centers) {
            return {};
        }
        var aggregate = {};



        // console.log(facility);
        var fids = [];
        if (facility) {
            fids = (facility + "").split(",").map(m => parseInt(m));
        }
        else {
            fids = data.Centers.map(m => m.Id);
        }

        aggregate.FId = fids;

        var fsIds = fids.map(m => m + "");

        //console.log(fids);

        var todayDate = new Date();

        var fdt = fromDate ? fromDate : new Date(todayDate.getFullYear(), todayDate.getMonth(), 1);
        var tdt = toDate ? toDate : new Date(todayDate.getFullYear(), todayDate.getMonth() + 1, 0, 23, 59, 59);
        var FDT = fdt;
        var TDT = tdt;
        var logs = [];
        var inittialStart = new Date();
        var startDate = new Date();
        var dataConst = {};

        dataConst = GetPrepData(role, data, fromDate, toDate, fids, $this);
        // if(prepedData)
        // {
        //     dataConst = prepedData;
        // }
        // else{

        // }

        switch (role.toUpperCase()) {
            case "BOSS":
                aggregate = PrepBossAggregates(fids, dataConst, fdt, tdt, facility, $this, onlyThese);
                break;
            case "THERAPIST":
                aggregate = PrepTherapistAggregates(fids, dataConst, fdt, tdt, facility, $this, onlyThese);
                break;
            default:
                aggregate = PrepOwnerAggregates(fids, dataConst, fdt, tdt, facility, $this, onlyThese, role);
                break;

        }



        // logs.push("Prep:" + GetDateDiff(startDate, new Date()));
        // if (role == "Admin" || role == "Receptionist" || role == "NCC" || role == "Owner"|| role=="FacilityOwner" || role=="Senior" || role=="Manager" || role == "Investor" || role == "Harvest") {


        //     // #endregion Pendings
        // }

        // try {

        //     if ((!onlyThese || onlyThese.length == 0) && (role == "Therapist" || role == "Senior" || role == "Admin" || role == "Harvest" || role == "Receptionist" || role == "Receptionist" || role == "NCC" || role == "Owner"|| role == "FacilityOwner" || role == "Investor" || role== 'Manager')) {



        //     }



        // }
        // catch (e) {
        //     console.log(e);
        // }
        // try {
        //     if (role == "Boss") {


        //     }

        //     else
        //     {

        //     }
        // }
        // catch (e) {

        //     SaveCleintWaufli(e,"Prep Aggregates Failed","PrepAggregates");

        //     console.log(e);
        // }



        if (null == onlyThese) {


            var endDate = new Date();
            console.log(inittialStart);
            var log = data.CFUser.Handle + "," + role + ","
                + inittialStart.getHours() + ":" + inittialStart.getMinutes() + ":" + inittialStart.getUTCSeconds() + ","
                + endDate.getHours() + ":" + endDate.getMinutes() + ":" + endDate.getUTCSeconds() + "," +
                GetDateDiff(inittialStart, endDate) + ","
                + logs.join(",");
            var exception = {};
            exception.Type = "CLIENTPREPAGGREGATES1V";
            exception.Message = log;
            // SaveExceptionToSentry(exception, "Transaction", getUserToken(), "CLIENTPREPAGGREGATES1V");
        }


        bbp.Log("PA", inittialStart, new Date());
        aggregate.CDT = new Date();
        return aggregate;
    }
    catch (e) {
        SaveCleintWaufli(e, "Prep Aggregates Failed", "PrepAggregates");

    }
}

export function PrepIndividualCenterAggregates($this, data) {
    console.log("PrepIndividualCenterAggregates");


    if (!data || !data.Centers) {
        return {};
    }




    //console.log(fids);






    //  var dataConst = GetPrepData("Owner", data,null,null,data.Centers.map(m => m.Id),$this);




    var aggregates = [];
    data.Centers.forEach(function (center) {
        var agg = PrepAggregates("Owner", data, "MONTHLYAGGREGATES", center.Id + "", $this, ["money"]);
        agg.GID = center.Id;
        agg.CenterName = center.Name;
        aggregates.push(agg);

    });
    //     res(aggregates);
    // });

    return aggregates;

}

function getAggregateValue(isleader) {
    var month = 0;
    var year = 0;
    var type = "ASON";
    var radioValue = $("input[name='custom-health-filter']:checked").val();
    console.log(radioValue);
    if (radioValue == "thismonth") {
        month = new Date().getMonth() + 1;
        year = new Date().getFullYear();
        type = "thismonth";
    }
    if (radioValue == "custom") {
        month = $("#business-month option:selected").val();
        year = $("#business-year option:selected").val();
        type = "custom";
    }
    var range = "";
    if (radioValue == "today" || radioValue == "thisweek" || radioValue == "yesterday") {
        range = radioValue;
    }
    if (isleader && isleader == "false") {
        month = $("#BTbusiness-month option:selected").val();
        year = $("#BTbusiness-year option:selected").val();

    }
    var obj = {};
    obj.month = month;
    obj.year = year;
    obj.range = range;
    obj.type = type;
    return obj;
}
function validation(event) {

    //console.log(event.target.value + "naveen");
    var value = event.target.value;
    var id = event.target.id;
    showValidationtext(value, id);

}
function isDateValid(value) {
    var dateWrapper = new Date(value);
    return !isNaN(dateWrapper.getDate());
}
function GetDateFormatValue(dateValue) {
    var minDate = "1900-01-01"
    var someDate = dateValue ? new Date(dateValue) : new Date("0001-01-01");
    someDate.setDate(someDate.getDate());
    var date = someDate.toISOString().substr(0, 10);

    if (date.toString() == "0001-01-01" || date.toString() == "01-01-0001") {
        date = minDate;
    }
    return date;
}
export function GetDateesofrleave(dateValue) {
    var minDate = "1900-01-01"
    var someDate = dateValue ? new Date(dateValue) : new Date("0001-01-01");
    someDate.setDate(someDate.getDate() + 1);
    var date = someDate.toISOString().substr(0, 10);

    if (date.toString() == "0001-01-01" || date.toString() == "01-01-0001") {
        date = minDate;
    }
    return date;
}
function GetTimeFormatValue(timeValue) {
    var minTime = "00:00:00"
    return timeValue ? new Date(timeValue) : new Date("0001-01-01");
    //return date;
}

function CaptializeText(str) {
    if (!str) {
        return '';
    }

    const arr = str.toLowerCase().split(" ");

    //loop through each element of the array and capitalize the first letter.


    for (var i = 0; i < arr.length; i++) {
        arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);

    }

    //Join all the elements of the array back into a string 
    //using a blankspace as a separator 
    return arr.join(" ");
}

function getRedirectionURL(Htype, currentuser, role, openUrl, fid) {
    var facilityId = fid && typeof fid != 'object' ? fid : $('#insightsFacility option:selected').val();
    var facilityText = fid && typeof fid != 'object' ? fid : $('#insightsFacility option:selected').text();

    var leaderRoles = ["receptionist", "manager", "owner", "ccc", "harvestadmin", "facilityowner"];


    if (!facilityId) {
        facilityId = "";
    }
    if (Htype && Htype == "dailyattendance") {
        var date = $('#att-label-date-from').val();
        var status = $('#att-status  option:selected').val();
    }


    var radioValue = $("input[name='custom-health-filter']:checked").val();
    var month = 0;
    var year = "";
    var type = "ASON";
    if (radioValue == "thismonth") {
        month = new Date().getMonth() + 1;
        year = new Date().getFullYear().toString();
        type = "thismonth";
    }
    if (radioValue == "custom") {
        var month = $("#business-month option:selected").val();
        var year = $("#business-year option:selected").val();

        type = "custom";
    }
    var range = "";
    if (radioValue == "today" || radioValue == "thisweek" || radioValue == "yesterday") {
        range = radioValue;
    }
    var fdt = "";
    var tdt = "";
    if (radioValue == "today") {
        var date = $("#business-date-filter").val();
        if (date) {
            fdt = date;
            tdt = date;
        }
    }
    if (!month) {
        month = 0;
    }
    var isFDTENable = true;
    var GHtitle = "";
    switch (Htype.toLowerCase()) {
        case "newpayments":
            isFDTENable = false;

            var st = "";
            var filterType = "";
            if (role) {
                var drole = role.split("{#}");
                st = drole[0];

                if (drole.length > 1) {
                    filterType = drole[1];
                }
            }

            var url = "/payments?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&status=" + (st) + "&filtertype=" + filterType + "&radiofiltertype=" + radioValue;
            break;
        case "leavespending":
        case "leavesall":
        case "leavesapproved":
        case "leavesunapproved":
            let ft = Htype == "leavespending" ? "pending" : Htype == "leavesapproved" ? "approved" : Htype == "leavesunapproved" ? "unapproved" : ""

            var url = "/alltherapistleaves?ft=" + ft + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&status=" + (st) + "&filtertype=" + filterType + "&radiofiltertype=" + radioValue;
            break;

        case "discountbusiness":
        case "pastpaid":
        case "advancepaidseva":
        case "advancepaid":
        case "paidseva":
        case "paid":
        case "paymentpending":
        case "advancepending":
        case "pastpending":
        case "overallpending":
        case "pinnacleclaritypending":
        case "business":
        case "inflow":
        case "outflow":
            var headerName = Htype == "discountbusiness" ? "discount" : Htype == "pastpaid" ? "Past Paid" : Htype == "paymentpending" ? "Pending" : Htype == "advancepending" ? "Advance Pending" : Htype == "pastpending" ? "Past Pending" : Htype == "advancepaidseva" ? "Advance Paid Seva" : Htype == "advancepaid" ?
                "Advance Paid" : Htype == "paidseva" ? "Paid Seva" : Htype == "overallpending" ? "Over All Pending" : Htype == "pastpending" ? "Past Pending" : Htype == "pinnacleclaritypending" ? "Pinnacle Clarity Report" : Htype == "business" ? "Business" : Htype == "inflow" ? "Inflow" : Htype == "outflow" ? "Outflow" : "Paid";
            var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=" + headerName + "&rtype=" + Htype;

            break;

        case "dueall":
        case "dueoverdue":
        case "duetoday":
        case "duetomorrow":
        case "duethisweek":
        case "duenextweek":
        case "duethismonth":
        case "duenextmonth":
        case "duefuture":
        case "etapending":

            var headerName = Htype == "dueall" ? "All Due" : Htype == "duetoday" ? "Today Due" : Htype == "dueoverdue" ? "Overdue" : Htype == "duetomorrow" ? "Tomorrow Due"
                : Htype == "duethisweek" ? "This Week" : Htype == "duenextweek" ? "Next Week" : Htype == "duethismonth" ?
                    "This Month" : Htype == "duenextmonth" ? "Next Month" : Htype == "duefuture" ? "Future Month" : Htype == "etapending" ? "Pending ETA" : "";

            var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=" + headerName + "&rtype=" + Htype;

            break;
        case "renewalclarityall":
        case "renewalclarityoverdue":
        case "renewalclaritytoday":
        case "renewalclaritytomorrow":
        case "renewalclaritythisweek":
        case "renewalclaritynextweek":
        case "renewalclaritythismonth":
        case "renewalclaritynextmonth":
        case "renewalclarityothers":
        case "renewalclaritypending":
        case "renewalclarityrenewed":
        case "renewalclaritytoberenewed":

            var headerName = Htype == "renewalclaritytoberenewed" ? "To Be Renewed" : Htype == "renewalclarityrenewed" ? "Renewed" : Htype == "renewalclarityall" ? "All" : Htype == "renewalclarityoverdue" ? "Overdue" : Htype == "renewalclaritytoday" ? "Today" : Htype == "renewalclaritytomorrow" ? "Tomorrow"
                : Htype == "renewalclaritythisweek" ? "This Week" : Htype == "renewalclaritynextweek" ? "Next Week" : Htype == "duerenewalclaritythismonththismonth" ?
                    "This Month" : Htype == "renewalclaritynextmonth" ? "Next Month" : Htype == "renewalclarityothers" ? "Not Renewing" : Htype == "renewalclaritypending" ? "Pending" : "";

            var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=" + headerName + "&rtype=" + Htype;


            break;

        case "pollinationclaritypromised":
        case "pollinationclaritycompleted":
        case "pollinationclarityyetto":
        case "pollinationclarityzero":
        case "pollinationclaritylessthanthree":
        case "pollinationclaritygreaterthanthree":
        case "pollinationopty":
        case "pollinationoptyst":
        case "pollinationoptyot":
        case "pollinationoptyaba":
        case "pollinationoptyse":


            var headerName = Htype == "pollinationclaritypromised" ? "Promised" : Htype == "pollinationclaritycompleted" ? "Completed" : Htype == "pollinationclarityyetto" ? "YetTo" : Htype == "renewalclarityoverdue" ? "Overdue" : Htype == "renewalclaritytoday" ? "Today" : Htype == "renewalclaritytomorrow" ? "Tomorrow"
                : Htype == "pollinationclarityzero" ? "Zero" : Htype == "pollinationclaritylessthanthree" ? "Less than 3" : Htype == "pollinationclaritygreaterthanthree" ?
                    "Greater then 3" : Htype == "pollinationopty" ? "Opty" : Htype == "pollinationoptyst" ? "ST" : Htype == "pollinationoptyaba" ? "ABA" : Htype == "pollinationoptyot" ? "OT" : Htype == "pollinationoptyse" ? "SE" : "";

            var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=" + headerName + "&rtype=" + Htype;


            break;

        case "feedbacksgiven":
        case "feedbackratings":
            var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=Feedbacks&rtype=feedbacksgiven";

            break;
        case "pollinatebytherapy":
            var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=Pollinate&rtype=pollinatebytherapy&FilterType=" + role;
            break;

        case "viewpayslips":
            var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=View Payslips&rtype=viewpayslips";
            break;
        case "salarystatement":
            var url = "/salarystatement?facility=" + facilityId;
            //var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=Salary Statement&rtype=salarystatement";
            break;

        case "downloadpayslips":
            var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=Download Payslips&rtype=downloadpayslips";
            break;
        case "coursescompleted":
            var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=Completed Courses&rtype=coursescompleted";
            break;
        case "dangpendingtoday":
            var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=Dang Today Pending&rtype=dangpendingtoday";
            break;

        case "therapistpti":
        case "adminpti":
            month = currentuser && currentuser.PTILM > 0 ? currentuser.PTILM : month;
            year = currentuser && currentuser.PTILY > 0 ? currentuser.PTILY : year;
            var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=" + ((Htype && Htype.toLowerCase() == "therapistpti" ? "PISI" : "CHI") + " " + CaptializeText(role)) + "&rtype=" + Htype + "&FilterType=" + role;
            break;
        case "compenstation":

            var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=" + " " + CaptializeText("Compenstation " + (role ? role : '')) + "&rtype=" + Htype + "&FilterType=" + role;
            break;
        case "therapistptireport":
            var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=" + ((Htype && Htype.toLowerCase() == "therapistpti" ? "PISI" : "CHI") + " " + CaptializeText(role)) + "&rtype=" + Htype + "&FilterType=" + role + "&isFromLocal=true";
            break;
        case "servicerequest":
        case "servicerequestactive":
        case "servicerequestrating":
        case "servicerequestwaiting":
        case "servicerequestresolved":
        case "servicerequestreopened":
        case "servicerequestrating1":
        case "servicerequestrating2":
        case "servicerequestrating3":
        case "servicerequestrating4":
        case "servicerequestrating5":
        case "sevatenurecompletion":
            var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=" + (role == "expire" ? "SEVA Tenure Completion" : "Service Request " + CaptializeText(role ? role : '')) + "&rtype=" + Htype + "&FilterType=" + role;
            break;
        case "leaverequestanalytic":
        case "leaverequestnonparent":
        case "leaverequestparent":
        case "leaverequestparentfuture":
        case "leaverequestparentcanceled":
        case "leaverequestparentcompleted":
        case "leaverequestanalyticunapproved":
        case "leaverequestnonparentcompleted":
        case "leaverequestnonparentfuture":
        case "leaverequestnonparentcanceled":
        case "leaverequestcomposlt4":
            var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=" + ("Leave Request " + CaptializeText(role ? role : '')) + "&rtype=" + Htype + "&FilterType=" + role;
            break;
        case "sevadocs":
        case "discountdocs":
        case "voucherdocs":
            var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=" + (Htype == "sevadocs" ? "Seva Docs" : Htype == "discountdocs" ? "Discount Docs" : "Gift Vouchers") + "&rtype=" + Htype + "&FilterType=" + role;
            break;
        case "pinnaclegiveawayoffer":
            var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=Offers&rtype=" + Htype + "&FilterType=" + role;
            break;
        case "availvoucherdocs":
            var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=" + (Htype == "availvoucherdocs" ? "Available Vouchers" : "Available Vouchers") + "&rtype=" + Htype + "&FilterType=" + role;
            break;
        case "gracecompensation":
            var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&hname=" + (Htype == "gracecompensation" ? "Grace Compensation" : "Grace Compensation") + "&rtype=" + Htype;
            break;
        case "noprofileusers":
            var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&hname=" + (Htype == "noprofileusers" ? "NO Profile Pics" : "No Profile Pics") + "&rtype=" + Htype;
            break;
        case "coworkers":
            var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&hname=" + ("Co-Workers") + "&rtype=" + Htype + "&isFromLocal=true";
            break;
        case "pinnaclerenewaloffer":
            var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&hname=" + ("Renewals") + "&rtype=" + Htype + "&isFromLocal=true&FilterType=" + role;
            break;
        case "empoweringkids":
            var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&hname=" + ("Empowring") + "&rtype=" + Htype + "&isFromLocal=true";
            break;
        case "allinvoices":

            var url = "/allinvoices?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=" + (Htype == "sevadocs" ? "Seva Docs" : "Discount Docs") + "&rtype=" + Htype + "&FilterType=" + role;
            break;
        case "coursespending":
            var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=Pending Courses&rtype=coursespending";
            break;

        case "tobefulfilled":
            var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=To-be Fulfilled&rtype=tobefulfilled";
            break;
        //case "newprofits":
        //    isFDTENable = false;
        //    var url = "/payments?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + currentuser.FDT + "&TDT=" + currentuser.TDT + "&status=" + (role ? role : "");
        //    break;
        case "payments":
            var url = "/d/PaymentsRecievedInsights?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range;
            break;
        case "paymenttype":
            var url = "/d/PaymentInsightsByType?facility = " + facilityId + "&month=" + month + "&year=" + year + " &status=Paid&mode=" + Htype + "&range=" + range;
            break;
        case "paidfee":
            var url = "/d/MonthlyPaidInsights?facility=" + facilityId + "&month=" + month + "&year=" + year + "&status=paid" + "&range=" + range;

        case "alreadypaid":

            var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=Advance Cleared&rtype=alreadyfulfilled&FilterType=";

            break;


        case "biometriclateearly":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&month=" + month + "&year=" + year + "&hname=Impunctual&rtype=biometriclateearly";


            break;
        case "pendingfee":
            var url = "/d/PaymentInsights?facility=" + facilityId + "&month=" + month + "&year=" + year + "&status=Pending" + "&range=" + range;
            break;
        case "seva":
            var url = "/d/SevaPaymentInsights?facility=" + facilityId + "&month=" + month + "&year=" + year;
            break;
        case "totalseva":
            var url = "/d/SevaInsights?facility=" + facilityId + "&month=" + month + "&year=" + year;
            break;
        case "fixedexpenses":
            var url = "/d/ExpensesInsights?facility=" + facilityId + "&month=" + month + "&year=" + year + "&IsOnlyForStaff=NO&hname=fixed";
            GHtitle = "Expenses";

            break;


        case "expensesreport":

            var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=" + (role == "outflow" ? "Outflow" : (role && role.toUpperCase() == "VARIABLEEXPENSES" ? "Variable " : role && role.toUpperCase() == "FIXEDEXPENSES" ? "Fixed " : "") + "Expanses") + "&rtype=expensesreport&FilterType=" + role;


            break;
        case "outflowreport":

            var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=OutFlow&rtype=outflowreport&FilterType=";


            break;


        case "dang":

            var url = "/dangkpi?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=Dang&rtype=dangreport&FilterType=" + role;


            break;
        case "parentsnotusingapp":
            var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=Parents Not Using App&rtype=parentsnotusingapp&FilterType=";
            break;
        case "proquery":

            month = currentuser && currentuser.PROLM > 0 ? currentuser.PROLM : month;
            year = currentuser && currentuser.PROLY > 0 ? currentuser.PROLY : year;

            var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=WHI" + (role ? " " + (role == "Top40" ? "Middle40" : role == "Bottom10" ? "Worst10" : role) : "") + "&rtype=proquery&FilterType=" + role;
            break;
        case "pisirankquery":
            month = currentuser && currentuser.PTILM > 0 ? currentuser.PTILM : month;
            year = currentuser && currentuser.PTILY > 0 ? currentuser.PTILY : year;

            var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=PISI" + (role ? " " + (role == "Top40" ? "Middle40" : role == "Bottom10" ? "Worst10" : role) : "") + "&rtype=pisirankquery&FilterType=" + role;
            break;

        case "expenses":
            var url = "/d/ExpensesInsights?facility=" + facilityId + "&month=" + month + "&year=" + year + "&IsOnlyForStaff=" + (role && role.toLowerCase() == "therapist" ? "YES" : "NO");
            GHtitle = "Expenses";
            if (role && role.toLowerCase() == "therapist") {
                GHtitle = "Food__Snacks";

            }
            break;
        case "salary":
            var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=Salaries" + "&rtype=salary&FilterType=";
            break;
        case "paymentinsights":
            var url = "/d/PaymentInsights?userId=" + currentuser.Id + "&month=" + (new Date().getMonth() + 1) + "&year=" + new Date().getFullYear() + "&facility=" + facilityId;
            break;
        case "services":
            var url = "/d/TherapiesInsights?facility=" + facilityId + "&Btype=all&month=" + month + "&year=" + year;
            break;

        case "addedservices":
            var url = "/d/TherapiesInsights?facility=" + facilityId + "&Btype=new&month=" + month + "&year=" + year;
            break;
        case "closedservices":
            var url = "/d/TherapiesInsights?facility=" + facilityId + "&Btype=lost&month=" + month + "&year=" + year;
            break;
        case "abnormalservices":
            var url = "/d/TherapiesInsights?facility=" + facilityId + "&Btype=abnormal&month=" + month + "&year=" + year;
            break;
        case "unhappyservices":
            var url = "/d/TherapiesInsights?facility=" + facilityId + "&Btype=unhappy&month=" + month + "&year=" + year;
            break;
        case "attendance":
            var url = "/d/TherapistStarAttendance?facility=" + facilityId + "&month=" + month + "&year=" + year + "&status=";
            break;
        case "pendingattendance":
        case "attendancepresent":
        case "attendanceabsent":
        case "homeworkpending":
            var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=" + "Attendance" + "&rtype=" + Htype + "&FilterType=" + role;
            break;
        case "compospending":
        case "compenstations":
            //var url = "/d/TherapistStarAttendance?facility=" + facilityId + "&month=" + month + "&year=" + year + "&status=pending";
            var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=" + "Compensations" + "&rtype=" + Htype + "&FilterType=" + role;
            // var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=Pending Attendance&rtype=pendingattendance";

            break;
        case "mirraclepending":
            //var url = "/d/TherapistStarAttendance?facility=" + facilityId + "&month=" + month + "&year=" + year + "&status=pending";

            var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&range=" + range + "&fdt=" + (radioValue == "alltime" ? "2018-05-01T00:00:00Z" : currentuser.FDT) + "&TDT=" + currentuser.TDT + "&radiofiltertype=" + radioValue + "&hname=Mirracle Pending&rtype=mirraclepending";

            break;

        //mirraclepending

        case "parentrating":
            var url = "/d/ParentRating?facility=" + facilityId + "&month=" + month + "&year=" + year;
            break;
        case "pendingparentrating":
            var url = "/d/ParentRating?status=pending&facility=" + facilityId + "&month=" + month + "&year=" + year;
            break;
        case "allparentrating":
            var url = "/d/ParentRating?status=all&facility=" + facilityId + "&month=" + month + "&year=" + year;
            break;
        case "allassessments":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Assessments&rtype=allassessments";
            break;
        case "consecutiveleaves":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Consecutive Leaves&rtype=consecutiveleaves";
            break;
        case "allrenewals":
            var st1 = "";
            var filterType1 = "";
            if (role) {
                var drole1 = role.split("{#}");
                st1 = drole1[0];

                if (drole1.length > 1) {
                    filterType1 = drole1[1];
                }
            }
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&FilterType=" + filterType1 + "&status=" + st1 + "&month=" + month + "&year=" + year + "&hname=" + (st1 ? st1 + " " : "") + "Renewals" + (filterType1 ? " " + filterType1 : "") + "&rtype=allrenewals";
            break;
        case "birthdayreports":
            var month = (new Date().getMonth() + 1);
            var year = (new Date().getFullYear());
            //fdt = year + "-" + month + "-01";
            // tdt = year + "-" + month + "-31";
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Birthdays&rtype=birthdayreports";
            break;


        case "extendedservices":
            var month = (new Date().getMonth() + 1);
            var year = (new Date().getFullYear());
            // fdt = year + "-" + month + "-01";
            // tdt = year + "-" + month + "-31";
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Extended Services&rtype=extendedservices";
            break;

        case "assessmentscompleted":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Completed Assessments&rtype=assessmentscompleted";
            break;
        case "assessmentpending":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Pending Assessments&rtype=assessmentpending";
            break;

        case "familyadded":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Family Added&rtype=familyadded";
            break;
        case "familynotadded":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Family Not Added&rtype=familynotadded";
            break;
        case "assessmentspayment":
            var url = "/d/AssessmentPaymentInsights?facility=" + facilityId + "&month=" + month + "&year=" + year + "&status=";
            break;
        case "assessmentsfee":
            var url = "/d/assessmentsinsights?facility=" + facilityId + "&month=" + month + "&year=" + year + "&status=";
            break;
        case "assessmentspaymentseva":
            var url = "/d/assessmentsinsights?facility=" + facilityId + "&month=" + month + "&year=" + year + "&status& mode=seva";
            // window.location.href = url;
            break;
        case "leads":
            var url = "/d/GetAllLeadsForBusiness?facility=" + facilityId + "&insight=" + type + "&status=new" + "&month=" + month + "&year=" + year;
            //window.location.href = url;
            break;
        case "closedleads":
            var url = "/d/GetAllLeadsForBusiness?facility=" + facilityId + "&insight=" + type + "&status=closed" + "&month=" + month + "&year=" + year;
            break;
        case "closedleadsnew":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Closed Leads&rtype=closedleads";
            break;
        case "activememos":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Active Memos&rtype=activememos";
            break;
        case "activestaff":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Staff&rtype=activestaff";
            break;
        case "activeparents":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Parents&rtype=activeparents";
            break;
        case "closedmemos":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Closed Memos&rtype=closedmemos";
            break;
        case "awards":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Awards&rtype=awards";
            break;
        case "newleadsnew":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=New Leads&rtype=newleads";
            break;
        case "walkinleads":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Walkins&rtype=walkinleads";
            break;
        case "joinedelsewhere":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Joined Else Where&rtype=joinedelsewhere";
            break;
        case "admissionleads":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Admissions&rtype=admissionleads";
            break;



        case "additionleads":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Additions&rtype=additionleads";
            break;
        case "assessmentsleads":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Assessments&rtype=assessmentsleads";
            break;
        case "activeleads":
            var url = "/d/GetAllLeadsForBusiness?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year;
            break;
        case "activeleadsnew":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Active Leads&rtype=activeleads";
            break;
        case "totalleads":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Active Leads&rtype=totalleads";
            break;
        case "pendingleads":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Pending Leads&rtype=pendingleads";
            break;
        case "goalsnotsetnew":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Not Set&rtype=goalsnotset";
            break;
        case "pendingpti":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Pending PTI&rtype=pendingpti";
            break;
        case "inactiveservices":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Inactive Services&rtype=inactiveservices";
            break;
        case "inactivecausepending":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Pending Service Root Cause&rtype=inactivecausepending";

            break;
        case "completedpti":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Completed PTI&rtype=completedpti";
            break;
        case "mirraclestotal":
            var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&hname=Mirracles&rtype=mirraclestotal";

            break;
        case "mirraclestop100":
            var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&hname=Top 100&rtype=mirraclestop100";
            break;
        case "mirraclesnotcovered":
            break;
        case "mirraclesbottom100":
            var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&hname=Bottom 100&rtype=mirraclesbottom100";
            break;
        case "allmirraclesviews":
            var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&hname=Views&rtype=allmirraclesviews";
            break;
        case "mirraclescontributed":
            var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&hname=Contributed&rtype=mirraclescontributed";
            break;
        case "mconsumedusers":
            var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&hname=Consumed&rtype=mconsumedusers";
            break;
        case "mnconsumedusers":
            var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&hname=Not Consumed&rtype=mnconsumedusers";
            break;
        case "mnotcontributed":
            var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&hname=Not Contributed&rtype=mnotcontributed";

            break;
        case "mirracleslc":
            var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&hname=Languages Covered&rtype=mirracleslc";
            break;
        case "kuberamonthlyfee":
            var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&hname=Kubera KU18&rtype=kuberamonthlyfee";
            break;
        case "kuberamissing":
            var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&hname=Kubera Missing&rtype=kuberamissing";
            break;
        case "kuberaabnormal":
            var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&hname=Kubera Abnormal&rtype=kuberaabnormal";
            break;
        case "allinvoicesthismonth":
            var url = "/kpireport?facility=" + facilityId + "&month=" + month + "&year=" + year + "&hname=Rest&rtype=allinvoicesthismonth";
            break;
        case "activeservices":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Services&rtype=activeservices";
            break;
        case "empwoer2single":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Single Services&rtype=empwoer2single";
            break;
        case "seetapending":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Seeta Pending&rtype=seetapending";
            break;
        case "seetapartiallypaid":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Seeta Partially paid&rtype=seetapartiallypaid";
            break;
        case "seetapaid":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Seeta Paid&rtype=seetapaid";
            break;
        case "seetakids":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Seeta Kids&rtype=seetakids";
            break;
        case "creditpackrenew":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Renew&rtype=creditpackrenew";
            break;
        case "monthlypack":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Monthly Packs&rtype=monthlypack";
            break;
        case "newservices":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=" + (role ? role : "New Services") + "&rtype=newservices&FilterType=" + (role ? role : "");
            break;
        case "newservicesst":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=" + (role ? role : "New Services ST") + "&rtype=newservicesst&FilterType=" + (role ? role : "");
            break;
        case "newservicesbt":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=" + (role ? role : "New Services BT") + "&rtype=newservicesbt&FilterType=" + (role ? role : "");
            break;
        case "newservicesot":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=" + (role ? role : "New Services OT") + "&rtype=newservicesot&FilterType=" + (role ? role : "");
            break;
        case "newservicesse":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=" + (role ? role : "New Services SE") + "&rtype=newservicesse&FilterType=" + (role ? role : "");
            break;
        case "futureservices":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=" + (role ? role : "Future Services") + "&rtype=futureservices&FilterType=" + (role ? role : "");
            break;
        case "addedparents":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Added Parents&rtype=addedparents";
            break;
        case "leftparents":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Lost Parents&rtype=leftparents";
            break;
        case "addedstaff":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Added Staff&rtype=addedstaff";
            break;

        case "localtherapistptireport":
            var url = "/kpireport?facility=&month=" + month + "&year=" + year + "&range=&fdt=&TDT=&radiofiltertype=&hname=Therapy PTI&rtype=therapistptireport&FilterType=pending&isFromLocal=true";
            break;
        case "leftstaff":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Left Staff&rtype=leftstaff";
            break;
        case "lockedaccounts":

            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Locked Accounts&rtype=lockedaccounts";
            break;
        case "staffutil":

            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Staff Util&rtype=staffutil";
            break;
        case "servicerequestpending":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Servicerequest Pending&rtype=servicerequestpending";
            break;
        case "assessmentcompleted":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Assessment Completed&rtype=assessmentcompleted";
            break;
        case "assessmentall":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Assessments&rtype=assessmentall";
            break;
        case "goalspending":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Goals Pending&rtype=goalspending";
            break;
        case "totalgoals":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Goals Total&rtype=totalgoals";
            break;
        case "todaypendinggoals":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Today Goals Pending&rtype=todaygoalspending";
            break;
        case "activegoals":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Goals Active&rtype=activegoals";
            break;
        case "goalreviewed":
            var url = "/kpireport?facility=" + facilityId + "&insight=" + type + "&status=active" + "&month=" + month + "&year=" + year + "&hname=Goal Reviewed&rtype=goalreviewed";
            break;
        case "leadsTadmissions":
            var url = "/d/GetAllLeadsForBusiness?facility=" + facilityId + "&insight=" + type + "&status=admissions" + "&month=" + month + "&year=" + year;
            break;
        //case "goalspending":
        //    var url = "/d/GoalsInsights?status=pendinggoals&goalUserId=" + (role && leaderRoles.indexOf(role.toLowerCase()) > -1 ? "" : currentuser.UId) + "&facility=" + facilityId + "&month=" + month + "&year=" + year;
        //    break;


        //case "goalreviewed":
        //    var url = "/d/GoalsInsights&status=goalreviews&goalUserId=" + (role && leaderRoles.indexOf(role.toLowerCase()) > -1 ? "" : currentuser.UId) + "&facility=" + facilityId + "&month=" + month + "&year=" + year;
        //    break;
        case "goalsdelayed":
            var url = "/d/GoalsInsights&status=delayed&goalUserId=" + (role && leaderRoles.indexOf(role.toLowerCase()) > -1 ? "" : currentuser.UId) + "&facility=" + facilityId + "&month=" + month + "&year=" + year;
            break;
        //case "totalgoals":
        //    var url = "/d/GoalsInsights?status=goals&goalUserId=" + (role && leaderRoles.indexOf(role.toLowerCase()) > -1 ? "" : currentuser.UId) + "&facility=" + facilityId + "&month=" + month + "&year=" + year;
        //    break;
        case "goalsnotset":
            var url = "/d/GoalsInsights?status=goalsnotset&goalUserId=" + (role && leaderRoles.indexOf(role.toLowerCase()) > -1 ? "" : currentuser.UId) + "&facility=" + facilityId + "&month=" + month + "&year=" + year;
            break;
        case "activegoalnew":
            var url = "/d/GoalsInsights?status=activegoals&goalUserId=" + (role && leaderRoles.indexOf(role.toLowerCase()) > -1 ? "" : currentuser.UId) + "&facility=" + facilityId + "&month=" + month + "&year=" + year;
            break;
        case "goalnotmet":
            var url = "/d/GoalsInsights?status=goalsnotmet&goalUserId=" + (role && leaderRoles.indexOf(role.toLowerCase()) > -1 ? "" : currentuser.UId) + "&facility=" + facilityId + "&month=" + month + "&year=" + year;
            break;
        case "goalmet":
            var url = "/d/GoalsInsights?status=goalsmet&goalUserId=" + (role && leaderRoles.indexOf(role.toLowerCase()) > -1 ? "" : currentuser.UId) + "&facility=" + facilityId + "&month=" + month + "&year=" + year;
            break;
        case "goalsdelayed":
            var url = "/d/GoalsInsights?status=delayed&goalUserId=" + (role && leaderRoles.indexOf(role.toLowerCase()) > -1 ? "" : currentuser.UId) + "&facility=" + facilityId + "&month=" + month + "&year=" + year;
            break;
        case "totalbiometric":
            var url = "/d/biometric?status=all&facility=" + facilityId + "&month=" + month + "&year=" + year;
            break;

        case "ontimebiometric":
            var url = "/d/biometric?status=ontime&facility=" + facilityId + "&month=" + month + "&year=" + year;
            break;
        case "latebiometric":
            var url = "/d/biometric?status=late&facility=" + facilityId + "&month=" + month + "&year=" + year;
            break;

        case "newparents":
            var url = "/d/ParentsInsightsForBusiness?facility=" + facilityId + "&Btype=new&month=" + month + "&year=" + year;
            break;
        case "lostparents":
            var url = "/d/ParentsInsightsForBusiness?facility=" + facilityId + "&Btype=lost&month=" + month + "&year=" + year;
            break;
        case "parents":
            var url = "/d/ParentsInsightsForBusiness?facility=" + facilityId + "&Btype=all" + "&month=" + month + "&year=" + year;
            break;


        case "newstaff":
            var url = "/d/GetNewStaffInsights?facility=" + facilityId + "&month=" + month + "&year=" + year;
            break;
        case "closedstaff":
            var url = "/d/GetDeleteUserInsights?facility=" + facilityId + "&month=" + month + "&year=" + year;
            break;
        case "staff":
            var url = "/d/StaffInsights?facility=" + facilityId + "&month=" + month + "&year=" + year + "&status=" + "monthly therapist";
            break;
        case "ptiactive":
            var url = "/d/PTIInsights?facility=" + facilityId + "&month=" + month + "&year=" + year + "&status=active";

            break;

        case "pticlosed":
            var url = "/d/PTIInsights?facility=" + facilityId + "&month=" + month + "&year=" + year + "&status=closed";

            break;
    }

    if (facilityText) {
        url = url + "&fatext=" + (facilityText + "").replace(/\+/gi, "PLUS");
    }

    //  alert(url);
    if (openUrl) {
        if (isFDTENable) {
            url = url + "&FDT=" + fdt + "&TDT=" + tdt + "&range=" + range;
        }
        window.historyInstance.push(url);
    }
    else {
        var token = getUserTokenMethod();
        var Token = encodeURIComponent(token);
        url += "&range=" + range + "&salt=" + Token;

        loadGuestHandler(url, "no", GHtitle);
    }
}

export function GetShortFormForService(sN) {

    if (!sN) {
        return "";
    }


    switch (sN.toLowerCase()) {
        case "speech therapy":
            return "ST";
        case "behavioral modification":
            return "BT";
        case "special education":
            return "SE";
        case "occupational therapy":
            return "OT";
        case "physio therapy":
            return "PT";
    }

    return sN;
}


export function GetServiceNameFromShortForm(sN) {

    if (!sN) {
        return "";
    }

    // console.log(sN);
    switch (sN.toLowerCase()) {
        case "st":
            return "Speech Therapy";
        case "bt":
        case "bm":
            return "Behavioral Modification";
        case "se":
            return "Special Education";
        case "ot":
            return "Occupational Therapy";
        case "pt":
            return "physio therapy";
    }

    return sN;
}

function loadGuestHandler(url, isAuthNeeded, title) {
    var guesturl = url;
    title = title || "";
    var token = getUserTokenMethod();
    if (isAuthNeeded != "no") {
        guesturl = url + encodeURIComponent(token);
    }
    console.log(guesturl);
    var app = getMobileOperatingSystem();
    if (app && IsApp(app)) {
        guesturl = guesturl + "&Device=" + app;
    }
    localStorage.setItem("GuestUrl", guesturl);
    localStorage.setItem("SiteUrl", currentURL);
    window.historyInstance.push("/guesthandler?ptitle=" + title);
}
function getUsageTypeFromLS() {
    try {
        var type = localStorage.getItem("UsageType");
        return type;
    } catch (e) {
        console.log("Error in getUsageTypeFromLS : " + e);
    }
}


function IsProType() {
    try {
        var type = getUsageTypeFromLS() == "2";
        return type;
    } catch (e) {
        console.log("Error in IsProType : " + e);
    }
}


function showValidationtext(value, id) {
    if (!id) {
        return;
    }
    if (!value) {
        $("span#" + id).addClass("active");
        // $(event.target).addClass("caseerror");
        //isCanBeValidated = false;
    }

    else {
        $("span#" + id).removeClass("active");
        //$(event.target).removeClass("caseerror");
        // isCanBeValidated = true;
    }
}

export function getNoOfAttendacesForGoals(goal, attendanceData) {
    if (goal.Title) {
        var isAttenadceTDTConsider = window.attendancesRecordingDate <= dateFromSDateTime(goal.CDT);

        var attendaceByGoal = $.grep(attendanceData, function (e) { return e.Status == "Present" && e.ServiceId == goal.TherapyId && new Date(e.ForDate) >= new Date(goal.CDT) });

        //var attendaceByGoal = $.grep(attendanceData, function (e) { return dateFromSDateTime(goal.CDT) <= dateFromSDateTime(window.attendancesRecordingDate <= dateFromSDateTime(e.CDT) ? e.TDT : e.CDT) && e.S && e.S.toLowerCase() == "present" && e.TOId == goal.TOId && e.F5 && e.F5.toLowerCase() == goal.F1.toLowerCase() && e.F2 && goal.RDD.toLowerCase().indexOf(e.F2.split("{#}")[0].toLowerCase()) > -1 });
        return attendaceByGoal && attendaceByGoal.length > 0 && attendaceByGoal.length > goal.Services ? goal.Services : attendaceByGoal && attendaceByGoal.length > 0 ? attendaceByGoal.length : 0;
    }
    return 0;
}
export function isGoalCompleted(goal, attendanceData) {
    var length = getNoOfAttendacesForGoals(goal, attendanceData);
    return (goal.Services - 1) <= length;
}

function showLockedBoxMessage(message, header, buttonvalue, isItError, callback, image) {

    header = header ? header : "Error";
    console.log(header.toLowerCase());
    var imageUrl = header.toLowerCase() == "alert" || header.toLowerCase() == "info" || header.toLowerCase() == "validation" || header.toLowerCase() == "pinnacle updated" ? "/images/alert.png" : header.toLowerCase() == "warning" || header == "Acho! You have gone too deep" ? "/images/warning.png" : header.toLowerCase() == "success" || header.toLowerCase() == "introducing" || header.toLowerCase() == "pinnacle mirracles : kids wonderful life" ? "/images/Success.jpg" : "/images/error.png";
    if (image) {
        imageUrl = image;
    }

    var multiple = message.split("{#}");
    message = multiple[0];

    header = multiple.length > 1 ? multiple[1] : header;

    try {
        $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations .asco-img").attr("src", imageUrl);
        $('.alert-success-confirm-overlay.working-inprogress-overlay-withanimations').addClass("single");
        $('.alert-success-confirm-overlay.working-inprogress-overlay-withanimations #alert-success-confirm-overlay-header').html(header);
        $('.alert-success-confirm-overlay.working-inprogress-overlay-withanimations input[data-value="ok"]').val(buttonvalue);
        $('.alert-success-confirm-overlay.working-inprogress-overlay-withanimations input[data-value="ok"]').css("width", "100%");
        $('.alert-success-confirm-overlay.working-inprogress-overlay-withanimations .alert-header').html(message);
        $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations").removeClass('close');
        $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations").addClass('open');
        $('.alert-success-confirm-overlay').show().addClass('active');
        $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations input[data-value='cancel']").hide();

        // $('.alert-success-confirm-overlay.working-inprogress-overlay-withanimations svg').hide();
        $('.alert-success-confirm-overlay.working-inprogress-overlay-withanimations').removeClass('error');
        if (isItError) {
            $('.alert-success-confirm-overlay.working-inprogress-overlay-withanimations').addClass('error');
        }

        $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations input[data-value='ok']").click(function () {
            $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations").removeClass('open');
            $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations").addClass('close');
            $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations input[data-value='ok']").unbind("click");
            $('.alert-success-confirm-overlay').show().removeClass('active');
            $('.alert-success-confirm-overlay.working-inprogress-overlay-withanimations').removeClass("single");

            if (callback) {
                callback(true);
            }
        });

    } catch (e) {
        console.log(e.message);
    }
}

function ResetErrorvalidation() {
    try {
        $('.case-error').removeClass('active').addClass('no-display');
        $('.book-details-section input').removeClass('caseerror');
        $('.book-details-section select').removeClass('caseerror');
        $('.book-details-section textarea').removeClass('caseerror');
        //$('.fsBody .fsForm input.error, .fsBody .fsForm select.error, .fsBody .fsForm textarea.error').css({ 'border': '1px solid #dedede !important;' });
    } catch (e) {
        console.log(e);
    }
}



function InputValidatorReturnObject(parent) {

    var ReadStatus = [];
    var focuscount = 0;
    var bool = false; //var isAllReq = true;  
    $(parent + ' input:not(input[type="button"],.donot-validate),' + parent + ' select:not(.donot-validate),' + parent + ' textarea:not(.donot-validate)').removeClass('error');
    $(parent + ' input:not(input[type="button"],.donot-validate),' + parent + ' select:not(.donot-validate),' + parent + ' textarea:not(.donot-validate)').each(function () {
        //  console.log('why');
        //  console.log($(this).is(":visible"));
        if ($(this).is(":visible")) {
            var eid = $(this).attr('id');
            var specificInputID = (eid == undefined || eid.length == 0) ? false : true;

            if (!specificInputID) {
                return;
            }
            if ($(this).attr('data-handledifferently') == "datepicker") {
                var pickerValue = $(this).val();
                if (pickerValue.valueOf() == "" || pickerValue.valueOf() == undefined || pickerValue.valueOf() == null) {
                    $(this).addClass('error');
                    $(this).focus();
                    bool = true;
                }
            }
            else {
                if (!$(this).val()) {
                    console.log($(this).attr('id'));
                    if ($(this).attr('data-error-message') != undefined) {
                        ReadStatus.push({ 'id': '#' + $(this).attr('id'), 'msg': ("&nbsp; <div class='errormsg'> " + $(this).attr('data-error-message') + "</div>") });
                    }
                    else if ($(this).attr('placeholder') == undefined) {
                        ReadStatus.push({ 'id': '#' + $(this).attr('id'), 'msg': (($('#' + $(this).attr('id')).find(":selected").text()) + "&nbsp;&nbsp:&nbsp; <div class='errormsg'> Please " + $('#' + $(this).attr('id')).find(":selected").text() + "</div>") });
                    } else {
                        ReadStatus.push({ 'id': '#' + $(this).attr('id'), 'msg': ($(this).attr('placeholder') + " &nbsp;&nbsp; :&nbsp; <div class='errormsg'>Please enter " + $(this).attr('placeholder') + "</div>") });
                    }

                    $(this).addClass('error');
                    if (focuscount == 0) {
                        focuscount = 1;
                        $(this).focus();
                    }
                    bool = true;
                }
            }
        }
    });

    return ReadStatus;
}

function showConfirmBoxWithCancel2(message, header1, buttonvalue, isItError, callback) {
    try {
        setTimeout(function () {
            //$('html, body').addClass('popUpBackround');
        }, 20);
        if (message == "DONTSHOWCONFIRMATIONBOX") {
            callback(false);
            return;
        }

        var header = header1 ? (header1.split("{#}").length > 1 ? header1.split("{#}")[0] : header1) : "Error";


        var textToDisplay = header1 ? (header1.split("{#}").length > 1 ? header1.split("{#}")[1] : header1) : "Error";
        $('.alert-success-confirm-overlay.working-inprogress-overlay-withanimations #alert-success-confirm-overlay-header').html(textToDisplay);

        var okbuttonName = buttonvalue ? buttonvalue.split("{#}")[0] ? buttonvalue.split("{#}")[0] : "Okay" : "Okay";
        var cancelbuttonName = buttonvalue ? buttonvalue.split("{#}")[1] ? buttonvalue.split("{#}")[1] : "Remove" : "Cancel";


        var imageUrl = header.toLowerCase() == "alert" || header.toLowerCase() == "info" || header.toLowerCase() == "validation" ? "/images/alert.png" : header.toLowerCase() == "warning" || header.toLowerCase() == "confirmation" ? "/images/warning.png" : (header.toLowerCase() == "success" || header.toLowerCase() == "pinnacle mirracles : kids wonderful life") ? "/images/Success.jpg" : "/images/error.png";

        $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations .asco-img").attr("src", imageUrl);

        $('.alert-success-confirm-overlay.working-inprogress-overlay-withanimations input[data-value="ok"]').val(okbuttonName);
        $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations input[data-value='cancel']").val(cancelbuttonName);

        $('.alert-success-confirm-overlay.working-inprogress-overlay-withanimations .alert-header').html(message);
        $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations").removeClass('close');
        $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations").addClass('open');
        $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations input[data-value='cancel']").show();
        if (cancelbuttonName == "Remove") {
            $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations input[data-value='cancel']").hide();
        }
        $('.alert-success-confirm-overlay').show().addClass('active');
        $('.alert-success-confirm-overlay.working-inprogress-overlay-withanimations').removeClass('error');
        $('.alert-success-confirm-overlay.working-inprogress-overlay-withanimations svg').hide();

        $('.alert-success-confirm-overlay.working-inprogress-overlay-withanimations .SVU-close svg').show();
        if (isItError) {
            $('.alert-success-confirm-overlay.working-inprogress-overlay-withanimations').addClass('error');
        }

        $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations input[data-value='ok']").click(function () {
            $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations").removeClass('open');
            $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations").addClass('close');
            $('.alert-success-confirm-overlay').show().removeClass('active');
            $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations input[data-value='ok']").unbind("click");
            $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations input[data-value='cancel']").unbind("click");
            //$('html, body').removeClass('popUpBackround');
            callback(true);

        });

        $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations input[data-value='cancel']").click(function () {
            $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations").removeClass('open');
            $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations").addClass('close');
            $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations input[data-value='cancel']").unbind("click");
            $(".alert-success-confirm-overlay.working-inprogress-overlay-withanimations input[data-value='ok']").unbind("click");
            $('.alert-success-confirm-overlay').show().removeClass('active');
            //$('html, body').removeClass('popUpBackround');
            callback(false);
        });

    } catch (e) {
        console.log(e.message);
        // $('html, body').removeClass('popUpBackround');
    }
}

function ToastMessage(message, timeout, type) {
    var toast = $('.toast-message .jq-toast-single:last-child');
    $(toast).find('.message').text(message);
    var typeClass = "";
    if (type != null && typeof (type) != "undefined" && type == "red") {
        typeClass = "error";
    }
    else {
        typeClass = "active";
    }

    console.log("Toast Message Loaded.");

    //$(toast).addClass(typeClass);
    //var time = ((timeout) / 1000) - 1;
    //if (timeout) {

    $(toast).slideToggle(400).delay(2000).slideToggle(400);


    //setTimeout(function () {
    //    $(toast).slideUp(function () {
    //        $(toast).removeClass(typeClass);
    //        $(toast).find('.message').text("");
    //    });

    //}, timeout);
    //}
}

export function GetAuthTokenFromLS() {
    var token = "";
    try {
        token = cookie.load('validatorauth-s');

        if (!token) {
            token = localStorage.getItem("validatorauth-s");
        }

    } catch (e) {
        token = localStorage.getItem("validatorauth-s");
    }
    return token;
}

export function EnableGuestHandlerFOrIQM(assessment, bookingId) {
    try {
        var token = "";
        try {
            token = cookie.load('validatorauth-s');

            if (!token) {
                token = localStorage.getItem("validatorauth-s");
            }

        } catch (e) {
            token = localStorage.getItem("validatorauth-s");
        }
        var orgId = "c316c785-2429-4a15-69ad-56d25dc8aefb";

        var sclientType = localStorage.getItem('validatorclienttype-s');
        var isWeb = sclientType && sclientType.toLocaleLowerCase() != "web" ? false : true;
        var assId = assessment.IQMId;
        var url = window.IQMURL + 'viewassessment/' + assId + '?orgid=' + orgId + '&authtoken=' + encodeURIComponent(token) + '&isweb=' + isWeb + '&bid=' + bookingId + (assessment.ISHANDLE ? "&issectionbased=true" : "");
        console.log(url);
        localStorage.setItem("SiteUrl", window.IQMURL);
        localStorage.setItem("GuestUrl", url);
        window.historyInstance.push("/guesthandler");
    } catch (e) {

    }
}
export function downloadPDF(URLToPDF, name) {
    try {
        console.log("download pdf called");
        console.log(URLToPDF);
        var oReq = new XMLHttpRequest();
        // The Endpoint of your server
        // var URLToPDF = serverPath + "Reports/" + analytic.Id + ".pdf";
        //  var URLToPDF = root + (analytic.Data3 ? analytic.Data3 : analytic.Data2);//analytic.Data2;//rootUrl + analytic.Data2;//"http://localhost:5523/" + analytic.Data2;//
        //   if (type == "Asse") {
        //      URLToPDF = iqmRooturl + analytic.F1;
        //  }


        // Configure XMLHttpRequest
        oReq.open("GET", URLToPDF, true);

        // Important to use the blob response type
        oReq.responseType = "blob";

        // When the file request finishes
        // Is up to you, the configuration for error events etc.
        oReq.onload = function () {
            try {
                // Once the file is downloaded, open a new window with the PDF
                // Remember to allow the POP-UPS in your browser
                var file = new Blob([oReq.response], {
                    type: 'application/pdf'
                });

                // Generate file download directly in the browser !
                saveAs(file, name + ".pdf");

            } catch (e) {
                console.log("Err::downloadPDF()" + e);
            }
        };

        oReq.send();
    } catch (e) {
        console.log("Error in  downloadPDF :" + e);
    }
}

export function GetPaymentOrderId(amount, callback) {
    amount = amount * 100;
    var dataURL = "https://mobile.pinnacleblooms.org/api/unsecuredapi/getpaymentorderid?amount=" + amount



    const response = fetch(dataURL, { mode: 'no-cors' }).then((r) => {
        callback(r);
    }).catch(() => callback(false))
    return;
}

export function sendTelegramMessage(subject, GID) {
    GID = GID || "1967073562";

    if (subject.indexOf("Invalid Request, Time not completed, Please Retry") > -1) {
        return;
    }
    var obj = {
        "chat_id": "-100" + GID,
        "text": subject,
        "parse_mode": 'Markdown'
    };

    var stringified = JSON.stringify(obj);

    //declare global varialble. : sreenivas
    var dataURL = "https://api.telegram.org/bot5961621807:AAEKrsNqOhdgaTNqcfJiYRLUgfAt3KP8CCI/sendMessage"

    const init = {
        body: stringified,
        method: 'POST',
        headers: {
            'content-type': 'application/json',
            'cache-control': 'no-cache'
        },
    }

    const response = fetch(dataURL, init);

    try {
        var res = response;
        //check statuss : sreenivas
        // read result.
        console.log(res)
    }
    catch (err) {
        console.log(err);
        //
    }
}

export async function shareOfferToParent(paramObj, currentUser) {
    var dataURL = 'https://pbn-planetscale-message-process.kgv.workers.dev/';

    let myrequest = new Request(dataURL);
    //console.log("Came to ProcessWhatsAppMessages Method ");
    paramObj.AT = "SHAREOFFERMESSAGETOPARENT";
    paramObj.Handle = "9676163423";
    var model = {};
    model.PayLoad = paramObj;
    model.CurrentUser = currentUser;
    model.IsEdit = false;

    console.log(JSON.stringify(model));

    const init = {
        body: JSON.stringify(model),
        method: 'POST',
        headers: {
            'content-type': 'application/json'
        },
    }

    const response = await fetch(dataURL, init);

    try {
        var res = response;
        //check statuss : sreenivas
        // read result.
        console.log(res)
    }
    catch (err) {
        console.log(err);
        //
    }
}


//export function uploadImage(file) {
//    fetch('https://<YOUR-OWN-WORKER>.workers.dev', {
//        method: 'POST',
//        headers: {
//            'Access-Control-Allow-Origin': '*',
//            'Content-Type': file.type
//        },
//        body: file
//    })
//        .then((response) => response.text())
//        .then((data) => console.log(data))
//        .catch((error) => console.error(error));
//}

export function UploadProfileFiletoR2(file, ActionType, MediaType, userId, FileName, callBack) {
    try {


        if ((null == file)) {
            callBack([{ Path: "" }]);
            return;
        }
        var fileToUpload = file && file.target ? file.target : file;
        var uplaoddata = new FormData();

        //if (croppedFIles) {
        //    //  alert(croppedFIles.length);
        //    for (var i = 0; i < croppedFIles.length; i++) {
        //        uplaoddata.append("croper", croppedFIles[i].target, croppedFIles[i].name);
        //    }
        //}
        $.ajax({
            //url: '/api/unsecuredapi/SaveMultMediaFile',
            url: 'https://psapi.pinnacleblooms.org/api/uploadr2',
            //url: 'http://localhost:8787/api/uploadr2',

            beforeSend: function (request) {
                request.setRequestHeader("ActionType", ActionType);
                request.setRequestHeader("MediaType", MediaType);
                request.setRequestHeader("ClientType", "WEB");
                request.setRequestHeader("ImagePersonId", userId);
                request.setRequestHeader("FileName", FileName);
                request.setRequestHeader("Tag", FileName);
                request.setRequestHeader("Content-Type", fileToUpload.type);

            },
            data: fileToUpload,
            xhr: function () {
                var myXhr = $.ajaxSettings.xhr();
                if (myXhr.upload) {
                    myXhr.upload.addEventListener('progress', function (e) {

                        if (e.lengthComputable) {
                            var max = e.total;
                            var current = e.loaded;
                            var Percentage = (current * 100) / max;
                            //console.log(Percentage);
                            // console.log(page.toLowerCase());



                            if (Percentage >= 100) {
                                // process completed  
                            }
                            else {
                                //callbackPerscentage(Percentage);
                            }
                        }
                    }, false);
                }
                return myXhr;
            },
            cache: false,
            // contentType: false,
            async: true,
            processData: false,
            type: 'POST',
            success: function (result) {
                //showLockedBox("Image Updated successfully", "", "Ok", true);
                callBack(result);
                return true;

            },
            error: function (xhr, ajaxOptions, thrownError) {
                //HideLoading();
                if (callBack) {
                    callBack();
                }
                $('.submit-wrapper').removeClass('is-saving');
                showLockedBox("Sorry, We are unable to upload files to server", "Error", "Ok", true);
            }
        });



    } catch (e) {
        console.log("Err::UploadProfileFile()" + e);
    }

}

export function UploadSecureFiletoR2(file, ActionType, MediaType, FileName, Tag, callBack) {
    try {


        if ((null == file)) {
            callBack([{ Path: "" }]);
            return;
        }
        var fileToUpload = file && file.target ? file.target : file;
        var uplaoddata = new FormData();

        //if (croppedFIles) {
        //    //  alert(croppedFIles.length);
        //    for (var i = 0; i < croppedFIles.length; i++) {
        //        uplaoddata.append("croper", croppedFIles[i].target, croppedFIles[i].name);
        //    }
        //}
        $.ajax({
            //url: '/api/unsecuredapi/SaveMultMediaFile',
            url: 'https://psapi.pinnacleblooms.org/api/uploadr2',
            // url: 'http://localhost:8787/api/uploadr2',

            beforeSend: function (request) {
                request.setRequestHeader("ActionType", ActionType);
                request.setRequestHeader("MediaType", MediaType);
                request.setRequestHeader("ClientType", "WEB");
                request.setRequestHeader("FileName", FileName);
                request.setRequestHeader("Tag", Tag);
                request.setRequestHeader("Content-Type", fileToUpload.type);

            },
            data: fileToUpload,
            xhr: function () {
                var myXhr = $.ajaxSettings.xhr();
                if (myXhr.upload) {
                    myXhr.upload.addEventListener('progress', function (e) {

                        if (e.lengthComputable) {
                            var max = e.total;
                            var current = e.loaded;
                            var Percentage = (current * 100) / max;
                            //console.log(Percentage);
                            // console.log(page.toLowerCase());



                            if (Percentage >= 100) {
                                // process completed  
                            }
                            else {
                                //callbackPerscentage(Percentage);
                            }
                        }
                    }, false);
                }
                return myXhr;
            },
            cache: false,
            // contentType: false,
            async: true,
            processData: false,
            type: 'POST',
            success: function (result) {
                //showLockedBox("Image Updated successfully", "", "Ok", true);
                callBack(result);
                return true;

            },
            error: function (xhr, ajaxOptions, thrownError) {
                //HideLoading();
                if (callBack) {
                    callBack();
                }
                $('.submit-wrapper').removeClass('is-saving');
                showLockedBox("Sorry, We are unable to upload files to server", "Error", "Ok", true);
            }
        });



    } catch (e) {
        console.log("Err::UploadProfileFile()" + e);
    }

}


export function UploadProfileFile(croppedFIles, ActionType, MediaType, userId, FileName, callBack) {
    try {


        if ((null == croppedFIles || croppedFIles.length == 0)) {
            callBack([{ Path: "" }]);
            return;
        }
        var uplaoddata = new FormData();

        if (croppedFIles) {
            //  alert(croppedFIles.length);
            for (var i = 0; i < croppedFIles.length; i++) {
                uplaoddata.append("croper", croppedFIles[i].target, croppedFIles[i].name);
            }
        }
        $.ajax({
            //url: '/api/unsecuredapi/SaveMultMediaFile',
            url: 'https://psapi.pinnacleblooms.org/api/uploadr2',
            // url: 'http://localhost:8787/api/uploadr2',

            beforeSend: function (request) {
                request.setRequestHeader("ActionType", ActionType);
                request.setRequestHeader("MediaType", MediaType);
                request.setRequestHeader("ClientType", "WEB");
                request.setRequestHeader("ImagePersonId", userId);
                request.setRequestHeader("FileName", FileName);
                request.setRequestHeader("Content-Type", croppedFIles[0].target.type);

            },
            data: croppedFIles[0].target,
            xhr: function () {
                var myXhr = $.ajaxSettings.xhr();
                if (myXhr.upload) {
                    myXhr.upload.addEventListener('progress', function (e) {

                        if (e.lengthComputable) {
                            var max = e.total;
                            var current = e.loaded;
                            var Percentage = (current * 100) / max;
                            //console.log(Percentage);
                            // console.log(page.toLowerCase());



                            if (Percentage >= 100) {
                                // process completed  
                            }
                            else {
                                // callbackPerscentage(Percentage);
                            }
                        }
                    }, false);
                }
                return myXhr;
            },
            cache: false,
            // contentType: false,
            async: true,
            processData: false,
            type: 'POST',
            success: function (result) {
                //showLockedBox("Image Updated successfully", "", "Ok", true);
                callBack(result);
                return true;

            },
            error: function (xhr, ajaxOptions, thrownError) {
                //HideLoading();
                if (callBack) {
                    callBack();
                }
                $('.submit-wrapper').removeClass('is-saving');
                showLockedBox("Sorry, We are unable to upload files to server", "Error", "Ok", true);
            }
        });



    } catch (e) {
        console.log("Err::UploadProfileFile()" + e);
    }

}
export function UploadSecureFile(blob, folderName, fileName, tag, callBack) {
    try {

        var uplaoddata = new FormData();
        uplaoddata.append(fileName, blob);

        $.ajax({
            url: '/api/unsecuredapi/SecureFileSave',
            beforeSend: function (request) {
                request.setRequestHeader("AuthToken", GetAuthTokenFromLS());
                request.setRequestHeader("Project", folderName);
                request.setRequestHeader("FID", fileName);
                request.setRequestHeader("TAG", tag);
                request.setRequestHeader("APPType", IamIOSWebAlso() ? "IOS" : "");
                //request.setRequestHeader("RelevantDataTitle", ActionType && ActionType.toLowerCase() != "cards" ? $('#ArticleTitle').val() : "IndiaHeraldCards");
            },
            data: uplaoddata,
            xhr: function () {
                var myXhr = $.ajaxSettings.xhr();
                if (myXhr.upload) {
                    myXhr.upload.addEventListener('progress', function (e) {

                        if (e.lengthComputable) {
                            var max = e.total;
                            var current = e.loaded;
                            var Percentage = (current * 100) / max;
                            console.log(Percentage);
                        }
                    }, false);
                }
                return myXhr;
            },
            cache: false,
            contentType: false,
            async: false,
            processData: false,
            type: 'POST',
            success: function (result) {
                console.log(result);
                $('.file-publish-loader').addClass('displaynone');
                callBack(result);

            },
            error: function (xhr, ajaxOptions, thrownError) {
                callBack("failed");

                showLockedBox(thrownError, "Error", "Ok", true);
                $('.file-publish-loader').addClass('displaynone');
                console.log(xhr);

                var errorObj = {};
                errorObj.Type = 3;
                errorObj.Message = thrownError;
                errorObj.CreatedDateTime = getCurrentDateTime();

                SaveExceptionToSentry(errorObj, "ERROR", getUserToken(), "UPLOADSECUREFILE");
                //alert("Sorry, We are unable to upload files to server", false);
            }
        });



    } catch (e) {
        console.log("Err::UploadProfileFile()" + e);
    }

}

function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
    }
    else if (/android/i.test(userAgent)) {
        return "Android";
    }

    // iOS detection
    else if (/iPad|iPhone|iPod/.test(userAgent)) {
        return "iOS";
    }

    return "unknown";
}




// #region cropper 


// #endregion cropper

export function ShowShare(activity, type) {
    try {
        if (!HandleOffline(function () { ShowShare(activity, type); })) {
            return;
        }
        var rootUrl = "";
        // var sTitle = FormatStringForUrl(activity.SN && activity.SN != "" ? activity.SN : activity.Title);
        var title = "";
        var url = "";
        if (!activity.AT) {
            var d1Data = window.globalCacheData.Types;
            // console.log(d1Data);
            console.log(activity.TypeId);
            var typeInLocal = d1Data ? d1Data.find((e) => e.Id == activity.TypeId) : null;
            console.log(typeInLocal);


            activity.AT = typeInLocal ? typeInLocal.Name : "";

            if (activity.Category) {


                activity.AT = activity.Category && activity.Category == "Service" ? "services" : activity.Category;  //d1Data ? d1Data.find((e) => e.Id == fdata.Category).Name : "";
            }
        }
        type = type.toLowerCase() == "pinnacleprofile" ? "pinnacleprofile" : activity.AT;
        switch (type.toLowerCase()) {
            case "mirracles":
                title = "*MIRRACLES @ PINNACLE*";
                url = "mirraclescheme://https://mirracle.pinnacleblooms.org" + "/mirracles?id=" + activity.UId;
                var description = activity.F2;
                break;
            case "pinnacleprofile":
                title = "*PINNACLE @ PROFILE*";
                url = "mirraclescheme://https://mirracle.pinnacleblooms.org" + "/" + activity.O4;
                var description = "";
                break;
            case "blogpost":
            case "imagegallery":
            case "video":
            case "audio":
            case "file":
            case "event":
                title = "*" + activity.RDT + "*";
                url = "https://mirracle.pinnacleblooms.org" + "/guru/" + FormatStringForUrl(activity.RDT && activity.RDT != "" ? activity.RDT : "title-missing") + "/" + activity.UId;
                var description = activity.RDD && activity.RDD.length > 0 ? parse(activity.RDD.substring(0, 180)) : "";
                break;
            case "assessment":
                title = "*SELF ASSESS:" + activity.RDT + "*";
                url = "https://mirracle.pinnacleblooms.org/assessment/" + FormatStringForUrl(activity.SN && activity.SN != "" ? activity.SN : "");
                var description = activity.RDD && activity.RDD.length > 0 ? parse(activity.RDD.substring(0, 180)) : "";
                break;
            case "services":
                title = "*" + activity.RDT + "*";
                url = "https://mirracle.pinnacleblooms.org/services/" + FormatStringForUrl(activity.SN && activity.SN != "" ? activity.SN : "");
                var description = activity.RDD && activity.RDD.length > 0 ? parse(activity.RDD.substring(0, 180)) : "";
                description = description ? description + "\n\n" + "*Enroll:* https://www.pinnacleblooms.org/enroll" : "";
                break;
            case "attendance":
                if (activity.S.toLowerCase() == "present") {
                    title = activity.F9 + "/5 -" + activity.F3 + " empowerment for " + getFormattedDate(activity.CDT) + "\n\nGoals Workedupon:\n" + activity.F2 + "\n\nTherapist Feedback:\n" + activity.RDT + "\n\nHomework:\n" + activity.RDD;
                } else if (activity.S.toLowerCase() == "absent") {
                    title = "We all at Pinnacle Blooms Network missed " + activity.F3 + " today.Our Therapist - Shri." + activity.CBPN + " Garu time of " + activity.F1 + " has remained empty."
                        + "\n\n" + "Would love to see " + activity.F1 + " making use of every single  therapy session and get the most of it.We would love to see you in next day and every working day session " + activity.F3 + " Garu."
                }
                url = "https://mirracle.pinnacleblooms.org/hanuman?id=" + activity.UId + "&at=" + activity.AT;
                break;
            case "invoice":
                var allmonthNames = ["January", "February", "March", "April", "May", "June",
                    "July", "August", "September", "October", "November", "December"
                ];
                title = "RECEIPT: " + (activity && activity.KidName ? activity.KidName : "") + " " + activity.ServiceName + " fee receipt for ₹" + activity.Amount + " of " + allmonthNames[new Date(activity.FDT).getMonth()] + "/" + new Date(activity.FDT).getFullYear() + "\n\n*Receipt*";
                url = "https://mirracle.pinnacleblooms.org/viewinvoice/" + activity.Id;
                break;
            case "goal settings":
                var committed = activity.Details.split('{##}')[0].replace(/{#}/gi, "\n\n");
                var stretched = activity.Details.split('{##}').length > 1 && activity.Details.split('{##}')[1] != "" ? ("\n\n*Stretched*\n\n " + activity.Details.split('{##}')[1].replace(/{#}/gi, "\n\n")) : "";

                title = activity.Title + " of " + activity.F3 + " by " + activity.CBPN + " created on " + getFormattedDate(activity.CDT) + "\n\n*Committed*" + committed + stretched;
                url = "https://mirracle.pinnacleblooms.org/hanuman?id=" + activity.Id + "&at=GOAL%20SETTINGS";
                break;
            case "userservice":
                title = "Dear Parent,\n\nHearty Congratulations on the empowerment journey for " + activity.RDT + ".\n\n" + activity.F2 + " by " + activity.F3 + " between " + getTimeStampfromTime(activity.F1, false) + " - " + getTimeStampfromTime(activity.F1, true) + " has been reserved for " + activity.F3
                    + "\n\nFirst 15 therapies are all about therapist earning emotional confidence of kid.\n\nThere after therapist and you will decide goals for every 20 therapy sessions and every therapy would be based upon the goal.\n\n"
                    + "Everyday therapy will be of 40 minutes therapeutic empowerment + 3 minutes of parental discussion with therapist.\n\n" + "You may please reach out to centre Administration manager for anything other than therapies, can speak to therapist or chief therapist everything about the therapies.\n\n"
                    + "You may reach National Care Centre on 9100 181 181 at any/ all times for anything/ everything of kids empowerment.\n\n" + "Hearty Congratulations! Wishing you all the very best  - Promising to do everything plausible. \n\n"
                    + "https://mirracle.pinnacleblooms.org \n# Autism Therapy Centres Network";
                description = "";
                url = "https://mirracle.pinnacleblooms.org/hanuman?id=" + activity.UId + "&at=" + activity.AT;
                break;
            case "user":
                url = "https://mirracle.pinnacleblooms.org/usercard?id=" + activity.OGID + "&role=" + type;
                if (type == "boss") {
                    var d = activity.S && activity.S.toLowerCase() == "female" ? "Baby" : "Master";
                    title = "*" + d + ". " + activity.RDT + "*";
                } else if (type == "staff") {
                    title = "Shri. " + activity.RDT + " - " + activity.F5.split("{#}")[0] + ", Since " + getFormattedDate(activity.TDT) + " @ " + activity.F5.split("{#}")[4];
                }


                break;
            case "award":
                url = window.R2Path + "/Assets/GeneratedAwards/" + activity.Id + "_Award.pdf";
                title = "Hearty Congratulations to " + activity.F2 + " on recieving " + activity.Title + "\n\n" + activity.Description;

                break;
            case "pinnaclegiftvoucher":
                url = activity.URL;
                title = activity.RDD;

                break;
            default:
                break;
        }

        console.log(url);
        var footer = "*Call 9100 181 181 for Franchise* ( Eligibility: Only for parents of kid with sensorial conditions, Proven Doctors, Certified Therapists with Profound work expertise in empowering kids, parents, families), *Admission*";
        title = title + "\n\n" + url + (description ? "\n\n" + description + "..." + "\n\n" : "\n\n") + footer;
        var app = localStorage.getItem("validatorapptype-s");
        console.log(title);
        if (IsIOS(app)) {
            window.location.href = "mirraclescheme://sharecallback=" + title;
            return;
        }

        if (navigator.share === undefined) {
            console.log('Undefined!');

            if (IsAndroid(app)) {
                // alert("handle android");
                window.currentShareVal = title;
                window.location.href = "mirraclescheme://sharecallback";
            }
            else {
                alert("Sharing is not available for your browser currently, we will enable it soon. You may still share via WhatsApp.");
            }
        }
        else {
            console.log('Sharing!');
            navigator.share({ title: title, text: title });
        }
    }
    catch (e) {
        console.log("Error in share: " + e);
    }

}

export function ConnectCall(mobile, Id, callback) {



    ConnectCallTWebSocket(mobile, function (response, error) {
        if (!error) {
            showLockedBox("Call Connected Successfully");
        }
        else {
            showLockedBox(error.ErrorMsg, "Error", "ok");
        }

    });
    // $.ajax({
    //     url: "/api/UnsecuredAPI/ClickOCall?mobileNumber=" + mobile + "&userId=" + Id,
    //     type: "POST",
    //     dataType: "json",
    //     success: function (data) {
    //         if (callback) {
    //             callback(true);
    //         }
    //     },
    //     error: function (x, y, z) {
    //         showLockedBox(x.responseText, "", "ok");

    //     }
    // });
}


export function SendTelegramMessageViaServer(request, callback) {

    var psurl = "https://psapi.pinnacleblooms.org/api/sendtelegramviaserver";

    $.ajax({
        url: psurl,
        data: JSON.stringify(request),
        type: "POST",
        dataType: "application/json",
        success: function (data) {
            if (callback) {
                callback(true);
            }
        },
        error: function (x, y, z) {
            //  showLockedBox(x.responseText, "", "ok");
        }
    });
}


export function LeadOrPTIShare(activity, type, facility) {
    try {

        var d1Data = localStorage.getItem("MasterFacilities");

        var md = JSON.parse(d1Data);
        var centername = "NCC";
        if (md) {
            try {
                centername = $.grep(md, function (e) { return e.Id == activity.CenterId })[0].Name;
            }
            catch (e) {
            }
        }
        var url = (type == "leadhistory") ? "mirraclescheme://https://mirracle.pinnacleblooms.org/hermes?id=" + activity.TOId : "mirraclescheme://https://mirracle.pinnacleblooms.org" + "/pti";

        var title = (facility ? facility + ": " : "") + (activity.F2 ? activity.F2 : " Lead") + " created on " + dateFromDateTime(activity.CDT) + (activity.F6 && activity.F6.split("{#}")[0] ? ", last followed up on " + activity.F6.split("{#}")[0] : "") + " , Next follow up: " + (activity.FDT ? dateFromDateTime(activity.FDT) : "N/A")
        //var description = activity.RDD && activity.RDD.length > 0 ? parse(activity.RDD.substring(0, 180)) : "";
        var footer = "*Download app:* https://mirracle.pinnacleblooms.org/dl \n*Brought to you by: *Pinnacle Blooms Network,\n#1 Autism Therapy Centres Network,\n#1 Multi - sensory, Multi - disciplinary, Integrated Autism Therapy Centres Network,\n\nPROVIDERS OF FREE NATIONAL AUTISM HELPLINE.*WhatsApp :* https://wa.me/+919100181181";
        title = title + "\n\n" + url + "\n\n" + footer;

        title = facility + '\n\n';
        title += (activity.Description ? (activity.Description == "MYOPERATOR CALL" ? "Pinnacle OMNI MO" : activity.Description == "Job enquiry" ? "Pinnacle OMNI JE" : activity.Description.indexOf("whatsapp to 9100 181 181") > -1 ? "Pinnacle OMNIW"
            : activity.Description == " TIDIO " ? "Pinnacle OMNIT" : activity.Description) + "\n\n" : "");
        title += ("Last Active: " + getFormattedDate(activity.CDT) + "\n\n");
        title += ("Created: " + (activity.CDT ? getFormattedDate(activity.CDT) : "") + "\n\n")
        title += ("" + url + "\n\n");

        var app = localStorage.getItem("validatorapptype-s");
        console.log(title);

        if (IsIOS(app)) {
            window.location.href = "mirraclescheme://sharecallback=" + title;
            return;
        }

        if (navigator.share === undefined) {
            console.log('Undefined!');

            if (IsAndroid(app)) {
                // alert("handle android");
                window.currentShareVal = title;
                window.location.href = "mirraclescheme://sharecallback";
            }
            else {
                alert("Sharing is not available for your browser currently, we will enable it soon. You may still share via WhatsApp.");
            }
        }
        else {
            console.log('Sharing!');
            navigator.share({ title: title, text: title });
        }
    }
    catch (e) {
        console.log("Error in share: " + e);
    }
}
export function GetFormatStringForUrl(text) {
    return FormatStringForUrl(text);
}
function FormatStringForUrl(text) {

    //  console.log("i am called with " + text);
    try {
        if (!text) {
            return text;
        }
        // return text.replace(/[^a-z0-9\s]/gi, '_').replace(/[_\s]/g, '_').replace(/--/g, '_').trim()

        return text.replace(/[^a-z0-9\s]/gi, '-').replace(/[_\s]/g, '-').replace(/ /g, "-").replace(/--/g, '-').trim()
    }
    catch (e) {
    }

    return "";
}

export var DownArrow = <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="16px" height="16px" viewBox="0 0 16 16"><g transform="translate(0, 0)"><polyline fill="none" stroke="#444444" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit={10} points="11.5,6.5 8,10 4.5,6.5 " data-color="color-2" /> <circle fill="none" stroke="#444444" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit={10} cx={8} cy={8} r="7.5" /></g></svg>

export var UpArrow = <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="16px" height="16px" viewBox="0 0 16 16"><g transform="translate(0, 0)"><polyline fill="none" stroke="#444444" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit={10} points="11.5,9.5 8,6 4.5,9.5 " data-color="color-2" /> <circle fill="none" stroke="#444444" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit={10} cx={8} cy={8} r="7.5" /></g></svg>


export var SlidaeBar = <div className="h-l">
    <span className="high">
        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="16px" height="16px" viewBox="0 0 16 16"><g transform="translate(0, 0)"><path d="M14.622,5.62l-.645,1.935C13.988,7.7,14,7.85,14,8A6,6,0,1,1,8,2c.151,0,.3.012.448.023l1.931-.644.745-.745a8,8,0,1,0,4.242,4.242Z" fill="#444444" /><path d="M15.707.293a1,1,0,0,0-1.414,0L11.459,3.126,5.684,5.052A1,1,0,0,0,5,6a5.006,5.006,0,0,0,5,5,1,1,0,0,0,.949-.684L12.874,4.54l2.833-2.833A1,1,0,0,0,15.707.293Z" fill="#444444" data-color="color-2" /></g></svg>
    </span>
    <span className="low">
        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="16px" height="16px" viewBox="0 0 16 16"><g transform="translate(0, 0)"><path data-color="color-2" fill="#444444" d="M9.4,6.6c0.8,0.8,0.8,2,0,2.8c-0.8,0.8-2,0.8-2.8,0C5.8,8.6,1.6,1.6,1.6,1.6S8.6,5.8,9.4,6.6 z" /> <path fill="#444444" d="M8,16c-4.4,0-8-3.6-8-8c0-0.6,0.4-1,1-1s1,0.4,1,1c0,3.3,2.7,6,6,6s6-2.7,6-6s-2.7-6-6-6C7.4,2,7,1.6,7,1 s0.4-1,1-1c4.4,0,8,3.6,8,8S12.4,16,8,16z" /></g></svg>
    </span>
</div>

export function GetHyperlink(item, noRoot) {
    return CreateHyperlink(item, noRoot);
}


export function IamIOSWebAlso() {
    console.log("(!!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform))");
    console.log((!!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)));
    return AreYouIOS() || (!!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform));

}


export function GetClientType() {
    var appCType = "";
    var cType = localStorage.getItem("validatorclienttype-s");
    if (isNullOrEmpty(cType) || cType == "null")
        cType = "";



    try {
        if (!cType) {
            cType = localStorage.getItem("validatorapptype-s");
            if (!cType) {
                cType = cookie.load("validatorapptype-s");
            }
        }

    } catch (e) {
    }


    return cType;
}

export function AreYouIOS() {
    var appCType = "";
    var cType = localStorage.getItem("validatorclienttype-s");
    if (isNullOrEmpty(cType) || cType == "null")
        cType = "";



    try {
        appCType = localStorage.getItem("validatorapptype-s");
        if (!appCType) {
            appCType = cookie.load("validatorapptype-s");
        }

    } catch (e) {
    }

    return IsIOS(appCType) || IsIOS(cType);
}

export function clearUserRelatedData(isForceLogOff) {
    try {

        var cType = localStorage.getItem("validatorclienttype-s");
        if (isNullOrEmpty(cType) || cType == "null")
            cType = "";

        var appCType = "";

        try {
            appCType = localStorage.getItem("validatorapptype-s");
            if (!appCType) {
                appCType = cookie.load("validatorapptype-s");
            }
        } catch (e) {
        }

        localStorage.removeItem("Role");
        localStorage.removeItem("UserRoles");
        localStorage.removeItem("UserData");
        clearLocalStorage();

        cookie.remove("validatorauth-s");
        cookie.remove("validatormobilenumber-s");
        cookie.remove("UserRoles");
        cookie.remove("UserData");
        try {
            cookie.remove('validatorauth-s', { path: "/", domain: "pinnacleblooms.org" });
            cookie.remove('validatormobilenumber-s', { path: "/", domain: "pinnacleblooms.org" });
            cookie.remove('UserRoles', { path: "/", domain: "pinnacleblooms.org" });
            cookie.remove('UserData', { path: "/", domain: "pinnacleblooms.org" });
        } catch (e) {

        }
        try {
            if ('caches' in window) {
                caches.keys()
                    .then(function (keyList) {
                        return Promise.all(keyList.map(function (key) {
                            return caches.delete(key);
                        }));
                    })
            }
        } catch (e) {
            console.log(e);
        }

        if (IsIOS(appCType) || IsAndroid(appCType)) {
            window.location.href = "mirraclescheme://logoff";
        }

        setTimeout(function () {

            if (isForceLogOff) {
                window.location.href = "/forcelogoff";
            }
            else {
                window.location.href = "/epass" + (appCType ? "?ct=" + appCType : "");
            }

        }, 20);

    } catch (e) {
        console.log("Error in clearUserRelatedData : " + e);
    }
}



export function IsLocalKeyExist(keyName) {
    const name = localStorage.getItem(keyName);
    return name ? true : false;

}

export function FlushServiceWorkerCache(currentVersion, serverVersion, callback) {
    console.log("Came for For Flush");
    // const name_of_cache = ['PINNACLE_M_063'];
    var isAllClean = false;
    try {
        var currentMajorVersion = currentVersion.split('.')[1];
        var serverMajorVersion = serverVersion.split('.')[1];
        if (currentMajorVersion != serverMajorVersion) {
            isAllClean = true;
        }
    } catch (e) {

    }
    try {
        if ('caches' in window) {
            caches.keys()
                .then(function (keyList) {
                    return Promise.all(keyList.map(function (key) {

                        //ADDED FOR ONLY REFRESHING THE HTML // DATA RAMIANS AS IT IS.
                        if (key.indexOf("PINNACLE_") >= 0) {
                            return caches.delete(key);

                        }
                        else if (isAllClean) {
                            return caches.delete(key);
                        }


                        //return caches.delete(key);
                    })).then(function (x) {
                        try {
                            //   localStorage.removeItem("LastPSSyncDataTime");
                            console.log("Flush Completed");
                            callback(true);
                        } catch (e) {
                            console.log("Error in FlushServiceWorkerCache : after flush successful.");
                            callback(false);
                        }
                        // location.reload();
                    });
                })
        }
    } catch (err) {
        console.log("Error while flushing : FlushServiceWorkerCache " + err);
    }
}

function clearLocalStorage() {
    try {
        var userid = "";
        var clientType = "";
        var vAppType = "";
        try {
            userid = localStorage.getItem('UserId');
            clientType = localStorage.getItem('validatorclienttype-s');
            vAppType = localStorage.getItem('validatorapptype-s');

        } catch (e) {

        }

        localStorage.clear();
        try {

            localStorage.setItem('validatorclienttype-s', clientType);
            localStorage.setItem('validatorapptype-s', vAppType);
            localStorage.removeItem('UserData');
            localStorage.removeItem('UserRoles');
            localStorage.removeItem('MasterData');
            localStorage.removeItem('LastPSSyncDataTime');
        } catch (e) {
        }
        console.log("start db clear");
    } catch (e) {

    }

    // clearIndexDB();
}


function CreateHyperlink(item, noRoot) {
    var approot = "https://mirracle.pinnacleblooms.org";
    //alert(item);
    // console.log("create hyperlink");
    if (typeof (item) == 'undefined' || null == item || null == item.AT) {
        return approot;
    }

    //  return noRoot ? "/" + "guru/" + item.RDT.replace(/ /g, "-") + "/" + item.UId : approot + "/guru/" + item.RDT.replace(/ /g, "-") + "/" + item.UId;

    if (item.AT.toLowerCase() == "imagegallery" || item.AT.toLowerCase() == "audio" || item.AT.toLowerCase() == "file" || item.AT.toLowerCase() == "blogpost" || item.AT.toLowerCase() == "video") {
        return approot + "/guru/" + item.Title.replace(/ /g, "-") + "/" + item.Id;
    }
    else if (item.AT.toLowerCase() == "services" || item.AT.toLowerCase() == "assessment") {
        return approot + "/" + item.AT.toLowerCase() + "/" + item.Title.replace(/ /g, "-");
    }
    return "";
}

export function GetLastSyncedFromLS() {

    try {
        console.log("LastPSSyncDataTime");
        var lsd = localStorage.getItem("LastPSSyncDataTime");
        if (lsd) {
            let dateStamp = new Date(lsd);
            return getFormattedDate(lsd);
        }
    } catch (e) {

    }

    return "";
}

export function SaveExceptionToSentry(exception, type, token, module) {
    try {
        var exObj = {};
        exObj.transaction = "PBN_Client_Logs"

        token = (!token) ? getUserToken() : token;

        exObj.event_type = (type) ? type : "Error";
        exObj.timestamp = getCurrentDateTime();


        var lsd = localStorage.getItem("LastPSSyncDataTime");
        var configJsonString = localStorage.getItem("UserSettings");
        var settingsSWV = "";
        if (configJsonString) {
            try {
                var settingsSW = JSON.parse(configJsonString).filter(function (e) { return e.Name == "SWVERSION" });
                if (settingsSW && settingsSW.length > 0) {
                    settingsSWV = settingsSW[0].Value;
                }
            } catch (e) {

            }
        }
        exObj.extra = {
            "token": (!token) ? "Token Does not exit" : token,
            "module": module ? module : "N/A",
            "SWVersion": "Layout: " + window.swVersion + " USERSETTINGS: " + settingsSWV,
            "LSD": lsd
        }

        //exObj.tags = { "from": "client" };


        var exList = [];
        exList.push({ "type": "" + exception.Type, "value": exception.Message });

        exObj.exception = { "values": exList };

        console.log(JSON.stringify(exObj));

        var sentryIOUrl = "https://sentry.io/api/5903837/store/";

        $.ajax({
            url: sentryIOUrl,
            type: "POST",
            headers: {
                "content-type": "application/json",
                "X-Sentry-Auth": "Sentry sentry_version=7,sentry_timestamp=1329096377,sentry_key=394708243fac4e4896f2446f5b4dd3c7,sentry_secret=330ef66ced594b09a1fa603a5bd693f1,sentry_client=sentry-python/1.0",
            },
            data: JSON.stringify(exObj),
            success: function (data, textStatus, jqXHR) {
                console.log(data);

                //alert('Success!');
            },
            error: function (jqXHR, textStatus, errorThrown) {
                //alert('Error occurred!');
                console.log(jqXHR);
            }
        });
    } catch (err) {
        console.log("Error in SaveExceptionToSentry :: " + err);
    }
}

function GetBrowser() {
    try {
        let userAgent = navigator.userAgent;

        return JSON.stringify(userAgent);

        //let browserName;

        // if(userAgent.match(/chrome|chromium|crios/i)){
        //     browserName = "chrome";
        //   }else if(userAgent.match(/firefox|fxios/i)){
        //     browserName = "firefox";
        //   }  else if(userAgent.match(/safari/i)){
        //     browserName = "safari";
        //   }else if(userAgent.match(/opr\//i)){
        //     browserName = "opera";
        //   } else if(userAgent.match(/edg/i)){
        //     browserName = "edge";
        //   }else{
        //     browserName="No browser detection";
        //   }
    }
    catch {
        return "No browser detection";
    }
}




export function makeUrlSchemeCallforIOS() {
    var app = getapptype();
    //  var userAgent = this.getMobileOperatingSystem();

    var isProType = IsAppTypePro();

    if (IsIOS(app)) {
        setTimeout(function () {
            window.location.href = "mirraclescheme://imagepickeropen";
        }, 100);
    }
}

export function StoreAIEIntoLocal(type, data) {
    var urls = localStorage.getItem(type);

    localStorage.setItem(type, data);
}
export function StoreViewMirraclesIntoLocal(id, type) {
    var urls = localStorage.getItem(type ? type : "viewmirracles");
    urls = urls ? urls + "{#}" : "";
    if (urls.indexOf(id) == -1) {
        urls = urls + id;
        localStorage.setItem(type ? type : "viewmirracles", urls);
    }
}

let colorsArray = ["#017EAE", "#96BF0D", "#E42827", "#FF7903", "#FFB900", "#9c27b0", "#009688", "#00bcd4", "#3f51b5", "#e91e63", "#f44336", "#827717", "#00c853", "#e64a19", "#4caf50", "#18ffff", "#e91e63"];

export function MgroupBy(objectArray, property) {

    return objectArray.reduce(function (acc, obj) {
        var key = obj[property];
        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(obj);
        return acc;
    }, {});
}

export function GetColors(count, leastMatching) {
    let colorCodes = [];
    for (var i = 0; i < count; i++) {
        let randomMatched = false;
        do {
            randomMatched = false;
            let random = Math.floor(Math.random() * Math.floor(colorsArray.length));
            let cNBA = colorsArray[random];

            for (var j = 0; j < leastMatching; j++) {
                if (colorCodes.length >= j + 1) {

                    randomMatched = colorCodes[colorCodes.length - (j + 1)] == cNBA;
                }
                if (randomMatched) {
                    break;
                }
            }
            if (!randomMatched) {
                colorCodes.push(cNBA);
            }

        }
        while (randomMatched);

    }
    console.log(colorCodes);
    return colorCodes;
}

export function GetViewMirracles(type) {
    var urls = localStorage.getItem(type ? type : "viewmirracles");
    urls = urls ? urls : "";
    return urls.split("{#}");
}

export function callIOSImageClose() {
    var app = getapptype();
    var userAgent = getMobileOperatingSystem();

    var isProType = IsAppTypePro();
    // alert(app);
    if (IsIOS(app)) {
        setTimeout(function () {
            window.location.href = "mirraclescheme://imagepickerclose";

            //document.body.onfocus = null;
        }, 100);
    }
}

function getapptype() {
    try {
        var clientType = localStorage.getItem("validatorapptype-s");
        if (!clientType) {
            clientType = cookie.load("validatorapptype-s");
        }

        console.log(clientType);
        return clientType;
    } catch (e) {
        console.log("error in reading clientype from local storage...");
        console.log(e);
    }
}

export function OpenTheUrlinWeb(url) {
    var app = getapptype();

    if (!app) {
        app = getMobileOperatingSystem();
    }

    if (IsApp(app)) {

        window.open(url, '_blank')
        // setTimeout(function () {
        //     window.location.href = "mirraclescheme://openinweb=" + url;
        // }, 100);
    }
    else {
        window.open(url, '_blank');

        // location.href = url;
    }
}

export function getCreatedDateTime() {

    var currentTime = new Date();

    var currentOffset = currentTime.getTimezoneOffset();

    var ISTOffset = 330; // IST offset UTC +5:30

    var ISTTime = new Date(currentTime.getTime() + (ISTOffset + currentOffset) * 60000);

    return ISTTime.toISOString();
}

export function getDateString(dateString, isDate) {

    var currentTime = isDate ? dateString : new Date(dateString);

    var currentMonth = currentTime.getMonth() + 1;
    var currentDate = currentTime.getDate();

    var currentDateString = currentTime.getFullYear() + "-" + (currentMonth <= 9 ? "0" + currentMonth : currentMonth) + "-" + (currentDate <= 9 ? "0" + currentDate : currentDate) + "T00:00:00.000Z";

    return currentDateString;
}

export function ShowInActivePaymentOverlay(allData) {

    try {

        //return true;
        var roles = localStorage.getItem("UserRoles");
        roles = JSON.parse(roles);
        if (!roles || roles == null) {
            return true;
        }

        var allowedRoles = ["Therapist", "Receptionist", "ChiefTherapist", "FacilityOwner", "CCC", "NCC", "HarvestAdmin", "Manager", "Owner"];
        var UserRoles = $.grep(roles, function (e) { return allowedRoles.indexOf(e) > -1 });

        var isAllowed = false;
        $.each(UserRoles, function (key, value) {
            var c = $.grep(allowedRoles, function (e) { return e.toLowerCase() == value.toLowerCase() })[0];
            if (c) {
                isAllowed = true;
            }

        });

        if (isAllowed) {
            return false;
        }
        else {
            var activeService = $.grep(allData, function (e) { return e.AT == "USERSERVICE" && e.RS != "DELETEACTIVITY" && (!e.S || (e.S && e.S.toLowerCase() != "inactive")) });
            if (!activeService || activeService.length == 0) {
                return true;
            }
        }
        return false;
    } catch (e) {
        return false;
    }

}

function groupOnMultipleKeys(data, key) {
    if (!data || data.length == 0 || !key) {
        return;
    }
    var keys = key.split(",");

    // return array.reduce((data, currentValue) => {
    //     // If an array already present for key, push it to the array. Else create an array and push the object

    //     if (currentValue) {

    //         var valueType = [];

    //         keys.forEach(function (e) {
    //             valueType.push((currentValue[e] ? currentValue[e] : ""));
    //         });


    //         (result[valueType.join(",")] = result[valueType.join(",")] || []).push(
    //             currentValue
    //         );

    //     }
    //     // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
    //     return result;
    //}, {});
}

export function FilterCourses(data, AT, S, pending) {
    if (!data || !AT) {
        return;
    }

    var courses = data.filter(function (e) {
        return e.AT == AT && ((!S || S == "Pending") ? (!e.S || e.S.toLowerCase() != "completed") : e.S.toLowerCase() == S.toLowerCase())
    });
    if (!courses) {
        return;
    }

    // lang = a.F10, Course = a.F14

    var gData = groupOnMultipleKeys(courses, "F10,F14");


    var finalPendingCources = [];
    gData.forEach(function (value, index) {

        finalPendingCources.push(value[0]);

    });


    if (S && S.toLowerCase() == "completed") {
        if (!pending) {

        }
    }
    console.log("finalPendingCources");
    console.log(finalPendingCources);
}

